import { Component, OnDestroy, OnInit } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import _ from "lodash";
import { Profile, createPreferences } from "src/app/Models/profile.interface";
import { AngularFirestore } from "@angular/fire/firestore";
import { PROFILES } from "src/Constants";
@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.css"],
})
export class UserProfileComponent implements OnInit, OnDestroy {
  leaving = new Subject();
  constructor(
    private um: UserManager,
    private afs: AngularFirestore,
    private db: AngularFireDatabase
  ) {}
  profile: Profile;
  profileSnapshot;
  editing = false;
  changingEmail = false;
  newEmail = "";
  confirmedEmail = "";
  ngOnInit(): void {
    this.um
      .getProfileSubject()
      .pipe(takeUntil(this.leaving))
      .subscribe((profile) => {
        this.profile = profile;
        this.profileSnapshot = _.cloneDeep(profile);
      });
    // this.onLoadit();
  }

  ngOnDestroy() {
    this.leaving.next();
  }

  toggleChangingEmail = () => {
    this.changingEmail = !this.changingEmail;
  };

  // onLoadit = () => {
  //   this.afs
  //     .collection("Languages")
  //     .doc("en")
  //     .collection("Lessons")
  //     .doc("1")
  //     .get()
  //     .take(1)
  //     .subscribe((doc) => {
  //       console.log(doc.data());
  //     });
  // };

  // onSaveit = () => {
  //   try {
  //     lessons.forEach((lesson, index) => {
  //       this.afs
  //         .collection("Languages")
  //         .doc("en")
  //         .collection("Lessons")
  //         .doc(String(index + 1))
  //         .set(lesson)
  //         .then(() => console.log("Saved lesson " + index + 1))
  //         .catch(console.error);
  //     });
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };

  onEmailSave = async () => {
    this.toggleChangingEmail();
    if (this.newEmail == "") {
      return;
    }

    if (
      this.emailTest.test(this.newEmail) &&
      this.newEmail === this.confirmedEmail
    ) {
      try {
        await this.um.updateEmail(this.newEmail);
      } catch (e) {
        alert(e.message);
      }

      this.newEmail = "";
      this.confirmedEmail = "";
    } else {
      alert("invalid email");
    }
  };

  onToggle = () => {
    this.um.toggleEmailPreference();
  };

  toggleEditing = () => {
    if (this.editing) {
      // save
      if (!this.validate()) {
        return;
      }
      // this.db.object('/profile/' + this.profile.uid).update({...this.profile})
    }
    this.editing = !this.editing;
  };

  setError = (value) => {
    alert(value);
  };

  emailTest = new RegExp(
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
  );

  validate = () => {
    if (!this.profile.firstname || this.profile.firstname === "") {
      this.setError("First Name Required");
      return false;
    } else if (!this.profile.lastname) {
      this.setError("Last Name Required");
      return false;
    } else if (
      !this.profile.email ||
      this.emailTest.test(this.profile.email) === false
    ) {
      this.setError("Valid Email Required");
      return false;
    } else if (
      !this.profile.city &&
      this.profile.country != "United States" &&
      !this.profile.city &&
      this.profile.country != "Canada"
    ) {
      this.setError("City Required");
      return false;
    } else if (
      (!this.profile.zipcode && this.profile.country == "United States") ||
      (!this.profile.zipcode && this.profile.country == "Canada")
    ) {
      this.setError("Zip Code Required");
      return false;
    } else if (
      !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.profile.zipcode) &&
      this.profile.country == "United States"
    ) {
      this.setError("Invalid US Zip Code");
      return false;
    } else if (
      !/^(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d)$/i.test(
        this.profile.zipcode
      ) &&
      this.profile.country == "Canada"
    ) {
      this.setError("Invalid Canadian Postal Code");
    } else if (!this.profile.country) {
      this.setError("Country Required");
      return false;
    } else {
      return true;
    }
  };
  countries = [
    { name: "United States", code: "US" },
    { name: "Canada", code: "CA" },
    { name: "Afghanistan", code: "AF" },
    { name: "Åland Islands", code: "AX" },
    { name: "Albania", code: "AL" },
    { name: "Algeria", code: "DZ" },
    { name: "American Samoa", code: "AS" },
    { name: "Andorra", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Anguilla", code: "AI" },
    { name: "Antarctica", code: "AQ" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Aruba", code: "AW" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bermuda", code: "BM" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia", code: "BO" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Bouvet Island", code: "BV" },
    { name: "Brazil", code: "BR" },
    { name: "British Indian Ocean Territory", code: "IO" },
    { name: "Brunei Darussalam", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cape Verde", code: "CV" },
    { name: "Cayman Islands", code: "KY" },
    { name: "Central African Republic", code: "CF" },
    { name: "Chad", code: "TD" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Christmas Island", code: "CX" },
    { name: "Cocos (Keeling) Islands", code: "CC" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros", code: "KM" },
    { name: "Congo", code: "CG" },
    { name: "Congo, The Democratic Republic of the", code: "CD" },
    { name: "Cook Islands", code: "CK" },
    { name: "Costa Rica", code: "CR" },
    { name: "Cote D'Ivoire", code: "CI" },
    { name: "Croatia", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Cyprus", code: "CY" },
    { name: "Czech Republic", code: "CZ" },
    { name: "Denmark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Equatorial Guinea", code: "GQ" },
    { name: "Eritrea", code: "ER" },
    { name: "Estonia", code: "EE" },
    { name: "Ethiopia", code: "ET" },
    { name: "Falkland Islands (Malvinas)", code: "FK" },
    { name: "Faroe Islands", code: "FO" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "French Guiana", code: "GF" },
    { name: "French Polynesia", code: "PF" },
    { name: "French Southern Territories", code: "TF" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Gibraltar", code: "GI" },
    { name: "Greece", code: "GR" },
    { name: "Greenland", code: "GL" },
    { name: "Grenada", code: "GD" },
    { name: "Guadeloupe", code: "GP" },
    { name: "Guam", code: "GU" },
    { name: "Guatemala", code: "GT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and Mcdonald Islands", code: "HM" },
    { name: "Holy See (Vatican City State)", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iran, Islamic Republic Of", code: "IR" },
    { name: "Iraq", code: "IQ" },
    { name: "Ireland", code: "IE" },
    { name: "Isle of Man", code: "IM" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kiribati", code: "KI" },
    { name: "Korea, Democratic People'S Republic of", code: "KP" },
    { name: "Korea, Republic of", code: "KR" },
    { name: "Kuwait", code: "KW" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: "Lao People'S Democratic Republic", code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libyan Arab Jamahiriya", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Marshall Islands", code: "MH" },
    { name: "Martinique", code: "MQ" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mayotte", code: "YT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia, Federated States of", code: "FM" },
    { name: "Moldova, Republic of", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands", code: "NL" },
    { name: "Netherlands Antilles", code: "AN" },
    { name: "New Caledonia", code: "NC" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Palau", code: "PW" },
    { name: "Palestinian Territory, Occupied", code: "PS" },
    { name: "Panama", code: "PA" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Pitcairn", code: "PN" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Puerto Rico", code: "PR" },
    { name: "Qatar", code: "QA" },
    { name: "Reunion", code: "RE" },
    { name: "Romania", code: "RO" },
    { name: "Russian Federation", code: "RU" },
    { name: "RWANDA", code: "RW" },
    { name: "Saint Helena", code: "SH" },
    { name: "Saint Kitts and Nevis", code: "KN" },
    { name: "Saint Lucia", code: "LC" },
    { name: "Saint Pierre and Miquelon", code: "PM" },
    { name: "Saint Vincent and the Grenadines", code: "VC" },
    { name: "Samoa", code: "WS" },
    { name: "San Marino", code: "SM" },
    { name: "Sao Tome and Principe", code: "ST" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Serbia and Montenegro", code: "CS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Solomon Islands", code: "SB" },
    { name: "Somalia", code: "SO" },
    { name: "South Africa", code: "ZA" },
    { name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sudan", code: "SD" },
    { name: "Suriname", code: "SR" },
    { name: "Svalbard and Jan Mayen", code: "SJ" },
    { name: "Swaziland", code: "SZ" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Syrian Arab Republic", code: "SY" },
    { name: "Taiwan, Province of China", code: "TW" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Tanzania, United Republic of", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tokelau", code: "TK" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Turkmenistan", code: "TM" },
    { name: "Turks and Caicos Islands", code: "TC" },
    { name: "Tuvalu", code: "TV" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "United Kingdom", code: "GB" },
    { name: "United States", code: "US" },
    { name: "United States Minor Outlying Islands", code: "UM" },
    { name: "Uruguay", code: "UY" },
    { name: "Uzbekistan", code: "UZ" },
    { name: "Vanuatu", code: "VU" },
    { name: "Venezuela", code: "VE" },
    { name: "Viet Nam", code: "VN" },
    { name: "Virgin Islands, British", code: "VG" },
    { name: "Virgin Islands, U.S.", code: "VI" },
    { name: "Wallis and Futuna", code: "WF" },
    { name: "Western Sahara", code: "EH" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
  ];
}

const lessons = [
  {
    "1-0": {
      body: "In 2009, an American businessman was sentenced to 150 years in prison. His wealth management company was found to have defrauded thousands of people out of billions of dollars. People trusted that the man with whom they’d invested their hard-earned money would act in their best interests, but that trust was betrayed. Trust is essential in day-to-day life. We trust that the package we send will arrive at its destination at the appointed time. We trust that a company will fix a defective product, or that money will be available from a bank when a withdrawal is made. Without this trust, life as we know it simply wouldn’t work.  But there’s a bigger question: Can God be trusted? And can the Bible be trusted? If a person has no firsthand knowledge of God, how can God earn that person’s trust? To push back against the arguments of those who challenge the Bible as unreliable and false, God must demonstrate that the Bible is worthy of complete confidence by showing that it is historically true and accurate. And in the Bible, God does that very thing!",
      lessonID: 1,
      questionID: 0,
      type: "text",
    },
    "1-1": {
      blanks: [
        {
          correctAnswer: "declaring",
          textAfter:
            " the end from the beginning, and from ancient times things that are",
          textBefore:
            "Remember the former things of old, for I am God, and there is no other; I am God, and there is none like Me,",
        },
        {
          choices: [
            "better",
            "not",
            "declaring",
            "done",
            "this",
            "options",
            "needs",
          ],
          correctAnswer: "not",
          textAfter: " yet",
        },
        {
          choices: [
            "better",
            "not",
            "declaring",
            "done",
            "this",
            "options",
            "needs",
          ],
          correctAnswer: "done",
          textAfter: " .",
        },
      ],
      body: "By showing that He has the ability to predict future events  before they happen, God shows that He can be trusted.",
      choices: [
        "better",
        "not",
        "declaring",
        "done",
        "this",
        "options",
        "needs",
      ],
      lessonID: 1,
      question: "How does God demonstrate that He can be trusted?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "9 Remember the former things of old, for I am God, and there is no other; I am God, and there is none like Me,\n\n10 Declaring the end from the beginning, and from ancient times things that are not yet done, saying, ‘My counsel shall stand, and I will do all My pleasure.’",
          ref: "Isaiah 46:9, 10",
        },
      ],
    },
    "1-10": {
      blanks: [
        {
          correctAnswer: "bronze",
          textAfter: " , which shall rule over all the earth.",
          textBefore: "A third kingdom of",
        },
      ],
      body: "Alexander the Great led the Greeks—known for their bronze armor—to victory over the Medes and Persians in the Battle of Arbela in 331 BC. The Jewish historian Josephus documented how Alexander the Great knew his destiny as a result of being shown the prophecies of Daniel (Josephus, Antiquities, p. 244).",
      choices: ["silver", "bronze"],
      lessonID: 1,
      question:
        "What metal was used to represent the third kingdom, the nation that would take over from Medo-Persia?",
      questionID: 10,
      questionType: "radio",
      verses: [
        {
          body: "But after you shall arise another kingdom inferior to yours; then another, a third kingdom of bronze, which shall rule over all the earth.",
          ref: "Daniel 2:39",
        },
      ],
    },
    "1-11": {
      blanks: [
        {
          correctAnswer: "iron",
          textAfter: " .",
          textBefore: "And the fourth kingdom shall be as strong as",
        },
      ],
      body: "The iron monarchy of Rome conquered the Greeks in 168 BC. The Romans ruled during the time of Jesus, and this great superpower was dominant for more than 600 years. The long legs of time resulted in much persecution of God’s people.",
      choices: ["straw", "iron"],
      lessonID: 1,
      question: "What metal was used to represent the fourth kingdom?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the fourth kingdom shall be as strong as iron, inasmuch as iron breaks in pieces and shatters everything; and like iron that crushes, that kingdom will break in pieces and crush all the others.",
          ref: "Daniel 2:40",
        },
      ],
    },
    "1-12": {
      blanks: [
        {
          correctAnswer: "divided",
          textAfter: " . . . so the kingdom shall be partly",
          textBefore:
            "Whereas you saw the feet and toes, partly of potter’s clay and partly of iron, the kingdom shall be",
        },
        {
          correctAnswer: "strong",
          textAfter: " and partly",
        },
        {
          correctAnswer: "fragile",
          textAfter: " .",
        },
      ],
      body: "Instead of being conquered by another world-ruling empire, Rome would\nbe divided into numerous kingdoms symbolized by the toes on the image in Nebuchadnezzar’s dream. By AD 476, barbarian tribes had conquered Rome, and 10 of these tribes developed into what eventually became modern Europe.",
      choices: ["fragile", "small", "divided", "unified", "weak", "strong"],
      lessonID: 1,
      question:
        "How was the breakup of the Roman Empire described in this prophecy?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "41 Whereas you saw the feet and toes, partly of potter’s clay and partly of iron, the kingdom shall be divided; yet the strength of the iron shall be in it, just as you saw the iron mixed with ceramic clay.\n\n42 And as the toes of the feet were partly of iron and partly of clay, so the kingdom shall be partly strong and partly fragile.",
          ref: "Daniel 2:41, 42",
        },
      ],
    },
    "1-13": {
      blanks: [
        {
          choices: ["mingle", "combine", "adhere", "cling", "stick"],
          correctAnswer: "mingle",
          textAfter: " with the seed of men; but they will not",
          textBefore: "As you saw iron mixed with ceramic clay, they will",
        },
        {
          choices: ["mingle", "combine", "adhere", "cling", "stick"],
          correctAnswer: "adhere",
          textAfter: " to one another, just as iron does not mix with clay.",
        },
      ],
      body: "In spite of multiple attempts by many different leaders, the Roman Empire has never been re-formed and never will be—just as the Bible predicted.  Charlemagne, Napoleon, Kaiser Wilhelm II and Hitler all attempted to unite Europe, but all failed to do so.  Even the European Union (EU) cannot succeed in reuniting Europe.  During World War II, certain British preachers drew large crowds by claiming the Bible taught that Hitler could not possibly be successful in bringing Europe under one banner.  Relying on the prophecy of Daniel 2, the preachers were 100 percent right!",
      choices: ["mingle", "combine", "adhere", "cling", "stick"],
      lessonID: 1,
      question: "Could a secular Roman Empire ever exist again?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "As you saw iron mixed with ceramic clay, they will mingle with the seed of men; but they will not adhere to one another, just as iron does not mix with clay.",
          ref: "Daniel 2:43",
        },
      ],
    },
    "1-14": {
      blanks: [
        {
          choices: ["King", "man", "horse", "table", "God", "people"],
          correctAnswer: "God",
          textAfter: " of heaven will setup a kingdom which shall ",
          textBefore: "And in the days of these kings the ",
        },
        {
          choices: ["sometimes", "always", "occasionally", "never"],
          correctAnswer: "never",
          textAfter: " be destroyed.",
        },
      ],
      body: "Daniel spoke of a 'stone...cut out without hands' that struck and destroyed the image in Nebuchadnezzar's dream, and grew until it became a great kingdom that would fill 'the whole earth' (Daniel 2:34, 35).    The stone that struck and destroyed the image represents Jesus, who will ultimately sweep away the kingdoms of the earth at His return. A stone or rock is a symbol often used in association with Jesus (Psalm 89:26, Matthew 16:18).      Jesus was represented by the smitten rock from which flowed water for all of Israel, the rock in which Moses hid himself, and the rock upon which the wise man built his house (Exodus 17:6, Exodus 33:22, and Matthew 7:24).     In addition,  1 Corinthians 10:4 says, 'For they drank of that spiritual Rock that followed them, and that Rock was Christ.'    The Bible predicts that it will be Jesus—not China, the United States or Israel—who will set up His kingdom and ultimately rule the world.  There will be a fifth world empire—an empire ruled by the King of kings, whose kingdom of peace will last forever!",
      choices: ["King", "man", "horse", "table", "God", "people", "never"],
      lessonID: 1,
      question: "Who will set up history's final kingdom?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "And in the days of these kings the God of heaven will set up a kingdom which shall never be destroyed; and the kingdom shall not be left to other people; it shall break in pieces and consume all these kingdoms, and it shall stand forever.",
          ref: "Daniel 2:44",
        },
      ],
    },
    "1-15": {
      Supplements: {
        "-L7fhWGlPA1-AfVuKxQ0": {
          body: "In ancient times, persecution of believers in the God of heaven was not uncommon.  The war-torn environment in which much of Bible history took place was filled with dispute and violence, perpetrated not only by unbelievers but also by God’s own people.\n\nOne of the most well-known stories in the Bible - the story of David and Goliath - took place against a backdrop of warfare and aggression as the Philistines threatened the existence of Israel.  Jesus Himself was murdered by people who could not tolerate His religious views.\n\nIn numerous countries today, Christians are being persecuted.  Many people live in constant fear of losing their life due to the persecution they suffer.  Many are tortured, others are imprisoned, discriminated against or punished in other ways.\n\nPlease pray for the many Christians who are suffering persecution for their faith.",
          title: "Are Christians being persecuted today?",
        },
      },
      blanks: [
        {
          choices: [
            "break",
            "mountain",
            "destroy",
            "stand",
            "consume",
            "strong",
            "people",
          ],
          correctAnswer: "break",
          textAfter: " in pieces and",
          textBefore: "It shall",
        },
        {
          choices: [
            "break",
            "mountain",
            "destroy",
            "stand",
            "consume",
            "strong",
            "people",
          ],
          correctAnswer: "consume",
          textAfter: " all these kingdoms.",
        },
      ],
      body: "The stone strikes the statue at its feet, indicating that Jesus will come during the time of the divided nations. The kingdoms of this world will be destroyed. Just as all the previous aspects of the prophecy have been perfectly fulfilled, so it will be that Jesus will soon return and establish His eternal kingdom.",
      choices: [
        "break",
        "mountain",
        "destroy",
        "stand",
        "consume",
        "strong",
        "people",
      ],
      lessonID: 1,
      question:
        "What will happen to earthly kingdoms when God sets up His kingdom?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "And in the days of these kings the God of heaven will set up a kingdom which shall never be destroyed; and the kingdom shall not be left to other people; it shall break in pieces and consume all these kingdoms, and it shall stand forever.",
          ref: "Daniel 2:44",
        },
      ],
    },
    "1-16": {
      Supplements: {
        "-L7fhEK17_Vh9Gl1YfF-": {
          body: "The second of the ten commandments says, “You shall not make for yourself a carved image—any likeness of anything that is in heaven above, or that is in the earth beneath, or that is in the water under the earth; you shall not bow down to them nor serve them.”  (Exodus 20:4,5)\n\nIdolatry is the worship of an idol, image, statue or icon.  While idolatry can take on many forms - a person can make an idol of a person, a sports team or a favorite possession - the idolatry prevalent in the Bible is the worship of images.\n\nWorship of idols dramatically lowers a person’s understanding of the true God, while degrading the person involved in the idolatrous practice.  \n\nPsalm 115:4-8 helps us understand the futility of worshipping idols.\n\nTheir idols are silver and gold,\nThe work of men’s hands.\nThey have mouths, but they do not speak;\nEyes they have, but they do not see;\nThey have ears, but they do not hear;\nNoses they have, but they do not smell;\nThey have hands, but they do not handle;\nFeet they have, but they do not walk;\nNor do they mutter through their throat.\n\t\nThose who make them are like them;\nSo is everyone who trusts in them.\n",
          title: "What is idolatry?",
        },
      },
      blanks: [
        {
          choices: ["idol", "God", "revealer", "deviner", "Lord"],
          correctAnswer: "God",
          textAfter: " of gods, the",
          textBefore: "Truly your God is the",
        },
        {
          choices: ["idol", "God", "revealer", "deviner", "Lord"],
          correctAnswer: "Lord",
          textAfter: " of kings, and a",
        },
        {
          choices: ["idol", "God", "revealer", "deviner", "Lord"],
          correctAnswer: "revealer",
          textAfter: " of secrets.",
        },
      ],
      body: "When Nebuchadnezzar saw that Daniel’s God could remember the forgotten, foretell the future, and overrule any earthly kingdom, he knew that this was the true God. This was a God who not only created secrets, but revealed them!",
      choices: ["idol", "God", "revealer", "deviner", "Lord"],
      lessonID: 1,
      question:
        "What did Nebuchadnezzar say about Daniel’s God when he realized that Daniel could reveal the meaning of his dream?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "The king answered Daniel, and said, “Truly your God is the God of gods, the Lord of kings, and a revealer of secrets, since you could reveal this secret.”",
          ref: "Daniel 2:47",
        },
      ],
    },
    "1-17": {
      correctAnswer: "true",
      question:
        "The Bible demonstrates that God can be trusted.  Are you willing to tell God you trust Him, and that you would like to know more about Him and His plan for your life?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "1-2": {
      Supplements: {
        "-L7ffXrexIv7yLixZMK_": {
          body: "King Nebuchadnezzar II was one of the most significant personalities in the Old Testament.  The most powerful king of ancient Babylon, his armies attacked and destroyed Jerusalem in 605 BC, at which time Daniel, Hananiah, Mishael and Azariah (better known as Shadrach, Meschach and Abednego) and others were captured and taken as slaves to Babylon.\n\nNebuchadnezzar is mentioned by name 90 times in the Bible, sometimes as “Nubuchadrezzar.”  He was a pagan who worshipped many gods including the sun, and was a ruthless leader who conquered not only Israel but Egypt, Assyria and others.  It is said Nebuchadnezzar built the fabled Hanging Gardens of Babylon for his wife, Amytis of Media.\n\nNebuchadnezzar commanded that the wise men who could not interpret his dream be executed (see Daniel 2).  His dream was interpreted by Daniel, leading ultimately to Nebuchadnezzar’s conversion.  It was Nebuchadnezzar who commanded a golden image be worshiped on the plane of Dura (Daniel 3:5).  For seven years he suffered from insanity (Daniel 4:16,33), but emerged from this episode convinced in the power and majesty of Daniel’s God, the God of heaven (Daniel 4:34-37).  \n\nHis grandson, Belshazzar was the ruler of Babylon when Babylon fell to the Medes and Persians (see Daniel 5.)  \n\nThis Biblical history of Nebuchadnezzar demonstrates that God desires that even the most unlikely people come to know Him as the Sovereign of the universe.  If God could reach the heart of the hardened Babylonian king, there is no doubt he can touch and change the heart of anyone who looks to Him in faith!",
          title: "Who was Nebuchadnezzar?",
        },
      },
      blanks: [
        {
          choices: ["stress", "a fit of rage", "dreams", "an idea"],
          correctAnswer: "dreams",
          textAfter:
            " ; and his spirit was so troubled that his sleep left him.",
          textBefore:
            "Now in the second year of Nebuchadnezzar’s reign, Nebuchadnezzar had",
        },
      ],
      body: "The Babylonian king Nebuchadnezzar had a dream that troubled him. As he lay awake at night, he knew he had dreamed something of great importance, but he couldn’t remember the details of the dream and didn’t know what it meant.",
      buttons: {
        "-Kst06-ngk5sOeTSgLdI": {
          body: "King Nebuchadnezzar II was one of the most significant personalities in the Old Testament.  The most powerful king of ancient Babylon, his armies attacked and destroyed Jerusalem in 605 BC, at which time Daniel, Hananiah, Mishael and Azariah (better known as Shadrach, Meschach and Abednego) were captured and taken as slaves to Babylon.  Nebuchadnezzar is mentioned by name 90 times in the Bible, sometimes as “Nubuchadrezzar.”  He was a pagan who worshipped many gods, including the sun, and was a ruthless leader who conquered not only Israel but Egypt, Assyria and others.  It is said Nebuchadnezzar built the fabled Hanging Gardens of Babylon for his wife, Amytis of Media.  Nebuchadnezzar commanded that the wise men who could not interpret his dream be executed (see Daniel 2).  His dream was interpreted by Daniel, leading ultimately to Nebuchadnezzar’s conversion.  It was Nebuchadnezzar who commanded a golden image image be worshiped on the plane of Dura (Daniel 3:5).  For seven years he suffered from insanity (Daniel 4:16,33), but emerged from his episode convinced in the power and majesty of Daniel’s God, the God of heaven (Daniel 4:34-37).    His grandson, Belshazzar was the ruler of Babylon when Babylon fell to the Medes and Persians (see Daniel 5.)    This Biblical history of Nebuchadnezzar demonstrates that God desires that even the most unlikely people come to know Him as the Sovereign of the universe.  If God could reach the heart of the hardened Babylonian king, there is no doubt he can touch and change the heart of anyone who looks to Him in faith!",
          content: "",
          icon: "help",
        },
      },
      choices: ["stress", "a fit of rage", "dreams", "an idea"],
      lessonID: 1,
      question:
        "In the story of King Nebuchadnezzar, how did God reveal His trustworthiness?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "Now in the second year of Nebuchadnezzar’s reign, Nebuchadnezzar had dreams; and his spirit was so troubled that his sleep left him.",
          ref: "Daniel 2:1",
        },
      ],
    },
    "1-3": {
      Supplements: {
        "-L7ffqoY7IN5CZeno3rr": {
          body: "The dream of King Nebuchadnezzar is one of the most influential and important communications ever given by God to humanity.\n\nNebuchadnezzar was the most powerful ruler on the planet when his sleep was disturbed by a startling dream.  Unable to recall the dream and therefore unable to know what it meant, Nebuchadnezzar was troubled.  Ancient rulers such as Nebuchadnezzar believed the gods communicated with them via dreams, so it was important to him that he understood the message he felt was intended for him.\n\nWhen the king’s inner circle of counsellors was unable to interpret the dream, Nebuchadnezzar commanded they be executed as they were evidently incapable of doing the work for which they were employed.  Daniel and his three friends - Hananiah, Mishael and Azariah - prayed God would give them understanding concerning the dream.  The interpretation given Daniel by God not only solved Nebuchadnezzar’s quandary, but it also provides the foundation for the major apocalyptic prophecies in the books of Daniel and Revelation.\n\nWhen God spoke to Daniel 600 or so years before the birth of Jesus, He was also speaking to us today!\n\n“You, O king, were watching; and behold, a great image! This great image, whose splendor was excellent, stood before you; and its form was awesome.  This image’s head was of fine gold, its chest and arms of silver, its belly and thighs of bronze, its legs of iron, its feet partly of iron and partly of clay.  You watched while a stone was cut out without hands, which struck the image on its feet of iron and clay, and broke them in pieces.  Then the iron, the clay, the bronze, the silver, and the gold were crushed together, and became like chaff from the summer threshing floors; the wind carried them away so that no trace of them was found. And the stone that struck the image became a great mountain and filled the whole earth.”  Daniel 2:31-35.",
          title: "What was the dream of King Nebuchadnezzar?",
        },
      },
      blanks: [
        {
          choices: ["only", "not", "time", "earth", "kill", "destroy", "place"],
          correctAnswer: "not",
          textAfter: " a man on",
          textBefore: "The Chaldeans answered the king, and said, “There is",
        },
        {
          choices: ["only", "not", "time", "earth", "kill", "destroy", "place"],
          correctAnswer: "earth",
          newline: [1],
          textAfter: " who can tell the king’s matter.”",
        },
        {
          choices: ["only", "not", "time", "earth", "kill", "destroy", "place"],
          correctAnswer: "destroy",
          textAfter: " all the wise men of Babylon.",
          textBefore:
            "\n\nFor this reason the king was angry and very furious, and gave the command to",
        },
      ],
      body: "This death sentence had serious implications for Daniel and his friends: Shadrach, Meshach and Abednego (also known as Hananiah, Mishael and Azariah). Although they were faithful followers of God, they were included in Nebuchadnezzar’s inner circle of wise men. The death sentence given to the wise men meant that Daniel and his friends would also die.",
      choices: ["only", "not", "time", "earth", "kill", "destroy", "place"],
      lessonID: 1,
      question:
        "What was Nebuchadnezzar’s reaction when his counselors could not interpret his dream?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "The Chaldeans answered the king, and said, “There is not a man on earth who can tell the king’s matter; therefore no king, lord, or ruler has ever asked such things of any magician, astrologer, or Chaldean.",
          ref: "Daniel 2:10",
        },
        {
          body: "For this reason the king was angry and very furious, and gave the command to destroy all the wise men of Babylon.",
          ref: "Daniel 2:12",
        },
      ],
    },
    "1-4": {
      Supplements: {
        "-L7fgk_StONFagdi9b4c": {
          body: "You can be certain God hears your prayers.  And God has promised you that your prayers will be answered!\n\nConsider the following Bible verses.\n\nMatthew 7:7,8.  “Ask, and it will be given to you; seek, and you will find; knock, and it will be opened to you.  For everyone who asks receives, and he who seeks finds, and to him who knocks it will be opened.”\n\n1 John 5:14,15.  “Now this is the confidence that we have in Him, that if we ask anything according to His will, He hears us.  And if we know that He hears us, whatever we ask, we know that we have the petitions that we have asked of Him.”\n\nMark 11:24.  “Therefore I say to you, whatever things you ask when you pray, believe that you receive them, and you will have them.”\n\nIsaiah 65:24.  “It shall come to pass that before they call, I will answer; and while they are still speaking, I will hear.”\n\nIt should be remembered that we must pray according to the will of God.  There are some things we might pray for that God knows would not be in our best interests to receive.  Or it might be that the timing is not right and God knows it would be better to wait before He grants the answer to our prayer.\n\nGod wants to bless you.  “As a father pities his children, so the Lord pities those who fear Him.” (Psalm 103:13)\n\nHowever, you can always be certain that in answer to your prayer God will forgive your sins, grant the gift of the Holy Spirit and provide a way of escape from temptation.",
          title: "Can you be sure your prayers will be answered?",
        },
      },
      blanks: [
        {
          choices: [
            "words",
            "mercies",
            "matter",
            "secret",
            "day dream",
            "night vision",
            "night mare",
          ],
          correctAnswer: "mercies",
          textAfter: " from the God of heaven concerning this",
          textBefore:
            "Then Daniel went to his house, and made the decision known to Hananiah, Mishael, and Azariah, his companions, that they might seek\n",
        },
        {
          choices: [
            "words",
            "mercies",
            "matter",
            "secret",
            "day dream",
            "night vision",
            "night mare",
          ],
          correctAnswer: "secret",
          newline: [1, 1],
          textAfter: " .",
        },
        {
          choices: [
            "words",
            "mercies",
            "matter",
            "secret",
            "day dream",
            "night vision",
            "night mare",
          ],
          correctAnswer: "vision",
          textAfter: " .",
          textBefore: "\n\nThen the secret was revealed to Daniel in a night",
        },
      ],
      body: "Having been given permission by the king to take time to consider the king’s dream, Daniel and his friends prayed that God would reveal the dream to them. And God did! Remember: God answers prayer!",
      choices: [
        "words",
        "mercies",
        "matter",
        "secret",
        "dream",
        "vision",
        "mare",
      ],
      lessonID: 1,
      question: "What did Daniel do?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "17 Then Daniel went to his house, and made the decision known to Hananiah, Mishael, and Azariah, his companions,\n\n18 that they might seek mercies from the God of heaven concerning this secret, so that Daniel and his companions might not perish with the rest of the wise men of Babylon.",
          ref: "Daniel 2:17, 18",
        },
        {
          body: "Then the secret was revealed to Daniel in a night vision. So Daniel blessed the God of heaven.",
          ref: "Daniel 2:19",
        },
      ],
    },
    "1-5": {
      blanks: [
        {
          choices: ["picture", "image", "dog"],
          correctAnswer: "image",
          textAfter: " !",
          textBefore: "You, O king, were watching; and behold, a great",
        },
      ],
      body: "Unsurprisingly, Nebuchadnezzar—an idol worshipper—dreamed of a large image made of various metals.",
      choices: ["picture", "image", "dog"],
      lessonID: 1,
      question: "How did Daniel describe the king’s dream?",
      questionID: 5,
      questionType: "radio",
      verses: [
        {
          body: "“You, O king, were watching; and behold, a great image! This great image, whose splendor was excellent, stood before you; and its form was awesome.",
          ref: "Daniel 2:31",
        },
      ],
    },
    "1-6": {
      blanks: [
        {
          choices: [
            "azure",
            "iron",
            "gold",
            "silver",
            "bronze",
            "iron",
            "clay",
          ],
          correctAnswer: "gold",
          textAfter: " , its chest and arms of",
          textBefore: "This image’s head was of fine",
        },
        {
          choices: [
            "azure",
            "iron",
            "gold",
            "silver",
            "bronze",
            "iron",
            "clay",
          ],
          correctAnswer: "silver",
          textAfter: " , its belly and thighs of",
        },
        {
          choices: [
            "azure",
            "iron",
            "gold",
            "silver",
            "bronze",
            "iron",
            "clay",
          ],
          correctAnswer: "bronze",
          textAfter: " , its legs of",
        },
        {
          choices: [
            "azure",
            "iron",
            "gold",
            "silver",
            "bronze",
            "iron",
            "clay",
          ],
          correctAnswer: "iron",
          textAfter: " , its feet partly of iron and partly of ",
        },
        {
          choices: [
            "azure",
            "iron",
            "gold",
            "silver",
            "bronze",
            "iron",
            "clay",
          ],
          correctAnswer: "clay",
          textAfter: ".",
        },
      ],
      choices: ["azure", "iron", "gold", "silver", "bronze", "clay"],
      lessonID: 1,
      question: "What were the elements that made up the image?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "32 This image’s head was of fine gold, its chest and arms of silver, its belly and thighs of bronze, \n\n33 its legs of iron, its feet partly of iron and partly of clay.",
          ref: "Daniel 2:32, 33",
        },
      ],
    },
    "1-7": {
      blanks: [
        {
          choices: ["filled", "hill", "feet", "struck", "mountain"],
          correctAnswer: "struck",
          textAfter: " the image on its",
          textBefore:
            "You watched while a stone was cut out without hands, which",
        },
        {
          choices: ["filled", "hill", "feet", "struck", "mountain"],
          correctAnswer: "feet",
          textAfter:
            " of iron and clay, and broke them in pieces . . . And the stone that struck the image became a great",
        },
        {
          choices: ["filled", "hill", "feet", "struck", "mountain"],
          correctAnswer: "mountain",
          textAfter: " and",
        },
        {
          choices: ["filled", "hill", "feet", "struck", "mountain"],
          correctAnswer: "filled",
          textAfter: " the whole earth.",
        },
      ],
      body: "Daniel told the king that a supernatural rock would hit the image—not on its golden head, but on its feet of iron and clay. This rock would then take the place of the image and fill the earth with its presence and power.",
      choices: ["filled", "hill", "feet", "struck", "mountain"],
      lessonID: 1,
      question: "What happened to this great image?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "34 You watched while a stone was cut out without hands, which struck the image on its feet of iron and clay, and broke them in pieces.\n\n35 Then the iron, the clay, the bronze, the silver, and the gold were crushed together, and became like chaff from the summer threshing floors; the wind carried them away so that no trace of them was found. And the stone that struck the image became a great mountain and filled the whole earth.",
          ref: "Daniel 2:34, 35",
        },
      ],
    },
    "1-8": {
      blanks: [
        {
          choices: ["Rome", "You", "Babylon"],
          correctAnswer: "You",
          textAfter: " are this head of gold.",
        },
      ],
      body: "The thought of Nebuchadnezzar’s kingdom of Babylon ever being overthrown seemed out of the question. Such was its wealth that the prophet Isaiah had previously described Babylon as “the golden city” (Isaiah 14:4). The city walls were almost 200 feet (60 meters) high, and wide enough for two chariots. The gates of the city were made from solid brass, and within the city there seemed to be limitless resources. The Euphrates River flowed through the city of Babylon, adding to its strength.",
      choices: ["Rome", "You", "Babylon"],
      lessonID: 1,
      question: "What does the head of gold represent?",
      questionID: 8,
      questionType: "radio",
      verses: [
        {
          body: "And wherever the children of men dwell, or the beasts of the field and the birds of the heaven, He has given them into your hand, and has made you ruler over them all—you are this head of gold.",
          ref: "Daniel 2:38",
        },
      ],
    },
    "1-9": {
      blanks: [
        {
          choices: ["after you", "before you", "despite you"],
          correctAnswer: "after you",
          textAfter: " shall arise another kingdom inferior to yours.",
          textBefore: "But",
        },
      ],
      body: "Remarkably, Daniel predicted that mighty Babylon would be overthrown—by an inferior kingdom! In Isaiah 13:19, 20, God had said Babylon would be overthrown, and that it would never again be inhabited.\n\nNebuchadnezzar’s kingdom ruled the world from 605 to 539 BC. It was the combined force of the Medes and Persians—the kingdom represented by the chest and arms of silver—that overthrew Babylon in the most amazing circumstances (Read about the fall of Babylon in Daniel chapter 5). More than 150 years prior to the fall of Babylon, the prophet Isaiah predicted that a man named Cyrus would overthrow the city (Isaiah 45:1, 2). And what God predicted years  before happened exactly as He said it would!",
      choices: ["after you", "before you", "despite you"],
      lessonID: 1,
      question: "What did Daniel predict would happen to Babylon?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "But after you shall arise another kingdom inferior to yours; then another, a third kingdom of bronze, which shall rule over all the earth.",
          ref: "Daniel 2:39",
        },
      ],
    },
  },
  {
    "2-0": {
      body: "Early on the morning of December 7, 1941, two United States servicemen reported for duty at a mobile radar unit on the island of Oahu in Hawaii. They were to scan the skies for anything that seemed to be out of the\nordinary. At 7:02 a.m., the radar screen revealed that a squadron of at least 50 planes was heading toward Oahu.\n\nSharing their concern with their superiors, they were assured they had no reason to worry. But less than an hour later, bombs were falling on Pearl Harbor, and more than 2,400 military personnel were dead—1,177 of whom died when the battleship USS Arizona sank.\n\nFor 51 minutes  before the attack commenced, there was clear evidence that an attack was about to take place. Yet that clear evidence was missed—or ignored— and disaster was the result.\n\nThe Bible contains clear evidence that the end of the world is near and that Jesus is soon to return. These unmistakable signs are signs you do not want to miss!",
      lessonID: 2,
      questionID: 0,
      type: "text",
    },
    "2-1": {
      blanks: [
        {
          correctAnswer: "your",
          textAfter: " ",
          textBefore:
            "Tell us, when will these things be? And what will be the sign of",
        },
        {
          correctAnswer: "coming",
          textAfter: " , and of the end of the age?",
          textBefore: "",
        },
      ],
      body: "The disciples correctly saw the Second Coming of Jesus and the end of the world (or age) as virtually the same event. They asked Jesus to tell them about the signs—or signals—that would indicate when this event would be near.",
      choices: ["his", "your", "my", "coming", "departure", "arrival"],
      lessonID: 2,
      question:
        "The signs Jesus shared with His disciples were signs of what great event?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "Now as He sat on the Mount of Olives, the disciples came to Him privately, saying, “Tell us, when will these things be? And what will be the sign of Your coming, and of the end of the age?”",
          ref: "Matthew 24:3",
        },
      ],
    },
    "2-10": {
      blanks: [
        {
          correctAnswer: "scoffers",
          textAfter:
            ' will come in the last days, walking according to their own lusts, and saying, "Where is the promise of His',
          textBefore: "Knowing this first: that",
        },
        {
          correctAnswer: "coming",
          textAfter: ' ?"',
        },
      ],
      body: "Although Jesus promised us He would return (John 14:1–3), many people do not take the Second Coming of Christ seriously. Organized atheism and opposition to established Christian beliefs—including the prevalence of evolutionary theory—suggest we are living in earth’s last days.",
      choices: ["scoffers", "haters", "false prophets", "coming"],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 10,
      questionIDTitle: "5f",
      questionType: "wordCloud",
      subQuestion: "People will ridicule the message of the Second Coming",
      verses: [
        {
          body: "3 knowing this first: that scoffers will come in the last days, walking according to their own lusts, \n\n4 and saying, “Where is the promise of His coming? For since the fathers fell asleep, all things continue as they were from the beginning of creation.",
          ref: "2 Peter 3:3, 4",
        },
      ],
    },
    "2-11": {
      blanks: [
        {
          correctAnswer: "signs",
          textAfter: " and",
          textBefore:
            "For false christs and false prophets will rise and show great",
        },
        {
          correctAnswer: "wonders",
          textAfter: " to deceive, if possible, even the elect.",
        },
      ],
      body: "Four times in Matthew 24, Jesus warns against religious deception. The Apostle John also wrote regarding false religion: “Beloved, do not believe every spirit, but test the spirits, whether they are of God; because many false prophets have gone out into the world” (1 John 4:1).  The Bible gives us a means by which we can evaluate the validity of a message or messenger: “To the law and to the testimony! If they do not speak according to this word, it is because there is no light in them” (Isaiah 8:20). In a world rife with religious confusion, the standard of truth is the Word of God.",
      choices: ["tricks", "magic", "power", "cunning", "signs", "wonders"],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 11,
      questionIDTitle: "5g",
      questionType: "wordCloud",
      subQuestion:
        "Deception through false miracles, false prophets and false christs:",
      verses: [
        {
          body: "For false christs and false prophets will rise and show great signs and wonders to deceive, if possible, even the elect.",
          ref: "Matthew 24:24",
        },
      ],
    },
    "2-12": {
      blanks: [
        {
          correctAnswer: "performs",
          textAfter:
            "great signs , so that he even makes fire come down from heaven on the earth in the sight of men. And he",
          textBefore: "He ",
        },
        {
          correctAnswer: "deceives",
          textAfter: " those who dwell on the earth by those",
        },
        {
          correctAnswer: "signs",
          newline: [1, 1],
          textAfter: " which he was granted to do.",
        },
        {
          correctAnswer: "demons",
          textAfter: " , performing signs, which go out to the ",
          textBefore: " For they are spirits of",
        },
        {
          correctAnswer: "kings",
          textAfter:
            " of the earth and of the whole world, to gather them to the battle of that great day of God Almighty.",
        },
      ],
      body: "Evil spirits will deceive people through signs and wonders. Spiritualism—mediums, witches and communication with the dead—is now viewed as mainstream.",
      choices: [
        "signs",
        "deceives",
        "performs",
        "demons",
        "images",
        "miracles",
        "shows",
        "things",
        "forest",
        "deeds",
        "kings",
      ],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 12,
      questionIDTitle: "5h",
      questionType: "wordCloud",
      subQuestion: "Rampant spiritualism:",
      verses: [
        {
          body: "13 He performs great signs, so that he even makes fire come down from heaven on the earth in the sight of men.\n\n14 And he deceives those who dwell on the earth by those signs which he was granted to do in the sight of the beast, telling those who dwell on the earth to make an image to the beast who was wounded by the sword and lived.",
          ref: "Revelation 13:13,14",
        },
        {
          body: "For they are spirits of demons, performing signs, which go out to the kings of the earth and of the whole world, to gather them to the battle of that great day of God Almighty.",
          ref: "Revelation 16:14",
        },
      ],
    },
    "2-13": {
      blanks: [
        {
          correctAnswer: "form",
          textAfter: " of godliness but denying its ",
          textBefore:
            "But know this, that in the last days perilous times will come: For men will be lovers of themselves . . . having a ",
        },
        {
          correctAnswer: "power",
          textAfter: " .",
        },
      ],
      body: "Paul predicted that in earth’s last days, much of what passes for faith in God will be faith in name only. A “form” of godliness will often not be accompanied by real spiritual power.",
      choices: ["appearance", "form", "look", "spark", "energy", "power"],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 13,
      questionIDTitle: "5i",
      questionType: "wordCloud",
      subQuestion: "Decline of genuine faith in God",
      verses: [
        {
          body: "1 But know this, that in the last days perilous times will come:\n\n2 For men will be lovers of themselves, lovers of money, boasters, proud, blasphemers, disobedient to parents, unthankful, unholy,\n\n5 having a form of godliness but denying its power. And from such people turn away!",
          ref: "2 Timothy 3:1, 2, 5",
        },
      ],
    },
    "2-14": {
      blanks: [
        {
          correctAnswer: "all",
          textAfter:
            " the world as a witness to all the nations, and then the end will come.",
          textBefore: "And this gospel of the kingdom will be preached in",
        },
      ],
      body: "A hopeful sign of Jesus’ return is that the gospel (the “good news” of salvation through Jesus) will be proclaimed around the world. This hopeful prophecy is in the process of being fulfilled!",
      choices: ["all", "most of", "some"],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 14,
      questionIDTitle: "5j",
      questionType: "radio",
      subQuestion: "The gospel preached all over the world",
      verses: [
        {
          body: "And this gospel of the kingdom will be preached in all the world as a witness to all the nations, and then the end will come.",
          ref: "Matthew 24:14",
        },
      ],
    },
    "2-15": {
      blanks: [
        {
          correctAnswer: "expect",
          textAfter: " .",
          textBefore:
            "Therefore you also be ready, for the Son of Man is coming at an hour you do not",
        },
      ],
      body: "Even though we don’t know exactly when Jesus will return, Jesus urged us to live in a state of constant readiness, in order to be prepared for the day He comes back to the earth.",
      choices: ["understand", "expect", "believe"],
      lessonID: 2,
      question: "What warning did Jesus give regarding the Second Coming?",
      questionID: 15,
      questionIDTitle: "6",
      questionType: "radio",
      verses: [
        {
          body: "Therefore you also be ready, for the Son of Man is coming at an hour you do not expect.",
          ref: "Matthew 24:44",
        },
      ],
    },
    "2-16": {
      blanks: [
        {
          correctAnswer: "hears",
          textAfter: " my voice and",
          textBefore: "Behold, I stand at the door and knock. If anyone",
        },
        {
          correctAnswer: "opens",
          textAfter:
            " the door, I will come in to him and dine with him, and he with Me.",
        },
      ],
      body: "First, listen constantly to hear Jesus knocking at the door of your heart, asking if He can enter your life. Second, open the door and ask Jesus to come in. Have you accepted Jesus as your personal Savior and asked Him to become an important part of your life?",
      choices: ["ignores", "closes", "hears", "opens", "heeds", "closes"],
      lessonID: 2,
      question: "How can we be ready for Jesus to come?",
      questionID: 16,
      questionIDTitle: "7",
      questionType: "wordCloud",
      verses: [
        {
          body: "Behold, I stand at the door and knock. If anyone hears My voice and opens the door, I will come in to him and dine with him, and he with Me.",
          ref: "Revelation 3:20",
        },
      ],
    },
    "2-17": {
      blanks: [
        {
          choices: ["watch", "pray", "find", "behold", "lie down", "rest"],
          correctAnswer: "watch",
          textAfter: " and",
          textBefore: "Take heed,",
        },
        {
          choices: ["watch", "pray", "find", "behold", "lie down", "rest"],
          correctAnswer: "pray",
          textAfter: " ; for you do not know when the time is.",
        },
      ],
      body: "While the signs of the times reveal that the return of Jesus is near, it is important to recognize that an understanding of the nearness of Jesus’ coming is of little use without a personal readiness for His coming! Along with “watching,” Jesus urged us to “pray”—to have our hearts open to God and to communicate frequently with Him. Personal spiritual growth should be the aim of every believer in Jesus. A vibrant devotional life—including daily prayer and Bible reading, and sharing one’s faith with others—is vital for those who desire to honor God and intend to live forever!",
      choices: ["watch", "pray", "find", "behold", "lie down", "rest"],
      lessonID: 2,
      question:
        "How should a person live in preparation for the return of Jesus?",
      questionID: 17,
      questionIDTitle: "8",
      questionType: "wordCloud",
      verses: [
        {
          body: "Take heed, watch and pray; for you do not know when the time is.\n",
          ref: "Mark 13:33",
        },
      ],
    },
    "2-18": {
      correctAnswer: "true",
      lessonID: 2,
      question:
        "Is it your desire to prepare now to be ready for the Second Coming of Jesus?  Will you ask Jesus now to be your personal Savior and trust Him to guide and direct your life?",
      questionID: 18,
      questionType: "truthConfirmation",
    },
    "2-2": {
      Supplements: {
        "-L7fcvb3fOLZDiqyp3dY": {
          body: "Luke 12:40 admonishes us, “Therefore you also be ready, for the Son of Man is coming at an hour you do not expect.” In Mark 13:32, Jesus says, “But of that day and hour no one knows, not even the angels in heaven, nor the Son, but only the Father.”\n\nJust because people seem sincere and are enthusiastic about their beliefs doesn’t mean they are right. It is best to follow the counsel of Isaiah 8:20, which says, “To the law and to the testimony! If they do not speak according to this word, it is because there is no light in them.”\nJesus is coming back. Of that we can be sure (John 14:1-3).   When will that happen?  Soon.\n",
          title:
            "I’ve seen some groups set dates for Christ’s return and they seem so sure of the event. How can I avoid being led astray by false predictions?",
        },
      },
      blanks: [
        {
          choices: ["true", "false"],
          correctAnswer: "no one",
          correctAnswerOld: "no one",
          textAfter:
            " knows, not even the angels of heaven, but My Father only.",
          textBefore: "But of that day and hour",
        },
      ],
      body: "Jesus said that no one knows the date of His return except for God. Predicting dates not only results in disappointment and discouragement, but it also encourages people to disbelieve and ridicule the Bible.",
      choices: ["true", "false"],
      correctAnswer: "false",
      lessonID: 2,
      question: "Does anyone know the exact date of Jesus’ return?",
      questionID: 2,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "According to the verse, we know the exact Day of Jesus' return",
      verses: [
        {
          body: "But of that day and hour no one knows, not even the angels of heaven, but My Father only.\n",
          ref: "Matthew 24:36",
        },
      ],
    },
    "2-3": {
      blanks: [
        {
          choices: ["not", "moment", "doors", "near", "amazing", "core"],
          correctAnswer: "near",
          textAfter: " -at the",
          textBefore:
            "Now learn this parable from the fig tree: When its branch has already become tender and puts forth leaves, you know that summer is near. So you also, when you see all these things, know that it is",
        },
        {
          choices: ["not", "moment", "doors", "near", "amazing", "core"],
          correctAnswer: "doors",
          textAfter: " !",
        },
      ],
      body: "Although Jesus warned us against setting dates for His return, He did tell us to investigate Bible prophecies and world events in order to see when His coming is near. Just as there were many prophecies regarding the first coming of Jesus, there are also clear prophecies relating to His return.",
      choices: ["not", "moment", "doors", "near", "amazing", "core"],
      lessonID: 2,
      question: "Can we know when the return of Jesus is near?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "32 Now learn this parable from the fig tree: When its branch has already become tender and puts forth leaves, you know that summer is near.\n\n33 So you also, when you see all these things, know that it is near—at the doors!",
          ref: "Matthew 24:32, 33",
        },
      ],
    },
    "2-4": {
      blanks: [
        {
          choices: ["patience", "love", "sorrows"],
          correctAnswer: "sorrows",
          textAfter: " .",
          textBefore: "All these are the beginning of",
        },
      ],
      body: "After outlining a number of prophetic signs, Jesus called them the “beginning of sorrows.” The word “sorrows” comes from the Greek word odin, which  literally means “birth pains.” Jesus used the illustration of childbirth as an example to describe the signs of His return. Just as birth contractions increase in frequency and intensity as a mother gets closer to the birth of her child, so the signs of Christ’s return become more frequent and intense as we near the end of time.",
      choices: ["patience", "love", "sorrows"],
      lessonID: 2,
      question:
        "What illustration does Jesus use when describing the signs of the Second Coming?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "All these are the beginning of sorrows.",
          ref: "Matthew 24:8",
        },
      ],
    },
    "2-5": {
      blanks: [
        {
          choices: ["wars", "against", "betrayal", "with", "kings", "upon"],
          correctAnswer: "wars",
          textAfter: " and rumors of wars . . . For nation will rise",
          textBefore: "And you will hear of",
        },
        {
          choices: ["wars", "against", "betrayal", "with", "kings", "upon"],
          correctAnswer: "against",
          textAfter: " nation, and kingdom against kingdom.",
        },
      ],
      body: "Jesus pointed to international warfare as one of the signs of earth’s last days. In the 20th century, there were two global wars, with multiple other conficts claiming millions of lives. War and terrorism continue to destabilize planet Earth and cause massive destruction and death.",
      choices: ["wars", "against", "betrayal", "with", "kings", "upon"],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 5,
      questionIDTitle: "5a",
      questionType: "wordCloud",
      verses: [
        {
          body: "6 And you will hear of wars and rumors of wars. See that you are not troubled; for all these things must come to pass, but the end is not yet.\n\n7 For nation will rise against nation, and kingdom against kingdom. And there will be famines, pestilences, and earthquakes in various places.",
          ref: "Matthew 24:6, 7",
        },
      ],
    },
    "2-6": {
      blanks: [
        {
          choices: [
            "hatred",
            "killing",
            "death",
            "famines",
            "pestilences",
            "earthquakes",
            "racism",
            "fear",
            "pain",
          ],
          correctAnswer: "famines",
          textAfter: " ,",
          textBefore: "And there will be",
        },
        {
          choices: [
            "hatred",
            "killing",
            "death",
            "famines",
            "pestilences",
            "earthquakes",
            "racism",
            "fear",
            "pain",
          ],
          correctAnswer: "pestilences",
          textAfter: " , and",
        },
        {
          choices: [
            "hatred",
            "killing",
            "death",
            "famines",
            "pestilences",
            "earthquakes",
            "racism",
            "fear",
            "pain",
          ],
          correctAnswer: "earthquakes",
          textAfter: " in various places.",
        },
      ],
      body: "Each year, there are approximately 500,000 detectable earthquakes, and several of these cause enormous damage and claim many lives. As populations increase, the potential for massive loss of life increases.  An increase in earthquakes (and at times, related tsunamis) is another sign that Jesus is coming back soon. Additionally, 1 billion people do not get enough food daily, and 500 million are chronically malnourished. It is said that population increase and a lack of fresh water will cause immense problems in the world in the near future. Pestilence—or disease—is also a sign of the end. A growing number of unusual diseases are threatening an increasing number of people around the world.",
      choices: [
        "hatred",
        "killing",
        "death",
        "famines",
        "pestilences",
        "earthquakes",
        "racism",
        "fear",
        "pain",
      ],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 6,
      questionIDTitle: "5b",
      questionType: "wordCloud",
      subQuestion: "Signs in the physical world:",
      verses: [
        {
          body: "For nation will rise against nation, and kingdom against kingdom. And there will be famines, pestilences, and earthquakes in various places.",
          ref: "Matthew 24:7",
        },
      ],
    },
    "2-7": {
      blanks: [
        {
          choices: ["influence", "power", "knowledge", "fear"],
          correctAnswer: "knowledge",
          textAfter: " shall increase.",
          textBefore:
            "But you, Daniel, shut up the words, and seal the book until the time of the end; many shall run to and fro, and",
        },
      ],
      body: "While Daniel was likely also referring to an increase in spiritual knowledge in earth’s last days, the dramatic increase in secular knowledge and technology is also a sign that we are in earth’s final days. Recent technological changes have been so rapid that we have become accustomed to innovation and advancement. Several decades ago, there was no Internet! The pace of technological change in recent years has been staggering.",
      choices: ["influence", "power", "knowledge", "fear"],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 7,
      questionIDTitle: "5c",
      questionType: "radio",
      subQuestion: "Increased knowledge and technology:",
      verses: [
        {
          body: "But you, Daniel, shut up the words, and seal the book until the time of the end; many shall run to and fro, and knowledge shall increase.",
          ref: "Daniel 12:4",
        },
      ],
    },
    "2-8": {
      Supplements: {
        "-L7fcTvBaMnLfXJi8Fl6": {
          body: "Remember that even when things look bad in the world Jesus is still with you. He promises in Hebrews 13:5, “I will never leave you nor forsake you.” Seeing the negative things taking place in the world lets us know that Jesus’ return is very near, “even at the doors.” (Matthew 24:33)\n\nSometimes, one of the best things to do is simply avoid getting bogged down with the news.  If you find that you end up feeling discouraged, spend more time reading God’s promises in the Bible and less time in front of the TV or computer. God’s promises will leave you feeling more encouraged than discouraged. Here are some of them.\n\nIsaiah 41:10 – “Fear not, for I am with you; Be not dismayed, for I am your God. I will strengthen you, Yes, I will help you, I will uphold you with My righteous right hand.”\n\nIsaiah 41:13 – “For I, the Lord your God, will hold your right hand, saying to you, ‘Fear not, I will help you.’”\n\nIsaiah 43:2 – “When you pass through the waters, I will be with you; and through the rivers, they shall not overflow you. When you walk through the fire, you shall not be burned, nor shall the flame scorch you.”\n\nJames 4:7 – “Therefore submit to God. Resist the devil and he will flee from you.”\n\n1 Peter 5:6,7 – “Therefore humble yourselves under the mighty hand of God, that He may exalt you in due time, casting all your care upon Him, for He cares for you.”\n\nThere are hundreds of uplifting promises in the Bible. Commit some to memory and you’ll gain a new outlook on life!\n",
          title:
            "How can I keep from getting depressed or worried by watching the news?",
        },
      },
      blanks: [
        {
          choices: [
            "Elijah",
            "desire",
            "design",
            "Joshua",
            "evil",
            "things",
            "Noah",
            "wickedness",
            "continually",
          ],
          correctAnswer: "Noah",
          newline: [1],
          textAfter: " were, so also will the coming of the Son of Man be. ",
          textBefore: "But as the days of",
        },
        {
          choices: [
            "Elijah",
            "desire",
            "design",
            "Joshua",
            "evil",
            "things",
            "Noah",
            "wickedness",
            "continually",
          ],
          correctAnswer: "wickedness",
          textAfter:
            " of man was great in the earth, and that every intent of the thoughts of his heart was only evil",
          textBefore: "Then the Lord saw that the",
        },
        {
          choices: [
            "Elijah",
            "desire",
            "design",
            "Joshua",
            "evil",
            "things",
            "Noah",
            "wickedness",
            "continually",
          ],
          correctAnswer: "continually",
          textAfter: " .",
        },
      ],
      body: "Jesus said that, just  before He returns, the earth will be in the same moral state as it was  before the Flood in Noah’s day. Social conditions in modern society indicate we are nearing the time of the return of Jesus. Immorality and violence continue to spiral out of control.",
      choices: [
        "Elijah",
        "desire",
        "design",
        "Joshua",
        "evil",
        "things",
        "Noah",
        "wickedness",
        "continually",
      ],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 8,
      questionIDTitle: "5d",
      questionType: "wordCloud",
      subQuestion: "Moral collapse:",
      verses: [
        {
          body: "But as the days of Noah were, so also will the coming of the Son of Man be.",
          ref: "Matthew 24:37",
        },
        {
          body: "Then the Lord saw that the wickedness of man was great in the earth, and that every intent of the thoughts of his heart was only evil continually.",
          ref: "Genesis 6:5",
        },
      ],
    },
    "2-9": {
      blanks: [
        {
          choices: ["cold", "frigid", "dark", "strong"],
          correctAnswer: "cold",
          textAfter: " .",
          textBefore:
            "And because lawlessness will abound, the love of many will grow",
        },
      ],
      body: "Marriages today are falling apart at a dramatic rate. The breakdown of the family is a key sign of the last days.",
      choices: ["cold", "frigid", "dark", "strong"],
      lessonID: 2,
      question:
        "What are some of the signs associated with the very last days  before Jesus returns?",
      questionID: 9,
      questionIDTitle: "5e",
      questionType: "radio",
      subQuestion: "Breakdown in relationships:",
      verses: [
        {
          body: "And because lawlessness will abound, the love of many will grow cold.",
          ref: "Matthew 24:12",
        },
      ],
    },
  },
  {
    "3-0": {
      body: "In August 1998, a bombing at the United States Embassy in Nairobi, Kenya, left more than 200 people dead and 4,000 injured. A couple—on vacation in Africa at the time—arrived at the scene of the bombing. Amid the carnage, they noticed a car that had been destroyed in the explosions. The occupants of the car had been killed, and on the windshield of the car was a sticker that read, “God is love.”\n\nThe question is often asked, “Why does God allow sin, pain and suffering?” The Bible has the answer, and it reveals that God truly is love!",
      lessonID: 3,
      questionID: 0,
      type: "text",
    },
    "3-1": {
      blanks: [
        {
          choices: ["forever", "undying", "love"],
          correctAnswer: "love",
          textAfter: " .",
          textBefore: "He who does not love does not know God, for God is",
        },
      ],
      body: "The Bible story begins by introducing God with the words: “In the beginning God . . . ” (Genesis 1:1). He is the One who creates out of nothing and sustains all life.\n\nGod is not merely loving. He “is love.” God is “merciful and gracious, long- suffering, and abounding in goodness and truth” (Exodus 34:6).",
      choices: ["forever", "undying", "love", "Holy", "Spirit"],
      lessonID: 3,
      question: "Who is God?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "He who does not love does not know God, for God is love.",
          ref: "1 John 4:8",
        },
      ],
    },
    "3-10": {
      blanks: [
        {
          choices: [
            "iniquity",
            "beauty",
            "splendor",
            "perfect",
            "Eden",
            "beauty",
          ],
          correctAnswer: "beauty",
          textAfter: " . You were in",
          textBefore:
            "You were the seal of perfection, full of wisdom and perfect in\n",
        },
        {
          choices: [
            "iniquity",
            "beauty",
            "splendor",
            "perfect",
            "Eden",
            "beauty",
          ],
          correctAnswer: "Eden",
          textAfter:
            " , the garden of God . . . You were the anointed cherub who covers; I established you; you were on the holy mountain of God . . . You were",
        },
        {
          choices: [
            "iniquity",
            "beauty",
            "splendor",
            "perfect",
            "Eden",
            "beauty",
          ],
          correctAnswer: "perfect",
          textAfter: " in your ways from the day you were created, till",
        },
        {
          choices: [
            "iniquity",
            "beauty",
            "splendor",
            "perfect",
            "Eden",
            "beauty",
          ],
          correctAnswer: "iniquity",
          textAfter:
            " was found in you . . . Your heart was lifted up because of your beauty",
        },
        {
          choices: [
            "iniquity",
            "beauty",
            "splendor",
            "perfect",
            "Eden",
            "beauty",
          ],
          correctAnswer: "corrupted",
          textAfter: "  your wisdom for the sake of your",
          textBefore: "; you ",
        },
        {
          choices: [
            "iniquity",
            "beauty",
            "splendor",
            "perfect",
            "Eden",
            "beauty",
          ],
          correctAnswer: "splendor",
          textAfter: " .",
        },
      ],
      body: "Having been endowed by God with such wisdom and beauty, Satan sought honor for himself rather than the honor of God. Such self-centered thinking is in direct contrast to the self-sacrificing love of the God of heaven.",
      choices: [
        "iniquity",
        "beauty",
        "splendor",
        "perfect",
        "Eden",
        "corrupted",
      ],
      lessonID: 3,
      question:
        "Does the Bible give any further indication as to why Satan rebelled against God?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "12 “Son of man, take up a lamentation for the king of Tyre, and say to him, ‘Thus says the Lord God:“You were the seal of perfection,\nFull of wisdom and perfect in beauty.\n13 You were in Eden, the garden of God;\nEvery precious stone was your covering:\nThe sardius, topaz, and diamond,\nBeryl, onyx, and jasper,\nSapphire, turquoise, and emerald with gold.\nThe workmanship of your timbrels and pipes\nWas prepared for you on the day you were created.\n\n14 “You were the anointed cherub who covers;\nI established you;\nYou were on the holy mountain of God;\nYou walked back and forth in the midst of fiery stones.\n\n15 You were perfect in your ways from the day you were created,\nTill iniquity was found in you.\n\n16 “By the abundance of your trading\nYou became filled with violence within,\nAnd you sinned;\nTherefore I cast you as a profane thing\nOut of the mountain of God;\nAnd I destroyed you, O covering cherub,\nFrom the midst of the fiery stones.\n\n17 “Your heart was lifted up because of your beauty;\nYou corrupted your wisdom for the sake of your splendor;\nI cast you to the ground,\nI laid you before kings,\nThat they might gaze at you.",
          ref: "Ezekiel 28:12-17",
        },
      ],
    },
    "3-11": {
      Supplements: {
        "-L7fe4Nd6i75nO7v1cah": {
          body: "God created all beings with a free will.  In order to truly love, a person must have free will.  A relationship without free will is not a relationship based on love.  Free will doesn’t exist if an individual doesn’t have the opportunity to say, “No.” Before Lucifer rebelled, the angels of heaven served God out of love.  If God had destroyed Lucifer after his rebellion, the remaining angels – without a clear understanding of the issues involved - would have served God from that time on out of fear. In mercy, God is allowing sin to take its natural course.  Once all people have had the opportunity to decide for or against faithfulness to God, God will bring an end to sin.  After God has rid the universe of sin, “Affliction will not rise up a second time” (Nahum 1:9.)",
          title: "Why didn’t God just destroy Lucifer when he rebelled?",
        },
      },
      blanks: [
        {
          choices: ["war", "strife", "the angels"],
          correctAnswer: "war",
          textAfter:
            " broke out in heaven: Michael and his angels fought with the dragon; and the dragon and his angels fought.",
          textBefore: "And",
        },
      ],
      body: "Satan’s opposition to God’s authority saw him undermine God’s leadership to the extent that a third of the heavenly angels chose to side with Satan and stand against God (Revelation 12:4).",
      choices: ["war", "strife", "the angels"],
      lessonID: 3,
      question: "What was the result of Lucifer’s rebellion against God?",
      questionID: 11,
      questionType: "radio",
      verses: [
        {
          body: "And war broke out in heaven: Michael and his angels fought with the dragon; and the dragon and his angels fought,",
          ref: "Revelation 12:7",
        },
      ],
    },
    "3-12": {
      blanks: [
        {
          choices: ["underworld", "earth", "depths", "beyond"],
          correctAnswer: "earth",
          textAfter: " , and his angels were cast out with him.",
          textBefore:
            "So the great dragon was cast out, that serpent of old, called the Devil and Satan, who deceives the whole world; he was cast to the",
        },
      ],
      body: "Planet Earth has become the epicenter of the great battle between Christ and Satan. While Satan misrepresents God on earth and tempts people to doubt the goodness and fairness of God, Jesus came to the earth to reveal to the human family the true character of God. Every person alive has the choice\nto accept Satan’s view of what God is like, or the view of God presented to the world by Jesus. Our choices will ultimately determine whether or not we believe God is love.",
      choices: ["underworld", "earth", "depths", "beyond"],
      correctAnswer: "true",
      lessonID: 3,
      question:
        "Where is the war between good and evil currently being played out?",
      questionID: 12,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "The war between good and evil is currently being fought on earth.",
      verses: [
        {
          body: "So the great dragon was cast out, that serpent of old, called the Devil and Satan, who deceives the whole world; he was cast to the earth, and his angels were cast out with him.",
          ref: "Revelation 12:9",
        },
      ],
    },
    "3-13": {
      blanks: [
        {
          choices: ["cherished", "loved", "Me", "gave", "God", "Father"],
          correctAnswer: "Me",
          textAfter: " has seen the",
          textBefore: "He who has seen",
        },
        {
          choices: ["cherished", "loved", "Me", "gave", "God", "Father"],
          correctAnswer: "Father",
          newline: [1],
          textAfter: " .",
        },
        {
          choices: ["cherished", "loved", "Me", "gave", "God", "Father"],
          correctAnswer: "loved",
          textAfter: " the world that He",
          textBefore: " \n\nFor God so",
        },
        {
          choices: ["cherished", "loved", "Me", "gave", "God", "Father"],
          correctAnswer: "gave",
          textAfter:
            " His only begotten Son, that whoever believes in Him should not perish but have everlasting life.",
        },
      ],
      body: "In order to know what our heavenly Father is like, all we need do is look at what Jesus was like, because He revealed the character of the Father to the world. The self-sacrificing, servant-like nature of Jesus—who “went about doing good” (Acts 10:38)—is a reflection of the character of God the Father.\n\nTo make a way for sinful people to experience eternal life and recovery from the power of sin, God paid the ultimate price when He allowed Jesus to come to earth to die for us. Such a sacrifice reveals that God is not indifferent toward suffering and sin. In fact, sin has cost God far more than it will ever cost any of us!",
      choices: ["cherished", "loved", "Me", "gave", "God", "Father"],
      lessonID: 3,
      question: "How can we know how God feels about the human family?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "Jesus said to him, “Have I been with you so long, and yet you have not known Me, Philip? He who has seen Me has seen the Father; so how can you say, ‘Show us the Father’?",
          ref: "John 14:9",
        },
        {
          body: "For God so loved the world that He gave His only begotten Son, that whoever believes in Him should not perish but have everlasting life.",
          ref: "John 3:16",
        },
      ],
    },
    "3-14": {
      blanks: [
        {
          choices: ["devoured", "ate", "consumed", "prayed"],
          correctAnswer: "ate",
          textAfter: " .",
          textBefore:
            "So when the woman saw that the tree was good for food, that it was pleasant to the eyes, and a tree desirable to make one wise, she took of its fruit and",
        },
      ],
      body: "Adam and Eve’s willful disobedience of God’s express wishes caused them to lose the purity and innocence that God gave them at creation. Their sin separated them from God and brought the planet under the dominion of the “enemy”—Satan. And like our  first parents, the Bible says that “all have sinned and fall short of the glory of God” (Romans 3:23). Like Adam and Eve, we have sinned and are under the penalty of sin—which is death (Romans 6:23).",
      choices: ["devoured", "ate", "consumed", "prayed"],
      lessonID: 3,
      question:
        "How did human beings become involved in the sin issue troubling our world?",
      questionID: 14,
      questionType: "radio",
      verses: [
        {
          body: "So when the woman saw that the tree was good for food, that it was pleasant to the eyes, and a tree desirable to make one wise, she took of its fruit and ate. She also gave to her husband with her, and he ate.",
          ref: "Genesis 3:6",
        },
      ],
    },
    "3-15": {
      blanks: [
        {
          choices: ["him", "fall", "believe", "down", "worship"],
          correctAnswer: "worship",
          textAfter: " ",
          textBefore: "All who dwell on the earth will",
        },
        {
          choices: ["him", "fall", "believe", "down", "worship"],
          correctAnswer: "him",
          textAfter:
            " , whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
        },
      ],
      body: "Such is Satan’s self-centered desire to receive worship that he eventually leads the world to the place where everyone alive makes a conscious decision for either God or Satan.",
      choices: ["him", "fall", "believe", "down", "worship"],
      lessonID: 3,
      question:
        "Where is Satan’s desire for worship ultimately going to lead planet Earth?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "All who dwell on the earth will worship him, whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
          ref: "Revelation 13:8",
        },
      ],
    },
    "3-16": {
      blanks: [
        {
          choices: ["burning", "misery", "brimstone", "fire", "death"],
          correctAnswer: "fire",
          textAfter: " and",
          textBefore: "The devil, who deceived them, was cast into the lake of",
        },
        {
          choices: ["burning", "misery", "brimstone", "fire", "death"],
          correctAnswer: "brimstone",
          textAfter: " where the beast and the false prophet are.",
        },
      ],
      body: "Satan’s ultimate doom is assured. He will not succeed in leading the entire planet in rebellion against God, and will himself be destroyed.",
      choices: ["burning", "misery", "brimstone", "fire", "death"],
      lessonID: 3,
      question:
        "What is Satan’s ultimate fate in this conflict between good and evil?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "The devil, who deceived them, was cast into the lake of fire and brimstone where the beast and the false prophet are. And they will be tormented day and night forever and ever.",
          ref: "Revelation 20:10",
        },
      ],
    },
    "3-17": {
      Supplements: {
        "-L7feaXXDmT4hX-IrAJV": {
          body: "Hebrews 11:24-26 says, “By faith Moses, when he became of age, refused to be called the son of Pharaoh’s daughter, choosing rather to suffer affliction with the people of God than to enjoy the passing pleasures of sin, esteeming the reproach of Christ greater riches than the treasures in Egypt; for he looked to the reward.”  If it seems to you that the wicked are prospering, remember that the passing pleasures of sin are only temporary.\n\nEcclesiastes 12:14 says, “For God will bring every work into judgment, including every secret thing, whether good or evil.” Eventually, everyone will answer to God for what they have done with their lives, and those who have chosen to live for self rather than for God will find themselves coming up short in that judgment.\n\nGod encourages us in Revelation 2:25, “But hold fast what you have till I come.” Don’t lose heart.  And remember: your relationship with God isn’t materially affected by how it appears another person is or isn’t prospering.  How God chooses to bless or prosper another person is for God to decide.  While there is something within every human being that desires to see justice, God’s dealings with another person need not discourage you.  And keep in mind that God is trying to save every person on the planet.  It might be that the path God is allowing the life of another person to take is calculated ",
          title:
            "Why does it seem like people who don’t love or serve God are so successful in this world while I seem to be having such a hard time?",
        },
      },
      blanks: [
        {
          choices: ["blue", "red", "God", "new", "righteousness"],
          correctAnswer: "heavens",
          textAfter: "  and a",
          textBefore:
            "Nevertheless we, according to His promise, look for new ",
        },
        {
          choices: ["blue", "red", "God", "new", "righteousness"],
          correctAnswer: "new",
          textAfter: " earth in which",
        },
        {
          choices: ["blue", "red", "God", "new", "righteousness"],
          correctAnswer: "righteousness",
          textAfter: " dwells.",
        },
      ],
      body: "God’s promise is that He will remake this world in perfection and beauty, and it will be a world without sin and suffering. The enemy will no longer taunt and tempt, and guilt and sorrow will no longer exist!\n\nConsider this fact: God created a perfect earth, and placed two perfect people in the midst of a sinless garden. With absolutely no reason to sin, they chose rebellion over faithfulness to God, and plunged the universe into the chaos of sin. And sin would cost God infinitely more than it would cost anyone else in existence!\n\nFaced with the loss of His eternal Son, God made the choice to redeem sinful humanity—even though it meant Jesus would die on the cross. There has never been another demonstration of such selfless love in all of history! As the Bible says, “God so loved the world that He gave His only begotten Son” (John 3:16).",
      choices: ["blue", "red", "God", "new", "righteousness", "heavens"],
      lessonID: 3,
      question:
        "In a world of sin and suffering, what do people have to look forward to?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "Nevertheless we, according to His promise, look for new heavens and a new earth in which righteousness dwells.",
          ref: "2 Peter 3:13",
        },
      ],
    },
    "3-18": {
      blanks: [
        {
          choices: ["lives", "grace", "saved", "trust", "faith", "belief"],
          correctAnswer: "grace",
          textAfter: " you have been",
          textBefore: "For by",
        },
        {
          choices: ["lives", "grace", "saved", "trust", "faith", "belief"],
          correctAnswer: "saved",
          newline: [1],
          textAfter:
            " through faith, and that not of yourselves; it is the gift of God.",
        },
        {
          choices: ["lives", "grace", "saved", "trust", "faith", "belief"],
          correctAnswer: "lives",
          textAfter:
            " in me; and the life which I now live in the flesh I live by",
          textBefore:
            "\n\nI have been crucified with Christ; it is no longer I who live, but Christ",
        },
        {
          choices: ["lives", "grace", "saved", "trust", "faith", "belief"],
          correctAnswer: "faith",
          textAfter:
            " in the Son of God, who loved me and gave Himself for me.",
        },
      ],
      body: "Through faith in Jesus Christ, every person may have the hope of eternal life. Jesus died to reveal the depth of the love of God for a fallen world, and in so doing, ensured the defeat of Satan and the eternal security of believers. One day, sin will no longer exist, the universe will again be safe and God alone will be worshipped.",
      choices: ["lives", "grace", "saved", "trust", "faith", "belief"],
      lessonID: 3,
      question:
        "How can a person be sure they will live in the New Earth without Satan and sin?",
      questionID: 18,
      questionType: "wordCloud",
      verses: [
        {
          body: "For by grace you have been saved through faith, and that not of yourselves; it is the gift of God.",
          ref: "Ephesians 2:8",
        },
        {
          body: "I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.",
          ref: "Galatians 2:20",
        },
      ],
    },
    "3-19": {
      correctAnswer: "true",
      question:
        "Are you willing to choose to have faith in Jesus,  and to stand with Him in the great battle between good and evil?",
      questionID: 19,
      questionType: "truthConfirmation",
    },
    "3-2": {
      blanks: [
        {
          choices: ["own", "its", "wholly", "justice", "sin"],
          correctAnswer: "its",
          textAfter: " ",
          textBefore:
            "Love suffers long and is kind; love does not envy; love does not parade itself, is not puffed up; does not behave rudely, does not seek",
        },
        {
          choices: ["own", "its", "wholly", "justice", "sin"],
          correctAnswer: "own",
          textAfter: " , is not provoked, thinks no evil.",
        },
      ],
      body: "God’s love for the human family is unconditional. “While we were still sinners, Christ died for us” (Romans 5:8). God’s love “does not seek its own.” His love is selfless, and is freely offered to every member of the human family.",
      choices: ["own", "its", "wholly", "justice", "sin"],
      lessonID: 3,
      question: "What is the nature of God’s love?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "4 Love suffers long and is kind; love does not envy; love does not parade itself, is not puffed up;\n\n5 does not behave rudely, does not seek its own, is not provoked, thinks no evil",
          ref: "1 Corinthians 13:4, 5",
        },
      ],
    },
    "3-3": {
      blanks: [
        {
          choices: ["increase", "wane", "abound", "awful"],
          correctAnswer: "abound",
          textAfter: " , the love of many will grow cold.",
          textBefore: "And because lawlessness will",
        },
      ],
      body: "The whole world is in distress, wracked by war, natural disasters, illness, disease and social problems of the most serious kind. According to the United States Bureau of Justice, more than 15,000 people are murdered every year, including more than 500 children.\n\nEvil and pain are real. This is a hurting world.",
      choices: ["increase", "wane", "abound", "awful"],
      lessonID: 3,
      question: "What is the condition of our world?",
      questionID: 3,
      questionType: "radio",
      verses: [
        {
          body: "And because lawlessness will abound, the love of many will grow cold.",
          ref: "Matthew 24:12",
        },
      ],
    },
    "3-4": {
      blanks: [
        {
          choices: ["evil doer", "enemy", "neighbor", "evil servant"],
          correctAnswer: "enemy",
          textAfter: " has done this.”",
          textBefore:
            "“Sir, did you not sow good seed in your  eld? How then does it have\ntares?” He said to them, “An",
        },
      ],
      body: "Jesus told a parable that depicted a farmer sowing wheat in the field. As the wheat grew, weeds appeared—growing in the midst of the wheat. When asked who was responsible for evil, Jesus blamed the “enemy,” which is the devil (Matthew 13:39).\n\nGod often gets blamed for the evil in the world—evil that is, in fact, the work of a fallen angel named Satan, the enemy of love and peace.",
      choices: ["evil doer", "enemy", "neighbor", "evil servant"],
      correctAnswer: "false",
      lessonID: 3,
      question: "Is God responsible for pain and evil?",
      questionID: 4,
      questionType: "trueOrFalse",
      trueFalseQuestion: "God is responsible for all the pain and evil today.",
      verses: [
        {
          body: "27 So the servants of the owner came and said to him, ‘Sir, did you not sow good seed in your field? How then does it have tares?’\n\n28 He said to them, ‘An enemy has done this.’ The servants said to him, ‘Do you want us then to go and gather them up?’",
          ref: "Matthew 13:27, 28",
        },
      ],
    },
    "3-5": {
      blanks: [
        {
          choices: ["time", "great", "long", "bit", "short"],
          correctAnswer: "short",
          textAfter: " ",
          textBefore:
            "Therefore rejoice, O heavens, and you who dwell in them! Woe to the inhabitants of the earth and the sea! For the devil has come down to you, having great wrath, because he knows that he has a",
        },
        {
          choices: ["time", "great", "long", "bit", "short"],
          correctAnswer: "time",
          textAfter: " .",
        },
      ],
      body: "Knowing he has so little time left before the end of the world, Satan is now working with increased fury and intensity in an effort to cause maximum distress to the world, and maximum pain to the heart of God.",
      choices: ["time", "great", "long", "bit", "short"],
      lessonID: 3,
      question: "How is Satan working in the world today?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore rejoice, O heavens, and you who dwell in them! Woe to the inhabitants of the earth and the sea! For the devil has come down to you, having great wrath, because he knows that he has a short time.",
          ref: "Revelation 12:12",
        },
      ],
    },
    "3-6": {
      blanks: [
        {
          choices: ["war", "amends", "disturbances"],
          correctAnswer: "war",
          textAfter:
            " with the rest of her offspring, who keep the commandments of God and have the testimony of Jesus Christ.",
          textBefore:
            "And the dragon was enraged with the woman, and he went to make",
        },
      ],
      body: "In Bible prophecy, a woman is used to symbolically represent a church. Satan is targeting the church—God’s people—in earth’s last days as the special focus of his hate and wrath.",
      choices: ["war", "amends", "disturbances"],
      lessonID: 3,
      question:
        "How is Satan especially targeting those people who have faith in God?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "And the dragon was enraged with the woman, and he went to make war with the rest of her offspring, who keep the commandments of God and have the testimony of Jesus Christ.",
          ref: "Revelation 12:17",
        },
      ],
    },
    "3-7": {
      blanks: [
        {
          choices: ["hate", "thoughtful", "terrible", "perfect", "iniquity"],
          correctAnswer: "perfect",
          textAfter: " in your ways from the day you were created, till",
          textBefore: "You were",
        },
        {
          choices: ["hate", "thoughtful", "terrible", "perfect", "iniquity"],
          correctAnswer: "iniquity",
          textAfter: " was found in you.",
        },
      ],
      body: "God didn’t create a devil. He created a perfect and beautiful angel named Lucifer (which means “Light Bearer”). But Lucifer chose to rebel against God. It was Lucifer’s own choices that alienated him from the heart of God.",
      choices: ["hate", "thoughtful", "terrible", "perfect", "iniquity"],
      lessonID: 3,
      question: "Did God create the devil?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "You were perfect in your ways from the day you were created, till iniquity was found in you.",
          ref: "Ezekiel 28:15",
        },
      ],
    },
    "3-8": {
      blanks: [
        {
          choices: ["Think", "Choose", "Decide"],
          correctAnswer: "Choose",
          textAfter: " for yourselves this day whom you will serve.",
        },
      ],
      body: "God extended to His created beings the special gift of freedom of choice. People are free to choose to serve God, and free to choose not to serve Him. Angels were given this same capacity. The decision to sin was a choice on the part of Lucifer, as well as on the part of Adam and Eve. We can choose to sin, or we can choose to obey God.",
      choices: ["Think", "Choose", "Decide"],
      lessonID: 3,
      question: "What special ability has God given to His children?",
      questionID: 8,
      questionType: "radio",
      verses: [
        {
          body: "And if it seems evil to you to serve the Lord, choose for yourselves this day whom you will serve, whether the gods which your fathers served that were on the other side of the River, or the gods of the Amorites, in whose land you dwell. But as for me and my house, we will serve the Lord.",
          ref: "Joshua 24:15",
        },
      ],
    },
    "3-9": {
      blanks: [
        {
          choices: ["great", "God", "commander", "son", "Most", "High"],
          correctAnswer: "Most",
          textAfter: " ",
          textBefore:
            "How are you fallen from heaven, O Lucifer, son of the morning! . . . For you have said in your heart . . . “I will exalt my throne above the stars of God . . . I will be like the",
        },
        {
          choices: ["great", "God", "commander", "son", "Most", "High"],
          correctAnswer: "High",
          textAfter: " .”",
        },
      ],
      body: "Remarkably, Lucifer wanted to sit in God’s place. He wanted to receive leadership, rulership and worship! Dissatisfied with his own elevated position as a covering cherub dwelling in the presence of God (Ezekiel 28:14), he rebelled against God in an attempt to receive the honor that belongs only to God.",
      choices: ["great", "God", "commander", "son", "Most", "High"],
      lessonID: 3,
      question: "Why did Lucifer rebel against God?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "12 How you are fallen from heaven, O Lucifer, son of the morning! How you are cut down to the ground, You who weakened the nations!\n13 For you have said in your heart:\n‘I will ascend into heaven,\nI will exalt my throne above the stars of God;\nI will also sit on the mount of the congregation\nOn the farthest sides of the north;\n\n\n14 I will ascend above the heights of the clouds,\nI will be like the Most High.’",
          ref: "Isaiah 14:12-14",
        },
      ],
    },
  },
  {
    "4-0": {
      body: "In 1914, ice prevented British explorer Ernest Shackleton and a crew from reaching Antarctica, where they were to attempt to become the first people in history to cross the great southern continent on foot. When the ice destroyed their ship, they sailed in small lifeboats to Elephant Island, a remote, barren island near the bottom of the world. Shackleton and five crewmen then attempted one of history’s most daring rescues—sailing one of the wooden lifeboats 800 miles in an effort to find help and save his crew.  For several months, most of Shackleton’s crew waited. Their only hope for survival was Ernest Shackleton, because no one else knew where they were.  Our planet finds itself in a similar situation to that of Shackleton’s men. Because of sin, our world is hopelessly lost and in need of outside help. But there is one Person who is able to save the inhabitants of planet Earth. Read on and discover what the Bible says about being saved from sin!",
      lessonID: 4,
      questionID: 0,
      type: "text",
    },
    "4-1": {
      Supplements: {
        "-L7aG8IDK40r7O6RLO9o": {
          body: "Revelation 12:7,8 says, “And there was war in heaven.  Michael and his angels fought against the dragon, and the dragon fought and his angels, and prevailed not, neither was there place found any more in heaven.”\n\nWhile the Bible is silent on the specifics of how the war was fought, we can understand that there was a conflict in heaven so intense that it led to one third of the angels being cast out of heaven  (see Revelation 12:4)  Revelation 12:9 says Satan and his angels were “cast out into the earth,” making earth the scene of a spiritual battle that sees Satan seeking to separate believers from God.\n\nThe war began owing to Satan’s desire for self exaltation, and his longing to sit as God in heaven.  His unsuccessful quest for worship in heaven has developed into a pursuit of worship here on Earth.",
          title: "What was the war in heaven?",
        },
      },
      blanks: [
        {
          choices: ["chicken pox", "satan", "confusion", "war"],
          correctAnswer: "war",
          textAfter: " broke out in heaven.",
          textBefore: "And",
        },
      ],
      body: "The Bible tells us that, long ago, an angel named Lucifer rebelled against the government of God. There was war in heaven as God attempted to contain the outbreak of sin, and as Lucifer attempted to receive in heaven the worship that belonged only to God. (Isaiah 14:13, 14)",
      choices: ["chicken pox", "satan", "confusion", "war"],
      lessonID: 4,
      question: "How did sin enter the world?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "And war broke out in heaven: Michael and his angels fought with the dragon; and the dragon and his angels fought.",
          ref: "Revelation 12:7",
        },
      ],
    },
    "4-10": {
      blanks: [
        {
          choices: ["forgive", "all", "expose", "his", "remember", "our"],
          correctAnswer: "forgive",
          textAfter: " us our sins and to cleanse us from",
          textBefore: "If we confess our sins, He is faithful and just to",
        },
        {
          choices: ["forgive", "all", "expose", "his", "remember", "our"],
          correctAnswer: "all",
          textAfter: " unrighteousness.",
        },
      ],
      body: "When we sincerely confess our sins to God in prayer, God forgives us and cleanses us. We know for certain we are forgiven simply because we believe God’s promise to us. That is, we accept God’s forgiveness by faith. We confess, and God forgives. It really is that simple!",
      choices: ["forgive", "all", "expose", "his", "remember", "our"],
      lessonID: 4,
      question: "Is it necessary to confess our sins to God?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.",
          ref: "1 John 1:9",
        },
      ],
    },
    "4-11": {
      blanks: [
        {
          choices: ["bow down", "submit", "give worship"],
          correctAnswer: "submit",
          textAfter: " to God.",
          textBefore: "Therefore",
        },
      ],
      body: "A vital key in living a satisfying Christian life is submission to God. Christianity is not simply a matter of believing certain ideas or principles—it’s a life lived in surrender to the will of God.",
      choices: ["bow down", "submit", "give worship"],
      lessonID: 4,
      question:
        "After being forgiven for my sins, how can I live the life God wants me to live?",
      questionID: 11,
      questionType: "radio",
      verses: [
        {
          body: "Therefore submit to God. Resist the devil and he will flee from you.",
          ref: "James 4:7",
        },
      ],
    },
    "4-12": {
      blanks: [
        {
          choices: ["all", "time", "thread", "means"],
          correctAnswer: "means",
          textAfter: " cast out.",
          textBefore: "The one who comes to Me I will by no",
        },
      ],
      body: 'Jesus pledges to accept all who come to Him in faith. It is not possible to be so sinful as to be beyond the reach of the grace of God. In Revelation 3:20, Jesus says "Behold, I stand at the door and knock. If anyone hears My voice and opens the door, I will come in to him".  Anyone! As long as you are willing for Jesus to accept and forgive and change and save you, He will do so. He has promised.  Four Simples Steps to SalvationBelieve - John 3:16Repent - Acts 3:19Confess - 1 John 1:9Submit - James4:7Jesus described the process of coming to faith in Him as the "new birth." As He explained to Nicodemus, in order to receive the gift of salvation, a person must be "born again" (John 3:3).That means a person is remade by God through the grace of God-given an entirely new nature, which creates a new life in place of the old, sinful life.  As Paul wrote to the Corinthians, "Old things have passed away; behold, all things have become new"(2 Corinthians 5:17). ',
      choices: ["way", "time", "thread", "means"],
      lessonID: 4,
      question:
        "Can I repent of my sins and confess them to God with confidence that He will accept me?",
      questionID: 12,
      questionType: "radio",
      verses: [
        {
          body: "All that the Father gives Me will come to Me, and the one who comes to Me I will by no means cast out.",
          ref: "John 6:37",
        },
      ],
    },
    "4-13": {
      Supplements: {
        "-L7fbM1jr6R6Ed4x-xCk": {
          body: "In Acts 3:19, Peter appealed to his listeners saying, “Repent, and be converted.”  Conversion is that miracle of grace that occurs when a repentant sinner surrenders in sorrow for sin and gives her or his life completely to God.  A converted person will be a person who still has spiritual growing to do, but a converted person has yielded her or his life to God and has received Jesus.  There is a desire to live for God, to see God’s will carried out in the life.  \n\nIn the Bible, the word “converted” is associated with a life changed by the grace of God.  Jesus said, “Except ye be converted, and become as little children, ye shall not enter into the kingdom of God.”  (Matthew 18:3)  The emphasis here is on surrendering the will and - like little children - obediently following one’s heavenly Father.  In Psalm 51:13, David prayed to God, “Then will I teach transgressors thy ways, and sinners shall be converted unto thee.”  Again, the thought connotes a life turning away from sin and embracing God’s forgiveness and new life.\n\nA converted life is a changed life, so impacted by the power of the indwelling Jesus that sin is renounced and a transformation is experienced and seen.  A converted person does not feel that he or she has “arrived” spiritually, but continues to reach out to God in faith and dependence.\n",
          title: "What does it mean to be converted?",
        },
      },
      blanks: [
        {
          choices: [
            "lives",
            "faith",
            "strong and almighty",
            "grace",
            "lord and savior",
            "trust",
          ],
          correctAnswer: "lives",
          textAfter: " ",
          textBefore:
            "I have been crucified with Christ; it is no longer I who live, but Christ",
        },
        {
          choices: [
            "lives",
            "in",
            "strong and almighty",
            "grace",
            "lord and savior",
            "trust",
          ],
          correctAnswer: "in",
          textAfter: " ",
        },
        {
          choices: [
            "lives",
            "faith",
            "strong and almighty",
            "grace",
            "lord and savior",
            "me",
          ],
          correctAnswer: "me",
          textAfter: " ; and the life I now live in the flesh I live by",
        },
        {
          choices: [
            "assumption",
            "faith",
            "strong and almighty",
            "grace",
            "lord and savior",
            "trust",
          ],
          correctAnswer: "faith",
          textAfter:
            " in the Son of God, who loved me and gave Himself for me.",
        },
      ],
      body: 'After accepting the gift of eternal life from Jesus, a person lives surrendered to the will of God, in each moment yielding to Jesus and asking that His will be done in his or her life. As it says in Philippians 2:13, “For it is God who works in you both to will and to do for His good pleasure".\n\n When we accept Jesus as our Savior from sin, yield our lives to Him and then allow Him to live His life in us, we can be confident the gift of eternal life is ours and we are living with heaven in view!',
      choices: ["lives", "faith", "me", "grace", "in", "trust"],
      lessonID: 4,
      question:
        "Having received the gift of eternal life, how can I now live a life that is pleasing in the sight of God?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.",
          ref: "Galatians 2:20",
        },
      ],
    },
    "4-14": {
      blanks: [
        {
          choices: [
            "farmer",
            "sheep",
            "full grain",
            "grass",
            "flower",
            "full grain",
            "blade",
            "head",
            "full grain",
          ],
          correctAnswer: "blade",
          textAfter: " , then the",
          textBefore: "For the earth yields crops by itself: first the",
        },
        {
          choices: ["farmer", "sheep", "head", "grass", "flower", "grain"],
          correctAnswer: "head",
          textAfter: " ,  after that the",
        },
        {
          choices: [
            "farmer",
            "sheep",
            "full",
            "grass",
            "flower",
            "empty",
            "blade",
            "head",
          ],
          correctAnswer: "full",
          textAfter: " ",
        },
        {
          choices: [
            "farmer",
            "sheep",
            "grain",
            "grass",
            "flower",
            "full plant",
          ],
          correctAnswer: "grain",
          textAfter: " in the head.",
        },
      ],
      body: "Jesus clearly told us that the life of faith is a life of growth. With each passing day, we learn to yield more fully to the presence of God in our lives, so that His will may be done through us.",
      choices: [
        "farmer",
        "sheep",
        "full",
        "grass",
        "flower",
        "blade",
        "head",
        "grain",
      ],
      lessonID: 4,
      question: "Will there be challenges in my relationship with God?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "For the earth yields crops by itself: first the blade, then the head, after that the full grain in the head.",
          ref: "Mark 4:28",
        },
      ],
    },
    "4-15": {
      correctAnswer: "true",
      question:
        "Jesus offers you the free gift of salvation.  Will you invite Jesus into your life today, accept Him as your Savior, and allow Him to live His life in you?",
      questionID: 15,
      questionType: "truthConfirmation",
    },
    "4-2": {
      Supplements: {
        "-L7bmQ617C4ea1B_lwdQ": {
          body: "Satan was moved to rebel against God by pride, and the desire for self-exaltation.  The prophet Isaiah explained Lucifer’s thought process in Isaiah 14:12-15.\n\n\n12 How you are fallen from heaven,\nO Lucifer, son of the morning!\nHow you are cut down to the ground,\nYou who weakened the nations!\n\n13 For you have said in your heart:\n‘I will ascend into heaven,\nI will exalt my throne above the stars of God;\nI will also sit on the mount of the congregation\nOn the farthest sides of the north;\n\n14 I will ascend above the heights of the clouds,\nI will be like the Most High.’\n\n15 Yet you shall be brought down to Sheol,\nTo the lowest depths of the Pit.\n\nYet Satan’s desire for self-exaltation - his longing to be equal with God - results ultimately in his own destruction.\n\nLucifer was evidently very beautiful, and his pride over this matter was a significant part of the reason he fell into sin and was evicted from heaven.  Ezekiel 28:17 says, “Thine heart was lifted up because of thy beauty, thou hast corrupted thy wisdom by reason of thy brightness.”\n",
          title: "Why did Lucifer rebel against God?",
        },
      },
      blanks: [
        {
          choices: ["truthfully", "indeed", "honestly"],
          correctAnswer: "indeed",
          textAfter: " ",
          textBefore: "And he said to the woman, Has God",
        },
        {
          choices: ["spoken", "said", "lied"],
          correctAnswer: "said",
          textAfter: ' , "You shall not eat of every tree of the garden?"',
        },
      ],
      body: "Satan tempted Eve to doubt what God had said—to reject some of the plainest words God could have spoken. God had told Adam and Eve not to eat the fruit that grew on “the tree of the knowledge of good and evil” (Genesis 2:16, 17). In choosing Satan’s suggestions over God’s clear word, Eve chose distrust of God over faith in God.",
      choices: ["truthfully", "indeed", "honestly", "said"],
      lessonID: 4,
      question:
        "After he was evicted from heaven, where did Satan carry forward his rebellion against God?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "Now the serpent was more cunning than any beast of the field which the LordGod had made. And he said to the woman, “Has God indeed said, ‘You shall not eat of every tree of the garden’?”",
          ref: "Genesis 3:1",
        },
      ],
    },
    "4-3": {
      Supplements: {
        "-L7f_z-MiyzenzWFOmZ9": {
          body: "God has promised power to help any person successfully resist any temptation.  1 Corinthians 10:13 says, “No temptation has overtaken you except such as is common to man; but God is faithful, who will not allow you to be tempted beyond what you are able, but with the temptation will also make the way of escape, that you may be able to bear it.”\n\nThis verse is a promise from God.  Notice the following points.  \n\n - No temptation is too great to bear.  \n\n - God is faithful.  \n\n - God won’t let you be tempted beyond your capacity to resist.  \n\n - God will make a way to escape in every temptation.\n\nThe Bible recounts the stories of several people who fell into temptation.  David succumbed to the temptation to take Uriah’s wife (2 Samuel 11:2-4).  Peter relented in the face of the temptation to deny Jesus (Matthew 26:69-75).  Solomon fell into idolatry (1 Kings 11:4-10).  But the Bible also gives us examples of people who successfully resisted temptation, one of the most notable being Joseph, who resisted the overtures of the wife of his master, Potiphar (Genesis 39:8,9).\n\nThere is power in the word of God, and power in the Holy Spirit to keep a person from sin.  By claiming the promises of God, a tempted person calls on God for deliverance and relies on God’s power for strength.  While no human is a match for the power of Satan, the weakest of sinners who calls on God for help and trusts in Him for strength will experience the power of God and will know victory in the place of defeat.\n\nRemember, God says his “strength is made perfect in weakness” (2 Corinthians 12:9).  He promises to “keep you from falling” (Jude 24), and assures all believers that they “can do all things through Christ” (Philippians 4:13).\n\nFor the believer who is overcome by temptation, God offers this assurance.  “If any man sin, we have an Advocate with the Father, Jesus Christ the righteous” (1 John 2:1).  Even though it is not God’s plan that we fall into sin, He is willing to forgive any sinner who turns to Him in faith.\n",
          title: "How can a person successfully resist temptation?",
        },
      },
      blanks: [
        {
          choices: ["separated", "hidden", "driven"],
          correctAnswer: "separated",
          textAfter:
            " you from your God; and your sins have hidden His face from you, so that He will not hear.",
          textBefore: "Your iniquities have",
        },
      ],
      body: "Sin separates us from God, because God is the source of life (John 17:3; 1 John 5:12; John 5:40). Eve’s lack of faith in God—her disobedience—caused a fracture in her relationship with God and separated her from the One who is the source of all life.\n\n  Sin created a gulf between the human family and the God of heaven, and caused humanity to pass from life to death. Romans 5:12 says that as a result of the sin of Adam and Eve, sin “spread to all.”",
      choices: ["separated", "hidden", "driven"],
      lessonID: 4,
      question: "What was the result of Eve choosing to sin?",
      questionID: 3,
      questionType: "radio",
      verses: [
        {
          body: "But your iniquities have separated you from your God; and your sins have hidden His face from you, so that He will not hear.",
          ref: "Isaiah 59:2",
        },
      ],
    },
    "4-4": {
      Supplements: {
        "-L7faEWzmnP0pDBpUFLn": {
          body: "Romans 6:23 says that the “wages of sin is death.”  Sin results in separation from God (Isaiah 59:2), while 1 John 5:12 says that “He who has the Son has life.”  Sin is deadly.  There is no life outside God, who is the source of all life.  Jesus said, “Come to me” (Matthew 11:28).  Sin causes a severing of the connection with God, and brings eternal death in the place of eternal life.",
          title: " What effect does sin have on a person?",
        },
      },
      blanks: [
        {
          choices: ["life", "not worth it", "death"],
          correctAnswer: "death",
          textAfter: " .",
          textBefore: "The wages of sin is",
        },
      ],
      body: "Sin leads to death. And every person on Earth is affected, because “all have sinned and fall short of the glory of God” (Romans 3:23). The entire human family faces eternal death as a result of sin having entered the world. \n\n Whether the sin is murder, drunkenness, pride, lying, stealing, gossip or fraud—whatever the sin, the consequence is the same: death.",
      choices: ["life", "not worth it", "death"],
      lessonID: 4,
      question: "How did sin affect Adam and Eve's descendants?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.",
          ref: "Romans 6:23",
        },
      ],
    },
    "4-5": {
      Supplements: {
        "-L7fapA9HxTnjNe5m9RT": {
          body: "1 John 3:4 states that “sin is the transgression of the law.”  1 John 5:17 says that “all unrighteousness is sin,” while Romans 14:23 says, “whatsoever is not of faith is sin.”\n\nRomans 3:23 says that those who have sinned have “come short of the glory of God.”\n\n1 John 5:11 says, “God hath given to us eternal life, and this life is in His Son.”  Sin is deadly, because it separates a person from God, the source of life.  \n\nIt is a tragedy that so many people treat sin lightly.  Sin is not “fun”, nor is sin a laughing matter.  Sin is deceptive, and only brings tragic results.  Yet the Bible says of Moses that he chose not to “enjoy the pleasures of sin for a season” (Hebrews 11:25.)  Any enjoyment derived from sin is transitory, temporary, and self-oriented.  Eternal life—real life—is found in Jesus Christ.",
          title: "How does the Bible define sin?",
        },
      },
      blanks: [
        {
          choices: ["Lord", "Father", "ourselves", "angles", "Christ"],
          correctAnswer: "Christ",
          textAfter: " ",
          textBefore:
            "The wages of sin is death, but the gift of God is eternal life in",
        },
        {
          choices: ["our Lord", "God", "our father", "Jesus", "power", "Lord"],
          correctAnswer: "Jesus",
          textAfter: " our",
        },
        {
          choices: [
            "master",
            "partner",
            "our father",
            "God",
            "task master",
            "Lord",
          ],
          correctAnswer: "Lord",
          textAfter: " .",
        },
      ],
      body: "God has made a way of escape from the death penalty sin introduced to the world. Through Jesus, every person alive can receive the gift of eternal life!\n\n First Corinthians 15:3 says, “Christ died for our sins.” The penalty for sin was—and is—death. But Jesus died to pay that penalty, to pay a debt we could never pay. As God (John 1:1), the death of Jesus—the Lawgiver—would be sufficient to pay the price of the sins of the human race.",
      choices: ["Lord", "Father", "ourselves", "angles", "Christ", "Jesus"],
      lessonID: 4,
      question: "How can a person escape the consequences of sin?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.",
          ref: "Romans 6:23",
        },
      ],
    },
    "4-6": {
      Supplements: {
        "-L7fayAXWgnxmCoQeKQX": {
          body: "Romans 6:23 is clear.  “The wages of sin is death.”  Sin results in the rejection of God’s grace and the forfeiture of everlasting life.",
          title: "What is the ultimate outcome of sin?",
        },
      },
      blanks: [
        {
          choices: ["believes", "understands", "loves"],
          correctAnswer: "believes",
          textAfter: " in Him should not perish but have everlasting life.",
          textBefore:
            "For God so loved the world that He gave His only begotten Son, that whosoever",
        },
      ],
      body: "Belief in Jesus Christ is the prerequisite for receiving the gift of everlasting life. And notice: it is a gift. God gives salvation to those who seek it. Eternal life cannot be bought or earned. It is given by God as a gift.",
      choices: ["believes", "understands", "loves"],
      lessonID: 4,
      question:
        "How may a person receive the gift of everlasting life through Jesus Christ?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "For God so loved the world that He gave His only begotten Son, that whoever believes in Him should not perish but have everlasting life.",
          ref: "John 3:16",
        },
      ],
    },
    "4-7": {
      blanks: [
        {
          choices: ["grace", "faith", "atonement", "Jesus", "Jesus", "works"],
          correctAnswer: "grace",
          textAfter: " you have been saved through",
          textBefore: "For by",
        },
        {
          choices: ["grace", "faith", "atonement", "Jesus", "Jesus", "works"],
          correctAnswer: "faith",
          textAfter: " .",
        },
      ],
      body: "Nobody deserves eternal life! Every person has sinned against God, and the wages of sin is death. Salvation from sin is received by grace, through faith. God’s grace—His power to forgive and cleanse from sin—extends salvation to the human family. Salvation is received by faith—the decision to believe that God can be relied upon, based on the promises in the Bible.",
      choices: ["grace", "faith", "atonement", "Jesus", "works"],
      lessonID: 4,
      question:
        "But can receiving everlasting life be so simple? What if I don't deserve to receive eternal life?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "For by grace you have been saved through faith, and that not of yourselves; it is the gift of God.",
          ref: "Ephesians 2:8",
        },
      ],
    },
    "4-8": {
      blanks: [
        {
          choices: ["perform", "miracle", "pray", "prayer", "speak", "word"],
          correctAnswer: "speak",
          textAfter: " a",
          textBefore:
            "Lord, I am not worthy that You should come under my roof. But only",
        },
        {
          choices: ["perform", "miracle", "pray", "prayer", "speak", "word"],
          correctAnswer: "word",
          textAfter: " , and my servant will be healed.",
        },
      ],
      body: "When Jesus offered to visit a man’s home and heal his servant, the man said that all Jesus needed to do was to speak and the servant would be healed. He believed that God’s word was able to do what it said it would do.\n\n In response, Jesus said, “I have not found such great faith, not even in Israel.” The man’s complete trust in Christ’s word was an example of true faith. Faith says, “If God said it, I expect it to be so.” \n\n When God says He gives you everlasting life, believing He does so and expecting God’s promise to be true is a demonstration of faith in action. God promises to forgive us for our sins and to give us everlasting life. Faith is simply choosing to believe what God has said—believing that the gift of everlasting life is yours!\n\n Another biblical example of faith is found in the experience of Abraham. Romans 4:20, 21 says, “He did not waver at the promise of God through unbelief, but was strengthened in faith, giving glory to God, and being fully convinced that what He had promised He was also able to perform.” Faith is a settled belief in God’s ability to do what the Word of God says God will do.",
      choices: ["perform", "show", "pray", "prayer", "speak", "tell", "word"],
      lessonID: 4,
      question: "What is faith?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "The centurion answered and said, “Lord, I am not worthy that You should come under my roof. But only speak a word, and my servant will be healed.",
          ref: "Matthew 8:8",
        },
      ],
    },
    "4-9": {
      Supplements: {
        "-L7fbARw66_AZ7Pc-KYg": {
          body: "Step Number One: Faith.\n\nThe steps to salvation can be defined in various ways.  However, before a person can exercise faith in God, he or she must know that God exists, and that God accepts and is willing to forgive sinners.  The Bible says, “We love Him, because He first loved us.”  (1 John 4:19)  Knowing and believing in God are essential to salvation.\n\nStep Number Two: A knowledge of the gospel.  \n\nRomans 10:17 says, “Faith comes by hearing, and hearing by the word of God.”  It is certainly true that a person can be saved without an exhaustive knowledge of God’s word or the plan of salvation, but one can only repent when one knows God is willing to forgive and cleanse.\n\nStep Number Three: Repentance.\nRepentance is turning away from sin.  When preaching at Pentecost Peter said to the assembled believers, “Repent, and let every one of you be baptized in the name of Jesus Christ for the remission of sins; and you shall receive the gift of the Holy Spirit.” (Acts 2:38)  Jesus said that no person can serve two masters (Matthew 6:24).  Sorrow for sin and turning away from sin are essential if a person is to come to faith in Jesus.\n\nStep Number Four: Confession.\nWhile related to repentance, confession is more than simply saying sorry for sin.  Confession is a demonstration of that sorrow for sin, as the sinner comes to God acknowledging his or her sinfulness, and recognizing God’s willingness and power to save from sin.  1 John 1:9 says, “If we confess our sins, He is faithful and just to forgives our sins and to cleanse us from all unrighteousness.”\n\nStep Number Five: Receive\nRevelation 3:20 says, ”Behold, I stand at the door and knock. If anyone hears My voice and opens the door, I will come in to him and dine with him, and he with Me.”  Once sins have been acknowledged and confessed the heart can be opened to receive Jesus Christ into your life.  Surrendering to Jesus is an important part of the salvation process.  Surrender takes salvation beyond theory to the experience of righteousness by faith in God.\n\nIt is true the steps to salvation can be expressed in numerous ways.  But these steps summarize the manner in which a saving relationship with Jesus Christ may be experienced.\n\nIs there anything to be done after the steps to salvation have been followed?\n\nYes there is.  Baptism.\n\nBelievers are not saved by baptism, but by grace through faith in Jesus Christ.  But while baptism does not save a person, Jesus made clear that saved people should be baptized.\n\nMatthew 28:19.  “Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost.”\n\nMark 16:15.  “He that believeth and is baptized shall be saved; but he that believeth not shall be damned.”\n\nWhile baptism does not save people, the Bible is clear that saved people will be baptized.\n\nAnd then…\n\nThe Bible says, “As ye have received Christ Jesus the Lord, so walk ye in Him.”  There is a need to continue to walk with Jesus, and especially to commit your life to Jesus daily.  Every day, come to God in commitment and consecration, and receive a fresh endowment of the Holy Spirit.  Paul wrote in 1 Corinthians 15:31, “I die daily.”  That is, every day he gave himself fully to God - He died to self - so that the Holy Spirit could fill his life and guide him according to God’s plan for his life.  Christianity involves a daily - even a moment by moment - commitment to God.  As you learn to more completely surrender your life to Jesus, you will experience more and greater blessing and a more fulfilling Christian walk.\n",
          title: "What are the steps to salvation?",
        },
      },
      blanks: [
        {
          choices: ["Worship", "Pray", "Repent", "Confess"],
          correctAnswer: "Repent",
          textAfter:
            " therefore and be converted, that your sins may be blotted out.",
        },
      ],
      body: "To repent is to turn away from sin. A repentant sinner is sorry for the sins that he or she has committed, and—acknowledging the sinfulness of sin—turns from sin to embrace the righteousness of God.",
      choices: ["Worship", "Pray", "Repent", "Confess"],
      lessonID: 4,
      question: "How do I receive forgiveness for my sins?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "Repent therefore and be converted, that your sins may be blotted out, so that times of refreshing may come from the presence of the Lord.",
          ref: "Acts 3:19",
        },
      ],
    },
  },
  {
    "5-0": {
      body: "In the north of Scotland is Loch Ness, a 21-mile-long lake famous for being the supposed home of a mythical creature known as the Loch Ness Monster. For many hundreds of years, stories have circulated\nclaiming that a mysterious sea creature has been seen in the lake.\n\nIn more recent years, photographs and even video footage of what is said to be the Loch Ness Monster have been released, and detailed scientific testing has been carried out at Loch Ness in an attempt to verify the existence of “Nessie.”\n\nBut in spite of the many claims made as to the existence of the Loch Ness Monster, nobody has been able to prove it exists. Even though there are some who are adamant that the Loch Ness Monster lives in the cool, deep waters of the Scottish lake, it appears to most observers that the Loch Ness Monster simply doesn’t exist.\n\nFor thousands of years, there have been claims made about the existence of a place that very few people can claim to have seen. The  first book of the Bible refers to heaven, as does the last book of the Bible, Revelation. In fact, heaven is mentioned in the Bible hundreds of times.\n\nDoes heaven really exist? And if it does, what is it like? As we consult the Bible, we’ll  find that what God has planned for us is as good as it gets!",
      lessonID: 5,
      questionID: 0,
      type: "text",
    },
    "5-1": {
      blanks: [
        {
          correctAnswer: "heaven",
          textAfter: " .",
          textBefore: "I am the living bread which came down from ",
        },
      ],
      body: "Jesus certainly believed in a place called heaven!  He declared that He came to the world from Heaven",
      choices: ["Rock", "God", "bread", "heaven"],
      lessonID: 5,
      question: "Is there a place call heaven?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "I am the living bread which came down from heaven. If anyone eats of this bread, he will live forever; and the bread that I shall give is My flesh, which I shall give for the life of the world.”",
          ref: "John 6:51",
        },
      ],
    },
    "5-10": {
      blanks: [
        {
          choices: ["earth", "new", "happy", "home"],
          correctAnswer: "new",
          textAfter: " ",
          textBefore:
            "Nevertheless we, according to His promise, look for new heavens and a",
        },
        {
          choices: ["earth", "home", "happy", "new"],
          correctAnswer: "earth",
          textAfter: " in which righteousness dwells.",
        },
      ],
      body: "The New Earth will be the eternal home of God’s saved children.  After spending time in heaven, the redeemed will relocate to a re-created planet Earth.",
      choices: ["earth", "home", "happy", "new"],
      lessonID: 5,
      question: "Will God’s people be in heaven for all eternity?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "Nevertheless we, according to His promise, look for new heavens and a new earth in which righteousness dwells.\n",
          ref: "2 Peter 3:13",
        },
      ],
    },
    "5-11": {
      blanks: [
        {
          choices: ["Paradise", "Jerusalem", "Heavens"],
          correctAnswer: "Jerusalem",
          textAfter:
            " , coming down out of heaven from God, prepared as a bride adorned for her husband.",
          textBefore: "Then I, John, saw the holy city, New",
        },
      ],
      body: "God will relocate what could be referred to as His capital city from heaven to planet Earth. This once-sinful planet, the home of the fall of humanity and the site of the brutal crucifixion of the Savior of the world—Jesus, the Son of God—is transformed into the eternal abode of not only the redeemed but also of Christ Himself (Revelation 21:3; 22:3)!",
      choices: ["Paradise", "Jerusalem", "Heavens"],
      lessonID: 5,
      question: "What will the New Earth be like?",
      questionID: 11,
      questionType: "radio",
      verses: [
        {
          body: "Then I, John, saw the holy city, New Jerusalem, coming down out of heaven from God, prepared as a bride adorned for her husband.",
          ref: "Revelation 21:2",
        },
      ],
    },
    "5-12": {
      blanks: [
        {
          choices: ["joy", "talk", "them", "dwell"],
          correctAnswer: "dwell",
          textAfter: " with",
          textBefore: "Behold, the tabernacle of God is with men, and He will",
        },
        {
          choices: ["joy", "talk", "them", "dwell"],
          correctAnswer: "them",
          textAfter:
            " , and they shall be His people. God Himself will be with them and be their God.",
        },
      ],
      body: "God’s intention—His great desire—is to dwell in the midst of His people for all eternity!",
      choices: ["joy", "talk", "them", "dwell"],
      lessonID: 5,
      question: "What does God intend to do throughout eternity?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I heard a loud voice from heaven saying, “Behold, the tabernacle of God is with men, and He will dwell with them, and they shall be His people. God Himself will be with them and be their God.",
          ref: "Revelation 21:3",
        },
      ],
    },
    "5-13": {
      blanks: [
        {
          choices: ["life", "water", "tree", "river", "life"],
          correctAnswer: "river",
          textAfter: " of",
          textBefore: "And he showed me a pure",
        },
        {
          choices: ["life", "water", "tree", "river", "life"],
          correctAnswer: "water",
          textAfter: " of life clear as ",
        },
        {
          choices: ["life", "water", "tree", "river", "life"],
          correctAnswer: "crystal",
          textAfter:
            " , proceeding from the throne of God and of the Lamb.\n\nIn the middle of its street, and on either side of the river, was the",
        },
        {
          choices: ["life", "water", "tree", "river", "life"],
          correctAnswer: "tree",
          textAfter: " of",
        },
        {
          choices: ["life", "water", "tree", "river", "life"],
          correctAnswer: "life",
          textAfter: " .",
        },
      ],
      body: "\nBoth the river of life and the tree of life will be in the New Earth—the forever home of the redeemed!",
      choices: ["life", "water", "tree", "river", "crystal"],
      lessonID: 5,
      question: "How is the New Earth described in the book of Revelation?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "And he showed me a pure river of water of life, clear as crystal, proceeding from the throne of God and of the Lamb.",
          ref: "Revelation 22:1",
        },
        {
          body: "In the middle of its street, and on either side of the river, was the tree of life, which bore twelve fruits, each tree yielding its fruit every month. The leaves of the tree were for the healing of the nations.",
          ref: "Revelation 22:2",
        },
      ],
    },
    "5-14": {
      blanks: [
        {
          choices: ["adore", "follow", "acknowledge", "serve"],
          correctAnswer: "serve",
          newline: [1],
          textAfter: " Him. ",
          textBefore:
            "And there shall be no more curse, but the throne of God and of the Lamb shall be in it, and His servants shall",
        },
        {
          choices: ["adore", "follow", "acknowledge", "serve"],
          correctAnswer: "face",
          newline: [1],
          textAfter: " and His name shall be on their foreheads.",
          textBefore: "They shall see His ",
        },
        {
          choices: ["adore", "follow", "acknowledge", "serve"],
          correctAnswer: "tear",
          newline: [1],
          textAfter:
            " from their eyes; there shall be no more death, nor sorrow, nor crying. There shall be no more pain, for the former things have passed away.",
          textBefore: "And God will wipe away every  ",
        },
        {
          choices: ["adore", "follow", "acknowledge", "serve"],
          correctAnswer: "Lord",
          textAfter: " ",
          textBefore:
            "There shall be no night there: They need no lamp nor light of the sun, for the  ",
        },
        {
          choices: ["adore", "follow", "acknowledge", "serve"],
          correctAnswer: "God",
          textAfter: " gives them light. And they shall",
          textBefore: " ",
        },
        {
          choices: ["adore", "follow", "acknowledge", "serve"],
          correctAnswer: "reign",
          textAfter: " forever and ever.  ",
        },
      ],
      body: "Throughout eternity, there will be no sin in the New Earth! Revelation 22:15 lists the types of people who will not be permitted to dwell in the Holy City. In short, those who have not yielded to Jesus and have clung instead to their sin will not be in the Earth made new. Sinners would not be happy spending eternity in the presence of a holy God.\n\nNot only will we see God face to face, but His character—represented here by His name—will be restored into the minds of His people!\n\nAnd God will wipe away every tear from their eyes; there shall be no more death, nor sorrow, nor crying. There shall be no more pain, for the former things have passed away.\n\n\nThroughout eternity, there will be no sorrow, pain or death. What a future God’s people have to look forward to!\n\nThere will be no night as the ages of eternity pass. Revelation 21:23 says the glory of the Father and the Son illuminates the New Jerusalem.",
      choices: [
        "adore",
        "follow",
        "acknowledge",
        "serve",
        "face",
        "Lord",
        "Master",
        "reign",
        "God",
        "tear",
      ],
      lessonID: 5,
      question:
        "Discover these remarkable facts about the New Earth that God will make.",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "And there shall be no more curse, but the throne of God and of the Lamb shall be in it, and His servants shall serve Him.",
          ref: "Revelation 22:3",
        },
        {
          body: "They shall see His face, and His name shall be on their foreheads.",
          ref: "Revelation 22:4",
        },
        {
          body: "And God will wipe away every tear from their eyes; there shall be no more death, nor sorrow, nor crying. There shall be no more pain, for the former things have passed away.”",
          ref: "Revelation 21:4",
        },
        {
          body: "There shall be no night there: They need no lamp nor light of the sun, for the Lord God gives them light. And they shall reign forever and ever.",
          ref: "Revelation 22:5",
        },
      ],
    },
    "5-15": {
      blanks: [
        {
          choices: ["construct", "build", "plant", "design"],
          correctAnswer: "build",
          textAfter: " ",
          textBefore: "They shall",
        },
        {
          choices: ["mansions", "vineyards", "houses", "build"],
          correctAnswer: "houses",
          textAfter: " and inhabit them;\nthey shall",
        },
        {
          choices: ["design", "cultivate", "plant", "build"],
          correctAnswer: "plant",
          textAfter: " ",
        },
        {
          choices: ["houses", "vineyards", "plant", "build"],
          correctAnswer: "vineyards",
          textAfter: " and eat their fruit.",
        },
      ],
      body: "Heaven will be a place of useful activity, where God’s people will be able to develop talents and skills and use them in constructive ways.",
      choices: ["houses", "vineyards", "plant", "build"],
      lessonID: 5,
      question:
        "What does the Bible say God’s people will do in the New Earth?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "They shall build houses and inhabit them;\nThey shall plant vineyards and eat their fruit.",
          ref: "Isaiah 65:21",
        },
      ],
    },
    "5-16": {
      blanks: [
        {
          choices: ["little", "multitude", "great", "child"],
          correctAnswer: "little",
          textAfter: " ",
          textBefore:
            "The wolf also shall dwell with the lamb, the leopard shall lie down with the young goat, the calf and the young lion and the fatling together; and a",
        },
        {
          choices: ["little", "multitude", "great", "child"],
          correctAnswer: "child",
          textAfter: " shall lead them.",
        },
      ],
      body: "Isaiah 11:9 says, “They shall not hurt nor destroy in all My holy mountain, for the earth shall be full of the knowledge of the Lord.”\n\nHeaven will be a place where there is no danger, and animals that are now natural enemies will dwell together in harmony.",
      choices: ["little", "multitude", "great", "child"],
      lessonID: 5,
      question:
        "How else does God describe the blessedness of our forever home?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "“The wolf also shall dwell with the lamb,\nThe leopard shall lie down with the young goat,\nThe calf and the young lion and the fatling together;\nAnd a little child shall lead them.",
          ref: "Isaiah 11:6",
        },
      ],
    },
    "5-17": {
      Supplements: {
        "-L83OIhEYZlfSFE6lH8w": {
          body: 'Revelation 21:8 describes the wicked in these terms: “But the cowardly, unbelieving, abominable, murderers, sexually immoral, sorcerers, idolaters, and all liars shall have their part in the lake which burns with fire and brimstone, which is the second death.” Sadly, cowardice (fear) and unbelief will keep many people out of heaven. Those same two things kept most people out of the ark in Noah’s day. Some people didn’t believe that a flood was coming and others heard Noah’s preaching (He preached for 120 years! - 2 Peter 2:5), but because they were afraid of what getting on the ark would cost them, they chose not to make the journey up the ramp. In the end, everyone who didn’t join Noah and his family were washed away.\n\nAnother group of the wicked described in Revelation 21:8 is the liars. 1 John 2:4 says, “He who says, “I know Him,” and does not keep His commandments, is a liar, and the truth is not in him." There will be many people who claim to know (love) Jesus, but their actions make it clear that their profession of love for their Savior is an empty one. True love will lead a person to want to believe and follow Jesus, not walk away from Him and His teachings. \n\nAnother important point to consider.  Jesus said in John 5:39,40, “Search the scriptures; for in them ye think ye have eternal life: and they are they which testify of me. And ye will not come to me, that ye might have life.” \n\nDid you notice that?  What is it that was keeping people from being saved?  They wouldn’t come to Jesus.  Jesus has died for our sins, and he is “the way of escape” (1 Corinthians 10:13) from temptation and our Advocate when we sin (1 John 2:1).  He invites you to come to Him in faith (Matthew 11:28).  Failing, refusing or neglecting to come to Him is what will keep people out of heaven.  If you come to Jesus, He is willing to forgive you for any and every sin you have committed (Matthew 12:31; Mark 3:28).\n\nThere is no better time than today to get ready for heaven. Make a decision to accept Jesus as your Savior and then follow Him wherever He leads.',
          title: "What will keep most people out of heaven?",
        },
      },
      blanks: [
        {
          choices: ["many", "grace", "works", "faith", "commandments"],
          correctAnswer: "grace",
          textAfter: " you have been saved through",
          textBefore: "For by",
        },
        {
          choices: ["faith", "grace", "works", "effort", "commandments"],
          correctAnswer: "faith",
          textAfter:
            " , and that not of yourselves; it is the gift of God.\n\nBlessed are those who do His",
        },
        {
          choices: ["will", "grace", "commandments", "faith", "works"],
          correctAnswer: "commandments",
          textAfter:
            " , that they may have the right to the tree of life, and may enter through the gates into the city.",
        },
      ],
      body: "The person who has faith in God will be given the gift of everlasting life, transformed by the power of His grace and prepared for eternity.\n\nLove for God will be manifest in loving obedience toward the One who is willing to save and keep His people for all eternity.",
      choices: ["many", "grace", "works", "faith", "commandments"],
      lessonID: 5,
      question:
        "How can a person have the assurance that he or she can look forward to eternity with God?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "For by grace you have been saved through faith, and that not of yourselves; it is the gift of God,",
          ref: "Ephesians 2:8",
        },
        {
          body: "Blessed are those who do His commandments, that they may have the right to the tree of life, and may enter through the gates into the city.",
          ref: "Revelation 22:14",
        },
      ],
    },
    "5-18": {
      blanks: [
        {
          choices: ["return", "again", "come", "call"],
          correctAnswer: "come",
          textAfter: " ",
          textBefore:
            "In My Father’s house are many mansions; if it were not so, I would have told you. I go to prepare a place for you. And if I go and prepare a place for you, I will",
        },
        {
          choices: ["there", "over", "here", "again"],
          correctAnswer: "again",
          textAfter:
            " and receive you to Myself; that where I am, there you may be also.",
        },
      ],
      body: "\nJesus promises us that one day soon, He will return to this world and take us to be with Him in heaven!\n\nThrough faith in God’s Word, you can have the assurance that heaven is real, that life after life on this earth is going to be full of meaning and purpose, and that the New Earth will be a place of blessing and goodness.\n\nJesus said that He is in heaven preparing a place for you—right now (John 14:2, 3)! Soon He will return to take us to our glorious heavenly home. You can be confident of your place in heaven simply by accepting Jesus as the Lord of your life—by accepting His offer of free forgiveness of sin and yielding your life unreservedly to Him.",
      choices: ["there", "again", "come", "dwell"],
      lessonID: 5,
      question: "What great promise did Jesus make us with regard to heaven?",
      questionID: 18,
      questionType: "wordCloud",
      verses: [
        {
          body: "2 In My Father’s house are many mansions; if it were not so, I would have told you. I go to prepare a place for you.\n\n3 And if I go and prepare a place for you, I will come again and receive you to Myself; that where I am, there you may be also.",
          ref: "John 14:2, 3",
        },
      ],
    },
    "5-19": {
      correctAnswer: "true",
      question:
        "Would you be willing to surrender your life to Jesus now, and ask Him to live His life in you?",
      questionID: 19,
      questionType: "truthConfirmation",
    },
    "5-2": {
      blanks: [
        {
          choices: ["air", "heaven", "tree", "sky", "firmament"],
          correctAnswer: "air",
          newline: [1],
          textAfter: " .\n\n",
          textBefore:
            "So He destroyed all living things which were on the face of the ground: both man and cattle, creeping thing and bird of the",
        },
        {
          choices: ["earth", "the sky", "heaven", "world", "firmament"],
          correctAnswer: "stars",
          newline: [1],
          textAfter: " of the heaven.",
          textBefore: "I will multiply your descendants as the ",
        },
        {
          choices: ["Israel", "heaven", "Jerusalem", "the sky", "firmament"],
          correctAnswer: "heaven",
          textAfter: " .",
          textBefore:
            "Let your light so shine  before men, that they may see your good works and glorify your Father in",
        },
      ],
      body: "In the Word of God, “heaven” can refer to the air (where the birds  fly), outer space (where the stars are), or to heaven itself, where God dwells.",
      choices: ["air", "heaven", "tree", "sky", "firmament", "stars"],
      lessonID: 5,
      question:
        "What is the Bible actually referring to when it mentions heaven?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "So He destroyed all living things which were on the face of the ground: both man and cattle, creeping thing and bird of the air. They were destroyed from the earth. Only Noah and those who were with him in the ark remained alive.",
          ref: "Genesis 7:23",
        },
        {
          body: "blessing I will bless you, and multiplying I will multiply your descendants as the stars of the heaven and as the sand which is on the seashore; and your descendants shall possess the gate of their enemies",
          ref: "Genesis 22:17",
        },
        {
          body: "Let your light so shine before men, that they may see your good works and glorify your Father in heaven.",
          ref: "Matthew 5:16",
        },
      ],
    },
    "5-3": {
      blanks: [
        {
          choices: ["house", "in", "Father's", "tree", "My", "heaven"],
          correctAnswer: "in",
          textAfter: " ",
          textBefore:
            "An inheritance incorruptible and undefiled and that does not fade away, reserved",
        },
        {
          choices: ["house", "in", "Father's", "tree", "My", "heaven"],
          correctAnswer: "heaven",
          textAfter: " for you.\n\nIn",
        },
        {
          choices: ["house", "in", "Father's", "tree", "My", "heaven"],
          correctAnswer: "My",
          textAfter: " ",
        },
        {
          choices: ["house", "in", "Father's", "tree", "My", "heaven"],
          correctAnswer: "Father's",
          textAfter: " ",
        },
        {
          choices: ["house", "in", "Father's", "tree", "My", "heaven"],
          correctAnswer: "house",
          textAfter:
            " are many mansions; if it were not so, I would have told you.",
        },
      ],
      body: "God’s people will certainly go to heaven!",
      choices: ["house", "in", "Father's", "tree", "My", "heaven"],
      lessonID: 5,
      question: "Is heaven a physical place to which God’s people can go?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "An inheritance incorruptible and undefiled and that does not fade away, reserved in heaven for you.",
          ref: "1 Peter 1:4",
        },
        {
          body: "In My Father’s house are many mansions; if it were not so, I would have told you. I go to prepare a place for you.",
          ref: "John 14:2",
        },
      ],
    },
    "5-4": {
      blanks: [
        {
          choices: ["gathered", "up", "caught", "the", "taken"],
          correctAnswer: "caught",
          textAfter: " ",
          textBefore:
            "For the Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will rise first. Then we who are alive and remain shall be",
        },
        {
          choices: ["away", "in", "up", "the", "with"],
          correctAnswer: "up",
          textAfter: " together with them in the clouds to meet the Lord",
        },
        {
          choices: ["in", "up", "below", "with", "air"],
          correctAnswer: "in",
          textAfter: " ",
        },
        {
          choices: ["in", "up", "caught", "the", "air"],
          correctAnswer: "the",
          textAfter: " ",
        },
        {
          choices: ["heavens", "up", "kingdom", "realm", "air"],
          correctAnswer: "air",
          textAfter: " . And thus we shall always be with the Lord.",
        },
      ],
      body: "Based on what we read in the Bible, God’s people will “travel” to heaven accompanied by Jesus! While it isn’t easy to understand exactly how this will look, it seems logical to assume that the redeemed are going to experience intergalactic space travel!",
      choices: ["in", "up", "caught", "the", "air"],
      lessonID: 5,
      question: "How will we get to heaven?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "16 For the Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will rise first.\n\n17 Then we who are alive and remain shall be caught up together with them in the clouds to meet the Lord in the air. And thus we shall always be with the Lord.",
          ref: "1 Thessalonians 4:16, 17",
        },
      ],
    },
    "5-5": {
      blanks: [
        {
          choices: [
            "heart",
            "imagination",
            "mind",
            "entered",
            "passed",
            "come",
          ],
          correctAnswer: "entered",
          textAfter: " into the",
          textBefore: "Eye has not seen, nor ear heard, nor have",
        },
        {
          choices: [
            "heart",
            "imagination",
            "mind",
            "entered",
            "passed",
            "come",
          ],
          correctAnswer: "heart",
          textAfter:
            " of man the things which God has prepared for those who love Him.",
        },
      ],
      body: "Try as we might, we can’t even imagine how wonderful heaven will be!\n\nTake a moment to think about the most beautiful place you’ve ever seen. Heaven will be better! Your most enjoyable vacation? Better! The most memorable time you’ve ever had? Heaven will be better than that! Although there’s no harm in trying, we simply cannot imagine how truly wonderful heaven is going to be.",
      choices: ["heart", "imagination", "mind", "entered", "passed", "come"],
      lessonID: 5,
      question: "What is heaven going to be like?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "Eye has not seen, nor ear heard, nor have entered into the heart of man the things which God has prepared for those who love Him.",
          ref: "1 Corinthians 2:9",
        },
      ],
    },
    "5-6": {
      blanks: [
        {
          choices: ["inexpressible", "in", "heaven", "words"],
          correctAnswer: "inexpressible",
          textAfter: " ",
          textBefore: "He was caught up into Paradise and heard",
        },
        {
          choices: ["inexpressible", "in", "heaven", "words"],
          correctAnswer: "words",
          newline: [1],
          textAfter: " .",
        },
        {
          choices: ["inexpressible", "in", "heaven", "words"],
          correctAnswer: "in",
          textAfter: " ",
          textBefore:
            "\n\n After these things I looked, and behold, a door standing open",
        },
        {
          choices: ["inexpressible", "in", "heaven", "words"],
          correctAnswer: "heaven",
          textAfter: " .",
        },
      ],
      body: "Paul says this individual was caught up to “the third heaven”—the heaven where God dwells (2 Corinthians 12:2).",
      choices: ["inexpressible", "in", "heaven", "words"],
      lessonID: 5,
      question: "Has anyone ever seen heaven and written about it?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "How he was caught up into Paradise and heard inexpressible words, which it is not lawful for a man to utter.",
          ref: "2 Corinthians 12:4",
        },
        {
          body: "After these things I looked, and behold, a door standing open in heaven. And the first voice which I heard was like a trumpet speaking with me, saying, “Come up here, and I will show you things which must take place after this.”",
          ref: "Revelation 4:1",
        },
      ],
    },
    "5-7": {
      blanks: [
        {
          choices: ["one", "sat", "throne", "God"],
          correctAnswer: "throne",
          textAfter: " set in heaven, and",
          textBefore: "Immediately I was in the Spirit; and behold, a",
        },
        {
          choices: ["one", "sat", "throne", "God"],
          correctAnswer: "one",
          textAfter: " ",
        },
        {
          choices: ["one", "sat", "throne", "God"],
          correctAnswer: "sat",
          textAfter: " on the throne.",
        },
      ],
      body: "John saw God’s throne, and God Himself—in heaven!\n\nIn Daniel 7:9, 10, Daniel describes a vision he received of heaven. \nIn heaven he saw:\n God the Father (the Ancient of Days)\n God’s clothing (as white as snow)\n God’s hair (like pure wool)\n God’s throne (a fiery flame)\n The wheels of the throne (a burning  fire)\n Great multitudes of angels\n\nIn Revelation 4, John describes:\n God the Father\n The throne of God\n A rainbow around God’s throne\n The 24 elders\n The sea of glass",
      choices: ["one", "sat", "throne", "God"],
      lessonID: 5,
      question: "What have Bible writers seen in heaven?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "Immediately I was in the Spirit; and behold, a throne set in heaven, and One sat on the throne.",
          ref: "Revelation 4:2",
        },
      ],
    },
    "5-8": {
      blanks: [
        {
          choices: ["of", "ark", "his", "covenant"],
          correctAnswer: "ark",
          textAfter: " ",
          textBefore: "Then the temple of God was opened in heaven, and the",
        },
        {
          choices: ["of", "ark", "his", "covenant"],
          correctAnswer: "of",
          textAfter: " ",
        },
        {
          choices: ["of", "ark", "his", "covenant"],
          correctAnswer: "his",
          textAfter: " ",
        },
        {
          choices: ["of", "ark", "his", "covenant"],
          correctAnswer: "covenant",
          textAfter: " was seen in His temple.",
        },
      ],
      body: "Heaven is the home of the Ark of the Covenant, the sacred repository of the Ten Commandments. The Ten Commandments are in heaven.",
      choices: ["of", "ark", "his", "covenant"],
      lessonID: 5,
      question:
        "What other significant aspect of heaven is revealed in the book of Revelation?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then the temple of God was opened in heaven, and the ark of His covenant was seen in His temple. And there were lightnings, noises, thunderings, an earthquake, and great hail.",
          ref: "Revelation 11:19",
        },
      ],
    },
    "5-9": {
      blanks: [
        {
          choices: ["Lord", "people", "sanctuary", "Highest"],
          correctAnswer: "sanctuary",
          textAfter: " and of the true tabernacle which the",
          textBefore:
            "We have such a High Priest, who is seated at the right hand of the throne of the Majesty in the heavens, a Minister of the",
        },
        {
          choices: ["Lord", "people", "sanctuary", "Highest"],
          correctAnswer: "Lord",
          textAfter: " erected.",
        },
      ],
      body: "Jesus is in heaven as our High Priest, interceding for us  before the Father’s throne. Jesus’ ministry takes place in the heavenly sanctuary, which was built by God. Heaven is where Jesus’ work in the plan of salvation is currently being carried out.",
      choices: ["Lord", "people", "sanctuary", "Highest"],
      lessonID: 5,
      question: "Where is Jesus now, and what is He doing?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "1 Now this is the main point of the things we are saying: We have such a High Priest, who is seated at the right hand of the throne of the Majesty in the heavens,\n\n2 a Minister of the sanctuary and of the true tabernacle which the Lord erected, and not man.\n ",
          ref: "Hebrews 8:1, 2",
        },
      ],
    },
  },
  {
    "6-0": {
      body: "Peace on Earth, and goodwill toward men...” Each year at Christmastime, the refrain is the same, but the truth is that there is little real peace on earth. Multiplied millions of people have died in wars in recent decades, and hostilities and conflicts continue to rage around the world. Society is not as safe as it was in past generations, and there is a tragic lack of peace in many homes and in the lives of countless individuals. Stress, depression, addiction, illness and much more conspire to rob people of peace. The Bible refers to Jesus as the “Prince of Peace” (Isaiah 9:6). Yet there seems to be a remarkable lack of peace in the world today. Does God have a way of restoring real peace into the lives of His people?",
      lessonID: 6,
      questionID: 0,
      type: "text",
    },
    "6-1": {
      blanks: [
        {
          choices: ["commandments", "ways", "law", "character"],
          correctAnswer: "law",
          textAfter: " .",
          textBefore: "Great peace have those who love your",
        },
      ],
      body: "Peace is promised to those who love the law of God.",
      choices: ["commandments", "ways", "law", "character"],
      lessonID: 6,
      question: "How can a person have real peace in today's troubled world?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "Great peace have those who love Your law,\nand nothing causes them to stumble.",
          ref: "Psalm 119:165",
        },
      ],
    },
    "6-10": {
      blanks: [
        {
          choices: [
            "destroy",
            "fulfill",
            "keep",
            "suspend",
            "reject",
            "accept",
          ],
          correctAnswer: "destroy",
          textAfter: " but to",
          textBefore:
            "Do not think that I came to destroy the Law or the Prophets. I did not come to",
        },
        {
          choices: [
            "destroy",
            "fulfill",
            "keep",
            "suspend",
            "reject",
            "accept",
          ],
          correctAnswer: "fulfill",
          textAfter:
            " . For Assuredly, I say to you, till heaven and earth pass away, one jot or one tittle will by no means pass from the law till all is fulfilled.",
        },
      ],
      body: "Jesus never intended that the Ten Commandments be set aside. While He was on the Earth He said, “I have kept My Father’s commandments” (John 15:10). Jesus counseled people to keep the Ten Commandments. His words to the rich young ruler could not be clearer: “If you want to enter into life, keep the commandments” (Matthew 19:17).",
      choices: ["destroy", "fulfill", "keep", "suspend", "reject", "accept"],
      lessonID: 6,
      question:
        "Did Jesus ever suggest the Ten Commandments would one day become obsolete?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "17 “Do not think that I came to destroy the Law or the Prophets. I did not come to destroy but to fulfill.\n\n18 For assuredly, I say to you, till heaven and earth pass away, one jot or one tittle will by no means pass from the law till all is fulfilled.",
          ref: "Matthew 5:17, 18",
        },
      ],
    },
    "6-11": {
      Supplements: {
        "-L83LtLiKAzspioSu717": {
          body: "God’s law is a transcript of His character. It shows us what God is like. For example, God is holy (Isa. 5:16), pure (1 John 3:2,3),  faithful (1 Cor. 1:9), and love (1 John 4:8). His law is also holy (Romans 7:12), pure (Psalm 19:8), faithful (Psalm 119:86), and love (Romans 13:10).  \n\nWhen we look at God’s law, it helps us to see our defects of character and how far short of His glory we fall. James likens it to a mirror (James 1:22),   because it points out our sins (1 John 3:4). \n\nNot surprisingly, there is a penalty for breaking God’s law. In the words of Paul in Romans 6:23,    “For the wages of sin is death.” That’s what we deserve. However, the verse continues, “...but the gift of God is eternal life in Christ Jesus our Lord.”    That’s grace.\n\nInstead of giving us what we deserve, God (because He is love), offers us life instead of death. That’s why Jesus chose to die on the cross    for us. He didn’t have to, but Hebrews 9:22 says, “Without shedding of blood there is no remission (for sin).” Since someone had to die for our transgression    of God’s law, Jesus stepped up and took our place, because He’d rather go through the agony of death than spend eternity without us. Romans 5:20 tells us, “Moreover the    law entered that the offense might abound. But where sin abounded, grace abounded much more.”\n\nTo experience that grace, we accept Jesus’ sacrifice on our behalf,    receive Him as our Savior, and confess our sins to Him that they may be forgiven (1 John 1:9).\n\nAnd the result? We can begin to live a victorious life in Him and     have a peace, “which surpasses all understanding” (Philippians 4:7). \n\nWhat an amazing God!\n",
          title: "How are God’s law and God’s grace related? ",
        },
      },
      blanks: [
        {
          choices: ["mind", "hearts", "tablets", "foreheads", "world", "books"],
          correctAnswer: "mind",
          textAfter: " and write them on their",
          textBefore:
            "For this is the covenant that I will make with the house of Israel after those days, says the Lord: I will put My laws in their",
        },
        {
          choices: ["mind", "hearts", "tablets", "foreheads", "world", "books"],
          correctAnswer: "hearts",
          textAfter: " ; and I will be their God, and they shall be My people.",
        },
      ],
      body: "The “Old Covenant” was God’s agreement with Israel in the Old Testament dispensation (Genesis 17:1–8). God agreed that He would be Israel’s God, and Israel would be His people—and both parties agreed that the Ten Commandments would provide a framework for the covenant (Deuteronomy 9:9–11). \n\nThe New Covenant is simply the Old Covenant renewed: God will be God to His people, and His people will be believers in Jesus. The Ten Commandments continue to provide a framework for a healthy relationship between God and His people.",
      choices: ["mind", "hearts", "tablets", "foreheads", "hand", "books"],
      lessonID: 6,
      question: "Are the Ten Commandments necessary under the New Covenant?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "For this is the covenant that I will make with the house of Israel after those days, says the Lord: I will put My laws in their mind and write them on their hearts; and I will be their God, and they shall be My people.",
          ref: "Hebrews 8:10",
        },
      ],
    },
    "6-12": {
      blanks: [
        {
          choices: [
            "Christ",
            "works in",
            "way of escape",
            "Jesus",
            "will command",
            "load much lighter",
            "God",
            "give you",
            "pain less terrible",
          ],
          correctAnswer: "Christ",
          newline: [1],
          textAfter: " lives in me.",
          textBefore:
            "I have been crucified with Christ; it is no longer I who live, but",
        },
        {
          choices: [
            "Christ",
            "works",
            "way of escape",
            "Jesus",
            "will command",
            "load much lighter",
            "God",
            "give you",
            "pain less terrible",
          ],
          correctAnswer: "works",
          textAfter: " ",
          textBefore: " It is God who",
        },
        {
          choices: [
            "Christ",
            "in",
            "way of escape",
            "Jesus",
            "will command",
            "load much lighter",
            "God",
            "give you",
            "pain less terrible",
          ],
          correctAnswer: "in",
          newline: [1],
          textAfter: " you both to will and to do for His good pleasure. ",
        },
        {
          choices: [
            "Christ",
            "works in",
            "way",
            "Jesus",
            "will command",
            "load much lighter",
            "of",
          ],
          correctAnswer: "way",
          textAfter: " ",
          textBefore:
            "No temptation has overtaken you except such as is common to man; but God is faithful, who will not allow you to be tempted beyond what you are able, but with the temptation will also make the",
        },
        {
          choices: [
            "Christ",
            "works in",
            "way",
            "Jesus",
            "will command",
            "load much lighter",
            "of",
          ],
          correctAnswer: "of",
          textAfter: " ",
        },
        {
          choices: [
            "escape",
            "works in",
            "way",
            "Jesus",
            "will command",
            "load much lighter",
            "of",
          ],
          correctAnswer: "escape",
          textAfter: ", that you may be able to bear it.",
        },
      ],
      body: "The Bible tells us that all people “have sinned and fall short of the glory of God” (Romans 3:23). However, through the Holy Spirit, Jesus is willing to live His life in us. Strengthened by His presence, God’s people can be assured of heaven’s power to provide a heavenly ability to live in harmony with His law.",
      choices: [
        "Christ",
        "escape",
        "works",
        "Jesus",
        "in",
        "way",
        "of",
        "pain",
        "less",
        "terrible",
      ],
      lessonID: 6,
      question: "How can a person keep the Ten Commandments?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.",
          ref: "Galatians 2:20",
        },
        {
          body: "For it is God who works in you both to will and to do for His good pleasure.",
          ref: "Philippians 2:13",
        },
        {
          body: "No temptation has overtaken you except such as is common to man; but God is faithful, who will not allow you to be tempted beyond what you are able, but with the temptation will also make the way of escape, that you may be able to bear it.",
          ref: "1 Corinthians 10:13",
        },
      ],
    },
    "6-13": {
      Supplements: {
        "-L83VefPo7J-nkeeMCTc": {
          body: "Faith in God is best demonstrated by adopting a humble heart. Perhaps the story of the centurion is a good example of someone who had such a heart. In Matthew 8 we find a fascinating story that can teach us an immense lesson on the importance of faith.\n\nA Roman centurion with a sick servant approached Jesus asking Him to heal his servant. “Now when Jesus had entered Capernaum, a centurion came to Him, pleading with Him, saying, ‘Lord, my servant is lying at home paralyzed, dreadfully tormented.’ And Jesus said to him, ‘I will come and heal him.’ The centurion answered and said, ‘Lord, I am not worthy that You should come under my roof. But only speak a word, and my servant will be healed. For I also am a man under authority, having soldiers under me. And I say to this one, ‘Go,’ and he goes; and to another, ‘Come,’ and he comes; and to my servant, ‘Do this,’ and he does it’”  (see Matthew 8:1-9).\n\nIn essence, the centurion tells Jesus that he is a pretty influential and powerful person, but his power and influence are nothing compared to that of Jesus. He doesn’t even want Jesus to come to his house, but rather to just, ‘say the word’, and the centurion has faith that his servant will be healed. \n\nThe remainder of the story concludes, “When Jesus heard it, He marveled, and said to those who followed, ‘Assuredly, I say to you, I have not found such great faith, not even in Israel! And I say to you that many will come from east and west, and sit down with Abraham, Isaac, and Jacob in the kingdom of heaven. But the sons of the kingdom will be cast out into outer darkness. There will be weeping and gnashing of teeth.’ Then Jesus said to the centurion, ‘Go your way; and as you have believed, so let it be done for you.’ And his servant was healed that same hour” (Matthew 8:10-13).\n\nYou are one of those who came “from east and west”. When we recognize just how great Jesus is and how insignificant (in comparison) we are, it helps us to be more humble and appreciative of all that He offers to us. We can learn to take Jesus at His word just as the centurion did. After all, Romans 10:17 tells us, “So then faith comes by hearing, and hearing by the word of God”.\n\nHebrews 11:1 says, “Now faith is the substance of things hoped for, the evidence of things not seen”. Do you hope to see Jesus and thank Him one day for giving you the gift of salvation? An attitude of gratitude will pay dividends, just as it did for the centurion.\n",
          title: "How is faith in God demonstrated?",
        },
      },
      blanks: [
        {
          choices: ["grace", "works", "Christ", "yourself", "love", "riches"],
          correctAnswer: "grace",
          textAfter:
            " you have been saved through faith, and that not of yourselves; it is the gift of God, not of",
          textBefore: "For by",
        },
        {
          choices: ["grace", "works", "Christ", "yourself", "love", "riches"],
          correctAnswer: "works",
          textAfter: " , lest anyone should boast.",
        },
      ],
      body: "Salvation is a gift (Romans 6:23), and cannot in any way be earned. While God promises us heaven’s power to enable us to live obedient lives (Jude 24), salvation is not received as a result of our obedience to God’s laws. Salvation is given by God as a gift, and is received when a sinner exercises faith in God’s ability and willingness to save. When you choose to accept the gift of salvation, you can know that salvation is yours!",
      choices: ["grace", "works", "Christ", "yourself", "love", "riches"],
      lessonID: 6,
      question: "Are people saved by keeping the Ten Commandments?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "8 For by grace you have been saved through faith, and that not of yourselves; it is the gift of God,\n\n9 not of works, lest anyone should boast.\n",
          ref: "Ephesians 2:8, 9",
        },
      ],
    },
    "6-14": {
      Supplements: {
        "-L83XKOJ3JryHr8afjx1": {
          body: "Let’s start by defining sin. The textbook definition, found in the Bible, is 1 John 3:4. It says, “Whoever commits sin also commits lawlessness, and sin is lawlessness.”\nWith sin now well defined, we have to address what should be done with it in order for it to be forgiven. 1 John 1:9 tells us, “If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.” So, we confess our sins and the promise is that they will be forgiven. But to whom do we confess our sins? To a priest? Well... yes. And we have One. \n\nHebrews 4:15 describes Him this way. “For we do not have a High Priest who cannot sympathize with our weaknesses, but was in all points tempted as we are, yet without sin.” Jesus was tempted just like we are, but He was victorious over those temptations. He also died the death that those transgressions required (Romans 6:23) and rose again as a Victor. That’s why He is the only one Who can forgive us our sins. We tell Jesus where we have fallen short of His perfect character, where we have broken His commandments, and how sorry we are for causing Him and others pain. We then ask Him to forgive us for what we have done in word, deed, or thought. \nIt is also helpful to remember that there are both sins of commission and sins of omission. Sins of commission are things that we have done that were wrong. Sins of omission are things that we should have done that we did not do. Both are wrong.\n\nIf we have sinned against another person, in addition to asking Jesus for forgiveness, we should also ask that person for forgiveness. And, where possible, we should also make amends for the offense. James 5:16 counsels us, “Confess your trespasses to one another, and pray for one another, that you may be healed.” Ezekiel 33:15 says, “If the wicked restores the pledge, gives back what he has stolen, and walks in the statutes of life without committing iniquity, he shall surely live; he shall not die.” \n\nGranted, there will be times when we cannot remember everything we have done to hurt someone, or it may not be possible to patch up the damage that we have done. In those cases, Jesus’ blood covers those sins. But where we can do something to help set things aright, it is part of the healing process.\n\nAlong the way, you can expect that the devil will try to beat you up about things you have done in the past. Remember, if you’ve confessed and forsaken those things, the promise is that they have been forgiven and cast into the depths of the sea (Micah 7:19). Take Jesus at His word. They’re forgiven. Because if you keep beating yourself up about the things that Jesus has already told you have been forgiven, you’re essentially believing the stories of the devil and calling Jesus a liar. And that’s never a good idea.\n",
          title: "What is confession of sin?",
        },
      },
      blanks: [
        {
          choices: [
            "Advocate",
            "Jesus",
            "confess",
            "forgive",
            "cleanse",
            "arrangement",
          ],
          correctAnswer: "Advocate",
          textAfter: " with the Father,",
          textBefore:
            "My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an",
        },
        {
          choices: [
            "Advocate",
            "Jesus",
            "confess",
            "forgive",
            "cleanse",
            "arrangement",
          ],
          correctAnswer: "Jesus",
          textAfter: " ",
        },
        {
          choices: [
            "Advocate",
            "Christ",
            "confess",
            "forgive",
            "cleanse",
            "arrangement",
          ],
          correctAnswer: "Christ",
          textAfter: " the righteous. If we",
        },
        {
          choices: [
            "Advocate",
            "Jesus Christ",
            "confess",
            "forgive",
            "cleanse",
            "arrangement",
          ],
          correctAnswer: "confess",
          textAfter: " our sins, He is faithful and just to",
        },
        {
          choices: [
            "Advocate",
            "Jesus Christ",
            "confess",
            "forgive",
            "cleanse",
            "arrangement",
          ],
          correctAnswer: "forgive",
          textAfter: " us our sins and to",
        },
        {
          choices: [
            "Advocate",
            "Jesus Christ",
            "confess",
            "forgive",
            "cleanse",
            "arrangement",
          ],
          correctAnswer: "cleanse",
          textAfter: " us from all unrighteousness.",
        },
      ],
      body: 'God is willing to forgive anyone who comes to Him in repentance.  Romans 5:20 says, "where sin abounded, grace abounded much more." This truth isn\'t intended to cause us to treat sin lightly, but to assure us that when we fall into sin and then turn to God in faith, He will extend grace and mercy to us.  The Bible is clear that "the Lord is merciful and gracious" (Psalm 103:8).',
      choices: [
        "Advocate",
        "Jesus",
        "confess",
        "forgive",
        "cleanse",
        "arrangement",
        "Christ",
      ],
      lessonID: 6,
      question:
        "What should a person do when they break the commandments of God?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an Advocate with the Father, Jesus Christ the righteous.",
          ref: "1 John 2:1",
        },
        {
          body: "If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.",
          ref: " 1 John 1:9",
        },
      ],
    },
    "6-15": {
      Supplements: {
        "-L83XzLvjXLbdo2g__D1": {
          body: "The Holy Spirit is the third Person of the Godhead. He is just as much God as the Father or the Son (Acts 5:3,4). He’s also the Father’s appointed Messenger for communicating with humanity today. The Holy Spirit teaches us (John 14:26), He guides us (John 16:13), He convicts us of our sins (John 16:7,8), and he seeks to unite us together (1 Corinthians 12:13). \n\nHe is that still, small voice in our minds (we often refer to Him as our “conscience,” though that’s a rather limited view of what He is) that tells us when something is right or wrong, and He always points us back to the Bible to find God’s will for our lives. If we resist His promptings (Acts 7:51), we can grieve Him away (Ephesians 4:30). And if we push Him away long enough, we will end up committing the unpardonable sin (Matthew 12:30-32).  So, ask God to send the Holy Spirit into your life and He will help you make the decisions that will bring joy and happiness to the Heart of God. And you’ll feel pretty good about life, too.\n",
          title: "Who is the Holy Spirit?",
        },
      },
      blanks: [
        {
          choices: ["desire", "heart", "against", "mind", "within", "will"],
          correctAnswer: "within",
          textAfter: "my",
          textBefore: "I delight to do Your will, O my God, and Your law is",
        },
        {
          choices: ["desire", "heart", "against", "mind", "within", "will"],
          correctAnswer: "heart",
          textAfter: ".",
        },
      ],
      body: "God promises to write His law in our heart (Hebrews 8:10). When the Holy Spirit enters a person's life–when your life is surrendered to Jesus–obedience to God becomes a joy. When Jesus comes into a person's heart, He brings with Him a love for God that includes a love for obeying God. God will do in us what we cannot do for ourselves!",
      choices: ["desire", "heart", "against", "mind", "within", "will"],
      lessonID: 6,
      question: "How does a person learn to keep the commandments of God?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "I delight to do Your will, O my God, and Your law is within my heart.",
          ref: "Psalm 40:8",
        },
      ],
    },
    "6-16": {
      blanks: [
        {
          choices: ["love", "hate", "want", "like"],
          correctAnswer: "love",
          textAfter: " Me, keep My commandments.",
          textBefore: "If you",
        },
      ],
      body: "Jesus is referring to what happens when a person loves God with his or her whole heart, soul, and mind (Matthew 22:37). Love for God results in an ever deepening surrender to God. When we love Jesus, obeying Him comes naturally!",
      choices: ["love", "hate", "want", "like"],
      lessonID: 6,
      question: "What is the key to living in harmony with God's law?",
      questionID: 16,
      questionType: "radio",
      verses: [
        {
          body: "If you love Me, keep My commandments.",
          ref: "John 14:15",
        },
      ],
    },
    "6-17": {
      correctAnswer: "true",
      question:
        "Are you willing today to invite Jesus to live His life in you, and to guide you in a life of loving obedience to God?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "6-2": {
      Supplements: {
        "-L83JOuKilIcS_u_mrRr": {
          body: "Patience (or perseverance) is often developed through trials and hardships. Romans 5:3 says, “And not only that, but we also glory in tribulations, knowing that tribulation produces perseverance.” It also comes from learning to trust that God knows what is best for us in our lives. Since we live in a society in which instant gratification is expected in nearly every situation, the development of patience can be difficult. \n\nJeremiah 29:11-13 gives us a beautiful picture of God’s will for our lives. He says, “For I know the thoughts that I think toward you, says the Lord, thoughts of peace and not of evil, to give you a future and a hope. Then you will call upon Me and go and pray to Me, and I will listen to you. And you will seek Me and find Me, when you search for Me with all your heart.” \n\nIf we can develop a genuine trust in God, we can learn to wait on His plan for our lives. And that patience that we learn to embrace in our relationship with God will exhibit itself in our interactions with others as well. Paul counsels believers with these words in Ephesians 4:1-3: “I, therefore, the prisoner of the Lord, beseech you to walk worthy of the calling with which you were called, with all lowliness and gentleness, with longsuffering, bearing with one another in love, endeavoring to keep the unity of the Spirit in the bond of peace.” \n\nIn the end, God is looking for people who have developed this very important attribute. He says in Revelation 14:12, “Here is the patience of the saints; here are those who keep the commandments of God and the faith of Jesus.” \nLet’s strive, by the grace of God, to be among that number.\n",
          title: "How can a person develop patience?",
        },
      },
      blanks: [
        {
          choices: ["commandments", "faith", "belief", "word", "love", "sound"],
          correctAnswer: "commandments",
          textAfter: " of God and the",
          textBefore:
            "Here is the patience of the saints; here are those who keep the",
        },
        {
          choices: ["commandments", "faith", "belief", "word", "love", "sound"],
          correctAnswer: "faith",
          textAfter: " of Jesus.",
        },
      ],
      body: "The people alive on earth and ready to meet Jesus when He returns are described as keeping God’s commandments. On the other hand, the Bible says that “there is no peace . . . for the wicked” (Isaiah 57:21).",
      choices: ["commandments", "faith", "belief", "word", "love", "sound"],
      lessonID: 6,
      question:
        "How does the Bible describe God's saved people in the last days of earth's history?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "Here is the patience of the saints; here are those who keep the commandments of God and the faith of Jesus.",
          ref: "Revelation 14:12",
        },
      ],
    },
    "6-3": {
      Supplements: {
        "-L83Kt9TA1nXqhsRx8Ss": {
          body: "1 John 3:4 gives us the clearest definition in the Bible. It says that, “Whoever commits sin also commits lawlessness, and sin is lawlessness.” So, in the simplest of terms, sin is breaking God’s commandments. And the penalty for sin is death (Romans 6:23). Because we’ve chosen to break God’s commandments, we deserve death. However, instead of giving us what we justly deserve, God offers us another option. He says, “For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.” \n\nNow, God is not just waiting around for us to sin so that He can mete out judgment against us. He wants us to be forgiven and be saved. In Ezekiel 33:11, He tells us, “‘As I live,’ says the Lord God, ‘I have no pleasure in the death of the wicked, but that the wicked turn from his way and live. Turn, turn from your evil ways! For why should you die, O house of Israel?’”\n\nBefore we know that something is wrong, God doesn’t hold us accountable for it (Acts 17:30), but once we know better, then intends that we surrender to His will. What should we do? 1 John 1:9 says, “If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.” \nAnd Paul admonishes us in Romans 6:16, “Do you not know that to whom you present yourselves slaves to obey, you are that one’s slaves whom you obey, whether of sin leading to death, or of obedience leading to righteousness?”\n\nRemember that with God, all things are possible (Matthew 19:26). You can do all things through Christ, who strengthens you (Philippians 4:13). Do you long to begin living a life that is victorious in Christ? Invite Him to start making your decisions for you and you’ll find all the help you need from the Holy Spirit. But if you try to do the right things in your own power, you’ll end up frustrated and going your own way — right back into sin.\n",
          title: "What is Sin?",
        },
      },
      blanks: [
        {
          choices: ["gods", "steal", "false", "covet", "people", "objects"],
          correctAnswer: "gods",
          newline: [1],
          textAfter: " before Me  (Exodus 20:3).",
          textBefore: "1. You shall have no other",
        },
        {
          choices: ["gods", "picture", "image", "middle", "mother", "father"],
          correctAnswer: "image",
          newline: [1],
          textAfter:
            " ...you shall not bow down to them nor serve them  (Exodus 20:4, 5).",
          textBefore: "2. You shall not make for yourself a carved",
        },
        {
          choices: ["number", "Sabbath", "name", "son"],
          correctAnswer: "name",
          newline: [1],
          textAfter: " of the Lord your God in vain  (Exodus 20:7).",
          textBefore: "3. You shall not take the",
        },
        {
          choices: ["day", "steal", "false", "covet", "Sabbath", "image"],
          correctAnswer: "Sabbath",
          textAfter: " day, to keep it holy...The",
          textBefore: "4. Remember the ",
        },
        {
          choices: ["first", "second", "fifth", "seventh", "forth"],
          correctAnswer: "seventh",
          newline: [1],
          textAfter:
            " day is the Sabbath of the Lord your God  (Exodus 20:8,10).",
        },
        {
          choices: ["cat", "livestock", "father", "cousin", "house", "donkey"],
          correctAnswer: "father",
          textAfter: " and your",
          textBefore: "5. Honor your",
        },
        {
          choices: ["cousin", "donkey", "house", "father", "seventh", "mother"],
          correctAnswer: "mother",
          newline: [1],
          textAfter: "   (Exodus 20:12).",
        },
        {
          choices: ["murder", "heal", "transgress", "hate", "love"],
          correctAnswer: "murder",
          newline: [1],
          textAfter: "   (Exodus 20:13).",
          textBefore: " 6. You shall not ",
        },
        {
          choices: ["sin", "adultery", "anger", "stealing", "crimes", "love"],
          correctAnswer: "adultery",
          newline: [1],
          textAfter: "   (Exodus 20:14).",
          textBefore: "7. You shall not commit ",
        },
        {
          choices: ["inspect", "remove", "take", "steal", "give", "covet"],
          correctAnswer: "steal",
          newline: [1],
          textAfter: "   (Exodus 20:15).",
          textBefore: "8. You shall not ",
        },
        {
          choices: [
            "ridiculous",
            "right",
            "negative",
            "bad",
            "inconsistent",
            "true",
            "false",
            "accurate",
          ],
          correctAnswer: "false",
          newline: [1],
          textAfter: " witness  (Exodus 20:16).",
          textBefore: "9. You shall not bear ",
        },
        {
          choices: ["want", "wish for", "covet", "desire"],
          correctAnswer: "covet",
          newline: [1],
          textAfter: "   (Exodus 20:17).",
          textBefore: "10. You shall not ",
        },
      ],
      choices: [
        "gods",
        "steal",
        "false",
        "covet",
        "people",
        "objects",
        "image",
        "name",
        "Sabbath",
        "seventh",
        "father",
        "adultery",
        "mother",
        "murder",
      ],
      lessonID: 6,
      question: "What are the Ten Commandments?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "2 “I am the Lord your God, who brought you out of the land of Egypt, out of the house of bondage.\n\n3 “You shall have no other gods before Me.\n\n4 “You shall not make for yourself a carved image—any likeness of anything that is in heaven above, or that is in the earth beneath, or that is in the water under the earth;\n\n5 you shall not bow down to them nor serve them. For I, the Lord your God, am a jealous God, visiting the iniquity of the fathers upon the children to the third and fourth generations of those who hate Me,\n\n6 but showing mercy to thousands, to those who love Me and keep My commandments.\n\n7 “You shall not take the name of the Lord your God in vain, for the Lord will not hold him guiltless who takes His name in vain.\n\n8 “Remember the Sabbath day, to keep it holy. \n\n9 Six days you shall labor and do all your work, \n\n10 but the seventh day is the Sabbath of the Lord it your God. In it you shall do no work: you, nor your son, nor your daughter, nor your male servant, nor your female servant, nor your cattle, nor your stranger who is within your gates. \n\n11 For in six days the Lord made the heavens and the earth, the sea, and all that is in them, and rested the seventh day. Therefore the Lord blessed the Sabbath day and hallowed it.\n\n12 “Honor your father and your mother, that your days may be long upon the land which the Lord your God is giving you.\n\n13 “You shall not murder.\n\n14 “You shall not commit adultery.\n\n15 “You shall not steal.\n\n16 “You shall not bear false witness against your neighbor.\n\n17 “You shall not covet your neighbor’s house; you shall not covet your neighbor’s wife, nor his male servant, nor his female servant, nor his ox, nor his donkey, nor anything that is your neighbor’s.”",
          ref: "Exodus 20:2-17",
        },
      ],
    },
    "6-4": {
      Supplements: {
        "-L83KYOZltwqwmdLsTdi": {
          body: "The short answer is, because it feels good. Hebrews 11:25 tells us that the pleasures of sin last “for a season”. If there was no pleasure in sin, people wouldn’t bother with it. And since we have a tendency to lean toward things that give us pleasure (whether they are good for us or not), it’s only with the help of Jesus that we can choose to turn away from sin.\n\nBut what is sin? 1 John 3:4 gives us the clearest definition in the Bible. It says that, “Whoever commits sin also commits lawlessness, and sin is lawlessness”. So, in the simplest of terms, sin is breaking God’s commandments. And the penalty for sin is death (Romans 6:23). Because we’ve chosen to break God’s commandments, we deserve death. However, instead of giving us what we justly deserve, God offers us another option. He says, “For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord”. \n\nNow, God is not just waiting around for us to sin so that He can mete out judgment against us. He wants us to be forgiven and be saved. In Ezekiel 33:11, He tells us, “‘As I live,’ says the Lord God, ‘I have no pleasure in the death of the wicked, but that the wicked turn from his way and live. Turn, turn from your evil ways! For why should you die, O house of Israel?’”\n\nBefore we know that something is wrong, God doesn’t hold us accountable for it (Acts 17:30), but once we know better, then He expects us to do something about it. What should we do? 1 John 1:9 says, “If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness”. \n\nAnd Paul admonishes us in Romans 6:16, “Do you not know that to whom you present yourselves slaves to obey, you are that one’s slaves whom you obey, whether of sin leading to death, or of obedience leading to righteousness?”\n\nRemember that with God, all things are possible (Matthew 19:26). You can do all things through Christ, who strengthens you (Philippians 4:13). Do you long to begin living a life that is victorious in Christ? Invite Him to start making your decisions for you and you’ll find all the help you need from the Holy Spirit. But if you try to do the right things in your own power, you’ll end up frustrated and going your own way – right back into sin.\n\n",
          title: "Why Do People Sin?",
        },
      },
      blanks: [
        {
          choices: ["suggestions", "will", "commandments", "guidelines"],
          correctAnswer: "commandments",
          textAfter: " , My statutes, and My laws.",
          textBefore: "Abraham obeyed My voice and kept charge, My",
        },
      ],
      body: "Abraham lived long before the commandments were written on stone at Sinai. When Cain killed Abel—breaking the sixth commandment—God told Cain that “sin lies at the door” (Genesis 4:7). Clearly, the Ten Commandments were in existence before God wrote them down at Mount Sinai.",
      choices: ["suggestions", "will", "commandments", "guidelines"],
      lessonID: 6,
      question:
        "Did the Ten Commandments exist before God wrote them on the tables of stone on Mount Sinai?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "Because Abraham obeyed My voice and kept My charge, My commandments, My statutes, and My laws.",
          ref: "Genesis 26:5",
        },
      ],
    },
    "6-5": {
      blanks: [
        {
          choices: ["obeying of", "will", "transgression", "guidelines"],
          correctAnswer: "transgression",
          textAfter: " (KJV, 'the transgression of the law').",
          textBefore: "Sin is ",
        },
      ],
      body: "The very fact that sin exists in today's world is evidence that God's law exists and is still binding. In fact, the Bible tells us that if the law of God didn't exist, there would be no such thing as sin (Romans 4:15).",
      choices: ["obeying of", "will", "transgression", "guidelines"],
      lessonID: 6,
      question: "How does the Bible define sin?",
      questionID: 5,
      questionType: "radio",
      verses: [
        {
          body: "Whoever commits sin also commits lawlessness, and sin is lawlessness.",
          ref: "1 John 3:4",
        },
      ],
    },
    "6-6": {
      blanks: [
        {
          choices: [
            "infallible",
            "great",
            "inspiring",
            "honey",
            "law",
            "fact",
            "truth",
            "just",
            "holy",
          ],
          correctAnswer: "holy",
          textAfter: " , and the commandment holy and",
          textBefore: "Therefore the law is",
        },
        {
          choices: [
            "just",
            "perfect",
            "complete",
            "total",
            "law",
            "fact",
            "truth",
            "just",
          ],
          correctAnswer: "just",
          textAfter: " and",
        },
        {
          choices: ["infallible", "bread", "butter", "good", "law", "fact"],
          correctAnswer: "good",
          textAfter: " .",
        },
      ],
      body: "New Testament writers understood the timeless nature of the Ten Commandments. In essence, the Ten Commandments are a written transcript of the character of God. Just as the laws of a country reflect the character of that nation and its lawmakers, the Ten Commandments reflect the character of God and the character of His kingdom.",
      choices: [
        "infallible",
        "holy",
        "inspiring",
        "just",
        "law",
        "fact",
        "truth",
        "good",
        "holy",
      ],
      lessonID: 6,
      question: "What does the New Testament say about the Ten Commandments?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore the law is holy, and the commandment holy and just and good.\n",
          ref: "Romans 7:12",
        },
      ],
    },
    "6-7": {
      Supplements: {
        "-L83YQGxbFwZ3WIoQwFO": {
          body: "God’s law is a transcript of His character. It shows us what God is like. For example, God is holy (Isa. 5:16),  pure (1 John 3:2,3), faithful (1 Cor. 1:9), and love (1 John 4:8). His law is also holy (Romans 7:12), pure (Psalm 19:8),   faithful (Psalm 119:86), and love (Romans 13:10). \n\nWhen we look at God’s law, it helps us to see our defects of character   and how far short of His glory we fall. James likens it to a mirror (James 1:22), because it points out our sins (1 John 3:4).   \n\nNot surprisingly, there is a penalty for breaking God’s law. In the words of Paul in Romans 6:23, “For the wages of sin    is death.” That’s what we deserve. However, the verse continues, “...but the gift of God is eternal life in Christ Jesus our Lord.”    That’s grace.\n\nThe reality is that sin separates us from God (Isaiah 59:2) and without God, we’re lost. But because God loves us     so much, He made a way for us to be reconciled to Him. And that way is embodied in Jesus Christ. God’s law (and our breaking thereof)     points us to the Savior.\n\nTo experience the reconciliation that we so desperately need, we have to accept Jesus’ sacrifice on our behalf,      receive Him as our Savior, and confess our sins to Him that they may be forgiven (1 John 1:9).\n\nAnd the result? We can begin to live a       victorious life in Him and have a peace  “which surpasses all understanding” (Philippians 4:7).\n\nWhat an amazing God!\n",
          title: "What is the purpose of God’s Law?",
        },
      },
      blanks: [
        {
          choices: ["forgotten", "unnecessary", "distasteful", "burdensome"],
          correctAnswer: "burdensome",
          textAfter: " .",
          textBefore:
            "For this is the love of God, that we keep His commandments. And His commandments are not",
        },
      ],
      body: "The Ten Commandments were given by God to be a blessing to His people. James wrote that the Ten Commandments are a “law of liberty” (James 1:25; 2:12). Any person who lives in harmony with God’s law will enjoy freedom from guilt, shame, sin and its penalty!",
      choices: ["forgotten", "unnecessary", "distasteful", "burdensome"],
      lessonID: 6,
      question:
        "Were the Ten Commandments given to be a burden for God's people?",
      questionID: 7,
      questionType: "radio",
      verses: [
        {
          body: "For this is the love of God, that we keep His commandments. And His commandments are not burdensome.",
          ref: "1 John 5:3",
        },
      ],
    },
    "6-8": {
      blanks: [
        {
          choices: ["known", "law", "committed", "Lord", "despised", "devil"],
          correctAnswer: "known",
          textAfter:
            " sin except through the law. For I would not have known covetousness unless the",
          textBefore:
            "What shall we say then? Is the law sin? Certainly not! On the contrary, I would not have",
        },
        {
          choices: ["known", "law", "committed", "Lord", "despised", "devil"],
          correctAnswer: "law",
          textAfter: ' had said, "You shall not covet."',
        },
      ],
      body: "The law of God identifies sin and points us away from sin and toward Jesus",
      choices: ["known", "law", "committed", "Lord", "despised", "devil"],
      lessonID: 6,
      question: "How do the Ten Commandments provide guidance to believers?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "What shall we say then? Is the law sin? Certainly not! On the contrary, I would not have known sin except through the law. For I would not have known covetousness unless the law had said, “You shall not covet.”",
          ref: "Romans 7:7",
        },
      ],
    },
    "6-9": {
      blanks: [
        {
          choices: ["follow", "abolish", "void", "establish"],
          correctAnswer: "establish",
          textAfter: " the law.",
          textBefore:
            "Do we then make void the law through faith? Certainly Not! On the contrary, we",
        },
      ],
      body: "The Apostle Paul never suggested a change had ever been made to the law of God. In fact, he was adamant that God’s law is unchangeable and eternal.",
      choices: ["follow", "abolish", "void", "establish"],
      lessonID: 6,
      question: "Were the Ten Commandments ever abolished?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "Do we then make void the law through faith? Certainly not! On the contrary, we establish the law.",
          ref: "Romans 3:31",
        },
      ],
    },
  },
  {
    "7-0": {
      body: "Some years ago, it became popular for married couples to schedule a regular “date night.” Faced with the demands of modern life, many husbands and wives  figured the only way they could get “quality time”\n was to reserve one night a week during which they could spend meaningful time together.\n\nBut what if your life is so busy that you  find it hard to make time for God?\n\nWhen He created the world, God did something special to make sure His children could always have time for Him!",
      lessonID: 7,
      questionID: 0,
      type: "text",
    },
    "7-1": {
      blanks: [
        {
          choices: ["vacation", "food", "rest", "income"],
          correctAnswer: "rest",
          textAfter: " .",
          textBefore:
            "Come to Me, all you who labor and are heavy laden, and I will give you",
        },
      ],
      body: "God wants us to unwind—with Him! He knows that for most people, life is busy and stressful, and He has provided a way for us to escape the busyness of life while spending time with Him.",
      choices: ["vacation", "food", "rest", "income"],
      lessonID: 7,
      question:
        "Has God demonstrated that He wants to spend time with His children?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "Come to Me, all you who labor and are heavy laden, and I will give you rest.",
          ref: "Matthew 11:28",
        },
      ],
    },
    "7-10": {
      blanks: [
        {
          choices: ["vacation", "weekend", "Sabbath", "mountains"],
          correctAnswer: "Sabbath",
          textAfter: " .",
          textBefore:
            "And pray that your  flight may not be in winter or on the",
        },
      ],
      body: "Before Jesus died, He gave counsel regarding the destruction of Jerusalem, which would take place in AD 70, nearly 40 years after He died. Looking four decades into the future, Jesus told His hearers that the Sabbath day would still be important long after His death on the cross.",
      choices: ["vacation", "weekend", "Sabbath", "mountains"],
      lessonID: 7,
      question:
        "Did Jesus intend for the Sabbath day to be kept holy after He died?",
      questionID: 10,
      questionType: "radio",
      verses: [
        {
          body: "And pray that your flight may not be in winter or on the Sabbath.",
          ref: "Matthew 24:20",
        },
      ],
    },
    "7-11": {
      Supplements: {
        "-L7fk0q8Q_q2_yZ-gUzd": {
          body: "The Jewish synagogue was central to life in Jesus’ day.  Unlike the temple, sacrifices were not offered at a synagogue.  It was a place of assembly, where God’s word was read and taught.  In Luke 4:16, Jesus is “in the synagogue on the Sabbath day, and stood up for to read.”  In Matthew 13:54, Jesus “taught them in their own synagogue,” as Paul did in Ephesus in Acts 18:19.   ",
          title: "What is a synagogue?",
        },
      },
      blanks: [
        {
          choices: ["family", "Sabbath", "month", "city"],
          correctAnswer: "Sabbath",
          textAfter:
            " . Now when the congregation had broken up, many of the Jews and devout proselytes followed Paul and Barnabas, who, speaking to them, persuaded them to continue in the grace of God. On the next Sabbath almost the whole",
          textBefore:
            "So when the Jews went out of the synagogue, the Gentiles begged that these words might be preached to them the next",
        },
        {
          choices: ["family", "Sabbath", "month", "city"],
          correctAnswer: "city",
          textAfter: " came together to hear the word of God.",
        },
      ],
      body: "The Apostle Paul kept the Sabbath day holy (Acts 17:2; 18:4). Along with the other apostles, he worshipped on the Sabbath with both Jews and Gentiles. On occasions when there was no synagogue in which to worship, Paul would meet by the riverside with Gentile believers (Acts 16:13). The seventh-day Sabbath was certainly the day of worship for the early Christian church.",
      choices: ["family", "Sabbath", "month", "city"],
      lessonID: 7,
      question:
        "Did the early Christian church keep the Sabbath holy after Jesus died?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "42 So when the Jews went out of the synagogue, the Gentiles begged that these words might be preached to them the next Sabbath.\n\n43 Now when the congregation had broken up, many of the Jews and devout proselytes followed Paul and Barnabas, who, speaking to them, persuaded them to continue in the grace of God.\n\n44 On the next Sabbath almost the whole city came together to hear the word of God.",
          ref: "Acts 13:42-44",
        },
      ],
    },
    "7-12": {
      blanks: [
        {
          choices: ["birth", "favorite", "seventh", "first"],
          correctAnswer: "seventh",
          textAfter: " day is the Sabbath of the Lord your God.",
          textBefore: "The",
        },
      ],
      body: "God specified the day we should keep as the Sabbath. In fact, it isn’t possible to keep any other day holy, because the seventh day is the only day that is holy.\n\nKeeping the seventh-day Sabbath holy is a sign that we are prepared to love God on His terms. God has not asked us to keep a Sabbath of our own choosing. God specifically stated that the seventh day is the Sabbath.",
      choices: ["birth", "favorite", "seventh", "first"],
      correctAnswer: "false",
      lessonID: 7,
      question: "Does it really matter which day I keep as the Sabbath?",
      questionID: 12,
      questionType: "trueOrFalse",
      trueFalseQuestion: "Keeping the sabbath isn't really that important.",
      verses: [
        {
          body: "But the seventh day is the Sabbath of the Lord your God. In it you shall do no work: you, nor your son, nor your daughter, nor your male servant, nor your female servant, nor your cattle, nor your stranger who is within your gates.",
          ref: "Exodus 20:10",
        },
      ],
    },
    "7-13": {
      blanks: [
        {
          choices: ["this", "one", "blasphemy", "all"],
          correctAnswer: "one",
          textAfter: " point, he is guilty of",
          textBefore: "Whoever shall keep the whole law, and yet stumble in",
        },
        {
          choices: ["this", "one", "blasphemy", "all"],
          correctAnswer: "all",
          textAfter: " .",
        },
      ],
      body: "While the Sabbath commandment is no more important than the rest of the Ten Commandments, it is no less important either! When a person breaks one of the commandments—whichever one it is—God regards that as being just as serious as breaking the rest of them.",
      choices: ["this", "one", "blasphemy", "all"],
      lessonID: 7,
      question:
        "Would failing to keep the Sabbath day holy really be regarded by God as a bad thing?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "For whoever shall keep the whole law, and yet stumble in one point, he is guilty of all.",
          ref: "James 2:10",
        },
      ],
    },
    "7-14": {
      blanks: [
        {
          choices: ["know", "speak", "chastise", "keep"],
          correctAnswer: "keep",
          textAfter: " the commandments of God and the faith of Jesus.",
          textBefore: "Here is the patience of the saints; here are those who",
        },
      ],
      body: "God’s children who are preparing for eternity keep His commandments. They realize that it is God’s will for people everywhere to keep all of the Ten Commandments.",
      choices: ["know", "speak", "chastise", "keep"],
      lessonID: 7,
      question:
        "Does God want His people living in Earth’s last days to keep the Sabbath holy?",
      questionID: 14,
      questionType: "radio",
      verses: [
        {
          body: "Here is the patience of the saints; here are those who keep the commandments of God and the faith of Jesus.",
          ref: "Revelation 14:12",
        },
      ],
    },
    "7-15": {
      blanks: [
        {
          choices: ["love", "fear", "abhor", "defend"],
          correctAnswer: "love",
          textAfter: " Me, keep My commandments.",
          textBefore: "If you",
        },
      ],
      body: "Jesus was very clear that obeying God is the inevitable result of loving God. Those who have accepted Jesus as their Savior find it a delight to do His will (Psalm 40:8).\n\nFar from being a burden, a life of obedience to God is the natural consequence of love for God in a person’s life. God works in the life of a believer “both to will and to do for His good pleasure” (Philippians 2:13).",
      choices: ["love", "fear", "abhor", "defend"],
      correctAnswer: "false",
      lessonID: 7,
      question:
        "Is a person who keeps the seventh-day Sabbath demonstrating that he or she believes in being saved by works?",
      questionID: 15,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "Those who keep the Sabbath are showing salvation by works.",
      verses: [
        {
          body: "If you love Me, keep My commandments.",
          ref: "John 14:15",
        },
      ],
    },
    "7-16": {
      blanks: [
        {
          choices: ["scripture", "feelings", "men", "God"],
          correctAnswer: "God",
          textAfter: " rather than",
          textBefore: "We ought to obey",
        },
        {
          choices: ["scripture", "feelings", "men", "God"],
          correctAnswer: "men",
          textAfter: " .",
        },
      ],
      body: "Irrespective of the views of the majority, the Christian is called by God to be a follower of Christ, and not a follower of other Christians.",
      choices: ["scripture", "feelings", "men", "God"],
      lessonID: 7,
      question:
        "In a world where most people do not keep the seventh-day Sabbath, what should a person do?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "But Peter and the other apostles answered and said: We ought to obey God rather than men.",
          ref: "Acts 5:29",
        },
      ],
    },
    "7-17": {
      Supplements: {
        "-L7fjX7XQIqXaaBSlALw": {
          body: "Isaiah 58:13,14.  “If you turn away your foot from the Sabbath, from doing your pleasure on my holy day, and call the Sabbath a delight, the holy day of the Lord honorable, and shall honor Him, not doing your own ways, nor finding your own pleasure, nor speaking your own words, then you shall delight yourself in the Lord; and I will cause you to ride on the high hills of the earth, and feed you with the heritage of Jacob your father. The mouth of the Lord has spoken.”\n\nIsaiah 56:1-8.  “Thus says the Lord: Keep justice, and do righteousness, for my salvation is about to come, ​and My righteousness to be revealed. ​​Blessed is the man who does this,\n​​And the son of man who lays hold on it; who keeps from defiling the Sabbath, and keeps his hand from doing any evil. ​​Do not let the son of the foreigner who has joined himself to the Lord\n​​Speak, saying, “The Lord has utterly separated me from His people”; nor let the eunuch say,\n​​“Here I am, a dry tree.” ​​For thus says the Lord: ​​“To the eunuchs who keep my Sabbaths, and choose what pleases me, and hold fast my covenant, ​​even to them I will give in my house and within my walls a place and a name better than that of sons and daughters; ​​I will give them an everlasting name that shall not be cut off. Also the sons of the foreigner who join themselves to the Lord, to serve Him, and to love the name of the Lord, to be His servants— everyone who keeps from defiling the Sabbath, and holds fast my covenant—​​even them I will bring to my holy mountain, and make them joyful in my house of prayer. ​Their burnt offerings and their sacrifices\n​​Will be accepted on my altar; ​​For my house shall be called a house of prayer for all nations.” ​​The Lord God, who gathers the outcasts of Israel, says, ​​“Yet I will gather to him others besides those who are gathered to him.”\n\nIsaiah also makes clear that the Sabbath day will be kept in heaven, for eternity!  Isaiah 66:23 says, ““And it shall come to pass that from one New Moon to another, And from one Sabbath to another, all flesh shall come to worship before me,” says the Lord.””",
          title: "What did the prophet Isaiah say about keeping the Sabbath?",
        },
      },
      blanks: [
        {
          choices: ["planets", "earth", "year", "Sabbath"],
          correctAnswer: "earth",
          textAfter:
            " which I will make shall remain  before Me . . . And it shall come to pass that from one New Moon to another, and from one",
          textBefore: "“For as the new heavens and the new",
        },
        {
          choices: ["planets", "earth", "year", "Sabbath"],
          correctAnswer: "Sabbath",
          newline: [1],
          textAfter:
            " to another, all  flesh shall come to worship  before Me,” says the Lord.",
        },
        {
          choices: ["planets", "earth", "year", "Sabbath"],
          correctAnswer: "love",
          textAfter: " Me, keep My commandments.",
          textBefore: "If you ",
        },
      ],
      body: "In the New Earth, God’s people will still come together to worship Him on the Sabbath. The Sabbath was created before man sinned in Eden (Genesis 2:2, 3), and it will be kept holy after sin has been eradicated from the universe. The Ten Commandments are in the temple of God in heaven (Revelation 11:19). Clearly, God intends for the fourth commandment to be eternal.",
      choices: ["planets", "earth", "year", "Sabbath", "love"],
      lessonID: 7,
      question: "Will the Sabbath day be kept holy throughout eternity?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "“For as the new heavens and the new earth which I will make shall remain before Me,” says the Lord,“so shall your descendants and your name remain.\n\n23 And it shall come to pass that from one New Moon to another, and from one Sabbath to another, all flesh shall come to worship before Me,” says the Lord.",
          ref: "Isaiah 66:22, 23",
        },
        {
          body: "If you love Me, keep My commandments.",
          ref: "John 14:15",
        },
      ],
    },
    "7-18": {
      correctAnswer: "true",
      question:
        "Out of love for God, are you willing to remember the Sabbath day and keep it holy?",
      questionID: 18,
      questionType: "truthConfirmation",
    },
    "7-2": {
      Supplements: {
        "-L7finf7F5Ln_hJZqWlN": {
          body: "Stress is hugely significantly.  A ‘stressor’ is something that affects you mentally, emotionally or physically.  You can be stressed physically by a cool breeze, or by a long hike on a hot day.  You can be stressed emotionally by listening to someone’s concerns or by experiencing grief.\n\nThe key with stress is how you respond to stressors.  If you think of ‘stressors’ as ‘challenges’, you can begin to determine how you might respond to the challenge you are facing.\n\nAdmittedly, not all stressors are created equal.  The stress from not having any milk in the fridge differs in seriousness from the street experienced by getting a flat tire on a country road, which in turn is markedly different to the stress that is caused by the death of a loved one.\n\nWhen stressors press upon you, it is important that you exercise faith in God.  Faith in the Creator God enables a person to contextualize stress and to operate with the assurance that God is able to help you through a difficult situation.  Jesus said in Matthew11:28, “Come unto me, all ye that labor and are heavy laden, and I will give you rest.”  \n\nA life lived in faith in God brings relief from the stress of sin, guilt and futility.  Romans 5:1 says, “Therefore being justified [pardoned, forgiven] by faith, we have peace with God through our Lord Jesus Christ.”  Isaiah wrote, “And the work of righteousness shall be peace; and the effect of righteousness quietness and assurance for ever.”  (Isaiah 32:17)\n\nStress can be mitigated through useful and meaningful physical activity.  Exercise or some other form of physical activity that has a ‘point’ to it brings rest to the mind and a sense of fulfillment.  Having a support system such as a family or a church family is important when coping with stress, and maintaining a good diet and getting adequate rest are also important keys in dealing with stress.\n",
          title: "What do you do with stress?",
        },
      },
      blanks: [
        {
          choices: ["created", "rested", "seventh", "first"],
          correctAnswer: "rested",
          textAfter:
            " on the seventh day from all His work which He had done. Then God blessed the",
          textBefore:
            "And on the seventh day God ended His work which He had done, and He",
        },
        {
          choices: ["created", "rested", "seventh", "first"],
          correctAnswer: "seventh",
          textAfter:
            " day and sanctified it, because in it He rested from all His work which God had created and made.",
        },
      ],
      body: "At the end of creation week, God set aside a day that would be a special time for His people to spend with Him. Knowing His people would be stressed and busy, He gave the Sabbath day as a release valve—as protection against the demands of life.",
      choices: ["created", "rested", "seventh", "first"],
      lessonID: 7,
      question:
        "What special gift did God give the human family to ensure we would have regular time with Him?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "2 And on the seventh day God ended His work which He had done, and He rested on the seventh day from all His work which He had done.\n\n3 Then God blessed the seventh day and sanctified it, because in it He rested from all His work which God had created and made.",
          ref: "Genesis 2:2, 3",
        },
      ],
    },
    "7-3": {
      blanks: [
        {
          choices: ["Jews", "work", "inconvenience", "man"],
          correctAnswer: "man",
          textAfter: " .",
          textBefore: "The Sabbath was made for",
        },
      ],
      body: "God created the Sabbath for the entire human race. That God made it “for” humanity indicates that God intentionally and thoughtfully made the Sabbath as a gift for people throughout the ages. Keep in mind: the Sabbath was made at creation—approximately 2,000 years before the existence of the first Jew. It was made for all people!",
      choices: ["Jews", "work", "inconvenience", "man"],
      correctAnswer: "true",
      lessonID: 7,
      question: "Was the Sabbath day intended only for Jews to keep?",
      questionID: 3,
      questionType: "trueOrFalse",
      trueFalseQuestion: "The Sabbath was made for everyone.",
      verses: [
        {
          body: "And He said to them, The Sabbath was made for man, and not man for the Sabbath.",
          ref: "Mark 2:27",
        },
      ],
    },
    "7-4": {
      blanks: [
        {
          choices: ["pure", "always", "holy", "undefiled"],
          correctAnswer: "holy",
          textAfter: " .",
          textBefore: "Remember the Sabbath day, to keep it",
        },
      ],
      body: "God included the keeping of the seventh-day Sabbath in the Ten Commandments. God “sanctified” the Sabbath day (Genesis 2:3), which means He made it and set it apart for holy use. Anything made holy by God is something God regards as very special.\n\nUnlike the other days of the week—the “six working days” (Ezekiel 46:1)—the Sabbath day is a day for people to refrain from their regular secular pursuits and instead dedicate that time to God.\n\nIn Exodus 20:10, God said, “In it [that is, on the Sabbath day] you shall do no work.” Rather than allow the demands of work to consume us completely, God gives us the Sabbath day in order for us to have quality time to spend with Him. That is not to say we shouldn’t worship God or spend time with Him every day. We must do that if we are to be healthy Christians. But the Sabbath is an entire day given to God.",
      choices: ["pure", "always", "holy", "undefiled"],
      lessonID: 7,
      question: "How important is the Sabbath in the eyes of God?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "Remember the Sabbath day, to keep it holy.",
          ref: "Exodus 20:8",
        },
      ],
    },
    "7-5": {
      Supplements: {
        "-L7fjCGSEQaNBEOsPdfG": {
          body: "These are just a few of the many promises in the Bible of God’s care for His children.\n\nMatthew 28:20.  “Lo, I am with you always, even to the end of the age.”\n\nHebrews 13:5.  “He Himself has said, “I will never leave you nor forsake you.””\n\nMatthew 11:28.  “Come to Me, all you who labor and are heavy laden, and I will give you rest.”\n\nJohn 14:1-3.  “Let not your heart be troubled; you believe in God, believe also in Me. “In My Father’s house are many mansions; if it were not so, I would have told you. I go to prepare a place for you. And if I go and prepare a place for you, I will come again and receive you to Myself; that where I am, there you may be also.”\n\nJeremiah 29:11.  “For I know the thoughts that I think toward you, says the Lord, thoughts of peace and not of evil, to give you a future and a hope.”\n\nPhilippians 4:19.  “And my God shall supply all your need according to His riches in glory by Christ Jesus.”\n\nIsaiah 26:3.  “You will keep him in perfect peace, whose mind is stayed on You, because he trusts in You.”\n\nIsaiah 48:18.  “Oh, that you had heeded My commandments! Then your peace would have been like a river, and your righteousness like the waves of the sea.”\n\nPsalm 46:10.  “Be still, and know that I am God.”\n\n",
          title: "How does God promise to care for us?",
        },
      },
      blanks: [
        {
          choices: ["made", "dissolved", "organized"],
          correctAnswer: "made",
          textAfter:
            " the heavens and the earth, the sea, and all that is in them, and rested the seventh day. Therefore the Lord blessed the Sabbath day and hallowed it.",
          textBefore: "For in six days the Lord",
        },
      ],
      body: "The seventh-day Sabbath is a memorial of God’s creative power. “In the beginning God created the heavens and the earth” (Genesis 1:1).\n\nThe Sabbath is a forever reminder of God’s work of creation. It tells us that the world was purposely made by a loving Creator, who prepared a beautiful world for His children to enjoy. The Sabbath also tells us that human beings were carefully constructed by a Designer. The Sabbath day tells us there is a Creator!",
      choices: ["made", "dissolved", "organized"],
      lessonID: 7,
      question:
        "How is the Sabbath day important in our daily experience with God?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "For in six days the Lord made the heavens and the earth, the sea, and all that is in them, and rested the seventh day. Therefore the Lord blessed the Sabbath day and hallowed it.",
          ref: "Exodus 20:11",
        },
      ],
    },
    "7-6": {
      blanks: [
        {
          choices: ["sign", "delight", "sanctifies", "encourages"],
          correctAnswer: "sign",
          textAfter:
            " between them and Me, that they might know that I am the Lord who",
          textBefore: "Moreover I also gave them My Sabbaths, to be a",
        },
        {
          choices: ["sign", "delight", "sanctifies", "encourages"],
          correctAnswer: "sanctifies",
          textAfter: " them.",
        },
      ],
      body: "Not only is the Sabbath a sign that God is our Creator, but it is also a sign that God is our re-Creator. Human beings who have fallen prey to sin have lost the holiness God intended for them to have.\n\nIsaiah 59:2 says that sin separates a person from God. Fallen sinners need to be remade. David’s prayer was, “Create in me a clean heart, O God” (Psalm 51:10). Ezekiel wrote that the Sabbath is a sign that God is our Sanctifier. God alone can make us holy by creating in us the clean heart we need. The Sabbath is a sign of that great truth!",
      choices: ["sign", "delight", "sanctifies", "encourages"],
      lessonID: 7,
      question:
        "What else does the Sabbath tell us about our relationship with God?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "Moreover I also gave them My Sabbaths, to be a sign between them and Me, that they might know that I am the Lord who sanctifies them.",
          ref: "Ezekiel 20:12",
        },
      ],
    },
    "7-7": {
      blanks: [
        {
          choices: ["first", "Sabbath", "convenient", "available"],
          correctAnswer: "Sabbath",
          textAfter: " day.",
          textBefore:
            "So He came to Nazareth, where He had been brought up. And as His custom was, He went into the synagogue on the",
        },
      ],
      body: "Jesus—like Adam, Abraham, Isaac, Moses and the early Christian church—kept the seventh-day Sabbath day holy every week.",
      choices: ["first", "Sabbath", "convenient", "available"],
      lessonID: 7,
      question: "What day did Jesus keep holy?",
      questionID: 7,
      questionType: "radio",
      verses: [
        {
          body: "So He came to Nazareth, where He had been brought up. And as His custom was, He went into the synagogue on the Sabbath day, and stood up to read.",
          ref: "Luke 4:16",
        },
      ],
    },
    "7-8": {
      blanks: [
        {
          choices: ["commandment", "rested", "custom", "anointed"],
          correctAnswer: "rested",
          textAfter: " on the Sabbath according to the",
          textBefore:
            "Then they returned and prepared spices and fragrant oils. And they",
        },
        {
          choices: ["commandment", "rested", "custom", "anointed"],
          correctAnswer: "commandment",
          textAfter: " .",
        },
      ],
      body: "The Bible says Jesus died on the preparation day (Luke 23:54), the day that is commonly referred to as Good Friday. He rose from the dead on the  first day of the week (Luke 24:1), the day that today is called Easter Sunday. The day in-between was the Sabbath day. Saturday is the day that comes between Friday and Sunday. The seventh-day Sabbath of the Bible is Saturday.",
      choices: ["commandment", "rested", "custom", "anointed"],
      lessonID: 7,
      question: "Which day of the week is the seventh-day Sabbath?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then they returned and prepared spices and fragrant oils. And they rested on the Sabbath according to the commandment.",
          ref: "Luke 23:56",
        },
      ],
    },
    "7-9": {
      Supplements: {
        "-L7fjjUNoMPf0FVg2LSu": {
          body: "In Matthew 5:18, Jesus said, ““For assuredly, I say to you, till heaven and earth pass away, one jot or one tittle will by no means pass from the law till all is fulfilled.”\n\nThe word Matthew wrote as “jot” is the Greek word “iota”.  “Iota” is the smallest letter in the Greek alphabet.  (The English expression “not one iota” finds its origin here.)  It is as if Jesus was saying that not even the smallest detail - such as the dot over an I - could be removed from God’s law.\n\nThe word for “tittle” is the Greek word “keraia”, and literally means “a little horn.”  This is most likely a reference to the small hook on the letter wau.  \n\nThis expression used by Jesus is to express the important truth that not any detail of God’s ten commandment law can be removed.",
          title: "What is a jot or tittle?",
        },
      },
      blanks: [
        {
          choices: ["fulfill", "observe", "destroy", "cheat"],
          correctAnswer: "destroy",
          textAfter: " but to",
          textBefore:
            "Do not think that I came to destroy the Law or the Prophets. I did not come to",
        },
        {
          choices: ["fulfill", "observe", "destroy", "cheat"],
          correctAnswer: "fulfill",
          textAfter:
            " . For assuredly, I say to you, till heaven and earth pass away, one jot or one tittle will by no means pass from the law till all is fulfilled.",
        },
      ],
      body: "Jesus was adamant that His mission did not include making changes to the Ten Commandments. Jesus did not change the Sabbath day. God gave the Sabbath to the human family as a blessing and a joy. Nowhere does the Bible suggest that God ever intended to remove the blessing of the Sabbath.",
      choices: ["fulfill", "observe", "destroy", "cheat"],
      lessonID: 7,
      question: "Did Jesus change the Sabbath day when He died on the cross?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "17 Do not think that I came to destroy the Law or the Prophets. I did not come to destroy but to fulfill.\n\n18 For assuredly, I say to you, till heaven and earth pass away, one jot or one tittle will by no means pass from the law till all is fulfilled.",
          ref: "Matthew 5:17, 18",
        },
      ],
    },
  },
  {
    "8-0": {
      body: "In 2012, a remarkable discovery was made. For many years, Sandy Island was shown on maps of the South Pacific. It was a small island located west of New Caledonia, a little over midway between New Zealand and Australia. But cartographers received a surprise when they looked at satellite images of the area and discovered Sandy Island wasn’t there! Bewildered scientists sailed to the area, and instead of Sandy Island, they found only water. The truth was that in spite of maps saying otherwise for decades, Sandy Island didn’t exist—and never had! Even though it appeared on maps—even though it was believed to be there—Sandy Island wasn’t real. How many other things are like that? Most “old wives’ tales” are harmless, but could it be possible that a commonly held belief within the Christian church simply isn’t true? Could Christians believe in something that simply doesn’t exist?",
      lessonID: 8,
      questionID: 0,
      type: "text",
    },
    "8-1": {
      blanks: [
        {
          choices: ["will", "God", "face", "Jesus", "law", "liberty"],
          correctAnswer: "law",
          textAfter: " of",
          textBefore: "He who looks into the perfect",
        },
        {
          choices: ["will", "God", "face", "Jesus", "law", "liberty"],
          correctAnswer: "liberty",
          textAfter:
            " and continues in it, and is not a forgetful hearer but a doer of the work, this one will be blessed in what he does.",
        },
      ],
      body: "James made it clear in James 2:10–12 that the law he is referring to is the Ten Commandments. God wants His children to lovingly obey Him.",
      choices: ["will", "God", "face", "Jesus", "law", "liberty"],
      lessonID: 8,
      question:
        "What has God given us to guide us in a happy and holy way of life?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "But he who looks into the perfect law of liberty and continues in it, and is not a forgetful hearer but a doer of the work, this one will be blessed in what he does.",
          ref: "James 1:25",
        },
      ],
    },
    "8-10": {
      blanks: [
        {
          choices: ["inside", "aside", "at church"],
          correctAnswer: "aside",
          textAfter:
            ", storing up as he may prosper, that there be no collections when I come. ",
          textBefore:
            "Now concerning the collection for the saints, as I have given orders to the churches of Galatia, so you must do also: On the first day of the week let each one of you lay something ",
        },
      ],
      body: "Paul urged the believers to set money aside - at home - on the first day of each week, so that when he sent a messenger to Corinth to collect this offering for believers in Jerusalem, there would be no cause for delay.  This setting aside of money on the first day of the week did not mean that day was considered holy.",
      choices: ["inside", "aside", "at church"],
      lessonID: 8,
      question:
        "Do any other New Testament texts mention the first day of the week?",
      questionID: 10,
      questionIDTitle: "8c",
      questionType: "radio",
      subQuestion: "Here's one more.",
      verses: [
        {
          body: "Now concerning the collection for the saints, as I have given orders to the churches of Galatia, so you must do also:  On the first day of the week let each one of you lay something aside, storing up as he may prosper, that there be no collections when I come.",
          ref: "1 Corinthians 16:1, 2",
        },
      ],
    },
    "8-11": {
      blanks: [
        {
          choices: ["lifted", "raised", "sent"],
          correctAnswer: "raised",
          textAfter: " from the ",
          textBefore:
            "Do you not know that as many of us as were baptized into Christ Jesus were baptized into His death?  therefore we are buried  with Him through baptism into death, that just as Christ was ",
        },
        {
          choices: ["life", "sleep", "dead", "heaven"],
          correctAnswer: "dead",
          newline: [1],
          textAfter:
            " by the glory of the Father, even so we also should walk in newness of life.",
          textBefore: "",
        },
        {
          choices: ["life", "eat", "dead", "heaven"],
          correctAnswer: "eat",
          textAfter: " this bread and ",
          textBefore: "\n\nFor as often as you ",
        },
        {
          choices: ["life", "drink", "dead", "heaven"],
          correctAnswer: "drink",
          textAfter: "this cup, you proclaim the Lord's",
          textBefore: " ",
        },
        {
          choices: ["life", "sleep", "death", "heaven"],
          correctAnswer: "death",
          textAfter: " till He comes",
          textBefore: " ",
        },
      ],
      body: "Rather than sunday observance, God gave the church the rite of baptism to commemorate the death, burial and resurrection of Jesus.  The Lord's Supper - or the communion service - was also given by God to His people so they could regularly commemorate the death of Jesus.  Nowhere in the Bible is Sunday referred to as any sort of memorial of the resurrection of Jesus.",
      choices: ["death", "drink", "eat", "raised", "life", "dead"],
      lessonID: 8,
      question:
        "Did God intend for Sunday to be observed in honor of the resurrection?",
      questionID: 11,
      questionIDTitle: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "3 Or do you not know that as many of us as were baptized into Christ Jesus were baptized into His death? 4 Therefore we were buried with Him through baptism into death, that just as Christ was raised from the dead by the glory of the Father, even so we also should walk in newness of life.",
          ref: "Romans 6:3",
        },
        {
          body: "For as often as you eat this bread and drink this cup, you proclaim the Lord’s death till He comes.",
          ref: "1 Corinthians 11:26",
        },
      ],
    },
    "8-12": {
      blanks: [
        {
          choices: [
            "Sundays",
            "other",
            "weeks",
            "textAfter",
            "Sabbaths",
            "every",
          ],
          correctAnswer: "Sabbaths",
          textAfter: "reasoned with them from the Scriptures. ",
          textBefore:
            "Then Paul, as his custom was, went in to them, and for three ",
        },
        {
          choices: [
            "Sundays",
            "other",
            "weeks",
            "textAfter",
            "Sabbaths",
            "every",
          ],
          correctAnswer: "every",
          newline: [1],
          textAfter: " Sabbath, and persuaded both Jews and Greeks.",
          textBefore: "He reasoned in the synagogue ",
        },
      ],
      body: "Many years after Jesus died, the apostles were observing the Sabbath on the seventh day of the week. They made no change to their weekly Sabbath observance.",
      choices: [
        "Sundays",
        "other",
        "weeks",
        "Sabbaths",
        "prayer",
        "whole",
        "every",
        "Gentiles",
      ],
      lessonID: 8,
      question:
        "Did the apostles begin observing Sunday after the death of Jesus?",
      questionID: 12,
      questionIDTitle: "10a",
      questionType: "wordCloud",
      verses: [
        {
          body: "Then Paul, as his custom was, went in to them, and for three Sabbaths reasoned with them from the Scriptures.",
          ref: "Acts 17:2",
        },
        {
          body: "And he reasoned in the synagogue every Sabbath, and persuaded both Jews and Greeks.",
          ref: "Acts 18:4",
        },
      ],
    },
    "8-13": {
      blanks: [
        {
          choices: ["meditation", "prayer", "thinking"],
          correctAnswer: "prayer",
          textAfter:
            " was customarily made; and we sat down and spoke to the women who met there",
          textBefore:
            "On the Sabbath day we went out of the city to the riverside, where ",
        },
      ],
      body: "When there was no synagogue in which to worship, the Sabbath was still observed, with worship services sometimes being held outdoors.  The early Christians did not keep the Sabbath simply because of Jewish customs.  They kept all of God's commandments out of love for Him.",
      choices: ["every", "Gentiles", "prayer"],
      lessonID: 8,
      question:
        "Did the apostles begin observing Sunday after the death of Jesus?",
      questionID: 13,
      questionIDTitle: "10b",
      questionType: "radio",
      verses: [
        {
          body: "And on the Sabbath day we went out of the city to the riverside, where prayer was customarily made; and we sat down and spoke to the women who met there.",
          ref: "Acts 16:13",
        },
      ],
    },
    "8-14": {
      blanks: [
        {
          choices: ["Gentiles", "Romans", "Jews"],
          correctAnswer: "Gentiles",
          newline: [1],
          textAfter:
            " begged that these words might be preached to them the next Sabbath... ",
          textBefore: "So when the Jews went out of the synagogue, the ",
        },
        {
          choices: ["whole", "some", "most"],
          correctAnswer: "whole",
          textAfter: " city came together to hear the word of God",
          textBefore: "On the next Sabbath almost the",
        },
      ],
      body: "Even Gentile believers worshipped on the Sabbath day.  If the Sabbath had been changed, these believers would have come together to hear the Word of God on Sunday.",
      choices: [
        "Sundays",
        "other",
        "weeks",
        "Sabbaths",
        "prayer",
        "whole",
        "every",
        "Gentiles",
      ],
      lessonID: 8,
      question:
        "Did the apostles begin observing Sunday after the death of Jesus?",
      questionID: 14,
      questionIDTitle: "10c",
      questionType: "wordCloud",
      verses: [
        {
          body: "42 So when the Jews went out of the synagogue, the Gentiles begged that these words might be preached to them the next Sabbath. 43 Now when the congregation had broken up, many of the Jews and devout proselytes followed Paul and Barnabas, who, speaking to them, persuaded them to continue in the grace of God.  44 On the next Sabbath almost the whole city came together to hear the word of God.",
          ref: "Acts 13:42-44",
        },
      ],
    },
    "8-15": {
      lessonID: 8,
      question: "How did Sunday-keeping become established?",
      questionID: 15,
      questionIDTitle: 11,
      questionType: "text",
      text: [
        "The bible offers not a single instance of Sunday observance.  However, over a period of some centuries, Sunday-keeping became established.  Some religious leaders embraced Sunday as a means of distancing themselves from the Jewish people ( who were being persecuted), while pagans in the Roman Empire recognized Sunday in honor of the sun god.",
        "In AD 321, roman Emperor Constantine passed the first law elevating Sunday above the Bible Sabbath.",
        "On the venerable Day of the Sun let the magistrates and people residing in cities rest, and let all workshops be closed. ( Codex Justinianus, book 3, title 12, law 3; trans. in Philip Schaff's History of the Christian Church, vol.3,5th edition, p.380)",
        "Several years later, the church issued a decree honoring Sunday over the Sabbath of the Bible.",
        "Christians shall not Judaize and be idle on Saturday, but shall work on that day; but the  Lord's day they shall especially honor, and , as being Christians, shall, if possible, do no work on that day.  If, however, they are found Judaizing, they shall be shut out from Christ.  ( Charles Joseph Hefele, A History of the Christian Councils, vol.2, p.316)",
        "Pagans and Christians were now united in recognizing Sunday - the day of the sun - as being the day of weekly  religious significance.  The Bible Sabbath was marginalized.",
        "The Catholic Church has throughout time reinforced the concept of Sunday worship, even claiming that it was responsible for the change from Sabbath to Sunday. ",
        " \n\nQuestion: which is the Sabbath day?",
        "\n\nAnswer: Saturday is the Sabbath day.",
        "\n\nQuestion: Why do we observe Sunday instead of Saturday?",
        "\n\nAnswer: We observe Sunday instead of Saturday because the Catholic Church, in the Council of Laodicea, transferred the solemnity from Saturday to Sunday.    (Peter Geiermann, The Convert's Catechism of Catholic Doctrine, 1957 edition, p.50)",
        "Today, much of Christianity finds itself disregarding the Bible Sabbath, and embracing instead a substitute Sabbath that is without foundation in the Word of God.",
      ],
    },
    "8-16": {
      blanks: [
        {
          choices: ["the King, others", "Jesus, man", "Him, them", "God, men"],
          correctAnswer: "God",
          textAfter: "",
          textBefore:
            'Peter and the other apostles answered and said: "We ought to obey',
        },
        {
          choices: ["the King, others", "Jesus, man", "Him, them", "God, men"],
          correctAnswer: "men",
          textAfter: ' ."',
          textBefore: " rather than ",
        },
      ],
      body: "The Bible is clear that whenever a person has a choice between God’s Word and the teachings of humans, it is the Bible we should yield to out of love for God.",
      choices: ["God", "you", "laws", "men", "no one"],
      lessonID: 8,
      question:
        "What does the Bible counsel in situations where the Word of God and the customs of the church or society seem to be in conflict?",
      questionID: 16,
      questionIDTitle: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "But Peter and the other apostles answered and said: We ought to obey God rather than men.",
          ref: "Acts 5:29",
        },
      ],
    },
    "8-17": {
      blanks: [
        {
          choices: ["spite", "vain", "holiness", "power"],
          correctAnswer: "vain",
          textAfter: " they worship Me, teaching as doctrines the ",
          textBefore: "In ",
        },
        {
          choices: ["traditions", "suggestions", "commandments"],
          correctAnswer: "commandments",
          textAfter: " of men",
          textBefore: " ",
        },
      ],
      body: '"A follower of Jesus is a follower of the Word of God.  Saved Christians motivated by love for God will keep God\'s commandments.  They will say with David,"I delight to do Your will, O my God, and Your law is within my heart" (Psalm 40:8).',
      choices: ["spite", "vain", "holiness", "power", "commandments"],
      lessonID: 8,
      question:
        "What did Jesus say about the concept of replacing divine commandments with human enactments?",
      questionID: 17,
      questionIDTitle: 13,
      questionType: "wordCloud",
      type: "text",
      verses: [
        {
          body: "And in vain they worship Me, teaching as doctrines the commandments of men.",
          ref: "Matthew 15:9",
        },
      ],
    },
    "8-18": {
      blanks: [
        {
          choices: ["spirit", "vain", "holiness", "power"],
          correctAnswer: "spirit",
          textAfter: " and ",
          textBefore:
            "God is Spirit, and those who worship Him must worship in  ",
        },
        {
          choices: ["assumption", "error", "truth"],
          correctAnswer: "truth",
          textAfter: " .",
          textBefore: " ",
        },
      ],
      choices: ["spirit", "vain", "holiness", "power", "truth"],
      lessonID: 8,
      question:
        "Does the Bible give clear guidelines when it comes to worship?",
      questionID: 18,
      questionIDTitle: 14,
      questionType: "wordCloud",
      type: "text",
      verses: [
        {
          body: "God is Spirit, and those who worship Him must worship in spirit and truth.",
          ref: "John 4:24",
        },
      ],
    },
    "8-19": {
      correctAnswer: "true",
      question:
        "Are you willing to worship God in spirit and truth, and observe the seventh-day Sabbath of the Bible?",
      questionID: 19,
      questionType: "truthConfirmation",
    },
    "8-2": {
      Supplements: {
        "-L7yjjeylsmd089La3IA": {
          body: "James 4:7 says, “Submit yourselves therefore to God. Resist the devil, and he will flee from you.”  Submission to God is the essence of the Christian experience.  A person who refuses to submit to God is choosing to live outside the will of God, and to follow his or her own leading rather than the leading of heaven.\n\nWhen Peter challenged Jesus over Jesus’ statements about His impending death, Jesus said to His disciples, “If any man will come after me, let him deny himself, and take up his cross, and follow me. For whosoever will save his life shall lose it: and whosoever will lose his life for my sake shall find it.”  (Matthew 16:24,25.)  It is interesting that Jesus went on to say, “For what is a man profited, if he shall gain the whole world, and lose his own soul? or what shall a man give in exchange for his soul?”  (Matthew 16:26.)\n\nIt is in submitting to God that we recognize God’s rulership, His Lordship in our lives.  A Christian who says he or she believes in God but refuses to submit to God’s authority is choosing to separate from God’s blessing, and would not be walking in the will of God.  In submitting to God, we demonstrate to Him that we are willing to be disciples, followers, and that we are opening our hearts to God’s will being done in our lives.  Romans 6:16 says, “Know ye not, that to whom ye yield yourselves servants to obey, his servants ye are to whom ye obey; whether of sin unto death, or of obedience unto righteousness?”\n\nJesus prayed the ultimate prayer of submission to God’s will when He said, “Father, if it is Your will, take this cup away from Me; nevertheless not My will, but Yours, be done.”  (Luke 22:42.)\n",
          title: "What is submission to God?",
        },
      },
      blanks: [
        {
          choices: ["fear", "trust", "love", "believe"],
          correctAnswer: "love",
          textAfter: " Me, keep My commandments.",
          textBefore: "If you",
        },
      ],
      body: "Love for God is the primary motivator when it comes to living a life of obedience to God. One may want to go to heaven or avoid being lost, but the greatest and most effective motivation to keep God’s commandments is love for God.",
      choices: ["fear", "trust", "love", "believe"],
      lessonID: 8,
      question:
        "What motivates a believer in Jesus to want to obey God and keep His commandments?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "If you love Me, keep My commandments.",
          ref: "John 14:15",
        },
      ],
    },
    "8-3": {
      Supplements: {
        "-L7z-oUQTAPHZaOoTVQa": {
          body: "The fourth commandment states, “The seventh day is the Sabbath of the Lord your God. In it you shall do no work.”  (Exodus 20:10.)\n\nMany people today are constantly on the go because of the demands of life. Workaholics would work eight days a week if they could. Others feel they have no option but to work every available hour because of the difficulty of making ends meet.\n\nThe Sabbath is a ‘pause’ button for modern living. Time out, so desperately needed, was built into the weekly cycle by God, who knew what we would need to be healthy, happy and holy in the final days of earth’s history.  An all-knowing God foresaw the challenges and the temptations of modern living.\n\nGod did not intend for anyone to have to work on the seventh-day Sabbath.  Of course the question may arise, “What about doctors and nurses?  What if they didn’t work on the Sabbath?”  People on the front lines in the medical profession may need to work on the Sabbath, if they cannot arrange to change their schedules.  But even then, there’s a danger inherent in failing to observe the Sabbath as the Sabbath day may under these circumstances become simply “another day” for the person concerned.  This can happen even if he or she works in a selfless, healing profession.\n\nFormer Senator Joe Lieberman was asked in an interview how society might change if everyone adopted Sabbath observance into their lives. He responded by saying, “I think we’d be a much happier country. We’d have much more perspective because part of what Sabbath does is force us to step back and take us out of the hullabaloo of the six work days and come back to first principles. But most of all, the Sabbath gives us the gratitude to appreciate that we’re alive and to appreciate the opportunities we have. I think this would be a much more peaceful and productive country, and in this particular time, especially when there’s such economic pain and anxiety, the Sabbath really brings you back to what’s most important. Of course, you want to have a job and be confident about the future, but the Sabbath reminds you that just being alive is a gift, and we each have the opportunity to make the most of it.”\n\nJesus sought to show that the Sabbath was a day of blessing. It is true God did not intend for us to work at our secular employment on the Sabbath day, or to busy ourselves with the daily, mundane things that could be defined as work. In saying, “Six days you shall labor and do all your work,” God was granting the human family a huge blessing!  He was giving us a day every week where work and chores and jobs and other secular pursuits wait, and a person is able to focus entirely on God, family, fellowship and ministry. \n\nIf you are faced with the prospect of having to work on God’s holy Sabbath day, prayerfully approach your employer and explain that as a Bible-believing Christian your conscience won’t allow you to violate the law of God and break the Sabbath day.  Ask your employer if he or she would accommodate your religious beliefs.  Be willing to work Sundays or evenings in order to inconvenience your employer as little as possible, and assure your employer that you are not merely trying to get a day off work.  Politely explain that your commitment to God will make you a more valuable employee, as you strive to do all things to honor God in your personal and working life.\n",
          title: "Should a person work on the Sabbath day?",
        },
        "-L7z0gOk9Mn-piu0DSAA": {
          body: "\nNotice what the prophet Isaiah said about the Sabbath.\n\nIsaiah 58:13,14.  “If you turn away your foot from the Sabbath, from doing your pleasure on my holy day, and call the Sabbath a delight, the holy day of the Lord honorable, and shall honor Him, not doing your own ways, nor finding your own pleasure, nor speaking your own words, then you shall delight yourself in the Lord; and I will cause you to ride on the high hills of the earth, and feed you with the heritage of Jacob your father. The mouth of the Lord has spoken.”\n\nIsaiah encourages us to see the Sabbath as a “delight.”  A day devoted to the worship of the Creator can easily be a delight.  No work, no secular worries, but a day which focuses on serving God is a day for which we can be grateful to God.  Notice that Isaiah speaks of “not doing your own ways, nor finding your own pleasure, not speaking your own words.”  The Sabbath is a day different from what Ezekiel referred to as “the six working days” (Ezekiel 46:1.)  It is a day when even our conversations veer away from regular, secular topics such as business and sports.  Our “own ways” might be mowing the grass or shopping for groceries, activities that can and should be left until after the Sabbath.  \n\nWhere Isaiah writes, “nor finding your own pleasure,” he isn’t talking about the “pleasure” we receive from eating or enjoying nature or spending time with friends and family.  Rather, Isaiah is referring to self-centered, secular pleasure, activities which might be appropriate for another day, but are best not participated in on the Sabbath day.\n",
          title: "Biblical counsel about the Sabbath.",
        },
      },
      blanks: [
        {
          choices: ["abomination", "afterthought", "effort", "inconvenience"],
          correctAnswer: "abomination",
          textAfter: " .",
          textBefore:
            "One who turns away his ear from hearing the law, even his prayer is an",
        },
      ],
      body: "While God is certainly willing to forgive us when we fall into sin (1 John 1:9), and although Jesus is our Advocate in heaven (1 John 2:1), an attitude of willful turning away from obedience to God cannot meet with God’s approval.",
      choices: ["abomination", "thought", "effort", "inconvenience"],
      correctAnswer: "false",
      lessonID: 8,
      question: "How important is it to God that we keep His commandments?",
      questionID: 3,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "It is not important to God that we keep His commandments.",
      verses: [
        {
          body: "One who turns away his ear from hearing the law, even his prayer is an abomination.",
          ref: "Proverbs 28:9",
        },
      ],
    },
    "8-4": {
      blanks: [
        {
          choices: [
            "lives",
            "faith",
            "stays by",
            "love",
            "works through",
            "trust",
          ],
          correctAnswer: "lives",
          textAfter: " ",
          textBefore:
            "I have been crucified with Christ; it is no longer I who live, but Christ",
        },
        {
          choices: [
            "loves",
            "faith",
            "stays by",
            "in",
            "works through",
            "trust",
          ],
          correctAnswer: "in",
          textAfter:
            " me; and the life which I now live in the flesh I live by",
        },
        {
          choices: [
            "lives in",
            "faith",
            "stays by",
            "love",
            "works through",
            "trust",
          ],
          correctAnswer: "faith",
          textAfter:
            " in the Son of God, who loved me and gave Himself for me.",
        },
      ],
      body: "When we surrender our lives to Jesus, He lives His life in us, bringing His power and His holiness into our lives. We obey God by allowing Jesus to live His life in us, and by cooperating with Him when He does so.",
      choices: [
        "lives",
        "faith",
        "stays by",
        "love",
        "works through",
        "trust",
        "in",
      ],
      lessonID: 8,
      question:
        "How does God make it possible for sinful human beings to obey His law?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.",
          ref: "Galatians 2:20",
        },
      ],
    },
    "8-5": {
      Supplements: {
        "-L7z1fQSU3VGi91_4Hi2": {
          body: "Clearly, obedience is important in a relationship with God.  The better question to ask is, “How do I live in obedience to God?”\n\nIt must be remembered that obedience does not merit salvation.  No one should choose to obey God simply because obedience will bring everlasting life.  People are saved only one way -  by grace through faith in Jesus Christ (see Ephesians 2:8).\n\nJesus said, “If you love me, keep my commandments.” (John 14:15)  Love for God produces obedience in a believer’s life.  Refusing to obey God is sin, and “the wages of sin is death” (Romans 6:23.)  The Bible speaks again and again of the blessing of obedience, and it speaks also of the inevitability of obedience when Jesus dwells in a person’s heart.  In Galatians 2:20 Paul writes, “I am crucified with Christ, nevertheless I live.  Yet not I, but Christ liveth in me.”  When Jesus lives His life in you, your life will be a life of conformity to God’s will, a life of joyful obedience guided by the Holy Spirit.\n\nRevelation 22:14 says, “Blessed are they that do His commandments, that they may have right to the tree of life, and may enter in through the gates into the city.”  1 John 5:3 says, “For this is the love of God, that we keep His commandments, and His commandments are not grievous.”\n\nThe life of a person who loves God and seeks to do His will will be characterized by obedience.  As life on earth is an experience of continued growth in God, it might be that different people are in different places in their growth experience.  But a life owned and governed by God will be a life that honors God and seeks to obey and serve and love Him.\n",
          title: "How important is it to obey God?",
        },
      },
      blanks: [
        {
          choices: ["laws", "demands", "Sabbaths", "thoughts"],
          correctAnswer: "Sabbaths",
          textAfter:
            " , to be a sign between them and Me, that they might know that I am the Lord who sanctifies them.",
          textBefore: "I also gave them My",
        },
      ],
      body: "The seventh-day Sabbath is the sign God gave His children so they would know He is able to re-create them in His image. The Sabbath is a sign of God’s creative power—the power He exercised at creation, and the power He exercises when He remakes a human heart.",
      choices: ["laws", "demands", "Sabbaths", "thoughts"],
      lessonID: 8,
      question:
        "Which of the Ten Commandments is a special sign between God and His people?",
      questionID: 5,
      questionType: "radio",
      verses: [
        {
          body: "Moreover I also gave them My Sabbaths, to be a sign between them and Me, that they might know that I am the Lord who sanctifies them.",
          ref: "Ezekiel 20:12",
        },
      ],
    },
    "8-6": {
      blanks: [
        {
          choices: ["weekend", "Sabbath", "holiday", "first day"],
          correctAnswer: "Sabbath",
          textAfter: " .",
          textBefore: "Pray that your flight may not be in winter or on the",
        },
      ],
      body: "Looking ahead to the destruction of Jerusalem—which happened four decades after Jesus’ death, in AD 70—Jesus encouraged His people to pray they would not have to flee on the Sabbath day. Jesus could not have made it clearer that the Sabbath would still be important to His people long after He died on the cross.",
      choices: ["weekend", "Sabbath", "holiday", "first day"],
      correctAnswer: "false",
      lessonID: 8,
      question:
        "Did God intend for Christians to keep the Sabbath after Jesus died on the cross?",
      questionID: 6,
      questionType: "trueOrFalse",
      trueFalseQuestion: "God only intended the Jews to keep the Sabbath.",
      verses: [
        {
          body: "And pray that your flight may not be in winter or on the Sabbath.",
          ref: "Matthew 24:20",
        },
      ],
    },
    "8-7": {
      Supplements: {
        "-L7z1Er3yJIBDNOOIJiX": {
          body: "The Bible says, “the seventh day is the Sabbath of the Lord thy God.”  (Exodus 20:10.)  But which day is “the seventh day”?\n\nAlmost any calendar shows clearly that the seventh day of the week is Saturday. And even though some modern calendars have begun showing the days of the week as running from Monday to Sunday, dictionaries define Saturday as being the week’s seventh day. Therefore, when God said “the seventh day”, even though the modern names of the week were not in existence, that seventh day equates to the day we now call Saturday.\n\nJesus was crucified on what the Bible refers to as “the preparation” day (Luke 23:54), which we know to be Good Friday.  Mark refers to the preparation day as “the day before the Sabbath” (Mark 15:42.)  Jesus rose on the first day of the week (Luke 24:1).  Today, we refer to the day on which Jesus rose from the dead as Easter Sunday.  Sunday is the first day of the week.\n\nAs Jesus died on Friday and rose on Sunday, the day in between - the day on which Jesus rested in the tomb - was a Saturday.\n\nTherefore, the Sabbath of the Bible is the day which today we call Saturday.\n",
          title:
            "How can we know from the Bible which day of the week is the Sabbath day?",
        },
      },
      blanks: [
        {
          choices: [
            "before",
            "gone",
            "last",
            "place",
            "first",
            "after",
            "past",
          ],
          correctAnswer: "after",
          newline: [1],
          textAfter:
            " the Sabbath, as the first day of the week began to dawn, Mary Magdalene and the other Mary came to see the tomb. ",
          textBefore: "Now",
        },
        {
          choices: ["before", "gone", "last", "place", "past"],
          correctAnswer: "past",
          textAfter:
            " , Mary Magdalene, Mary the mother of James, and Salome bought spices, that they might come and anoint Him. Very early in the morning, on the",
          textBefore: "Now when the Sabbath was ",
        },
        {
          choices: ["before", "gone", "last", "place", "first"],
          correctAnswer: "first",
          newline: [1],
          textAfter:
            " day of the week, they came to the tomb when the sun had risen.",
        },
        {
          choices: ["before", "gone", "last", "place", "day"],
          correctAnswer: "day",
          newline: [1],
          textAfter:
            " of the week, He appeared first to Mary Magdalene, out of whom He had cast seven demons.",
          textBefore: "Now when He rose early on the first ",
        },
        {
          choices: ["before", "tomb", "last", "place", "first"],
          correctAnswer: "tomb",
          newline: [1],
          textAfter: " bringing the spices which they had prepared. ",
          textBefore:
            "Now on the first day of the week, very early in the morning, they and certain other women with them, came to the ",
        },
        {
          choices: ["Before", "gone", "last", "place", "first"],
          correctAnswer: "Mary",
          textAfter:
            "  Magdalene went to the tomb early, while it was still dark, and saw that the stone had been taken away from the tomb.",
          textBefore: "Now on the first day of the week  ",
        },
      ],
      body: "This is not due to any reason found in the Bible. Sunday observance is not mandated in the Bible, and it was never given to the human family by God as a day to keep holy. Nowhere does the Bible suggest that we should keep Sunday holy! The first day of the week—Sunday—is mentioned infrequently in the New Testament. Each of these texts mentions the first day of the week, but never do they suggest that Sunday was to be recognized as a day of rest or worship.",
      choices: [
        "before",
        "gone",
        "last",
        "tomb",
        "first",
        "after",
        "past",
        "day",
        "Mary",
      ],
      lessonID: 8,
      question:
        "Why is it that many people observe Sunday for the Sabbath, in place of the seventh day of the week?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "Now after the Sabbath, as the first day of the week began to dawn, Mary Magdalene and the other Mary came to see the tomb.",
          ref: "Matthew 28:1",
        },
        {
          body: "1 Now when the Sabbath was past, Mary Magdalene, Mary the mother of James, and Salome bought spices, that they might come and anoint Him.\n\n2 Very early in the morning, on the first day of the week, they came to the tomb when the sun had risen.",
          ref: "Mark 16:1,2",
        },
        {
          body: "Now when He rose early on the first day of the week, He appeared first to Mary Magdalene, out of whom He had cast seven demons.",
          ref: "Mark 16:9",
        },
        {
          body: "Now on the first day of the week, very early in the morning, they, and certain other women with them, came to the tomb bringing the spices which they had prepared.",
          ref: "Luke 24:1",
        },
        {
          body: "Now on the first day of the week Mary Magdalene went to the tomb early, while it was still dark, and saw that the stone had been taken away from the tomb.",
          ref: "John 20:1",
        },
      ],
    },
    "8-8": {
      blanks: [
        {
          choices: ["fear", "spite", "tidings"],
          correctAnswer: "fear",
          textAfter: " ",
          textBefore:
            "Then the same day at evening, being the first day of the week, when the doors were shut where the disciples were assembled, for",
        },
        {
          choices: ["of", "were", "grim"],
          correctAnswer: "of",
          textAfter: " ",
        },
        {
          choices: ["the", "nearby", "were"],
          correctAnswer: "the",
          textAfter: " ",
        },
        {
          choices: ["Jews", "Romans", "Disciples"],
          correctAnswer: "Jews",
          textAfter:
            ' , Jesus came and stood in the midst, and said to them, "Peace be with you."',
        },
      ],
      body: "The only reason the disciples were assembling on the first day of the week was because they feared the Jews in the wake of the death of Jesus.",
      choices: [
        "tidings",
        "fear",
        "joy",
        "of",
        "in",
        "the",
        "by",
        "Romans",
        "Greeks",
        "Jews",
      ],
      lessonID: 8,
      question:
        "Do any other New Testament texts mention the first day of the week?",
      questionID: 8,
      questionIDTitle: "8a",
      questionType: "wordCloud",
      subQuestion: "Let's look at the first text.",
      verses: [
        {
          body: "Then, the same day at evening, being the first day of the week, when the doors were shut where the disciples were assembled, for fear of the Jews, Jesus came and stood in the midst, and said to them, “Peace be with you.”",
          ref: "John 20:19",
        },
      ],
    },
    "8-9": {
      blanks: [
        {
          choices: ["mid day", "midnight", "mid morning"],
          correctAnswer: "midnight",
          textAfter:
            " .  There were many lamps in the upper room where they were gathered together.",
          textBefore:
            " Now on the first day of the week, when the disciples came together to break bread, Paul, ready to depart the next day, spoke to them and continued his message until ",
        },
      ],
      body: "Paul was preaching on the first day of the week. Biblically speaking, a day starts and ends at sunset.  (Leviticus 23:32; Mark 1:32) Therefore, Paul - preaching on the dark part of the first day of the week - was preaching on Saturday night.  (Sunday night would have been the second day of the week.) The fact that Paul was preaching on the first day of the week did not make that day a holy day.",
      choices: ["mid day", "midnight", "mid morning"],
      lessonID: 8,
      question:
        "Do any other New Testament texts mention the first day of the week?",
      questionID: 9,
      questionIDTitle: "8b",
      questionType: "wordCloud",
      subQuestion: "The second text is in Acts.  Let's take a look.",
      verses: [
        {
          body: "Now on the first day of the week, when the disciples came together to break bread, Paul, ready to depart the next day, spoke to them and continued his message until midnight.  There were many lamps in the upper room where they were gathered together.",
          ref: "Acts 20:7-8",
        },
      ],
    },
  },
  {
    "9-0": {
      body: "When Japan attacked Pearl Harbor on December 7, 1941, the United States was thrust into World War II. After many fierce conflicts in the Pacific, it became evident that Japan could not triumph in its war against the United States. Repeated calls were made for Japan to surrender, but that didn’t happen, and it appeared the war would drag on, costing many more lives. On August 6, 1945, an atomic bomb nicknamed “Little Boy” was dropped from the Enola Gay—a B-29 bomber—over the Japanese city of Hiroshima. Three days later, a similar bomb was dropped on the city of Nagasaki. Japan soon signaled its intention to surrender. On September 2 of the same year, the Instrument of Surrender was signed aboard the USS Missouri in Tokyo Bay. World War II was over. In the same way, the war so many people experience with sin will be over when a surrender is made. Surrender to God is a vital key to living a life of real faith!",
      lessonID: 9,
      questionID: 0,
      type: "text",
    },
    "9-1": {
      Supplements: {
        "-L7z2VYiUU7au5PcRmSG": {
          body: "Romans 6:16 says, “Do you not know that to whom you present yourselves slaves to obey, you are that one’s slaves whom you obey, whether of sin leading to death, or of obedience leading to righteousness?”\n\nThe Christian life is a series of choices.  Every temptation presents the opportunity to chose to surrender to God or to chose not to surrender to God.  The choice to not surrender to God is in actuality the choice to serve the enemy, Satan.\n\nTo be a disciple of Jesus is to chose the service of God and the leading of the Holy Spirit.  But as Jesus said in John 8:34, “Jesus answered them, 'Most assuredly, I say to you, whoever commits sin is a slave of sin.'”\n\nSin enslaves.  Sin holds people in bondage, in servitude.  Thankfully, there is a way to escape the slavery of sin.  Jesus died on the cross so that human beings can be free from sin.  Through the power of forgiveness and the gift of a new heart, those who once served sin can instead serve Jesus Christ.\n\nGod said in Ezekiel 36:26, 27, “I will give you a new heart and put a new spirit within you; I will take the heart of stone out of your flesh and give you a heart of flesh. I will put my Spirit within you and cause you to walk in my statutes, and you will keep my judgments and do them.”\n\nIn John 8:36, Jesus said, “Therefore if the Son makes you free, you shall be free indeed.”",
          title: " What is a “slave to sin”?",
        },
      },
      blanks: [
        {
          choices: [
            "speak",
            "cause",
            "life",
            "present",
            "sin",
            "obedience",
            "say",
            "life",
            "salvation",
          ],
          correctAnswer: "present",
          textAfter:
            " yourselves slaves to obey, you are that one’s slaves whom you obey, whether of",
          textBefore: "Do you not know that to whom you",
        },
        {
          choices: [
            "speak",
            "cause",
            "life",
            "present",
            "sin",
            "obedience",
            "say",
            "life",
            "salvation",
          ],
          correctAnswer: "sin",
          textAfter: " leading to death, or of",
        },
        {
          choices: [
            "speak",
            "cause",
            "life",
            "present",
            "sin",
            "obedience",
            "say",
            "life",
            "salvation",
          ],
          correctAnswer: "obedience",
          textAfter: " leading to righteousness?",
        },
      ],
      body: "God asks us to surrender to Him. That is, to yield to God moment by moment so we can live in harmony with His will for our lives.",
      choices: [
        "speak",
        "cause",
        "life",
        "present",
        "sin",
        "obedience",
        "say",
        "salvation",
      ],
      lessonID: 9,
      question: "What sort of relationship does God call us to have with Him?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "Do you not know that to whom you present yourselves slaves to obey, you are that one’s slaves whom you obey, whether of sin leading to death, or of obedience leading to righteousness?",
          ref: "Romans 6:16",
        },
      ],
    },
    "9-10": {
      Supplements: {
        "-L7z7OAl2JCja8pt77gr": {
          body: "1 John 2:1 says, “My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an Advocate with the Father, Jesus Christ the righteous.”\n\nThe Greek word translated “Advocate” is the word “parakletos,” which means “one who pleads another’s cause before a judge.”  As our High Priest in heaven, Jesus is our Advocate before the Father.\n\nWhile some have suggested that the word “Mediator” or “Intercessor” would be preferable to “Advocate,” the wording in 1 John 2:1 presents to us a picture of Someone who pleads our cause before God.  \n\nAs Hebrews 9:24 says, “For Christ has not entered the holy places made with hands, which are copies of the true, but into heaven itself, now to appear in the presence of God for us.”  The incredibly good news is that Jesus is not only in heaven, but that He is there for us, to represent us, and to provide grace and strength.  As our Advocate, Jesus is on our side. “For He knows our frame; He remembers that we are dust” (Psalm 103:14), and is on our side in our battle with temptation and sin.",
          title: " Why is Jesus described in the Bible as our “Advocate”?",
        },
      },
      blanks: [
        {
          choices: [
            "audience",
            "saviour",
            "arrangement",
            "lord",
            "Advocate",
            "righteous",
          ],
          correctAnswer: "Advocate",
          textAfter: " with the Father, Jesus Christ the",
          textBefore:
            "My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an",
        },
        {
          choices: [
            "audience",
            "saviour",
            "arrangement",
            "lord",
            "Advocate",
            "righteous",
          ],
          correctAnswer: "righteous",
          textAfter: " .",
        },
      ],
      body: "God is gracious! When we repent of our sins, we can know that Jesus, as our Advocate and Defense Attorney, represents us before the throne of God. That is not to say that we want to become presumptuous and choose to cling to sin. Faith in Jesus will develop in us a hatred of sin. We will strive to surrender to God. \n\nHowever, we can recognize that God is willing to forgive us our imperfections when we experience genuine repentance. Like a parent tenderly watching over a young child falling over while learning to walk, God looks on us with patience and love when we fall while growing in His grace. This does not minimize the seriousness of sin. The wages of sin is death! But God does not cast us off when we make mistakes. If our hearts are with Him, God helps us to grow in Him.",
      choices: [
        "audience",
        "righteous",
        "arrangement",
        "lord",
        "Advocate",
        "Savior",
      ],
      lessonID: 9,
      question:
        "What about when we fall short? What is God’s reaction when we fail?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an Advocate with the Father, Jesus Christ the righteous.",
          ref: "1 John 2:1",
        },
      ],
    },
    "9-11": {
      blanks: [
        {
          choices: [
            "works in you",
            "His",
            "keeps you safe",
            "your",
            "loves you most",
            "His",
          ],
          correctAnswer: "works",
          textAfter: " ",
          textBefore: "It is God who",
        },
        {
          choices: [
            "works in you",
            "His",
            "keeps you safe",
            "your",
            "loves you most",
            "His",
          ],
          correctAnswer: "in",
          textAfter: " ",
        },
        {
          choices: [
            "works in you",
            "His",
            "keeps you safe",
            "your",
            "loves you most",
            "His",
          ],
          correctAnswer: "you",
          textAfter: " both to will and to do for",
        },
        {
          choices: [
            "works in you",
            "His",
            "keeps you safe",
            "your",
            "loves you most",
            "His",
          ],
          correctAnswer: "His",
          textAfter: " good pleasure.",
        },
      ],
      body: "It is God’s plan that when we yield ourselves to Him (Romans 6:16), He lives in us. And notice: He will bring into our lives both the willingness (“to will”) to live for Him, and the ability (“and to do”) to live for Him! \n\nThe Bible says that we are “by nature children of wrath” (Ephesians 2:3). But God’s plan is to transform our nature—to re-create us in the image of God that was lost when Adam and Eve fell into sin in the Garden of Eden. “Even when we were dead in trespasses, [God has] made us alive together with Christ” (Ephesians 2:5). \n\nThose who are “dead in trespasses and sins” (Ephesians 2:1) are accepted, forgiven, cleansed and kept by God as He lives His life in them.",
      choices: ["works", "for", "your", "you", "His", "in"],
      lessonID: 9,
      question:
        "What does God promise to do in the lives of believers who fully surrender to Him?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "For it is God who works in you both to will and to do for His good pleasure.",
          ref: "Philippians 2:13",
        },
      ],
    },
    "9-12": {
      blanks: [
        {
          choices: ["with you", "beside you", "in you"],
          correctAnswer: "in",
          textAfter: " ",
          textBefore:
            "The Spirit of truth, whom the world cannot receive, because it neither sees Him nor knows Him; but you know Him, for He dwells with you and will be",
        },
        {
          choices: ["with you", "beside you", "in you"],
          correctAnswer: "you",
          textAfter: " .",
        },
      ],
      body: "God has given the gift of the Holy Spirit so that He can dwell with us and in us, strengthening us and keeping us as we live a life of surrender.",
      choices: ["with", "after", "you", "beside", "in"],
      lessonID: 9,
      question: "How does God live in His children?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "The Spirit of truth, whom the world cannot receive, because it neither sees Him nor knows Him; but you know Him, for He dwells with you and will be in you.",
          ref: "John 14:17",
        },
      ],
    },
    "9-13": {
      blanks: [
        {
          choices: ["trust", "ask", "love", "believe"],
          correctAnswer: "ask",
          textAfter: " Him!",
          textBefore:
            "If you then, being evil, know how to give good gifts to your children, how much more will your heavenly Father give the Holy Spirit to those who",
        },
      ],
      body: "As Jesus said, “Ask, and it will be given to you” (Matthew 7:7). God wants to give His Spirit to those who recognize their need of Divine help and ask God for His Spirit! It is good to keep in mind that God wants us to succeed spiritually. He wants to help us, to guide us and to dwell in us. God is with us and not against us!",
      choices: ["trust", "ask", "love", "believe"],
      lessonID: 9,
      question: "How can a person receive the gift of the Holy Spirit?",
      questionID: 13,
      questionType: "radio",
      verses: [
        {
          body: "If you then, being evil, know how to give good gifts to your children, how much more will your heavenly Father give the Holy Spirit to those who ask Him!",
          ref: "Luke 11:13",
        },
      ],
    },
    "9-14": {
      blanks: [
        {
          choices: ["keep", "love", "complete", "bear"],
          correctAnswer: "complete",
          textAfter: " it until the day of Jesus Christ.",
          textBefore:
            "Being confident of this very thing, that He who has begun a good work in you will",
        },
      ],
      body: "God has promised that He will perform the work that He has begun in your life. Instead of fighting your spiritual battles in your own strength, you can expect God to provide you with His strength in your daily Christian experience.",
      choices: ["keep", "love", "complete", "bear"],
      lessonID: 9,
      question:
        "How has God taken responsibility for our spiritual well-being?",
      questionID: 14,
      questionType: "radio",
      verses: [
        {
          body: "Being confident of this very thing, that He who has begun a good work in you will complete it until the day of Jesus Christ.",
          ref: "Philippians 1:6",
        },
      ],
    },
    "9-15": {
      blanks: [
        {
          choices: ["word", "minds", "seal", "hearts", "name", "foreheads"],
          correctAnswer: "name",
          textAfter: " shall be on their",
          textBefore: "They shall see His face, and His",
        },
        {
          choices: ["word", "minds", "seal", "hearts", "name", "foreheads"],
          correctAnswer: "foreheads",
          textAfter: " .",
        },
      ],
      body: "The plan of salvation is about more than giving sinners the gift of everlasting life. The plan of salvation deals with humankind’s complete recovery from the power of sin. And, ultimately, God will restore His own image in the minds of fallen sinners who have been redeemed. What Adam and Eve lost in the Garden of Eden will be restored! \n\nGod wants to do this work in you. Christianity goes far beyond simply believing certain truths—Christianity is a total surrender to the will of God. \n\nThe Holy Spirit will come to you as God’s Representative and guide you in the path you should go. As Isaiah wrote, “Your ears shall hear a word behind you, saying, ‘This is the way, walk in it,’ whenever you turn to the right hand or whenever you turn to the left” (Isaiah 30:21).",
      choices: ["word", "foreheads", "seal", "hearts", "name", "minds"],
      lessonID: 9,
      question:
        "What remarkable promise has God made to those who surrender their lives to Him?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "They shall see His face, and His name shall be on their foreheads.",
          ref: "Revelation 22:4",
        },
      ],
    },
    "9-16": {
      blanks: [
        {
          choices: ["mind", "soul", "faith", "vows"],
          correctAnswer: "mind",
          textAfter: " .",
          textBefore:
            "Do not be conformed to this world, but be transformed by the renewing of your",
        },
      ],
      body: "Transformation! That’s what God can do in us. When you surrender your will to Him—when you ask Him to take your life and make it His—God will create in you a clean heart and renew a steadfast spirit within you (Psalm 51:10). And you can be confident that having surrendered to Him, you will dwell with Him throughout eternity.",
      choices: ["mind", "soul", "faith", "vows"],
      lessonID: 9,
      question: "How does God encourage us to live through His power?",
      questionID: 16,
      questionType: "radio",
      verses: [
        {
          body: "And do not be conformed to this world, but be transformed by the renewing of your mind, that you may prove what is that good and acceptable and perfect will of God.",
          ref: "Romans 12:2",
        },
      ],
    },
    "9-17": {
      correctAnswer: "true",
      question:
        "Are you willing to make a complete surrender to God, and ask that His will - and not your will - be done in your life?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "9-2": {
      Supplements: {
        "-L7z567htXD2ToSKI0Nh": {
          body: "The Bible tells us that Jesus was affected by temptation, saying in Hebrews 4:15 that He “was in all points tempted like as we are.”  Temptation was real to Jesus, yet as Hebrews 4:15 goes on to say, “He was in all points tempted like as we are, yet without sin.”\n\nHow could it be said of Jesus that He “did no sin, neither was guile found in his mouth” (1 Peter 2:22)?\n \nIn John 17:21, Jesus said, “As You, Father, are in Me, and I in You.”  Jesus remained surrendered to His Father’s will, as demonstrated in Luke 22:42 when He said, “Nevertheless not My will, but Yours, be done.”\n\nIt was Jesus highest delight to remain in the center of God’s will.  “Jesus said to them, 'My food is to do the will of Him who sent Me, and to finish His work'”  (John 4:34).  Submission to God was a joy for Jesus, and never a burden.  You can have that same experience.  Your greatest joy can be from surrendering your will to God and experiencing His plan for your life.\n\n",
          title: " How did Jesus submit to His Father?",
        },
      },
      blanks: [
        {
          choices: ["will", "You", "wish", "I", "do", "You"],
          correctAnswer: "will",
          textAfter: " , but as",
          textBefore:
            "He went a little farther and fell on His face, and prayed, saying, “O My Father, if it is possible, let this cup pass from Me; nevertheless, not as I",
        },
        {
          choices: ["will", "You", "wish", "I", "do", "You"],
          correctAnswer: "You",
          textAfter: " will.”",
        },
      ],
      body: "In His darkest hour, when faced with the prospect of crucifixion, even though His humanity shrank from dying on the cross, Jesus surrendered His will to the will of His Father. In doing so, salvation came to the human family.",
      choices: ["will", "You", "wish", "I", "do"],
      lessonID: 9,
      question: "How did Jesus model the concept of surrender to God?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "He went a little farther and fell on His face, and prayed, saying, “O My Father, if it is possible, let this cup pass from Me; nevertheless, not as I will, but as You will.”",
          ref: "Matthew 26:39",
        },
      ],
    },
    "9-3": {
      Supplements: {
        "-L7z5T3SY6sn5xj3gqLp": {
          body: "The Bible occasionally equates the Christian experience with warfare.  In Ephesians 6, Paul said that believers should “put on the whole armor of God” (Ephesians 6:11).  Towards the end of his life Paul stated that he had “fought the good fight” (2 Timothy 4:7).\n\nThe greatest battle believers have is the battle against self, against the fallen, sinful nature we are born with.  When temptation comes, self often wants to yield to that temptation.  It can be a struggle to surrender the will to God.\n\nHowever, the power of God is always great enough to keep you from temptation.  (See 1 Corinthians 10:13; Jude 24).  As your experience with God deepens, many temptations will cease to be tempting, and you learn to better and more readily surrender to God and call on Him for help.\n\nThings such as heredity, habits and even hunger or fatigue can intensify the battle with the sinful nature.  But nothing is so great a challenge as to be beyond the power of God.  No temptation is greater than the Holy Spirit’s power to give you victory in the midst of temptation.  In spite of how it may sometimes seem, God is always able to deliver you from sin and give you spiritual success instead of failure.",
          title: " Why does faith in God sometimes seem to be a struggle?",
        },
      },
      blanks: [
        {
          choices: ["think", "know", "will", "perform", "know", "do"],
          correctAnswer: "will",
          textAfter: " is present with me, but how to",
          textBefore:
            "I know that in me (that is, in my flesh) nothing good dwells; for to",
        },
        {
          choices: ["think", "know", "will", "perform", "know", "do"],
          correctAnswer: "perform",
          textAfter: " what is good I do not find.",
        },
      ],
      body: "Paul experienced what all human beings experience: the gravity of our human nature. Because we are fallen, we naturally want to live for self rather than live for God, but the life of a true Christian is the life of one who lives in harmony with heaven.",
      choices: ["think", "know", "will", "perform", "do"],
      lessonID: 9,
      question:
        "How did Paul describe the inner struggle experienced by sinful human beings?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "For I know that in me (that is, in my flesh) nothing good dwells; for to will is present with me, but how to perform what is good I do not find.",
          ref: "Romans 7:18",
        },
      ],
    },
    "9-4": {
      blanks: [
        {
          choices: ["our Father", "Your will", "Jesus Christ"],
          correctAnswer: "Jesus",
          textAfter: " ",
          textBefore: "I thank God—through",
        },
        {
          choices: ["our Father", "Your will", "Jesus Christ"],
          correctAnswer: "Christ",
          textAfter: " our Lord!",
        },
      ],
      body: "Paul discovered that Jesus was able to strengthen him in his battle against self!\n\nHe wrote in Romans 8:13, “For if you live according to the flesh you will die; but if by the Spirit you put to death the deeds of the body, you will live.” Through the power of the Holy Spirit, Jesus brings to us a supernatural ability to live in harmony with God.",
      choices: ["our", "Father", "Your", "will", "Jesus", "Christ"],
      lessonID: 9,
      question:
        "How did Paul find his way out of the struggle against his fallen nature?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "I thank God—through Jesus Christ our Lord! So then, with the mind I myself serve the law of God, but with the flesh the law of sin.",
          ref: "Romans 7:25",
        },
      ],
    },
    "9-5": {
      Supplements: {
        "-L7z6EXpP7OmGury2CvM": {
          body: "Read 1 Corinthians 10:13 below.  It’s a powerful verse.\n\n“No temptation has overtaken you except such as is common to man; but God is faithful, who will not allow you to be tempted beyond what you are able, but with the temptation will also make the way of escape, that you may be able to bear it.”\n\nThe Bible says we are saved by grace, through faith in Jesus Christ (Ephesians 2:8).  When temptation comes, the person who surrenders to God in that moment will find “the way of escape” (1 Corinthians 10:13) from that temptation, whatever it may be.\n\nJude 24 says that God is able to “keep you from falling.”  When you claim the promises of God and ask God to deliver you from any temptation, He will do so.  He has promised.\n\nIt must be remembered that victory comes through faith in God.  Willpower isn’t the key to remaining strong in Christ when temptation comes.  No person’s will is any match for the enemy of souls.  However, when you surrender your will to God, He takes hold of your will and strengthens you through His own mighty power.\n\nHere’s a practical suggestion.  Memorize God’s promises, and recall them and claim them when temptation comes.  In a certain situation you might claim Philippians 4:13.  “I can do all things through Christ who strengthens me.”  You could claim the power of God’s Word in 2 Timothy 2:22, which says, “Flee also youthful lusts: but follow righteousness, faith, charity, peace, with them that call on the Lord out of a pure heart.”  Recall Proverbs 1:10.  “My son, if sinners entice you, do not consent.”\n\nClaim God’s promises, stay close to God, be filled with the power of the Holy Spirit, and you will see remarkable spiritual growth.  You will discover that as Paul said in Romans 6:14, “sin shall not have dominion over you.”\n",
          title: "How can a person have victory over sin?",
        },
      },
      blanks: [
        {
          choices: [
            "in",
            "flesh",
            "Spirit",
            "saved",
            "light",
            "word",
            "Your's",
            "gospel",
            "faith",
          ],
          correctAnswer: "in",
          textAfter: " Christ Jesus, who do not walk according to the",
          textBefore: "There is therefore now no condemnation to those who are",
        },
        {
          choices: [
            "in",
            "flesh",
            "Spirit",
            "saved",
            "light",
            "word",
            "Your's",
            "gospel",
            "faith",
          ],
          correctAnswer: "flesh",
          textAfter: " , but according to the",
        },
        {
          choices: [
            "in",
            "flesh",
            "Spirit",
            "saved",
            "light",
            "word",
            "Your's",
            "gospel",
            "faith",
          ],
          correctAnswer: "Spirit",
          textAfter: " .",
        },
      ],
      body: "Paul discovered the key to successful Christian living: surrender to God! He found that walking in the Spirit—living a life of being guided by the Holy Spirit moment by moment—allowed Him to no longer be a slave to his own selfishness and sinfulness! \n\nPaul offered the same counsel when writing to the Galatians, in Galatians 5:17, 18: “For the flesh lusts against the Spirit, and the Spirit against the flesh; and these are contrary to one another, so that you do not do the things that you wish. But if you are led by the Spirit, you are not under the law.” \n\nWe can be led by either the Spirit of God or by the flesh our natural desires and inclinations. It is when we choose to be led by the Spirit of God that God’s will is done in our lives.",
      choices: [
        "in",
        "word",
        "gospel",
        "saved",
        "light",
        "flesh",
        "Your's",
        "Spirit",
        "faith",
      ],
      lessonID: 9,
      question:
        "How did Paul describe the experience of a person who embraces a saving relationship with God?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "There is therefore now no condemnation to those who are in Christ Jesus, who do not walk according to the flesh, but according to the Spirit.",
          ref: "Romans 8:1",
        },
      ],
    },
    "9-6": {
      Supplements: {
        "-L7z6jQrU51X3YuyO_r3": {
          body: "Paul wrote in Galatians 2:20, “I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.”\n\nA paradox of the Christian faith is that in order to live eternally one must first die.  That death is the death to self, the death to one’s own will in order that Jesus may live and reign in the life.  Paul wrote in 1 Corinthians 15:31 that he died “daily.”\n\nJesus spoke to this subject when He said in Luke 9:23, “If anyone desires to come after Me, let him deny himself, and take up his cross daily, and follow Me.”  Simply put, when our hearts are given to Jesus, self dies, and we are “crucified with Christ.”  \n\nConsider carefully what Paul wrote in Ephesians 4:21-24.  “If indeed you have heard Him and have been taught by Him, as the truth is in Jesus: that you put off, concerning your former conduct, the old man which grows corrupt according to the deceitful lusts, and be renewed in the spirit of your mind, and that you put on the new man which was created according to God, in true righteousness and holiness.”\n\nThe “old man” Paul writes of is the person who did not know Jesus, and was not surrendered to the indwelling of the Holy Spirit.  The “new man” is the one who was “corrupt according to the deceitful lusts” but has experienced renewal through the power of God.\n\nWhen a person comes to faith in God, accepts Jesus as his or her personal Savior, is forgiven and cleansed and receives the Holy Spirit into the life - in other words, is converted - that person is “crucified with Christ.”  No longer living for self, he or she is living for Jesus Christ.",
          title: "What does it mean to be “Crucified with Christ”?",
        },
      },
      blanks: [
        {
          choices: [
            "bound",
            "love",
            "world",
            "love",
            "saved",
            "He",
            "word",
            "faith",
            "crucified",
            "Christ",
            "flesh",
            "faith",
          ],
          correctAnswer: "crucified",
          textAfter: " with Christ; it is no longer I who live, but",
          textBefore: "I have been",
        },
        {
          choices: [
            "bound",
            "love",
            "world",
            "love",
            "saved",
            "He",
            "word",
            "faith",
            "crucified",
            "Christ",
            "flesh",
            "faith",
          ],
          correctAnswer: "Christ",
          textAfter: " lives in me; and the life which I now live in the",
        },
        {
          choices: [
            "bound",
            "love",
            "world",
            "love",
            "saved",
            "He",
            "word",
            "faith",
            "crucified",
            "Christ",
            "flesh",
            "faith",
          ],
          correctAnswer: "flesh",
          textAfter: " I live by",
        },
        {
          choices: [
            "bound",
            "love",
            "world",
            "love",
            "saved",
            "He",
            "word",
            "faith",
            "crucified",
            "Christ",
            "flesh",
            "faith",
          ],
          correctAnswer: "faith",
          textAfter:
            " in the Son of God, who loved me and gave Himself for me.",
        },
      ],
      body: "Paul described the experience of surrendering to Jesus as being a “death.” When we come to Christ by faith, self dies, and we are made new through Jesus living His life in us.",
      choices: [
        "bound",
        "crucified",
        "world",
        "love",
        "faith",
        "He",
        "word",
        "faith",
        "love",
        "saved",
        "flesh",
        "Christ",
      ],
      lessonID: 9,
      question:
        "What metaphor did Paul use when describing this surrender to the presence of the Holy Spirit?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.",
          ref: "Galatians 2:20",
        },
      ],
    },
    "9-7": {
      Supplements: {
        "-L7z6_MIgPO2RyoV0DSA": {
          body: "Several times, the Bible refers to being “in Christ.”  For example…\n\nRomans 6:11.  “Likewise you also, reckon yourselves to be dead indeed to sin, but alive to God in Christ Jesus our Lord.”\n\nRomans 8:1.  “There is therefore now no condemnation to those who are in Christ Jesus, who do not walk according to the flesh, but according to the Spirit.”\n\n1 Corinthians 1:30.  “But of Him you are in Christ Jesus, who became for us wisdom from God—and righteousness and sanctification and redemption.”\n\n2 Corinthians 5:17.  “Therefore, if anyone is in Christ, he is a new creation; old things have passed away; behold, all things have become new.”\n\nPhilippians 3:9.  “And be found in Him, not having my own righteousness, which is from the law, but that which is through faith in Christ, the righteousness which is from God by faith.”\n\nEach of the above references was written by Paul.  It is interesting to notice that he occasionally defines “in Christ.”  In Romans 8:1, those who are “in Christ” “do not walk according to the flesh, but according to the Spirit.”  In 2 Corinthians 5:17, “in Christ” is equated with being “a new creation,” old things having “passed away” and all things having “become new.”  In Philippians 3:9, “in Christ” is said to be not having one’s own righteousness, but having “the righteousness which is from God by faith.”\n\nFurther insight is given by Jesus Himself, where He said in John 15, “Abide in Me, and I in you. As the branch cannot bear fruit of itself, unless it abides in the vine, neither can you, unless you abide in Me.”  “If you abide in Me, and My words abide in you, you will ask what you desire, and it shall be done for you” (John 15:4,7).\n\n“In Christ” is surrendered to Christ, yielded to Christ, filled with the Spirit of God and clothed with the righteousness of Christ.  A person who is “in Christ” is yielded to God’s leading, living a life connected with the life of Jesus, as Jesus lives His life through that person.\n\nGod desires every believer to be “in Christ.”  If you are not surrendered to Jesus, experiencing Jesus living His life in you, take a moment to pray and ask that God would give you a new heart, and connect you inseparably to Himself.\n",
          title: " What does it mean to be “in Christ”?",
        },
      },
      blanks: [
        {
          choices: ["sent", "heavens", "raised", "dead", "denied", "world"],
          correctAnswer: "raised",
          textAfter: " from the",
          textBefore:
            "Do you not know that as many of us as were baptized into Christ Jesus were baptized into His death? Therefore we were buried with Him through baptism into death, that just as Christ was",
        },
        {
          choices: ["sent", "heavens", "raised", "dead", "denied", "world"],
          correctAnswer: "dead",
          textAfter:
            " by the glory of the Father, even so we also should walk in newness of life.",
        },
      ],
      body: "When a person gives his or her life to Jesus, self dies and Jesus reigns in the heart of that individual. It is in baptism that this experience is symbolically demonstrated. Baptism is the burial—in a watery grave—of an old life of sin, followed by a resurrection from that burial to walk in “newness of life.” [Note: There is more on the subject of baptism in It Is Written Bible Study Guide #14, “Buried Alive?”]",
      choices: ["sent", "dead", "denied", "heavens", "raised", "world"],
      lessonID: 9,
      question: "When is this death to self especially demonstrated?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "3 Or do you not know that as many of us as were baptized into Christ Jesus were baptized into His death?\n\n4 Therefore we were buried with Him through baptism into death, that just as Christ was raised from the dead by the glory of the Father, even so we also should walk in newness of life.",
          ref: "Romans 6:3, 4",
        },
      ],
    },
    "9-8": {
      blanks: [
        {
          choices: ["tomorrow", "happy", "peacefully", "daily"],
          correctAnswer: "daily",
          textAfter: " .",
          textBefore:
            "I affirm, by the boasting in you which I have in Christ Jesus our Lord, I die",
        },
      ],
      body: "Paul understood that living a life of surrender to Jesus was not accomplished in a one-time experience. He recognized that he needed to die to self and allow Jesus to be the Lord of His life on a daily basis. It is a constant connection with God—rather than a one-time connection with Him—that transforms us into people ready for eternal life.",
      choices: ["tomorrow", "happy", "peacefully", "daily"],
      lessonID: 9,
      question:
        "How often should a person die to self and surrender to the indwelling presence of God?",
      questionID: 8,
      questionType: "radio",
      verses: [
        {
          body: "I affirm, by the boasting in you which I have in Christ Jesus our Lord, I die daily.",
          ref: "1 Corinthians 15:31",
        },
      ],
    },
    "9-9": {
      Supplements: {
        "-L7z7EFLwiTcuAsHkJ56": {
          body: 'When Jesus spoke to Nicodemus in John 3, he told Nicodemus that he needed to be “born again,” or “born from above” (John 3:3,7).  People who come to faith  in Christ are - spiritually speaking - babies, and need to grow “to the measure of the stature of the fullness of Christ” (Ephesians 4:13).\n\nJesus   compared spiritual growth to the growth of a plant in Mark 4:28.  “For the earth yields crops by itself: first the blade, then the head, after that the    full grain in the head.”\n\nIt is important to recognize that people grow as Christians.  No one comes to faith in God with every question answered or    every aspect of the spiritual life mastered.  Shortcomings in our spiritual experience should not necessarily be equated with failure as a Christian.      Jesus said in 1 John 2:1, “My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an Advocate with the      Father, Jesus Christ the righteous.”  Defeat in a given spiritual situation should drive a person to God, and not drive a person further away from God.       Hebrews 4:16 says, “Let us therefore come boldly to the throne of grace, that we may obtain mercy and find grace to help in time of need.”\n\nJust        as a plant grows, Christians grow also.  A plant needs good soil, water, light and food in order to thrive.  Additionally, many plants do not thrive         owing to their environment.\n\nPrayer, God’s word, and sharing one’s faith are essential to spiritual growth.  Prayer connects a person with the         mind of God and ensures good and regular communication with God.  The Bible gives insight into the character and purposes of God, and connects you          with the power of God.  Sharing your faith is vital to a healthy Christian experience.  Also, the growth of many Christians is retarded by proximity          to unhelpful influences.  A person’s living situation, relationships, job or other factors may impede spiritual growth.  \n\nGod wants you to grow           spiritually in preparation for eternity.  Be certain to spend time with God, to feed on His word, and to make Jesus the focus of your life.   As 2 Peter 1:10 says, “Therefore, brethren, be even more diligent to make your call and election sure, for if you do these things you will never stumble." ',
          title: " What is spiritual growth? ",
        },
      },
      blanks: [
        {
          choices: ["blade", "head", "wheat", "grain", "grass", "seeds"],
          correctAnswer: "blade",
          textAfter: " , then the",
          textBefore: "The earth yields crops by itself: first the",
        },
        {
          choices: ["blade", "head", "wheat", "grain", "grass", "seeds"],
          correctAnswer: "head",
          textAfter: " ,  after that the full grain in the head.",
        },
      ],
      body: "Growing in Christ is a process—the work of a lifetime. God in His mercy accepts us when we come to Him in faith, and He gives us the gift of His righteousness. As we remain surrendered to Him, our relationship with Him deepens, and growing in grace, we become more like Him.",
      choices: ["grass", "head", "wheat", "grain", "blade", "seeds"],
      lessonID: 9,
      question: "How does a person learn to live a life of surrender to God?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "For the earth yields crops by itself: first the blade, then the head, after that the full grain in the head.",
          ref: "Mark 4:28",
        },
      ],
    },
  },
  {
    "10-0": {
      body: "In 1981, not long  before he died, writer William Saroyan was quoted by the Associated Press as having said, “Everybody has got to die, but I have always believed an exception would be made in my case. Now what?” That’s a question every person alive must eventually face. What happens when a person dies? Does the Bible tell us? And how is the subject important in the overall picture of Bible truth? In order to understand how human beings end, we must first examine how human beings were originally made.",
      lessonID: 10,
      questionID: 0,
      type: "text",
    },
    "10-1": {
      Supplements: {
        "-L7z7ueRVBsO9ZJCXLTL": {
          body: "Adam was the first human created.  He was created on the sixth day of creation, as recorded in Genesis 1:26,27.  “Then God said, “Let Us make man in Our image, according to Our likeness; let them have dominion over the fish of the sea, over the birds of the air, and over the cattle, over all the earth and over every creeping thing that creeps on the earth. So God created man in His own image; in the image of God He created him; male and female He created them.”  \n\nAdam was created in the “image of God,” meaning he was to bear God’s image both in resemblance and in character.  The Bible says he was made “a living soul” (Genesis 2:7), meaning a “living being.”  Endowed with free will, Adam was created by God to grow to his God-given potential and to glorify God in all things.",
          title: "Who was Adam?",
        },
        "-L7z8-ZH4v7lhoj3aaiz": {
          body: "Eve, Adam’s wife was the first woman ever created.  Along with Adam, she was created on the sixth day of creation week, according to Genesis 2:21-23.  “And the Lord God caused a deep sleep to fall on Adam, and he slept; and He took one of his ribs, and closed up the flesh in its place. Then the rib which the Lord God had taken from man He made into a woman, and He brought her to the man. And Adam said: “This is now bone of my bones and flesh of my flesh;\nShe shall be called Woman, because she was taken out of Man.”",
          title: " Who was Eve?",
        },
      },
      blanks: [
        {
          choices: ["end", "die", "live", "fly"],
          correctAnswer: "die",
          textAfter: " .",
          textBefore:
            "Of the tree of the knowledge of good and evil you shall not eat, for in the day that you eat of it you shall surely",
        },
      ],
      body: "God was clear. Disobedience would result in death. As Adam and Eve surrendered their loyalty to God, separation from God would occur (see Isaiah 59:2), and death would be the inevitable result.",
      choices: ["end", "die", "live", "fly"],
      lessonID: 10,
      question: "What warning did God give Adam and Eve about death?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "But of the tree of the knowledge of good and evil you shall not eat, for in the day that you eat of it you shall surely die.",
          ref: "Genesis 2:17",
        },
      ],
    },
    "10-10": {
      blanks: [
        {
          choices: ["live", "die", "sleep", "party"],
          correctAnswer: "die",
          textAfter: " .",
          textBefore: "The soul who sins shall",
        },
      ],
      body: "The Bible is consistent. Nowhere does the Bible say human beings possess an immortal soul. In fact, Romans 2:7 says that people “seek for” immortality. One would not need to seek for something one already possesses. And 1 Timothy 6:15-16 says that God “alone has immortality.”",
      choices: ["live", "die", "sleep", "party"],
      lessonID: 10,
      question: "Do people possess an immortal soul?",
      questionID: 10,
      questionType: "radio",
      verses: [
        {
          body: "“Behold, all souls are Mine; the soul of the father as well as the soul of the son is Mine; the soul who sins shall die.",
          ref: "Ezekiel 18:4",
        },
      ],
    },
    "10-11": {
      blanks: [
        {
          choices: [
            "gathering",
            "horn",
            "made",
            "fire",
            "angels",
            "shown",
            "trumpet",
            "trumpet",
            "raised",
          ],
          correctAnswer: "trumpet",
          textAfter: " . For the trumpet will",
          textBefore:
            "Behold, I tell you a mystery: We shall not all sleep, but we shall all be changed—in a moment, in the twinkling of an eye, at the last",
        },
        {
          choices: [
            "gathering",
            "horn",
            "made",
            "fire",
            "angels",
            "shown",
            "trumpet",
            "trumpet",
            "raised",
          ],
          correctAnswer: "sound",
          textAfter: " , and the dead will be",
        },
        {
          choices: [
            "gathering",
            "horn",
            "made",
            "fire",
            "angels",
            "shown",
            "trumpet",
            "trumpet",
            "raised",
          ],
          correctAnswer: "raised",
          textAfter: " incorruptible, and we shall be changed.",
        },
      ],
      body: "Paul was very clear that the dead sleep until the resurrection, when the trumpet sounds. This has not yet taken place. Therefore, the dead have not yet ascended to heaven.",
      choices: [
        "gather",
        "horn",
        "raised",
        "fire",
        "angels",
        "day",
        "trumpet",
        "made",
        "sound",
      ],
      lessonID: 10,
      question: "When do the righteous dead go to heaven?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "51 Behold, I tell you a mystery: We shall not all sleep, but we shall all be changed—\n\n52 in a moment, in the twinkling of an eye, at the last trumpet. For the trumpet will sound, and the dead will be raised incorruptible, and we shall be changed.",
          ref: "1 Corinthians 15:51, 52",
        },
      ],
    },
    "10-12": {
      blanks: [
        {
          choices: ["trumpet", "rise", "sound", "be", "voice", "made"],
          correctAnswer: "trumpet",
          textAfter: " of God. And the dead in Christ will",
          textBefore:
            "The Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the",
        },
        {
          choices: ["trumpet", "rise", "sound", "be", "voice", "made"],
          correctAnswer: "rise",
          textAfter: " first.",
        },
      ],
      body: "The trumpet sounds and the resurrection of the saved takes place on the day that Jesus returns to this world.",
      choices: ["voice", "rise", "sound", "be", "trumpet", "made"],
      lessonID: 10,
      question:
        "When will the trumpet sound—signaling the resurrection of the saints?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "For the Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will rise first.",
          ref: "1 Thessalonians 4:16",
        },
      ],
    },
    "10-13": {
      blanks: [
        {
          choices: [
            "be well",
            "speak",
            "final",
            "rise again",
            "rise",
            "last",
            "laugh again",
            "breathe",
            "end",
          ],
          correctAnswer: "rise",
          textAfter: " ",
          textBefore: "Jesus said to her, “Your brother will",
        },
        {
          choices: [
            "be well",
            "speak",
            "final",
            "rise again",
            "rise",
            "last",
            "laugh again",
            "breathe",
            "end",
          ],
          correctAnswer: "again",
          textAfter:
            " .” Martha said to Him, “I know that he will rise again in the ",
        },
        {
          choices: [
            "be well",
            "speak",
            "final",
            "rise again",
            "rise",
            "last",
            "laugh again",
            "breathe",
            "end",
          ],
          correctAnswer: "resurrection",
          textAfter: " at the",
        },
        {
          choices: [
            "be well",
            "speak",
            "final",
            "rise again",
            "rise",
            "last",
            "laugh again",
            "breathe",
            "end",
          ],
          correctAnswer: "last",
          textAfter: " day.”",
        },
      ],
      body: "Martha perfectly understood the sleep of death. She was under no illusion that her brother, Lazarus, had gone to heaven when he died. The Old Testament expresses the thought in exactly the same way. In 1 Kings 2:10, we read that when David died, he “rested [slept] with his fathers.” And 1 Kings 11:43 says, “Solomon rested [slept] with his fathers.” The thought expressed throughout the Bible is that the dead sleep until the resurrection.",
      choices: [
        "again",
        "speak",
        "final",
        "ascend",
        "rise",
        "laugh",
        "last",
        "resurrection",
        "end",
      ],
      lessonID: 10,
      question:
        "In Bible times, did people understand that the dead would sleep until the resurrection?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "23 Jesus said to her, “Your brother will rise again.”\n\n24 Martha said to Him, “I know that he will rise again in the resurrection at the last day.”",
          ref: "John 11:23, 24",
        },
      ],
    },
    "10-14": {
      blanks: [
        {
          choices: [
            "sinners",
            "believers",
            "Jesus",
            "Satan",
            "life",
            "condemnation",
          ],
          correctAnswer: "life",
          textAfter: " , and those who have done evil, to the resurrection of",
          textBefore:
            "The hour is coming in which all who are in the graves will hear His voice and come forth—those who have done good, to the resurrection of",
        },
        {
          choices: [
            "sinners",
            "believers",
            "Jesus",
            "Satan",
            "life",
            "condemnation",
          ],
          correctAnswer: "condemnation",
          textAfter: " .",
        },
      ],
      body: "When Jesus returns, “the dead in Christ will rise first” (1 Thessalonians 4:16). The resurrection of damnation takes place at another time. [Note: This will be discussed in It Is Written Bible Study Guide #12, “Hellfire: Would God Really Do That?”]",
      choices: [
        "sinners",
        "life",
        "Jesus",
        "Satan",
        "believers",
        "condemnation",
      ],
      lessonID: 10,
      question: "How many resurrections will there be?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "28 Do not marvel at this; for the hour is coming in which all who are in the graves will hear His voice\n\n29 and come forth—those who have done good, to the resurrection of life, and those who have done evil, to the resurrection of condemnation.",
          ref: "John 5:28, 29",
        },
      ],
    },
    "10-15": {
      Supplements: {
        "-L7z9jGU0HW-BagGrdgI": {
          body: "The Bible says that “the living know that they will die, but the dead know nothing.”  If by “ghost” we mean some part of a person who has returned from the dead, possibly to communicate with the living, then we recognize the Bible does not support such an idea.\n\nAs the Bible states that people who die sleep until the resurrection, there are no spirits or souls existing independent of a human body.  As Genesis 2:7 says, “man became a living soul.”  Human beings were not given a soul.  Rather, the combination of body and breath which together make up a living person is itself a “living soul.”  When a person dies, the life-giving breath goes back to God and the person in question simply sleeps until Jesus returns.\n\nTherefore, there are no ghosts in terms of the spirits of the departed returning to communicate with or live among those alive on Earth.\n\nHowever, it is very possible Satan can deceive those who are vulnerable to deception.  It may be that some “ghosts” are an invention of the devil.  Spiritualism is one of Satan’s greatest deception, and it is clear Satan has been successful in passing this off to the human family.",
          title: "What does the Bible say about ghosts?",
        },
      },
      blanks: [
        {
          choices: ["house", "field", "family"],
          correctAnswer: "house",
          textAfter: " , nor shall his place know him anymore.",
          textBefore:
            "As the cloud disappears and vanishes away, so he who goes down to the grave does not come up. He shall never return to his",
        },
      ],
      body: "The teachings of spiritualism are prevalent today in popular culture. Psychics who claim to communicate with the dead, and movies and books about vampires and sorcery have become part of the fabric of society. They all propagate Satan’s original lie when he told Adam and Eve, “You will not surely die” (Genesis 3:4). Ghosts are widely believed in, when the truth is that the dead are resting in the grave—not haunting houses!",
      choices: ["church", "house", "field", "job", "family"],
      lessonID: 10,
      question:
        "What popular deception is countered by the truth of the sleep in death?",
      questionID: 15,
      questionType: "radio",
      verses: [
        {
          body: "9 As the cloud disappears and vanishes away, so he who goes down to the grave does not come up.\n\n10 He shall never return to his house, nor shall his place know him anymore.",
          ref: "Job 7:9, 10",
        },
      ],
    },
    "10-16": {
      blanks: [
        {
          choices: ["angels", "death", "demons"],
          correctAnswer: "demons",
          textAfter: " , performing signs.",
          textBefore: "They are spirits of",
        },
      ],
      body: "According to the Bible, spiritualism is going to be a major force in earth’s final days. Only those who understand the true state of a person in death will not be deceived by Satan’s major end-time delusion.",
      choices: ["angels", "people", "death", "demons"],
      correctAnswer: "true",
      lessonID: 10,
      question:
        "How widespread will the teachings of spiritualism be in earth’s final days?",
      questionID: 16,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "Spiritualism will be rampant everywhere at the end of time?",
      verses: [
        {
          body: "For they are spirits of demons, performing signs, which go out to the kings of the earth and of the whole world, to gather them to the battle of that great day of God Almighty.",
          ref: "Revelation 16:14",
        },
      ],
    },
    "10-17": {
      blanks: [
        {
          choices: ["way", "truth", "resurrection", "life", "light", "way"],
          correctAnswer: "resurrection",
          textAfter: " and the",
          textBefore: "Jesus said . . . “I am the",
        },
        {
          choices: ["way", "truth", "resurrection", "life", "light", "way"],
          correctAnswer: "life",
          textAfter: " .”",
        },
      ],
      body: "If a person died and went straight to heaven, there would be no need for a resurrection to take place. However, because we die and go to the grave, we need Someone to wake us up from our sleep, clothe us with new bodies and take us to heaven. \n\nOnly one Person can do that—Jesus, the Resurrection and the Life. Through Jesus, we can live again. He is the Bread of Life, and anyone who eats of this Bread “will live forever” (John 6:51). Our hope in death is in Jesus—the Resurrection and the Life—through Whom we can live again.",
      choices: ["way", "truth", "way", "life", "light", "resurrection"],
      lessonID: 10,
      question:
        "What is the great Bible truth demonstrated in the sleep of death?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: 'Jesus said to her, “I am the resurrection and the life. He who believes in Me, though he may die, he shall live."',
          ref: "John 11:25",
        },
      ],
    },
    "10-18": {
      correctAnswer: "true",
      question:
        "Are you willing to put your faith in Jesus - the Resurrection and the Life - and trust Him to be your Lord and Savior?",
      questionID: 18,
      questionType: "truthConfirmation",
    },
    "10-2": {
      blanks: [
        {
          choices: ["possibly", "die", "not"],
          correctAnswer: "not",
          textAfter: ' surely die."',
          textBefore: 'The serpent said to the woman, "you will',
        },
      ],
      body: "Satan directly contradicted the plain statement of God. This is the first lie recorded in the Bible. Tragically, Adam and Eve believed the lie and ate the forbidden fruit. Their disobedience brought death into the world.",
      choices: ["possibly", "die", "not"],
      lessonID: 10,
      question: "How did Satan counter what God told Adam and Eve?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: 'Then the serpent said to the woman, “You will not surely die."',
          ref: "Genesis 3:4",
        },
      ],
    },
    "10-3": {
      blanks: [
        {
          choices: ["living", "being", "breathing being", "true being"],
          correctAnswer: "living",
          textAfter: " ",
          textBefore:
            "The Lord God formed man of the dust of the ground, and breathed into his nostrils the breath of life; and man became a",
        },
        {
          choices: [
            "living being",
            "human being",
            "breathing being",
            "true being",
          ],
          correctAnswer: "being",
          textAfter: " .",
        },
      ],
      body: "It is important to recognize that when Adam was created, he was not given a soul. The Bible teaches that Adam was a soul. The King James Version of the Bible refers to the combination of body and breath as a “living soul.” \n\nAs you read this It Is Written Bible Study Guide, you can know that—in God’s eyes—you are a “soul.” \n\nThe Bible does not teach that human beings have a soul that returns to God at death. \n\nRemember this equation: The dust of the ground + the breath of life = a living soul. \n\nPsalm 146:4 puts it this way: “His spirit departs, he returns to his earth; in that very day his plans [or thoughts] perish.” \n\nAt death, the dust human beings were made from returns to the earth, and the breath God breathed into us to give us life leaves our bodies.",
      choices: ["being", "human", "breathing", "living"],
      lessonID: 10,
      question: "How were Adam and Eve created?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the Lord God formed man of the dust of the ground, and breathed into his nostrils the breath of life; and man became a living being.",
          ref: "Genesis 2:7",
        },
      ],
    },
    "10-4": {
      Supplements: {
        "-L7z8uQFGcWvupCr542m": {
          body: "Genesis 2:7 (KJV) says, “And the Lord God formed man of the dust of the ground, and breathed into his nostrils the breath of life; and man became a living soul.”  The NKJV renders the last part of that verse, “and man became a living being,” as do numerous other translations including the NASB and the RSV.\n\nThe word translated “soul” in Genesis 2:7 (KJV) is the Hebrew word “nephesh,” which is translated in the Bible in a variety of ways, including “breath”, “life” and “living being.”\n\nThe word “soul” often refers to a living human being.  Ezekiel 18:4 says, “The soul who sins shall die.”  The King James version of Revelation 16:3 (KJV) states, “and every living soul died in the sea,” while other translations refer to “every living creature” or every living thing.”  Again, a “soul” is shown to represent a living being.\n\nConfusion often arises owing to the belief that suggests a “soul” is something living or conscious that survives bodily death.  The Bible does not teach that human beings have a soul that survives bodily death. Rightly understood, a human being is a soul, and does not have a soul.",
          title: " What does the Bible say about the “soul”?",
        },
      },
      blanks: [
        {
          choices: ["dirt", "fly", "ground", "go", "earth", "return"],
          correctAnswer: "earth",
          textAfter: " as it was, and the spirit will",
          textBefore: "The dust will return to the",
        },
        {
          choices: ["dirt", "fly", "ground", "go", "earth", "return"],
          correctAnswer: "return",
          textAfter: " to God who gave it.",
        },
      ],
      body: "Job describes this “spirit” as being “breath” when he says in Job 27:3 (KJV), “All the while my breath is in me, and the spirit of God is in my nostrils.” \n\nThe “spirit” that returns to God at death and the “breath” that returns to God are one and the same thing. \n\nRather than being something living or conscious, the breath of life is simply the life force that keeps a person alive. When we stop breathing, we soon die. The Bible says that when we die, our “breath” returns to God.",
      choices: ["dirt", "return", "ground", "go", "earth", "fly"],
      lessonID: 10,
      question:
        'If human beings don\'t have a soul that goes back to God at death, perhaps our "spirit" returns to God when we die?',
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then the dust will return to the earth as it was, and the spirit will return to God who gave it.",
          ref: "Ecclesiastes 12:7",
        },
      ],
    },
    "10-5": {
      blanks: [
        {
          choices: ["not", "God", "nothing", "peace"],
          correctAnswer: "nothing",
          textAfter: " .",
          textBefore: "The living know that they will die; but the dead know",
        },
      ],
      body: "People are unconscious in death. Their minds are inactive. Ecclesiastes 9:6 says, “Also their love, their hatred, and their envy have now perished.”",
      choices: ["not", "God", "nothing", "peace"],
      lessonID: 10,
      question: "Are people conscious in death?",
      questionID: 5,
      questionType: "radio",
      verses: [
        {
          body: "For the living know that they will die; but the dead know nothing, and they have no more reward, for the memory of them is forgotten.",
          ref: "Ecclesiastes 9:5",
        },
      ],
    },
    "10-6": {
      blanks: [
        {
          choices: ["praise", "silence", "see", "death", "love", "themselves"],
          correctAnswer: "praise",
          textAfter: " the Lord, nor any who go down into",
          textBefore: "The dead do not",
        },
        {
          choices: ["praise", "silence", "see", "death", "love", "themselves"],
          correctAnswer: "silence",
          textAfter: " .",
        },
      ],
      body: "Just as the dead “know nothing,” the dead do not praise the Lord. The Bible describes their state as “silence.”",
      choices: ["love", "silence", "see", "death", "praise", "themselves"],
      lessonID: 10,
      question: "Do dead people praise the Lord immediately after they die?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "The dead do not praise the Lord, nor any who go down into silence.",
          ref: "Psalm 115:17",
        },
      ],
    },
    "10-7": {
      Supplements: {
        "-L7z9FjgeupzXv_oaX35": {
          body: "The Bible speaks of two resurrections.  John 5:28, 29 says, “Marvel not at this: for the hour is coming, in the which all that are in the graves shall hear his voice, and shall come forth; they that have done good, unto the resurrection of life; and they that have done evil, unto the resurrection of damnation.”  \n\nThe first resurrection is the “resurrection of life” which happens when Jesus returns.  The second, the “resurrection of damnation” takes place later (see It Is Written Bible Study Guide #11, Revelation’s 1000 Years.”)  When Jesus returns, the sleeping saints will be raised from the dead and will be crowned with immortality.  \n\nThis is what Paul referred to in 1 Corinthians 15:51-54, when he wrote, “Behold, I tell you a mystery: We shall not all sleep, but we shall all be changed—in a moment, in the twinkling of an eye, at the last trumpet. For the trumpet will sound, and the dead will be raised incorruptible, and we shall be changed.  For this corruptible must put on incorruption, and this mortal must put on immortality.  So when this corruptible has put on incorruption, and this mortal has put on immortality, then shall be brought to pass the saying that is written: “Death is swallowed up in victory.”",
          title: "What is the resurrection?",
        },
      },
      blanks: [
        {
          choices: [
            "sleeps",
            "wake",
            "dead",
            "died",
            "raise",
            "alive",
            "sinned",
            "lift",
            "dead",
          ],
          correctAnswer: "sleeps",
          textAfter: " , but I go that I may",
          textBefore: 'He said to them, "Our friend Lazarus',
        },
        {
          choices: [
            "sleeps",
            "wake",
            "dead",
            "died",
            "raise",
            "alive",
            "sinned",
            "lift",
            "dead",
          ],
          correctAnswer: "wake",
          textAfter: ' him up."...Then Jesus said to them plainly, "Lazarus is',
        },
        {
          choices: [
            "sleeps",
            "wake",
            "dead",
            "died",
            "raise",
            "alive",
            "sinned",
            "lift",
            "dead",
          ],
          correctAnswer: "dead",
          textAfter: ' ."',
        },
      ],
      body: "Jesus described death as a “sleep.” Rather than going immediately into the presence of God at death, the dead sleep a dreamless sleep in anticipation of a future resurrection. In fact, there are dozens of locations in the Bible where death is referred to as sleep.",
      choices: [
        "wake",
        "alive",
        "died",
        "praise",
        "sleeps",
        "sinned",
        "lift",
        "dead",
      ],
      lessonID: 10,
      question: "How did Jesus describe death?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "11 These things He said, and after that He said to them, “Our friend Lazarus sleeps, but I go that I may wake him up.”\n\n14 Then Jesus said to them plainly, “Lazarus is dead.",
          ref: "John 11:11, 14",
        },
      ],
    },
    "10-8": {
      blanks: [
        {
          choices: ["come out", "wake up", "come forth", "rise up"],
          correctAnswer: "come",
          textAfter: " ",
          textBefore: 'He cried with a loud voice, "Lazarus,',
        },
        {
          choices: ["come out", "wake up", "come forth", "rise up"],
          correctAnswer: "forth",
          textAfter: ' !"',
        },
      ],
      body: "Lazarus had been dead for four days, yet Jesus did not call him down from heaven, for the simple reason that Lazarus did not go to heaven when he died. Instead, he went into the grave. Jesus called Lazarus forth from the place where he had been buried.",
      choices: ["out", "wake", "come", "up", "forth"],
      lessonID: 10,
      question:
        "What did Jesus say to Lazarus after Lazarus had been dead for four days?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "Now when He had said these things, He cried with a loud voice, “Lazarus, come forth!”",
          ref: "John 11:43",
        },
      ],
    },
    "10-9": {
      Supplements: {
        "-L7zA5tzt-QrJDu9-2Ai": {
          body: "See It Is Written Study Guide #12, Hell Fire, Would God Really do That?\n",
          title: "What about the rich man and Lazarus?",
        },
      },
      blanks: [
        {
          choices: ["not", "heavens", "just", "sky", "not", "deep"],
          correctAnswer: "not",
          textAfter: " ascend into the",
          textBefore:
            "Men and brethren, let me speak freely to you of the patriarch David, that he is both dead and buried, and his tomb is with us to this day . . . For David did",
        },
        {
          choices: ["not", "heavens", "just", "sky", "not", "deep"],
          correctAnswer: "heavens",
          textAfter: " .",
        },
      ],
      body: "Although we expect to see King David in heaven one day, God made very clear through Peter that approximately 1,000 years after his death, David was not in heaven. Peter made a very plain statement when he said, “David did not ascend into the heavens.” Where was David? David was still in his tomb, sleeping the sleep of death.",
      choices: ["sky", "heavens", "just", "not", "throne", "deep"],
      lessonID: 10,
      question: "Do saved people go straight to heaven when they die?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "29 Men and brethren, let me speak freely to you of the patriarch David, that he is both dead and buried, and his tomb is with us to this day.\n\n34 For David did not ascend into the heavens, but he says himself: The Lord said to my Lord,\n'Sit at My right hand.'",
          ref: "Acts 2:29, 34",
        },
      ],
    },
  },
  {
    "11-0": {
      body: "Unemployment is no trivial matter. During the first decade of the 21st century, the global economy contracted, and jobs became much more difficult to find. It isn’t usually good news to find out that someone is out of work. But what if you found out Satan was out of a job? What if something happened that was so epic that Satan found himself unemployed—for 1,000 years?",
      lessonID: 11,
      questionID: 0,
      type: "text",
    },
    "11-1": {
      blanks: [
        {
          choices: ["fool", "pain", "liar", "cheat"],
          correctAnswer: "liar",
          textAfter: " and the father of it.",
          textBefore: "He is a",
        },
      ],
      body: "At his core, Satan is a liar. He told the Bible’s original lie when he told Eve that she would not die (Genesis 3:4), and he continues to lie to the human family—especially as he misrepresents the character of God.",
      choices: ["fool", "pain", "liar", "cheat"],
      lessonID: 11,
      question: "How did Jesus describe Satan?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "You are of your father the devil, and the desires of your father you want to do. He was a murderer from the beginning, and does not stand in the truth, because there is no truth in him. When he speaks a lie, he speaks from his own resources, for he is a liar and the father of it.",
          ref: "John 8:44",
        },
      ],
    },
    "11-10": {
      blanks: [
        {
          choices: [
            "wanted",
            "missed",
            "remembered",
            "lamented",
            "gathered",
            "buried",
            "here",
            "there",
            "anywhere",
          ],
          correctAnswer: "lamented",
          textAfter: " , or",
          textBefore:
            "At that day the slain of the Lord shall be from one end of the earth even to the other end of the earth. They shall not be",
        },
        {
          choices: [
            "wanted",
            "missed",
            "remembered",
            "lamented",
            "gathered",
            "buried",
            "here",
            "there",
            "anywhere",
          ],
          correctAnswer: "gathered",
          textAfter: " , or",
        },
        {
          choices: [
            "wanted",
            "missed",
            "remembered",
            "lamented",
            "gathered",
            "buried",
            "here",
            "there",
            "anywhere",
          ],
          correctAnswer: "buried",
          textAfter: " ; they shall become refuse on the ground.",
        },
      ],
      body: "The destruction on planet Earth will be complete. Nobody will mourn over the dead, and there will be no funeral services held. The dead will simply decay on the surface of the earth. The world with all its billions of people will be completely depopulated. There will not be one human alive on earth after the Second Coming.",
      choices: [
        "wanted",
        "gathered",
        "missed",
        "remembered",
        "buried",
        "here",
        "lamented",
        "there",
        "anywhere",
      ],
      lessonID: 11,
      question:
        "How does the Bible describe the effect of the Second Coming on lost people?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "And at that day the slain of the Lord shall be from one end of the earth even to the other end of the earth. They shall not be lamented, or gathered, or buried; they shall become refuse on the ground.",
          ref: "Jeremiah 25:33",
        },
      ],
    },
    "11-11": {
      blanks: [
        {
          choices: ["form", "man", "cause", "life", "hope", "animals"],
          correctAnswer: "form",
          textAfter:
            " , and void; and the heavens, they had no light . . . I beheld, and indeed there was no",
          textBefore: "I beheld the earth, and indeed it was without",
        },
        {
          choices: ["form", "man", "cause", "life", "hope", "animals"],
          correctAnswer: "man",
          textAfter: " , and all the birds of the heavens had fled.",
        },
      ],
      body: "This world will be desolate during the millennium. It will not be a place of peace or prosperity. The earth will be “empty” (Isaiah 24:1). Jesus said it will be destroyed just like Sodom and Gomorrah were destroyed (Luke 17:28–30). Far from being a place of glory, this planet will be like it was prior to creation—“without form and void”. Earth will become a wasteland.",
      choices: ["cause", "man", "life", "hope", "form", "animals"],
      lessonID: 11,
      question:
        "What will be the condition of planet Earth during the 1,000 years?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "23 I beheld the earth, and indeed it was without form, and void; and the heavens, they had no light.\n\n25 I beheld, and indeed there was no man, and all the birds of the heavens had fled.",
          ref: "Jeremiah 4:23, 25",
        },
      ],
    },
    "11-12": {
      blanks: [
        {
          choices: [
            "stools",
            "food",
            "trees",
            "heaven",
            "thrones",
            "judgement",
          ],
          correctAnswer: "thrones",
          textAfter: " , and they sat on them, and",
          textBefore: "I saw",
        },
        {
          choices: [
            "stools",
            "food",
            "trees",
            "heaven",
            "thrones",
            "judgement",
          ],
          correctAnswer: "judgement",
          textAfter: " was committed to them.",
        },
      ],
      body: "The redeemed will be involved in the judgment of the wicked (1 Corinthians 6:2, 3). God will open up the record books of heaven and reveal to His people why the wicked have been judged as He has judged them. During this time, many questions will be answered. It will be understood why certain people were saved or lost, and God will reveal how much was done to save humanity. During the millennium, God is not only just, but is seen to be just.",
      choices: ["stools", "judgement", "food", "trees", "heaven", "thrones"],
      lessonID: 11,
      question:
        "What will the righteous be doing in heaven during the millennium?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I saw thrones, and they sat on them, and judgment was committed to them. Then I saw the souls of those who had been beheaded for their witness to Jesus and for the word of God, who had not worshiped the beast or his image, and had not received his mark on their foreheads or on their hands. And they lived and reigned with Christ for a thousand years.",
          ref: "Revelation 20:4",
        },
      ],
    },
    "11-13": {
      blanks: [
        {
          choices: ["sent", "released", "thrown", "kept"],
          correctAnswer: "released",
          textAfter: " from his prison.",
          textBefore: "Now when the thousand years have expired, Satan will be",
        },
      ],
      body: "Satan has been “bound” during the millennium—not with a literal chain but with chains of circumstance. He has been exiled on a desolate earth with nothing to do but reflect on the misery he has caused throughout human history. With the righteous in heaven and the unrighteous destroyed, Satan is left on the earth with his legions of evil angels.",
      choices: ["sent", "released", "thrown", "kept"],
      lessonID: 11,
      question: "What has Satan been doing during the millennium?",
      questionID: 13,
      questionType: "radio",
      verses: [
        {
          body: "Now when the thousand years have expired, Satan will be released from his prison",
          ref: "Revelation 20:7",
        },
      ],
    },
    "11-14": {
      blanks: [
        {
          choices: ["be still", "ever wake", "live again"],
          correctAnswer: "live",
          textAfter: " ",
          textBefore: "The rest of the dead did not",
        },
        {
          choices: ["be still", "ever wake", "live again"],
          correctAnswer: "again",
          textAfter: " until the thousand years were finished.",
        },
      ],
      body: "At the end of the 1,000 years, every lost person who ever lived is raised from the dead. This event results in the devil being “released from his prison” (Revelation 20:7), in that he again has people to tempt. As the millennium ends, Satan is back in business.",
      choices: ["still", "live", "be", "wake", "again", "ever"],
      lessonID: 11,
      question:
        "What remarkable event takes place at the end of the 1,000 years?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "But the rest of the dead did not live again until the thousand years were finished. This is the first resurrection.",
          ref: "Revelation 20:5",
        },
      ],
    },
    "11-15": {
      blanks: [
        {
          choices: ["down", "heaven", "forth", "clouds", "through", "glory"],
          correctAnswer: "down",
          textAfter: " out of",
          textBefore: "I, John, saw the holy city, New Jerusalem, coming",
        },
        {
          choices: ["down", "heaven", "forth", "clouds", "through", "glory"],
          correctAnswer: "heaven",
          textAfter: " from God, prepared as a bride adorned for her husband.",
        },
      ],
      body: "At the end of the 1,000 years, the Holy City descends from heaven—inhabited by God’s people, settling on a plain formed on the site of the Mount of Olives (Zechariah 14:4). The Holy City is so majestic that it is described as looking like a “bride adorned for her husband” (Revelation 21:2). The city has walls made from jasper and streets made of gold. There are 12 gates made from solid pearls, and the foundations are made from a variety of precious stones. (Revelation 21:18–20)",
      choices: ["forth", "heaven", "clouds", "through", "down", "glory"],
      lessonID: 11,
      question: "What other event marks the end of Revelation’s 1,000 years?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then I, John, saw the holy city, New Jerusalem, coming down out of heaven from God, prepared as a bride adorned for her husband.",
          ref: "Revelation 21:2",
        },
      ],
    },
    "11-16": {
      blanks: [
        {
          choices: ["antagonize", "fight", "all", "see", "deceive", "battle"],
          correctAnswer: "deceive",
          textAfter:
            " the nations which are in the four corners of the earth, Gog and Magog, to gather them together to",
          textBefore:
            "When the thousand years have expired, Satan will be released from his prison and will go out to",
        },
        {
          choices: ["antagonize", "fight", "all", "see", "deceive", "battle"],
          correctAnswer: "battle",
          textAfter: " , whose number is as the sand of the sea.",
        },
      ],
      body: "A thousand years languishing on a desolate earth—desolate because of his own sin—has not caused Satan to change his attitude toward God. Still in rebellion against God, he deceives the wicked into joining him in a final battle against God. The lost of all ages unite with the devil in a futile attempt to gain control of the New Jerusalem.",
      choices: ["antagonize", "battle", "fight", "all", "deceive", "see"],
      lessonID: 11,
      question:
        "What will Satan influence the wicked to do when they are raised from the dead?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "7 Now when the thousand years have expired, Satan will be released from his prison\n\n8 and will go out to deceive the nations which are in the four corners of the earth, Gog and Magog, to gather them together to battle, whose number is as the sand of the sea.",
          ref: "Revelation 20:7,8",
        },
      ],
    },
    "11-17": {
      blanks: [
        {
          choices: [
            "fire",
            "devoured",
            "angels",
            "smote",
            "lightning",
            "cooked",
          ],
          correctAnswer: "fire",
          textAfter: " came down from God out of heaven and",
          textBefore:
            "They went up on the breadth of the earth and surrounded the camp of the saints and the beloved city. And",
        },
        {
          choices: [
            "fire",
            "devoured",
            "angels",
            "smote",
            "lightning",
            "cooked",
          ],
          correctAnswer: "devoured",
          textAfter: " them.",
        },
      ],
      body: "The Bible refers to this event as the “second death” (Revelation 20:14). [Learn more about this in It Is Written Bible Study Guide #12, “Hellfire: Would God Really Do That?”]",
      choices: ["angels", "devoured", "smote", "lightning", "fire", "cooked"],
      lessonID: 11,
      question: "How does God end this attempted overthrow of the holy city?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "They went up on the breadth of the earth and surrounded the camp of the saints and the beloved city. And fire came down from God out of heaven and devoured them.",
          ref: "Revelation 20:9",
        },
      ],
    },
    "11-18": {
      blanks: [
        {
          choices: ["hell", "planet", "earth", "sun"],
          correctAnswer: "earth",
          textAfter:
            " , for the first heaven and the first earth had passed away. Also there was no more sea.",
          textBefore: "I saw a new heaven and a new",
        },
      ],
      body: "God’s plan is to re­create the earth, making it at least as beautiful as it was when Adam and Eve lived in the Garden of Eden. Sin and sinners will be gone forever. God’s people will now live in a perfect world—in the presence of God! There will be no sickness, sadness, tears, pain, or death (Isaiah 33:24; Revelation 21:4).",
      choices: ["hell", "planet", "earth", "sun"],
      lessonID: 11,
      question: "What does God do once this final rebellion has been put down?",
      questionID: 18,
      questionType: "radio",
      verses: [
        {
          body: "Now I saw a new heaven and a new earth, for the first heaven and the first earth had passed away. Also there was no more sea.",
          ref: "Revelation 21:1",
        },
      ],
    },
    "11-19": {
      blanks: [
        {
          choices: [
            "be",
            "friends",
            "friend",
            "dwell",
            "people",
            "God",
            "dine",
            "children",
            "father",
          ],
          correctAnswer: "dwell",
          textAfter: " with them, and they shall be His",
          textBefore:
            'I heard a loud voice from heaven saying, "Behold, the tabernacle of God is with men, and He will',
        },
        {
          choices: [
            "be",
            "friends",
            "friend",
            "dwell",
            "people",
            "God",
            "dine",
            "children",
            "father",
          ],
          correctAnswer: "people",
          textAfter: " . God Himself will be with them and be their",
        },
        {
          choices: [
            "be",
            "friends",
            "friend",
            "dwell",
            "people",
            "God",
            "dine",
            "children",
            "father",
          ],
          correctAnswer: "God",
          textAfter: ' ."',
        },
      ],
      body: "Revelation's 1,000 years reveal that God's wish ultimately comes true! After creation, sin interrupted God's fellowship with His children. God dwelled among His people when He inhabited the earthly sanctuary (Exodus 25:8), but the sin of His people prevented them from knowing God as He wished them to know Him. Jesus came and dwelled in the midst of His people, but \"His own did not receive Him\"(John 1:11). \n\nFinally, God enjoys true closeness with His people. And without sin and Satan, the redeemed are free to enjoy the presence of God for eternity!",
      choices: [
        "be",
        "God",
        "friends",
        "friend",
        "people",
        "dine",
        "children",
        "dwell",
        "father",
      ],
      lessonID: 11,
      question:
        "How does the book of Revelation describe God's relationship with His people in the earth made new?",
      questionID: 19,
      questionType: "wordCloud",
      verses: [
        {
          body: 'And I heard a loud voice from heaven saying, “Behold, the tabernacle of God is with men, and He will dwell with them, and they shall be His people. God Himself will be with them and be their God."',
          ref: "Revelation 21:3",
        },
      ],
    },
    "11-2": {
      Supplements: {
        "-L7zDPeSPT3HmD8R0UmQ": {
          body: "The Bible speaks a lot about pride, and often warns against it.  In fact, the Bible calls pride an “abomination” (Proverbs 6:16,17.)\n\nProverbs 16:18.  “Pride goes before destruction, and a haughty spirit before a fall.”\n\nProverbs 8:13.  “The fear of the LORD is to hate evil; pride and arrogance and the evil way and the perverse mouth I hate.”\n\nProverbs 13:10.  “By pride comes nothing but strife, but with the well-advised is wisdom.”\n\nProverbs 29:23.  “A man's pride will bring him low, but the humble in spirit will retain honor.”\n\nMalachi 4:1.  ““For behold, the day is coming, burning like an oven, and all the proud, yes, all who do wickedly will be stubble.”\n\nJames 4:6.  “God resists the proud, but gives grace to the humble.”\n\nIt was pride that brought about the fall of Satan.  Speaking of Satan, Ezekiel 28:17 says, “Your heart was lifted up because of your beauty; You corrupted your wisdom for the sake of your splendor.”  In Isaiah 14, the depths of Satan’s pride are revealed.  “How you are fallen from heaven, O Lucifer, son of the morning! How you are cut down to the ground, you who weakened the nations!  For you have said in your heart: ‘I will ascend into heaven, I will exalt my throne above the stars of God; I will also sit on the mount of the congregation on the farthest sides of the north.”  \n\nFurther describing Satan's pride, Isaiah 14:14 says \"I will ascend above the heights of the clouds, I will be like the Most High.’\n\nSatan’s pride and desire for exaltation led him to desire to sit on God’s throne and rule as God!\n\nIf you are battling pride, know that God can help you in your battle.  1 Corinthians 10:13 assures you that no temptation is too great for God to deliver you from.\n\nThere is power in the word of God.  As you read the Bible, claim Bible promises and ask (expect) God to give you victory instead of defeat.  The closer you come to God in faith, the more you will be led by God’s Spirit to choose God’s path rather than the path of self.\n\nPride is defined as “a feeling or deep pleasure or satisfaction derived from one's own achievements.”  Pride focuses on self, and prevents a person from recognizing his or her deep need of God.\n\nYou can guard against pride by appealing to God to grant you humility, and to make decisions that would keep your eyes focused less on appearance and instead on Jesus..\n",
          title: " How can I guard against pride?",
        },
      },
      blanks: [
        {
          choices: ["equal to", "High", "like", "Father", "as", "Most"],
          correctAnswer: "like",
          textAfter: " the",
          textBefore:
            "How you are fallen from heaven, O Lucifer, son of the morning! How you are cut down to the ground, you who weakened the nations! For you have said in your heart: “I will ascend into heaven, I will exalt my throne above the stars of God; I will also sit on the mount of the congregation on the farthest sides of the north; I will ascend above the heights of the clouds, I will be",
        },
        {
          choices: [
            "like",
            "Most high",
            "as",
            "Father himself",
            "glory",
            "chosen one",
          ],
          correctAnswer: "Most",
          textAfter: " ",
        },
        {
          choices: [
            "like",
            "Most high",
            "as",
            "Father himself",
            "glory",
            "chosen one",
          ],
          correctAnswer: "High",
          textAfter: " .”",
        },
      ],
      body: "As incredible as it seems, Satan came to the place where he wanted worship. Self­ exaltation led Satan to want to draw people to follow himself rather than render their allegiance to God.",
      choices: ["equal to", "High", "like", "Father", "as", "Most"],
      lessonID: 11,
      question: "What caused Satan’s fall from his high position in heaven?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "12 “How you are fallen from heaven,\nO Lucifer, son of the morning!\nHow you are cut down to the ground,\nYou who weakened the nations!\n\n13 For you have said in your heart:\n‘I will ascend into heaven,\nI will exalt my throne above the stars of God;\nI will also sit on the mount of the congregation\nOn the farthest sides of the north;\n\n14 I will ascend above the heights of the clouds,\nI will be like the Most High.’",
          ref: "Isaiah 14:12-14",
        },
      ],
    },
    "11-20": {
      correctAnswer: "true",
      question:
        "All who accept Jesus by faith can anticipate living one day with God in an earth made new.  Are you willing to accept Jesus today as your personal Savior, and are you looking forward to living with Jesus on a re-created earth?",
      questionID: 20,
      questionType: "truthConfirmation",
    },
    "11-3": {
      blanks: [
        {
          choices: [
            "humans",
            "follow",
            "animals",
            "understand",
            "All",
            "worship",
          ],
          correctAnswer: "All",
          textAfter: " who dwell on the earth will",
        },
        {
          choices: [
            "humans",
            "follow",
            "animals",
            "understand",
            "All",
            "worship",
          ],
          correctAnswer: "worship",
          textAfter:
            " him, whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
        },
      ],
      choices: ["All", "understand", "Most", "follow", "worship", "Some"],
      lessonID: 11,
      question:
        "How successful will Satan ultimately be at receiving the worship of the world?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "All who dwell on the earth will worship him, whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
          ref: "Revelation 13:8",
        },
      ],
    },
    "11-4": {
      blanks: [
        {
          choices: ["thousand years", "millions years", "single day"],
          correctAnswer: "thousand",
          textAfter: " ",
          textBefore:
            "I saw an angel coming down from heaven, having the key to the bottomless pit and a great chain in his hand. He laid hold of the dragon, that serpent of old, who is the Devil and Satan, and bound him for a",
        },
        {
          choices: ["thousand years", "millions years", "single day"],
          correctAnswer: "years",
          textAfter: " .",
        },
      ],
      body: "The Bible tells us that Satan will be bound for 1,000 years. During this millennium, Satan will be held fast—no longer receiving the homage of those who gave him their allegiance while he dominated the earth. \n\nThe word “millennium” is derived from two Latin words: mille, meaning “thousand,” and annus, meaning “year.” Although the word “millennium” does not appear in the Bible, the millennium itself does. The millennium is the 1,000­ year period written about by John in Revelation chapter 20.",
      choices: ["years", "million", "hours", "thousand", "day", "single"],
      lessonID: 11,
      question: "When does Satan’s domination of planet Earth come to an end?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "1 Then I saw an angel coming down from heaven, having the key to the bottomless pit and a great chain in his hand.\n\n2 He laid hold of the dragon, that serpent of old, who is the Devil and Satan, and bound him for a thousand years.",
          ref: "Revelation 20:1, 2",
        },
      ],
    },
    "11-5": {
      blanks: [
        {
          choices: [
            "torment",
            "once again",
            "deceive",
            "no more",
            "persuade",
            "to sin",
          ],
          correctAnswer: "deceive",
          textAfter: " the nations",
          textBefore:
            "He [the angel] cast him [Satan] into the bottomless pit, and shut him up, and set a seal on him, so that he should",
        },
        {
          choices: [
            "torment",
            "once again",
            "deceive",
            "no more",
            "persuade",
            "to sin",
          ],
          correctAnswer: "no",
          textAfter: " ",
        },
        {
          choices: [
            "torment",
            "once again",
            "deceive",
            "no more",
            "persuade",
            "to sin",
          ],
          correctAnswer: "more",
          textAfter: " till the thousand years were finished.",
        },
      ],
      body: "The millennium, when Satan is bound, causes Satan to be jobless for 1,000 years. He is essentially out of business, unable to “deceive the nations.”",
      choices: [
        "torment",
        "again",
        "no",
        "deceive",
        "more",
        "persuade",
        "temp",
      ],
      lessonID: 11,
      question:
        "What happens as a result of Satan being bound for 1,000 years?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "And he [the angel] cast him [Satan] into the bottomless pit, and shut him up, and set a seal on him, so that he should deceive the nations no more till the thousand years were finished. But after these things he must be released for a little while.",
          ref: "Revelation 20:3",
        },
      ],
    },
    "11-6": {
      blanks: [
        {
          choices: ["rise", "speak", "sing", "descend", "strike", "see"],
          correctAnswer: "descend",
          textAfter:
            " from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will",
          textBefore: "The Lord Himself will",
        },
        {
          choices: ["descend", "rise", "speak", "sing", "strike", "see"],
          correctAnswer: "rise",
          textAfter:
            " first. Then we who are alive and remain shall be caught up together with them in the clouds to meet the Lord in the air. And thus we shall always be with the Lord.",
        },
      ],
      body: "When Jesus returns, the kingdoms of the world are swept away (Daniel 2:44). It is at this time that the righteous dead are raised and taken to heaven. Satan can no longer tempt them.",
      choices: ["descend", "rise", "speak", "sing", "strike", "see"],
      lessonID: 11,
      question: "What event precedes the binding of Satan?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "16 For the Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will rise first.\n\n17 Then we who are alive and remain shall be caught up together with them in the clouds to meet the Lord in the air. And thus we shall always be with the Lord.",
          ref: "1 Thessalonians 4:16, 17",
        },
      ],
    },
    "11-7": {
      blanks: [
        {
          choices: ["Christ", "them", "man", "Satan", "life", "condemnation"],
          correctAnswer: "life",
          textAfter: " , and those who have done evil, to the resurrection of",
          textBefore:
            "The hour is coming in which all who are in the graves will hear His voice and come forth—those who have done good, to the resurrection of",
        },
        {
          choices: ["Christ", "them", "man", "Satan", "life", "condemnation"],
          correctAnswer: "condemnation",
          textAfter: " .",
        },
      ],
      body: "The resurrection of life takes place when Jesus returns—at the beginning of the millennium. The resurrection of condemnation takes place at the end of Revelation’s 1,000 years.",
      choices: ["Christ", "condemnation", "them", "man", "Satan", "life"],
      lessonID: 11,
      question: "How many resurrections will there be?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "28 Do not marvel at this; for the hour is coming in which all who are in the graves will hear His voice\n\n29 and come forth—those who have done good, to the resurrection of life, and those who have done evil, to the resurrection of condemnation.",
          ref: "John 5:28, 29",
        },
      ],
    },
    "11-8": {
      blanks: [
        {
          choices: [
            "in heaven",
            "with",
            "house",
            "Christ",
            "prepare",
            "place",
            "the earth",
            "build",
            "friend",
          ],
          correctAnswer: "Christ",
          newline: [1],
          textAfter: " for a thousand years.  ",
          textBefore: "They lived and reigned with ",
        },
        {
          choices: [
            "in heaven",
            "build",
            "house",
            "with Christ",
            "prepare",
            "place",
            "the earth",
            "find",
            "friend",
          ],
          correctAnswer: "prepare",
          textAfter: "a ",
          textBefore: "I go to",
        },
        {
          choices: [
            "in heaven",
            "build",
            "house",
            "with Christ",
            "prepare",
            "place",
            "the earth",
            "find",
            "friend",
          ],
          correctAnswer: "place",
          textAfter: "for you",
        },
        {
          choices: [
            "in heaven",
            "build",
            "house",
            "with Christ",
            "prepare",
            "place",
            "the earth",
            "find",
            "friend",
          ],
          correctAnswer: "Myself",
          textAfter: "; that where I am, there you may be also.",
          textBefore: "...I will come again and receive you to",
        },
      ],
      body: "Jesus made it clear that His saved people will be with Him in heaven. All of God’s children will spend the 1,000 years of Revelation in His presence in heaven!",
      choices: [
        "heaven",
        "house",
        "Christ",
        "prepare",
        "place",
        "earth",
        "build",
        "friend",
        "Myself",
      ],
      lessonID: 11,
      question:
        "Where does the Bible describe the righteous as being during the millennium?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I saw thrones, and they sat on them, and judgment was committed to them. Then I saw the souls of those who had been beheaded for their witness to Jesus and for the word of God, who had not worshiped the beast or his image, and had not received his mark on their foreheads or on their hands. And they lived and reigned with Christ for a thousand years.",
          ref: "Revelation 20:4",
        },
        {
          body: "2 In My Father’s house are many mansions; if it were not so, I would have told you. I go to prepare a place for you.\n\n3 And if I go and prepare a place for you, I will come again and receive you to Myself; that where I am, there you may be also.",
          ref: "John 14:2, 3",
        },
      ],
    },
    "11-9": {
      Supplements: {
        "-L7zDljUMWfGut5lpI9g": {
          body: "While the word “millennium” is not in the Bible, the concept of the thousand years definitely is.  There are other commonly-used words that also don’t appear in the Bible.  While the word “trinity” isn’t found in Scripture, the concept of a divine union of three eternal persons definitely is.  “Rapture” isn’t found in the Bible, but the Bible does teach that at the second coming the dead in Christ shall rise and along with the living saints will be caught up to meet Him in the air.\n\n",
          title:
            "Does it matter that the word “millennium” is not in the Bible?",
        },
      },
      blanks: [
        {
          choices: [
            "stand",
            "did",
            "Step",
            "remove",
            "Fall",
            "resist",
            "hide",
            "until",
            "will",
            "not",
            "for",
            "finished",
            "nothing",
          ],
          correctAnswer: "Fall",
          textAfter: " on us and",
          textBefore:
            "[All who were not saved] said to the mountains and rocks, “",
        },
        {
          choices: [
            "Fall",
            "hide",
            "stand",
            "did not",
            "until",
            "finished",
            "Step",
            "remove",
            "resist",
            "will yet",
            "for",
            "nothing",
          ],
          correctAnswer: "hide",
          textAfter:
            " us from the face of Him who sits on the throne and from the wrath of the Lamb! For the great day of His wrath has come, and who is able to",
        },
        {
          choices: [
            "Fall",
            "hide",
            "stand",
            "did not",
            "until",
            "finished",
            "Step",
            "remove",
            "resist",
            "will yet",
            "for",
            "nothing",
          ],
          correctAnswer: "stand",
          newline: [1],
          textAfter: " ?",
        },
        {
          choices: [
            "Fall",
            "hide",
            "stand",
            "did not",
            "until",
            "finished",
            "Step",
            "remove",
            "resist",
            "will yet",
            "for",
            "nothing",
          ],
          correctAnswer: "not",
          textAfter: " live again",
          textBefore: "The rest of the dead did",
        },
        {
          choices: [
            "Fall",
            "hide",
            "stand",
            "did not",
            "until",
            "finished",
            "Step",
            "remove",
            "resist",
            "will yet",
            "for",
            "nothing",
          ],
          correctAnswer: "until",
          textAfter: " the thousand years were",
        },
        {
          choices: [
            "Fall",
            "hide",
            "stand",
            "did not",
            "until",
            "finished",
            "Step",
            "remove",
            "resist",
            "will yet",
            "for",
            "nothing",
          ],
          correctAnswer: "finished",
          textAfter: " .",
        },
      ],
      body: "The return of Jesus causes the wicked people living on earth to be destroyed. However, according to Revelation 20:5, they “live again” at the conclusion of the millennium.",
      choices: [
        "stand",
        "not",
        "Step",
        "remove",
        "Fall",
        "resist",
        "hide",
        "until",
        "will",
        "for",
        "finished",
        "nothing",
      ],
      lessonID: 11,
      question:
        "If the righteous are in heaven during the millennium, where are the unrighteous?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "16 And said to the mountains and rocks, “Fall on us and hide us from the face of Him who sits on the throne and from the wrath of the Lamb!\n\n17 For the great day of His wrath has come, and who is able to stand?”",
          ref: "Revelation 6:16, 17",
        },
        {
          body: "But the rest of the dead did not live again until the thousand years were finished. This is the first resurrection.",
          ref: "Revelation 20:5",
        },
      ],
    },
  },
  {
    "12-0": {
      body: "When Mary-Ellen was asked why she was a practicing witch, the answer she gave surprised the questioner. She said, “As a child, I was raised in a hellfire and brimstone-spitting church. I was told God would burn people—even old people and little children—for as long as time should last. I decided that if that’s what God is like, I’d be better off without Him!” Mary-Ellen wrestled with a commonly-asked question: “Would God really do that?”",
      lessonID: 12,
      questionID: 0,
      type: "text",
    },
    "12-1": {
      blanks: [
        {
          choices: ["love", "God", "kind"],
          correctAnswer: "love",
          textAfter: " .",
          textBefore: "God is",
        },
      ],
      body: "Although it might not be always possible to understand the providence of God, the Bible clearly states that God is love.",
      choices: ["love", "God", "kind"],
      lessonID: 12,
      question: "What is God really like?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "He who does not love does not know God, for God is love.",
          ref: "1 John 4:8",
        },
      ],
    },
    "12-10": {
      blanks: [
        {
          choices: [
            "forever",
            "ever",
            "fire",
            "up",
            "up",
            "water",
            "faster",
            "faster",
            "lava",
          ],
          correctAnswer: "forever",
          textAfter: " and",
          textBefore: "The smoke of their torment ascends",
        },
        {
          choices: [
            "forever",
            "ever",
            "fire",
            "up",
            "up",
            "water",
            "faster",
            "faster",
            "lava",
          ],
          correctAnswer: "ever",
          newline: [1],
          textAfter:
            " ; and they have no rest day or night, who worship the beast and his image, and whoever receives the mark of his name. ",
        },
        {
          choices: [
            "forever",
            "ever",
            "fire",
            "up",
            "up",
            "water",
            "faster",
            "faster",
            "lava",
          ],
          correctAnswer: "fire",
          textAfter:
            " and brimstone where the beast and the false prophet are. And they will be tormented day and night forever and ever.",
          textBefore: "The devil, who deceived them, was cast into the lake of",
        },
      ],
      body: "As we have already seen, the Bible teaches that Satan will be reduced to ashes in the fires of hell. It isn’t possible for the devil to be reduced to ashes and to burn forever and ever at the same time!",
      choices: ["forever", "ever", "fire", "up", "water", "faster", "lava"],
      lessonID: 12,
      question: "But doesn’t the Bible say the wicked will burn forever?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the smoke of their torment ascends forever and ever; and they have no rest day or night, who worship the beast and his image, and whoever receives the mark of his name.",
          ref: "Revelation 14:11",
        },
        {
          body: "The devil, who deceived them, was cast into the lake of fire and brimstone where the beast and the false prophet are. And they will be tormented day and night forever and ever.",
          ref: "Revelations 20:10",
        },
      ],
    },
    "12-11": {
      blanks: [
        {
          choices: [
            "permanently",
            "breathes",
            "again",
            "forty",
            "forty",
            "forever",
            "lives",
            "forever",
            "three",
            "three",
          ],
          correctAnswer: "forever",
          newline: [1],
          textAfter: '. " ',
          textBefore:
            "Hannah . . . said to her husband, “Not until the child is weaned; then I will take him, that he may appear before the Lord and remain there",
        },
        {
          choices: [
            "permanently",
            "breathes",
            "again",
            "forty",
            "forty",
            "forever",
            "lives",
            "forever",
            "three",
            "three",
          ],
          correctAnswer: "lives",
          newline: [1, 1],
          textAfter: " he shall be lent to the Lord.” ",
          textBefore: '“I also have lent him to the Lord; as long as he"',
        },
        {
          choices: [
            "permanently",
            "breathes",
            "again",
            "forty",
            "forty",
            "forever",
            "lives",
            "forever",
            "three",
            "three",
          ],
          correctAnswer: "three",
          newline: [1],
          textAfter: " days and three nights.",
          textBefore:
            "I went down to the moorings of the mountains; the earth with its bars closed behind me forever.  Jonah was in the belly of the fish",
        },
      ],
      body: "Hannah says her child will live in the temple “forever.” Then she says that he will be in the temple for “as long as he lives.” In this case, “forever” means “for as long as Samuel lives.\n\nJonah said that he was in the sea “forever,” yet the Bible explains it as being a time period of “three days and three nights.” As with Samuel at the temple, “forever” did not mean “forever” in the sense of an event lasting eternally. If\n“forever” meant “eternal,” we could still expect to find Samuel in the temple today, and Jonah still in the belly of the fish. While on two occasions the Bible refers to hellfire as lasting “forever,” it uses the phrase “forever” in the same way it does on dozens of other occasions where “forever” refers to “as long as an event should last.” Many times the Bible uses the phrase “forever” in conjunction with an event that has long expired.",
      choices: [
        "permanently",
        "breathes",
        "again",
        "forty",
        "forever",
        "lives",
        "me",
        "three",
      ],
      lessonID: 12,
      question: "What does “forever” mean when it refers to hellfire?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "But Hannah did not go up, for she said to her husband, “Not until the child is weaned; then I will take him, that he may appear before the Lord and remain there forever.”",
          ref: "1 Samuel 1:22",
        },
        {
          body: "Therefore I also have lent him to the Lord; as long as he lives he shall be lent to the Lord. So they worshiped the Lord there.",
          ref: "1 Samuel 1:28",
        },
        {
          body: "I went down to the moorings of the mountains; the earth with its bars closed behind me forever; yet You have brought up my life from the pit, O Lord, my God.",
          ref: "Jonah 2:6",
        },
        {
          body: "Now the Lord had prepared a great fish to swallow Jonah. And Jonah was in the belly of the fish three days and three nights.",
          ref: "Jonah 1:17",
        },
      ],
    },
    "12-12": {
      blanks: [
        {
          choices: [
            "offering",
            "God's",
            "nothing",
            "",
            "example",
            "eternal",
            "ashes",
            "establishment",
            "holy",
            "smoke",
          ],
          correctAnswer: "example",
          textAfter: " , suffering the vengeance of",
          textBefore:
            "Sodom and Gomorrah, and the cities around them . . . are set forth as an",
        },
        {
          choices: [
            "offering",
            "God's",
            "nothing",
            "",
            "example",
            "eternal",
            "ashes",
            "establishment",
            "holy",
            "smoke",
          ],
          correctAnswer: "eternal",
          textAfter: " fire. Turning the cities of Sodom and Gomorrah into",
        },
        {
          choices: [
            "offering",
            "God's",
            "nothing",
            "",
            "example",
            "eternal",
            "ashes",
            "establishment",
            "holy",
            "smoke",
          ],
          correctAnswer: "ashes",
          textAfter:
            " ,condemned them to destruction, making them an example to those who  afterward would live ungodly.",
        },
      ],
      body: "The Bible states clearly that the experience of Sodom and Gomorrah was an example of the “eternal” fires of hell. Clearly, “eternal” does not mean that the fires of hell will burn eternally. Sodom and Gomorrah are not still burning today. While the effects of hellfire are eternal, sinners in hellfire will be—as Sodom and Gomorrah were—reduced to ashes.",
      choices: [
        "offering",
        "God's",
        "nothing",
        "example",
        "eternal",
        "ashes",
        "establishment",
        "holy",
        "smoke",
      ],
      lessonID: 12,
      question:
        "What event does the Bible use as being an example of what hell will be like?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "As Sodom and Gomorrah, and the cities around them in a similar manner to these, having given themselves over to sexual immorality and gone after strange flesh, are set forth as an example, suffering the vengeance of eternal fire.",
          ref: "Jude 7",
        },
        {
          body: "And turning the cities of Sodom and Gomorrah into ashes, condemned them to destruction, making them an example to those who afterward would live ungodly.",
          ref: "2 Peter 2:6",
        },
      ],
    },
    "12-13": {
      blanks: [
        {
          choices: ["devil", "angels", "Lord", "hosts", "sinner", "family"],
          correctAnswer: "devil",
          textAfter: " and his",
          textBefore:
            "Depart from Me, you cursed, into the everlasting fire prepared for the",
        },
        {
          choices: ["devil", "angels", "Lord", "hosts", "sinner", "family"],
          correctAnswer: "angels",
          textAfter: " .",
        },
      ],
      body: "Hell was conceived of as a means of ridding the universe of sin and the arch-sinner, Satan. In Ezekiel 33:11, God says, “I have no pleasure in the death of the wicked, but that the wicked turn from his way and live”. Those who choose the service of Satan over the service of God will be destroyed along with Satan and the fallen angels in what Matthew 25:41 calls “everlasting fire.”",
      choices: ["devil", "angels", "Lord", "hosts", "sinner", "family"],
      lessonID: 12,
      question: "For whom was hell designed?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: 'Then He will also say to those on the left hand, "Depart from Me, you cursed, into the everlasting fire prepared for the devil and his angels."',
          ref: "Matthew 25:41",
        },
      ],
    },
    "12-14": {
      blanks: [
        {
          choices: ["everlasting", "burning", "blue", "unquenchable"],
          correctAnswer: "unquenchable",
          textAfter: " fire.",
          textBefore: "The chaff He will burn with",
        },
      ],
      body: "In Jeremiah 17:27, God discusses a fire that shall not be “quenched.” This fire is referred to in 2 Chronicles 36:19–21, and took place when Jerusalem was destroyed by Babylon. Jerusalem is not still burning today! God is clarifying a very solemn point: nothing will be able to in any way lessen the seriousness of hellfire. Hell will burn until it has done its work. Nothing will be able to escape the seriousness of hell. It will completely annihilate everything it touches.",
      choices: ["everlasting", "burning", "blue", "unquenchable"],
      lessonID: 12,
      question:
        "Why does the Bible mention “unquenchable fire” if the fires of hell will eventually burn out?",
      questionID: 14,
      questionType: "radio",
      verses: [
        {
          body: "His winnowing fan is in His hand, and He will thoroughly clean out His threshing floor, and gather the wheat into His barn; but the chaff He will burn with unquenchable fire.",
          ref: "Luke 3:17",
        },
      ],
    },
    "12-15": {
      lessonID: 12,
      question:
        "What about the story of the rich man and Lazarus in Luke 16: 19 - 31?",
      questionID: 15,
      questionType: "text",
      text: [
        "The story of the rich man and Lazarus is a parable.  Jesus shared this story not to illustrate the realities of the afterlife, but to teach His hearers some vital lessons",
        "A. Wealth ( in the case of the rich man) is not a guarantee of God's blessings.  Neither is poverty ( in the case of Lazarus) a sign of lacking God's blessing.",
        "B. Salvation is not by birthright.  Many Jews felt that because they were the descendants of Abraham, they were guaranteed salvation.  This parable demonstrated to Jesus' hearers that heredity does not provide eternal life.",
        'C. Believers must follow what is written in the Bible.  In the parable, the rich man is told that if his brothers would not hear "Moses and the prophets," the would not believe - even if one of them rose from the dead.  Interestingly, a man named Lazarus did rise from the dead, and rather than believe in Jesus, the religious leaders plotted to have Lazarus murdered ( John 12: 10).',
      ],
    },
    "12-16": {
      blanks: [
        {
          choices: ["old", "new", "beautiful", "broken"],
          correctAnswer: "new",
          textAfter:
            " earth, for the first heaven and the first earth had passed away. Also there was no more sea.",
          textBefore: "I saw a new heaven and a",
        },
      ],
      body: "After the fires of hell have gone out, God will re-create the earth. Every last trace of sin will be gone. Our eternal home will be a place of beauty and perfection, where God will dwell with His people (Revelation 21:3). \n\nHellfire reveals the love of a gracious God.  After doing everything He can to save every last person for all eternity, God ultimately destroys the earth and rids it of every trace of sin. \n\nThose who choose not to receive everlasting life will not be caused to suffer for eternity; they will be blotted out of existence. Sin and sinners will be no more. The saved will be free to enjoy eternity without the presence of sin!",
      choices: ["old", "new", "beautiful", "broken"],
      lessonID: 12,
      question: "What will God do after hellfire has burned?",
      questionID: 16,
      questionType: "radio",
      verses: [
        {
          body: "Now I saw a new heaven and a new earth, for the first heaven and the first earth had passed away. Also there was no more sea.",
          ref: "Revelation 21:1",
        },
      ],
    },
    "12-17": {
      correctAnswer: "true",
      question:
        "Are you willing to accept the gift of salvation from Jesus today, and are you looking forward to eternity in a world without sin and sadness?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "12-2": {
      blanks: [
        {
          choices: ["him", "dine", "repentance", "relax"],
          correctAnswer: "repentance",
          textAfter: " .",
          textBefore:
            "The Lord is . . . not willing that any should perish but that all should come to",
        },
      ],
      body: "While it is evident that not everyone will repent, God’s wish is that all people would find salvation in Him. Jesus invited all who labor and are heavy laden to come to Him (Matthew 11:28), while whoever believes in Him should not perish, but have everlasting life (John 3:16).",
      choices: ["him", "dine", "repentance", "relax"],
      lessonID: 12,
      question: "What is God’s desire for the entire human family?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "The Lord is not slack concerning His promise, as some count slackness, but is longsuffering toward us, not willing that any should perish but that all should come to repentance.",
          ref: "2 Peter 3:9",
        },
      ],
    },
    "12-3": {
      Supplements: {
        "-L7zFpAGlB7URCIHTqPB": {
          body: "God’s intent is to rid the universe of sin.  Sin was never in God’s original plan for planet Earth, but as a result of the disobedience of the human family sin entered the world.  Sin not only separates human beings from God (Isaiah 59:2), it resulted in a curse on the ground (Genesis 3:17).  As a result of sin, “the whole creation groans and labors with birth pangs together until now” (Romans 8:22).\n\nThe Bible states clearly after the millennium, the Earth will be the eternal home of the redeemed (Revelation 21:1,2.)  Hell eradicates sin and sinners (Revelation 20:9).  Just as God cleansed the Earth with a flood in Noah’s day, God will again cleanse the Earth using fire.  As a result, there will be no more death, sorrow, crying or pain (Revelation 21:4.)\n\nJesus said hell was “prepared for the devil and his angels,” (Matthew 25:41), and those who choose the service of Satan rather than the service of God will join Satan and his angels in the destruction of the wicked.  Hell removes sin and sinners from the universe.  As Nahum wrote, “affliction shall not rise up a second time.”  (Nahum 1:9)",
          title: "What is the reason for hell?",
        },
      },
      blanks: [
        {
          choices: ["hate", "turmoil", "hell"],
          correctAnswer: "hell",
          textAfter: " .",
          textBefore:
            "Do not fear those who kill the body but cannot kill the soul. But rather fear Him who is able to destroy both soul and body in",
        },
      ],
      body: "Jesus certainly believed there was a hell!",
      choices: ["hate", "turmoil", "hell"],
      lessonID: 12,
      question: "Is there really a hell?",
      questionID: 3,
      questionType: "radio",
      verses: [
        {
          body: "And do not fear those who kill the body but cannot kill the soul. But rather fear Him who is able to destroy both soul and body in hell.",
          ref: "Matthew 10:28",
        },
      ],
    },
    "12-4": {
      blanks: [
        {
          choices: [
            "fall",
            "night",
            "pit",
            "snakes",
            "end",
            "age",
            "furnace",
            "fire",
            "beginning",
            "millennium",
          ],
          correctAnswer: "end",
          textAfter: " of this",
          textBefore:
            "As the tares are gathered and burned in the fire, so it will be at the",
        },
        {
          choices: [
            "fall",
            "night",
            "pit",
            "snakes",
            "end",
            "age",
            "furnace",
            "fire",
            "beginning",
            "millennium",
          ],
          correctAnswer: "age",
          textAfter:
            " . The Son of Man will send out His angels, and they will gather out of His kingdom all things that offend, and those who practice lawlessness, and will cast them into the",
        },
        {
          choices: [
            "fall",
            "night",
            "pit",
            "snakes",
            "end",
            "age",
            "furnace",
            "fire",
            "beginning",
            "millennium",
          ],
          correctAnswer: "furnace",
          textAfter: " of",
        },
        {
          choices: [
            "fall",
            "night",
            "pit",
            "snakes",
            "end",
            "age",
            "furnace",
            "fire",
            "beginning",
            "millennium",
          ],
          correctAnswer: "fire",
          textAfter: " .",
        },
      ],
      body: "According to Jesus, hellfire will not start burning until the “end of this age,” which means there is presently no one burning in hell!",
      choices: [
        "fall",
        "night",
        "pit",
        "snakes",
        "end",
        "age",
        "furnace",
        "fire",
        "beginning",
        "millennium",
      ],
      lessonID: 12,
      question: "When is hell going to burn?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "40 Therefore as the tares are gathered and burned in the fire, so it will be at the end of this age.\n\n41 The Son of Man will send out His angels, and they will gather out of His kingdom all things that offend, and those who practice lawlessness,\n\n42 and will cast them into the furnace of fire. There will be wailing and gnashing of teeth.",
          ref: "Matthew 13:40-42",
        },
      ],
    },
    "12-5": {
      Supplements: {
        "-L7zH5Du4k8_AhHsJ1P9": {
          body: "None.\n\nThe Bible is clear that there will be a hell.  Jesus said as much (see Matthew 10:28.)  But in the parable of the wheat and the tares, Jesus expressly stated that the tares would be “gathered and burned… in the end of this world.”  Revelation 20 places the destruction of the wicked after the second coming of Jesus, at the end of the thousand years (Revelation 20: 7, 14.)\n\nNot one person is currently in hell.",
          title: "How many people are suffering in hell at this moment?",
        },
      },
      blanks: [
        {
          choices: [
            "resurrection",
            "condemnation",
            "beginning",
            "end",
            "last",
            "men",
          ],
          correctAnswer: "resurrection",
          textAfter: " of",
          textBefore:
            "The hour is coming in which all who are in the graves will hear His voice and come forth—those who have done good, to the resurrection of life, and those who have done evil, to the",
        },
        {
          choices: [
            "resurrection",
            "condemnation",
            "beginning",
            "end",
            "last",
            "men",
          ],
          correctAnswer: "condemnation",
          textAfter: " .",
        },
      ],
      body: "Jesus spoke about two resurrections. One—the resurrection of life—would take place at His Second Coming, while the other—the resurrection of condemnation—would not occur until the end of Revelation’s 1,000 years, a whole millennium after the Second Coming of Jesus. \n\nBased on the teachings of Jesus, no one will be subjected to hellfire until after the millennium. [See It Is Written Bible Study Guide #11, “Revelation’s 1,000 Years.”]",
      choices: [
        "resurrection",
        "condemnation",
        "beginning",
        "end",
        "last",
        "men",
      ],
      lessonID: 12,
      question: "When will sinners go to hell?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "28 Do not marvel at this; for the hour is coming in which all who are in the graves will hear His voice\n\n29 and come forth—those who have done good, to the resurrection of life, and those who have done evil, to the resurrection of condemnation.",
          ref: "John 5:28, 29",
        },
      ],
    },
    "12-6": {
      Supplements: {
        "-L7zIxMxFLfMvbG5jaix": {
          body: "The Bible is so clear on this subject there should be no confusion.  Consider what the Bible says.\n\nRevelation 20:9 says, “They went up on the breadth of the earth and surrounded the camp of the saints and the beloved city. And fire came down from God out of heaven and devoured them.”  The lost were devoured while they were “on the breadth of the earth.”  Hell is not in the center of the earth, as has been taught by many people.\n\nThis is supported by 2 Peter 3:7, which says, “But the heavens and the earth which are now preserved by the same word, are reserved for fire until the day of judgment and perdition of ungodly men.”\n\nRemember God’s purpose concerning hell.  God intends to rid the universe of every last trace of sin.  Sin will not stain the universe throughout eternity.  Sin, which has brought immeasurable pain to the heart of God and has been responsible for so much anguish and misery through the ages, will be gone forever.  God intends to create a new earth in which people can dwell forever without sin.\n\nThe earth will be cleansed by fire, and sin will never exist again.  As stated by the prophet Nahum, “Affliction shall not rise up a second time.”  (Nahum 1:9)\n\n",
          title: "Where is hell located?",
        },
      },
      blanks: [
        {
          choices: ["sky", "hells", "earth", "heavens", "universe"],
          correctAnswer: "earth",
          newline: [1],
          textAfter:
            " and surrounded the camp of the saints and the beloved city. And fire came down from God out of heaven and devoured them.",
          textBefore:
            "They [Satan and all the unsaved] went up on the breadth of the",
        },
        {
          choices: ["sky", "hells", "earth", "earth", "heavens", "earth"],
          correctAnswer: "heavens",
          textAfter:
            " and the earth which are now preserved by\nthe same word, are reserved for fire until the day of judgment and perdition of ungodly men.",
          textBefore: " But the ",
        },
      ],
      body: "The Bible teaches that hellfire takes place on the earth. While it has been common for people to teach that hell is located in the center of the earth, such an idea is clearly a fallacy—a modern myth. Hellfire consumes the entire planet.",
      choices: ["sky", "hells", "earth", "earth", "heavens", "earth"],
      lessonID: 12,
      question: "Where is hell?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "They went up on the breadth of the earth and surrounded the camp of the saints and the beloved city. And fire came down from God out of heaven and devoured them.",
          ref: "Revelation 20:9",
        },
        {
          body: "But the heavens and the earth which are now preserved by the same word, are reserved for fire until the day of judgment and perdition of ungodly men.",
          ref: "2 Peter 3:7",
        },
      ],
    },
    "12-7": {
      blanks: [
        {
          choices: [
            "die",
            "death",
            "death",
            "",
            "burn",
            "death",
            "torment",
            "live",
            "life",
            "coming",
          ],
          correctAnswer: "die",
          newline: [1],
          textAfter: " .",
          textBefore: "The soul who sins shall",
        },
        {
          choices: [
            "die",
            "death",
            "death",
            "",
            "burn",
            "death",
            "torment",
            "live",
            "life",
            "coming",
          ],
          correctAnswer: "wages",
          newline: [1],
          textAfter: "of sin is death",
          textBefore: "The ",
        },
        {
          choices: [
            "die",
            "death",
            "death",
            "",
            "burn",
            "death",
            "torment",
            "live",
            "life",
            "coming",
          ],
          correctAnswer: "death",
          textAfter: " .",
          textBefore: "This [hellfire] is the second",
        },
      ],
      body: "People who find themselves in the fires of hell die in hell. The most well-known verse in the Bible says that anyone who believes in Jesus “will not perish.” The Bible does not teach that people will suffer in hell throughout eternity.",
      choices: ["die", "death", "wages", "torment", "live", "life", "coming"],
      lessonID: 12,
      question: "What happens to lost people who go to hell?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "Behold, all souls are Mine; the soul of the father as well as the soul of the son is Mine; the soul who sins shall die.",
          ref: "Ezekiel 18:4",
        },
        {
          body: "For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.",
          ref: "Romans 6:23",
        },
        {
          body: "Then Death and Hades were cast into the lake of fire. This is the second death.",
          ref: "Revelation 20:14",
        },
      ],
    },
    "12-8": {
      blanks: [
        {
          choices: [
            "stoned",
            "crushed",
            "killed",
            "trampled",
            "stubble",
            "ashes",
          ],
          correctAnswer: "stubble",
          textAfter:
            " . And the day which is coming shall burn them up,” says the Lord of hosts, “that will leave them neither root nor branch . . . You shall trample the wicked, for they shall be",
          textBefore:
            "“Behold, the day is coming, burning like an oven, and all the proud, yes, all who do wickedly will be",
        },
        {
          choices: [
            "stoned",
            "crushed",
            "killed",
            "trampled",
            "stubble",
            "ashes",
          ],
          correctAnswer: "ashes",
          textAfter:
            " under the soles of your feet on the day that I do this,” says the Lord of hosts.",
        },
      ],
      body: "The Bible is unambiguous when discussing the fate of the lost in hell. Hellfire destroys the wicked. \n\nIt is not God’s intention that the wicked should exist forever. In fact, it is not possible that the wicked could exist forever. Eternal life is a gift given to those who have faith in Christ. \n\nThe lost are lost because they do not have faith in Jesus. God will not grant immortality to those who have not chosen to love Him. As 1 John 5:12 says, “He who has the Son has life; he who does not have the Son of God does not have life.” \n\nThe lost do not have the Son, and therefore cannot live forever—even in hell!",
      choices: ["stoned", "crushed", "killed", "trampled", "stubble", "ashes"],
      lessonID: 12,
      question:
        "What, ultimately, is the condition of people who are burned in hell?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: '"For behold, the day is coming, burning like an oven, and all the proud, yes, all who do wickedly will be stubble. And the day which is coming shall burn them up,” says the Lord of hosts,“That will leave them neither root nor branch.\n\n3 You shall trample the wicked, for they shall be ashes under the soles of your feet on the day that I do this,” says the Lord of hosts.',
          ref: "Malachi 4:1, 3",
        },
      ],
    },
    "12-9": {
      Supplements: {
        "-L7zI39PtYFji-fmzaPv": {
          body: "The prevalent Christian belief regarding hell fire is that God burns the wicked in hell for all eternity.  That is, the punishment never, ever stops.  How easy is it to imagine a loving God - 1 John 4:8 says that “God is love” - inflicting unbearable torture on the lost for ever and ever and ever?  The thought is repugnant.  Such an act could not be carried out by a loving God, and the Bible clearly says as much.  The idea of an eternally burning hell is repulsive to a vast number of people, making it easy for people to dismiss the idea of hell even existing.\n\nAdditionally, the thought of Satan being in charge of hell is likewise absurd.  This concept makes Satan an agent of God for the purpose of carrying out God’s punishment.  Ezekiel 28:17-19 spells out that Satan himself will be destroyed in the lake of fire.  Malachi 4:1-3 clarifies that the wicked - which includes Satan - will be reduced to ashes by the fires of hell.  Depicting Satan as being in charge of hell makes it easier to dismiss the entire concept of hell as fantasy.  Faced with the idea of hell burning forever without end, and the concept of Satan being in charge of hell, numerous people are led to completely reject the idea of hell altogether.  Satan himself has advanced the promulgation of the belief that he is in charge of hell, to the end that hell is not taken seriously and people reject the plain statements of the Word of God.",
          title: "Why is the devil often depicted as being in charge of hell?",
        },
      },
      blanks: [
        {
          choices: ["rubble", "nothing", "ashes", "food"],
          correctAnswer: "ashes",
          textAfter: " upon the earth in the sight of all who saw you.",
          textBefore:
            "Therefore I brought fire from your midst; it devoured you, and I turned you to",
        },
      ],
      body: "Even the devil is reduced to ashes by the fires of hell. Satan and his angels will not be given authority to torture the lost in hell. Satan himself—along with every fallen angel—will be blotted out of existence in the fires of hell. \n\nHell exists to cleanse the world—to rid the planet and the universe of every last trace of sin. God has no interest in reserving a small corner of the universe as an eternal cesspool where people enduring indescribable torment suffer for all eternity. \n\nAs He did in the days of Noah, God will cleanse the world once again, but this time “affliction will not rise up a second time” (Nahum 1:9). Sin and sinners will be gone forever!",
      choices: ["rubble", "nothing", "ashes", "food"],
      lessonID: 12,
      question: "What effect does hell have on the devil?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "You defiled your sanctuaries by the multitude of your iniquities, by the iniquity of your trading; therefore I brought fire from your midst; it devoured you, and I turned you to ashes upon the earth in the sight of all who saw you.",
          ref: "Ezekiel 28:18",
        },
      ],
    },
  },
  {
    "13-0": {
      body: "While General Douglas McArthur was commander of U.S. Army Forces in the Far East during World War II, the American-occupied Philippines was invaded by Japan. Defense was futile, and on February 22, 1942, President Franklin D. Roosevelt ordered General MacArthur to leave the Philippines. Once in Australia, MacArthur gave a famous speech in which he said, “I shall return.” On October 20, 1944, MacArthur made good on his promise when he waded ashore with his troops on the island of Leyte.  Before long, liberation came to the Philippines.",
      lessonID: 13,
      questionID: 0,
      type: "text",
    },
    "13-1": {
      blanks: [
        {
          choices: ["be there", "come again", "not stop"],
          correctAnswer: "come",
          textAfter: " ",
          textBefore:
            "Let not your heart be troubled; you believe in God, believe also in Me. In My Father’s house are many mansions; if it were not so, I would have told you. I go to prepare a place for you. And if I go and prepare a place for you, I will",
        },
        {
          choices: ["there", "be", "again", "stop", "come"],
          correctAnswer: "again",
          textAfter:
            " and receive you to Myself; that where I am, there you may be also.",
        },
      ],
      body: "Jesus promised that He would return to this world, gather His waiting people, and take them to be with Him in heaven!",
      choices: ["there", "be", "again", "stop", "come"],
      lessonID: 13,
      question:
        "What promise did Jesus make to the human family  before He went to heaven?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "1 Let not your heart be troubled; you believe in God, believe also in Me. \n\n2 In My Father’s house are many mansions; if it were not so, I would have told you. I go to prepare a place for you.\n\n3 And if I go and prepare a place for you, I will come again and receive you to Myself; that where I am, there you may be also.",
          ref: "John 14:1-3",
        },
      ],
    },
    "13-10": {
      blanks: [
        {
          choices: ["noise", "loud", "beast", "scary", "fire", "tempestuous"],
          correctAnswer: "fire",
          textAfter: " shall devour before Him, and it shall be very",
          textBefore: "Our God shall come, and shall not keep silent; a",
        },
        {
          choices: ["noise", "loud", "beast", "scary", "fire", "tempestuous"],
          correctAnswer: "tempestuous",
          textAfter: " all around Him.",
        },
      ],
      body: "The return of Jesus will undoubtedly be a glorious event!",
      choices: ["noise", "loud", "beast", "tempestuous", "scary", "fire"],
      lessonID: 13,
      question: "What will the return of Jesus look like?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "Our God shall come, and shall not keep silent; a fire shall devour before Him, and it shall be very tempestuous all around Him.",
          ref: "Psalm 50:3",
        },
      ],
    },
    "13-11": {
      blanks: [
        {
          choices: [
            "rise",
            "resurrection",
            "life",
            "be",
            "dismay",
            "others",
            "sing",
            "realization",
            "sinners",
          ],
          correctAnswer: "rise",
          textAfter:
            " first. The hour is coming in which all who are in the graves will hear His voice and come forth—those who have done good, to the",
          textBefore: "The dead in Christ will",
        },
        {
          choices: [
            "rise",
            "resurrection",
            "life",
            "be",
            "dismay",
            "others",
            "sing",
            "realization",
            "sinners",
          ],
          correctAnswer: "resurrection",
          textAfter: " of",
        },
        {
          choices: [
            "rise",
            "resurrection",
            "life",
            "be",
            "dismay",
            "others",
            "sing",
            "realization",
            "sinners",
          ],
          correctAnswer: "life",
          textAfter:
            " , and those who have done evil, to the resurrection of condemnation.",
        },
      ],
      body: "When Jesus returns, the first resurrection takes place, when the dead in Christ shall rise to be with Jesus forever. The dreamless sleep of death will come to an end, and the sleeping saints of God will rise to be with Him and to die no more. [For more information about the subject of death, see It Is Written Bible Study Guide #10, “The Mystery of Death.”]",
      choices: [
        "rise",
        "resurrection",
        "life",
        "be",
        "dismay",
        "others",
        "sing",
        "realization",
        "sinners",
      ],
      lessonID: 13,
      question:
        "What great event will take place at the Second Coming of Jesus?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "For the Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will rise first.",
          ref: "1 Thessalonians 4:16",
        },
        {
          body: "28 Do not marvel at this; for the hour is coming in which all who are in the graves will hear His voice\n\n29 and come forth—those who have done good, to the resurrection of life, and those who have done evil, to the resurrection of condemnation.",
          ref: "John 5:28, 29",
        },
      ],
    },
    "13-12": {
      blanks: [
        {
          choices: [
            "whole",
            "water",
            "fire",
            "happy",
            "corruption",
            "mortality",
            "changed",
            "incorruption",
            "immortality",
          ],
          correctAnswer: "changed",
          textAfter: " . For this corruptible must put on",
          textBefore:
            "For the trumpet will sound, and the dead will be raised incorruptible, and we shall be",
        },
        {
          choices: [
            "whole",
            "water",
            "fire",
            "happy",
            "corruption",
            "mortality",
            "changed",
            "incorruption",
            "immortality",
          ],
          correctAnswer: "incorruption",
          textAfter: " , and this mortal must put on",
        },
        {
          choices: [
            "whole",
            "water",
            "fire",
            "happy",
            "corruption",
            "mortality",
            "changed",
            "incorruption",
            "immortality",
          ],
          correctAnswer: "immortality",
          textAfter: " .",
        },
      ],
      body: "When Jesus returns, believers in Jesus will receive immortal, eternal bodies. The righteous at Jesus’ return will never again endure physical distress. Aches and pains will be gone forever, as God gives them new bodies in which they will live eternally!",
      choices: [
        "whole",
        "incorruption",
        "water",
        "immortality",
        "fire",
        "happy",
        "corruption",
        "mortality",
        "changed",
      ],
      lessonID: 13,
      question:
        "What incredible transformation takes place in the living saints at Jesus’ return?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "52 In a moment, in the twinkling of an eye, at the last trumpet. For the trumpet will sound, and the dead will be raised incorruptible, and we shall be changed.\n\n53 For this corruptible must put on incorruption, and this mortal must put on immortality.",
          ref: "1 Corinthians 15:52, 53",
        },
      ],
    },
    "13-13": {
      Supplements: {
        "-L7zMiW-c-ynpqDSakF6": {
          body: "No.  And, perhaps!\n\nJesus has offered the entire world the gift of everlasting life.  For those who have repented of their sins and accepted Jesus as Lord and Savior, the second coming is the “blessed hope” (Titus 2:13.)  As Isaiah 25:9 says, “And it will be said in that day: “Behold, this is our God; We have waited for Him, and He will save us. This is the Lord; We have waited for Him; We will be glad and rejoice in His salvation.””  For those who love God and have surrendered their hearts to Him, the second coming of Jesus is something to be celebrated and anticipated.\n\nHowever, Jeremiah 8:20 records the sentiment of those who are not ready for the return of Jesus.  “The harvest is past, the summer is ended, and we are not saved!”  \n\nRevelation 6:15-17 paints a vivid picture of the second coming with respect to the lost.  “And the kings of the earth, the great men, the rich men, the commanders, the mighty men, every slave and every free man, hid themselves in the caves and in the rocks of the mountains, and said to the mountains and rocks, “Fall on us and hide us from the face of Him who sits on the throne and from the wrath of the Lamb! For the great day of His wrath has come, and who is able to stand?””\n\nFor the lost, the return of Jesus represents the end of every hope of salvation.\n\nThis is why God appeals to humanity in the book of Hebrews, saying, “Today, if you will hear His voice, do not harden your hearts as in the rebellion” (Hebrews 3:15.)  Jesus spelled out humanity’s great problem in John 5:40.  “But you are not willing to come to Me that you may have life.”\n\nPreparation for eternity is very simple.  A person who comes to Christ, experiences forgiveness of sin and receives a new heart has the assurance of the gift of everlasting life.  That life lived in surrender to God and dependence on His Spirit is a life that will be ready for the second coming of Jesus.\n",
          title: "Should a person be worried about the return of Jesus?",
        },
        "-L7zNUs93lisksuyblnC": {
          body: "There is nothing in the Bible suggesting that the flood in Noah’s day was local and not global.\n\nGenesis 7 repeatedly refers to the flood being upon the “earth.”  For example, Genesis 7:17-20 says, “Now the flood was on the earth forty days. The waters increased and lifted up the ark, and it rose high above the earth. The waters prevailed and greatly increased on the earth, and the ark moved about on the surface of the waters. And the waters prevailed exceedingly on the earth, and all the high hills under the whole heaven were covered. The waters prevailed fifteen cubits upward, and the mountains were covered.”  Genesis 7 also says that God “destroyed all living things which were on the face of the ground.”  (Genesis 7:23)  \n\nGenesis 6:7,11-13 makes clear God’s intent in sending the flood.  “So the Lord said, “I will destroy man whom I have created from the face of the earth, both man and beast, creeping thing and birds of the air, for I am sorry that I have made them…” The earth also was corrupt before God, and the earth was filled with violence. So God looked upon the earth, and indeed it was corrupt; for all flesh had corrupted their way on the earth. And God said to Noah, “The end of all flesh has come before Me, for the earth is filled with violence through them; and behold, I will destroy them with the earth.””\n\nAdditionally, God gave the rainbow as a sign that He would never again send a flood upon the earth.  It was God’s assurance that “never again shall all flesh be cut off by the waters of the flood; never again shall there be a flood to destroy the earth.”  (Genesis 9:11)  God certainly didn’t mean that He would never again send a localized flood on the Earth.\n\nIsaiah 54:9 references God’s promise that “the waters of Noah would no longer cover the earth,” while in Matthew 24, Jesus cites the flood in Noah’s day as a type of the destruction of the Earth on the day when Jesus returns.  Nothing in the Scriptural account of the flood suggests it was anything other than a global event.\n",
          title: "Was the flood in Noah’s day a localized or global event?",
        },
      },
      blanks: [
        {
          choices: ["Adam", "hunger", "Noah", "know", "Abraham", "repent"],
          correctAnswer: "Noah",
          textAfter:
            " were, so also will the coming of the Son of Man be. For as in the days  before the flood, they were eating and drinking, marrying and giving in marriage, until the day that Noah entered the ark, and did not",
          textBefore: "As the days of",
        },
        {
          choices: ["Adam", "hunger", "Noah", "know", "Abraham", "repent"],
          correctAnswer: "know",
          textAfter:
            " until the flood came and took them all away, so also will the coming of the Son of Man be.",
        },
      ],
      body: "Comparing His return with the flood that covered the earth in the days of Noah, Jesus warned that indifference would affect the world. Most people will be carrying on with their daily lives, apathetic toward spiritual realities.",
      choices: ["know", "Adam", "hunger", "Noah", "Abraham", "repent"],
      lessonID: 13,
      question: "What warning did Jesus give in relation to His Second Coming?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "37 But as the days of Noah were, so also will the coming of the Son of Man be.\n\n38 For as in the days before the flood, they were eating and drinking, marrying and giving in marriage, until the day that Noah entered the ark,\n\n39 and did not know until the flood came and took them all away, so also will the coming of the Son of Man be.",
          ref: "Matthew 24:37-39",
        },
      ],
    },
    "13-14": {
      Supplements: {
        "-L7zN2zMkn-JpYswNIbV": {
          body: "Here is the passage in question.  Matthew 24:36:42.\n\n“But as the days of Noah were, so also will the coming of the Son of Man be. For as in the days before the flood, they were eating and drinking, marrying and giving in marriage, until the day that Noah entered the ark, and did not know until the flood came and took them all away, so also will the coming of the Son of Man be. Then two men will be in the field: one will be taken and the other left. Two women will be grinding at the mill: one will be taken and the other left. Watch therefore, for you do not know what hour your Lord is coming.”\n\nIt is important to note the context of the passage.  Matthew 24 contains the signs of Christ’s coming.  In this passage, Jesus refers to the flood in the time of Noah, at which time Noah and his family entered the ark.  Noah and his family were saved, while all others perished in the flood.\n\nThen Jesus explains that just as in Noah’s day, when there were two groups of people - the saved and the lost - there will likewise be two groups in the day when Jesus returns.  People in the same walks of life, with the same advantages and opportunities, will meet with differing fates.  Those who chose to accept Jesus will be saved.  Those who did not - but could have - will be lost.\n\nIn Noah’s day, those who were not on the ark were lost.  There were no second chances.  That is why Jesus says, “As the days of Noah were.”  As it was then, so it will be in Earth’s last day.  Those who have repented and given their hearts to Jesus will be saved.  It will be seen in that day that many could have surrendered to Christ but chose not to.  They will be lost.  No person will be left behind on the earth to have another chance at salvation after the second coming of Jesus.\n",
          title:
            "What does the Bible mean when it says that one will be taken and the other left?  Will some people be left behind when Jesus returns?",
        },
      },
      blanks: [
        {
          choices: [
            "here",
            "there",
            "here",
            "there",
            "present",
            "missing",
            "present",
            "missing",
            "taken",
            "left",
            "taken",
            "left",
          ],
          correctAnswer: "two",
          textAfter:
            "  men will be in the field: one will be taken and the other",
          textBefore: "Then ",
        },
        {
          choices: [
            "here",
            "there",
            "here",
            "there",
            "present",
            "missing",
            "present",
            "missing",
            "taken",
            "left",
            "taken",
            "left",
          ],
          correctAnswer: "left",
          textAfter: " .",
        },
        {
          choices: [
            "here",
            "there",
            "here",
            "there",
            "present",
            "missing",
            "present",
            "missing",
            "taken",
            "left",
            "taken",
            "left",
          ],
          correctAnswer: "taken",
          textAfter: " and the other left. ",
          textBefore: " Two women will be grinding at the mill: one will be",
        },
        {
          choices: [
            "here",
            "there",
            "here",
            "there",
            "present",
            "missing",
            "present",
            "missing",
            "taken",
            "left",
            "taken",
            "left",
          ],
          correctAnswer: "Watch",
          textAfter:
            " therefore, for you do not know what hour your Lord is coming.",
        },
      ],
      body: "Jesus helps us understand the meaning of this passage by comparing events at His return with what took place in the days of Noah. In Noah’s day, there were two groups of people: those who got on the ark and were saved, and those who did not get on the ark and were lost. \n\nJesus tells us that when He returns, circumstances on this planet will be as they were in Noah’s day. One group of people will be saved, and another will be lost. People in similar situations (“two men will be in the field”) and with similar opportunities (“two women will be grinding at the mill”)—will meet with different fates. One will be saved, while another will be lost.",
      choices: [
        "left",
        "here",
        "two",
        "present",
        "taken",
        "missing",
        "there",
        "Watch",
      ],
      lessonID: 13,
      question:
        "What did Jesus mean when He said that when He returns, one would be taken and another would be left?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "40 Then two men will be in the field: one will be taken and the other left. \n\n41 Two women will be grinding at the mill: one will be taken and the other left. \n\n42 Watch therefore, for you do not know what hour your Lord is coming.",
          ref: "Matthew 24:40-42",
        },
      ],
    },
    "13-15": {
      blanks: [
        {
          choices: ["not", "not", "please", "please", "instead", "instead"],
          correctAnswer: "Look",
          textAfter:
            " He is in the desert!” do not go out; or “Look, He is in the inner rooms!” do",
          textBefore: "If they say to you, “ ",
        },
        {
          choices: ["not", "maybe", "please", "never", "instead", "Look"],
          correctAnswer: "not",
          textAfter: " believe it.",
        },
      ],
      body: "Jesus specifically stated that we should not believe that His return will be a secret event. If someone were to claim that Jesus had returned and was in a location, we should likewise reject that claim. Jesus’ return will not be a secret. \n\nSome people teach that the return of Jesus is going to be a secret event - that He will first return for the saved believers, and then return some time later for those who have become ready after having been given a second chance. \n\nNowhere does the Bible talk of a secret Second Coming of Jesus, nor does it indicate that those who are not ready for the return of Jesus will be given another opportunity to be saved.",
      choices: ["not", "maybe", "please", "never", "instead", "Look"],
      lessonID: 13,
      question: "Is the return of Jesus going to be a secret?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore if they say to you, ‘Look, He is in the desert!’ do not go out; or ‘Look, He is in the inner rooms!’ do not believe it.",
          ref: "Matthew 24:26",
        },
      ],
    },
    "13-16": {
      Supplements: {
        "-L7zNohO1ZSaIcfvrbZN": {
          body: "The Bible makes clear Satan has power to work miracles.  While he does not have creative power, Satan has the ability to cause illness and physical suffering (see Job 2:6,7; Luke 13:16).  Revelation 16:14 states that the “spirits of devils, working miracles” go into the world in preparation for the battle of Armageddon.  Satan’s wonders and signs are also mentioned in Revelation 13:13,14 and Revelation 19:20.  \n\nMiracles of a spiritualistic nature will be performed to deceive people and lead them away from faith in Christ.  Jesus said Satan is a “liar, and the father of it” (John 8:44), and he uses his ability to deceive and confuse to destructive ends.  However, safety is found in following the word of God.  Isaiah 8:20 says, “To the law and to the testimony! If they do not speak according to this word, it is because there is no light in them.”  God wishes that people accept the Bible as the guide for their lives and as the authoritative rule of truth.  As Peter wrote, “if ye do these things, ye shall never fall.” 2 Peter 1:10.",
          title: "What are Satan’s power, signs and lying wonders?",
        },
      },
      blanks: [
        {
          choices: [
            "death",
            "miracles",
            "power",
            "tricks",
            "demons",
            "signs",
            "signs",
            "wonders",
          ],
          correctAnswer: "demons",
          textAfter: " , performing",
          textBefore: "They are spirits of",
        },
        {
          choices: [
            "death",
            "miracles",
            "power",
            "tricks",
            "demons",
            "signs",
            "signs",
            "wonders",
          ],
          correctAnswer: "signs",
          newline: [1],
          textAfter:
            " , which go out to the kings of the earth and of the whole world, to gather them to the battle of that great day of God Almighty.",
        },
        {
          choices: [
            "death",
            "miracles",
            "power",
            "tricks",
            "demons",
            "signs",
            "signs",
            "wonders",
          ],
          correctAnswer: "prophets",
          textAfter: " will rise and show great signs and",
          textBefore: " For false christs and false ",
        },
        {
          choices: [
            "death",
            "miracles",
            "power",
            "tricks",
            "demons",
            "signs",
            "signs",
            "wonders",
          ],
          correctAnswer: "wonders",
          textAfter: " to deceive, if possible, even the elect.",
        },
      ],
      body: "Before Jesus returns, Satan will work with great power to deceive as many people as he can. Paul wrote that Satan will work “with all power, signs, and lying wonders” (2 Thessalonians 2:9). \n\nRecognizing that he only has a short time left in which to deceive the world, Satan works miracles calculated to destroy the faith of God’s people.",
      choices: [
        "death",
        "signs",
        "miracles",
        "power",
        "wonders",
        "tricks",
        "demons",
        "prophets",
      ],
      lessonID: 13,
      question:
        "What does the Bible say will precede the Second Coming of Jesus?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "For they are spirits of demons, performing signs, which go out to the kings of the earth and of the whole world, to gather them to the battle of that great day of God Almighty.",
          ref: "Revelation 16:14",
        },
        {
          body: "For false christs and false prophets will rise and show great signs and wonders to deceive, if possible, even the elect.",
          ref: "Matthew 24:24",
        },
      ],
    },
    "13-17": {
      blanks: [
        {
          choices: ["still", "believe", "ready", "watch", "silent", "listen"],
          correctAnswer: "ready",
          textAfter: " . What I say to you, I say to all:",
          textBefore: "Therefore you also be",
        },
        {
          choices: ["still", "believe", "ready", "watch", "silent", "listen"],
          correctAnswer: "watch",
          textAfter: " !",
        },
      ],
      body: "Jesus urges us to be ready for His return. Because we cannot know exactly when the return of Jesus will be, it is vitally important that we live in a state of constant readiness for the Second Coming. Peter warned that “scoffers will come in the last days, walking according to their own lusts, and saying, ‘Where is the promise of His coming? For since the fathers fell asleep, all things continue as they were from the beginning of creation’” (2 Peter 3:3, 4). It is important to get ready for the Second Coming of Jesus, and stay ready!",
      choices: ["still", "believe", "watch", "silent", "ready", "listen"],
      lessonID: 13,
      question:
        "What urgent advice does Jesus give us in reference to His Second Coming?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore you also be ready, for the Son of Man is coming at an hour you do not expect.",
          ref: "Matthew 24:44",
        },
        {
          body: "And what I say to you, I say to all: Watch!",
          ref: "Mark 13:37",
        },
      ],
    },
    "13-18": {
      blanks: [
        {
          choices: [
            "Lean",
            "knows",
            "tone",
            "Trust",
            "recognizes",
            "sound",
            "Believe",
            "opens",
            "doors",
          ],
          correctAnswer: "Believe",
          newline: [1],
          textAfter: " on the Lord Jesus Christ, and you will be saved.",
        },
        {
          choices: [
            "Lean",
            "knows",
            "tone",
            "Trust",
            "recognizes",
            "sound",
            "Believe",
            "opens",
            "doors",
          ],
          correctAnswer: "opens",
          textAfter: " the",
          textBefore:
            " Behold, I stand at the door and knock. If anyone hears My voice and",
        },
        {
          choices: [
            "Lean",
            "knows",
            "tone",
            "Trust",
            "recognizes",
            "sound",
            "Believe",
            "opens",
            "doors",
          ],
          correctAnswer: "door",
          textAfter:
            " , I will come in to him and dine with him, and he with Me.",
        },
      ],
      body: "By accepting Jesus as your Lord and Savior, confessing your sins and living a life of surrender to God, you can have the assurance of everlasting life, and of being ready for Jesus at His return.",
      choices: [
        "Lean",
        "opens",
        "knows",
        "door",
        "Trust",
        "Believe",
        "recognizes",
      ],
      lessonID: 13,
      question:
        "How can a person be certain they will be ready to meet Jesus when He returns?",
      questionID: 18,
      questionType: "wordCloud",
      verses: [
        {
          body: "So they said, “Believe on the Lord Jesus Christ, and you will be saved, you and your household.”",
          ref: "Acts 16:31",
        },
        {
          body: "Behold, I stand at the door and knock. If anyone hears My voice and opens the door, I will come in to him and dine with him, and he with Me.",
          ref: "Revelation 3:20",
        },
      ],
    },
    "13-19": {
      correctAnswer: "true",
      question:
        "Are you willing to surrender your life to Jesus, invite Him into your heart and live by faith in Jesus in preparation for His return?",
      questionID: 19,
      questionType: "truthConfirmation",
    },
    "13-2": {
      blanks: [
        {
          choices: ["coming", "blessed", "love", "hope", "sweet", "great"],
          correctAnswer: "blessed",
          textAfter: " ",
          textBefore: "Looking for the",
        },
        {
          choices: ["blessed hope", "sweet coming", "great love"],
          correctAnswer: "hope",
          textAfter:
            " and glorious appearing of our great God and Savior Jesus Christ.",
        },
      ],
      body: "The Bible portrays the return of Jesus in the most hopeful terms. One day, the trials and disappointments of this world will be gone forever. Jesus’ return is truly the blessed hope of the world.",
      choices: ["coming", "blessed", "love", "hope", "sweet", "great"],
      lessonID: 13,
      question: "How does the Bible describe the return of Jesus?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "Looking for the blessed hope and glorious appearing of our great God and Savior Jesus Christ.",
          ref: "Titus 2:13",
        },
      ],
    },
    "13-3": {
      Supplements: {
        "-L7zLMtoywyOIHgc2-sK": {
          body: "Job 19:25 says, “For I know that my Redeemer lives, and He shall stand at last on the earth.”  Isaiah wrote in Isaiah 47:4, “As for our Redeemer, the Lord of hosts is His name, the Holy One of Israel.”  Similarly, Luke 24:21 says, “But we trusted that it had been he which should have redeemed Israel: and beside all this, to day is the third day since these things were done.”\n\nThe word redeem means “to buy back.”  Jesus redeemed the world through His death on the cross.  The Biblical concept of redemption held that the one doing the redeeming would be a close relative (or, a “near kinsman,” as in Ruth chapter three, KJV.)  Jesus, as a member of the human family, bought humanity back after it had been sold into sin.  ",
          title: "Why is Jesus referred to as “Redeemer”?",
        },
      },
      blanks: [
        {
          choices: ["peace", "know", "Jerusalem", "hear", "last", "see"],
          correctAnswer: "last",
          textAfter:
            " on the earth; and  after my skin is destroyed, this I know, that in my flesh I shall",
          textBefore: "I know that my Redeemer lives, and He shall stand at",
        },
        {
          choices: ["peace", "know", "Jerusalem", "hear", "last", "see"],
          correctAnswer: "see",
          textAfter: " God.",
        },
      ],
      body: "Job, in the first book of the Bible to be written, looked with hope toward the return of Jesus to this world. Every author in the New Testament mentions the Second Coming of Jesus, and Jesus Himself referred to His return numerous times. (Matthew 24:30 and Matthew 26:64 are two examples.)",
      choices: ["peace", "see", "know", "Jerusalem", "last", "hear"],
      lessonID: 13,
      question:
        "For how long have people been looking forward to the return of Jesus?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "25 For I know that my Redeemer lives, and He shall stand at last on the earth;\n\n26 And after my skin is destroyed, this I know, that in my flesh I shall see God.",
          ref: "Job 19:25, 26",
        },
      ],
    },
    "13-4": {
      Supplements: {
        "-L7zLYHpG-ss8D1CLaqU": {
          body: "The Bible refers to the “blessed hope” in Titus chapter 2.\n\n“Looking for the blessed hope and glorious appearing of our great God and Savior Jesus Christ. who gave Himself for us, that He might redeem us from every lawless deed and purify for Himself His own special people, zealous for good works.”  Titus 2:13,14.\n\nThis refers to the second coming of Jesus, when He will return to the Earth to gather up His waiting saints, resurrect the saved who sleep in death and take all of the redeemed to heaven.\n\nThe apostle Paul, who wrote the book of Titus, spent time in prison and many years living with persecution.  For the early Christians, the return of Jesus was truly a “blessed hope.”  Then, as now, it can be known that when Jesus returns to Earth there will be no more, sin, suffering, injustice, death or pain.  Truly, the hope of Jesus’ return is a blessed hope!",
          title: "What is the “blessed hope”?",
        },
      },
      blanks: [
        {
          choices: [
            "death",
            "sorrow",
            "crying",
            "pain",
            "pain",
            "sadness",
            "tears",
            "hope",
          ],
          correctAnswer: "death",
          textAfter: " , nor",
          textBefore:
            "God will wipe away every tear from their eyes; there shall be no more",
        },
        {
          choices: [
            "death",
            "sorrow",
            "crying",
            "pain",
            "pain",
            "sadness",
            "tears",
            "hope",
          ],
          correctAnswer: "sorrow",
          textAfter: " , nor",
        },
        {
          choices: [
            "death",
            "sorrow",
            "crying",
            "pain",
            "pain",
            "sadness",
            "tears",
            "hope",
          ],
          correctAnswer: "crying",
          textAfter: " . There shall be no more",
        },
        {
          choices: [
            "death",
            "sorrow",
            "crying",
            "pain",
            "pain",
            "sadness",
            "tears",
            "hope",
          ],
          correctAnswer: "pain",
          textAfter: " , for the former things have passed away.",
        },
      ],
      body: "The sin and sadness of life will all be banished when Jesus returns! The last funeral service will have been held, no longer will people get sick and die, and no more tears will be shed. Truly, the Second Coming of Jesus is the “blessed hope”!",
      choices: [
        "crying",
        "sadness",
        "tears",
        "sorrow",
        "hope",
        "death",
        "pain",
      ],
      lessonID: 13,
      question: "What great hope does the return of Jesus promise the world?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "And God will wipe away every tear from their eyes; there shall be no more death, nor sorrow, nor crying. There shall be no more pain, for the former things have passed away.",
          ref: "Revelation 21:4",
        },
      ],
    },
    "13-5": {
      blanks: [
        {
          choices: ["only God", "no christian", "no one"],
          correctAnswer: "no",
          textAfter: " ",
          textBefore: "Of that day and hour",
        },
        {
          choices: ["only God", "no christian", "no one"],
          correctAnswer: "one",
          textAfter:
            " knows, not even the angels of heaven, but My Father only.",
        },
      ],
      body: "Throughout the years, many people have predicted when Jesus would return to the earth—but they have all been wrong! No one knows the day or the hour of Jesus’ return.",
      choices: ["some", "one", "only", "christian", "no", "man"],
      lessonID: 13,
      question: "When will Jesus come back to this world?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "But of that day and hour no one knows, not even the angels of heaven, but My Father only.",
          ref: "Matthew 24:36",
        },
      ],
    },
    "13-6": {
      blanks: [
        {
          choices: ["end", "beginning", "doors", "coming"],
          correctAnswer: "doors",
          textAfter: " !",
          textBefore:
            "Learn this parable from the fig tree: When its branch has already become tender and puts forth leaves, you know that summer is near. So you also, when you see all these things, know that it is near—at the",
        },
      ],
      body: "While it isn’t possible to know exactly when Jesus is going to return to this planet, it is possible to know—based on the signs He gave—when His return is near. [See It Is Written Bible Study Guide #2, “Seeing the Signs.”]",
      choices: ["end", "beginning", "doors", "coming"],
      lessonID: 13,
      question: "Is it possible to know when Jesus’ return is near?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "32 Now learn this parable from the fig tree: When its branch has already become tender and puts forth leaves, you know that summer is near. \n\n33 So you also, when you see all these things, know that it is near—at the doors!",
          ref: "Matthew 24:32,33",
        },
      ],
    },
    "13-7": {
      blanks: [
        {
          choices: ["same", "come", "is", "return", "isn't", "leave"],
          correctAnswer: "same",
          textAfter: " Jesus, who was taken up from you into heaven, will so",
          textBefore:
            "While they looked steadfastly toward heaven as He went up, behold, two men stood by them in white apparel, who also said, “Men of Galilee, why do you stand gazing up into heaven? This",
        },
        {
          choices: ["same", "come", "is", "return", "isn't", "leave"],
          correctAnswer: "come",
          textAfter: " in like manner as you saw Him go into heaven.”",
        },
      ],
      body: "The return of Jesus will be a literal event. Jesus Himself will personally return to this world.",
      choices: ["is", "same", "return", "isn't", "come", "leave"],
      lessonID: 13,
      question: "What will Jesus’ return be like?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "10 And while they looked steadfastly toward heaven as He went up, behold, two men stood by them in white apparel, \n\n11 who also said, “Men of Galilee, why do you stand gazing up into heaven? This same Jesus, who was taken up from you into heaven, will so come in like manner as you saw Him go into heaven.",
          ref: "Acts 1:10, 11",
        },
      ],
    },
    "13-8": {
      blanks: [
        {
          choices: [
            "the",
            "see",
            "witness",
            "every",
            "see",
            "see",
            "no",
            "hear",
            "know",
          ],
          correctAnswer: "every",
          textAfter: " eye will",
          textBefore: "Behold, He is coming with clouds, and",
        },
        {
          choices: [
            "the",
            "see",
            "witness",
            "every",
            "see",
            "see",
            "no",
            "hear",
            "know",
          ],
          correctAnswer: "see",
          newline: [1],
          textAfter: " Him. ",
        },
        {
          choices: [
            "the",
            "see",
            "witness",
            "every",
            "see",
            "see",
            "no",
            "hear",
            "know",
          ],
          correctAnswer: "Son",
          textAfter:
            " of Man coming on the clouds of heaven with power and great glory.",
          textBefore:
            "Then the sign of the Son of Man will appear in heaven, and then all the tribes of the earth will mourn, and they will see the ",
        },
      ],
      body: "The return of Jesus will be a visible event. People all over the world will see Jesus return to the world.",
      choices: ["some", "see", "witness", "every", "no", "hear", "Son"],
      lessonID: 13,
      question: "Will the return of Jesus be witnessed by people on the earth?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "Behold, He is coming with clouds, and every eye will see Him, even they who pierced Him. And all the tribes of the earth will mourn because of Him. Even so, Amen.",
          ref: "Revelation 1:7",
        },
        {
          body: "Then the sign of the Son of Man will appear in heaven, and then all the tribes of the earth will mourn, and they will see the Son of Man coming on the clouds of heaven with power and great glory.",
          ref: "Matthew 24:30",
        },
      ],
    },
    "13-9": {
      blanks: [
        {
          choices: [
            "shout",
            "voice",
            "trumpet",
            "noise",
            "sound",
            "voice",
            "bang",
            "face",
            "sound",
          ],
          correctAnswer: "shout",
          textAfter: " , with the",
          textBefore: "For the Lord Himself will descend from heaven with a",
        },
        {
          choices: [
            "shout",
            "voice",
            "trumpet",
            "noise",
            "sound",
            "voice",
            "bang",
            "face",
            "sound",
          ],
          correctAnswer: "voice",
          textAfter: " of an archangel, and with the",
        },
        {
          choices: [
            "shout",
            "voice",
            "trumpet",
            "noise",
            "sound",
            "voice",
            "bang",
            "face",
            "sound",
          ],
          correctAnswer: "trumpet",
          textAfter: " of God. And the dead in Christ will rise first.",
        },
      ],
      body: "We can only imagine what it will sound like when Jesus returns to earth accompanied by the angels of heaven (Matthew 16:27). The Second Coming of Jesus will be an event that people will hear.",
      choices: ["noise", "voice", "shout", "bang", "trumpet", "sound"],
      lessonID: 13,
      question: "Will the return of Jesus be heard by people on earth?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "For the Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will rise first.",
          ref: "1 Thessalonians 4:16",
        },
      ],
    },
  },
  {
    "14-0": {
      body: "Students of American literature are familiar with Edgar Allan Poe’s famous fictional story, “The Fall of the House of Usher,” in which a woman is mistakenly buried alive by her twin brother, only to escape from her coffin and cause her brother’s death by the shock of seeing her again. Today, premature burial is extremely rare, at least in a physical sense. In a spiritual sense, however, it happens more often than we realize! Baptism is a ceremony described in the Bible as a symbol of conversion—the death of our sinful past as we rise to experience a new life of joy and victory in Jesus. Our former life of self-pleasing and rebellion against God is buried and left behind. Jesus made clear that it is important to know what the Bible says about baptism. And without understanding the true meaning of baptism, many people are being buried alive!",
      lessonID: 14,
      questionID: 0,
      type: "text",
    },
    "14-1": {
      Supplements: {
        "-L7zQ0nYKXYhtHjbDGR5": {
          body: "It is important to remember that anyone who goes to God in faith does so as a result of God’s drawing.  Jesus said in John 6:44, “No one can come to Me unless the Father who sent Me draws him.”  This indicates that God is at work in a person’s heart, even before that person has surrendered his or her life to Him.  This speaks of the immense goodness of God in drawing those who may be ignoring Him, or even living in opposition to Him.\n\nThe Bible says we are to accept Jesus by faith.  Ephesians 3:17 says, “That Christ may dwell in your hearts by faith.”  Ephesians 2:8 says people are saved “by grace, through faith.”\n\nHaving been miraculously freed from a prison cell, Paul and Silas were approached by the keeper of the prison, who asked, “Sirs, what must I do to be saved?”  He was told, “Believe on the Lord Jesus Christ, and you will be saved, you and your household.”  (Acts 16:30,31)  As Romans 10:9 says, “If you confess with your mouth the Lord Jesus and believe in your heart that God has raised Him from the dead, you will be saved.”\n\nWhen we are drawn to Jesus through the work of the Holy Spirit, we believe in His ability to forgive us and save us, and we surrender our lives to Him.  This happens by faith, as we trust that God is who the Bible says He is, and as we believe He will do what the Bible says He will do.  When we choose Jesus as our Savior and Lord and believe in Him as such, we have accepted Jesus into our lives.",
          title: "How does a person accept Jesus into his or her life?",
        },
      },
      blanks: [
        {
          choices: ["grace", "brought", "sin", "shown", "water", "baptized"],
          correctAnswer: "water",
          newline: [1],
          textAfter: " and the Spirit, he cannot enter the kingdom of God.",
          textBefore: "Unless one is born of",
        },
        {
          choices: ["grace", "brought", "sin", "shown", "water", "baptized"],
          correctAnswer: "baptized",
          textAfter: " into Christ have put on Christ.",
          textBefore: "For as many of you as were",
        },
      ],
      body: "According to Jesus, all Christians need to be baptized. Salvation comes through faith in Jesus Christ, and believers in Jesus publicly demonstrate that belief through baptism. Jesus clearly says that the practice of baptism, which is mentioned nearly 100 times in the Bible, is an integral part of the Christian experience.",
      choices: ["grace", "baptized", "brought", "sin", "water", "shown"],
      lessonID: 14,
      question: "How important is baptism?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: 'Jesus answered, “Most assuredly, I say to you, unless one is born of water and the Spirit, he cannot enter the kingdom of God".',
          ref: "John 3:5",
        },
        {
          body: "For as many of you as were baptized into Christ have put on Christ.",
          ref: "Galatians 3:27",
        },
      ],
    },
    "14-10": {
      choices: ["sin", "word", "poverty", "wealth", "water", "Spirit"],
      lessonID: 14,
      question: "How do you know if you are ready for baptism?",
      questionID: 10,
      questionType: "text",
      text: [
        "When you accept Jesus as your personal Savior (Acts 8:37; John 3:3,5) and experience the new birth, you:",
        "*Understand the teachings of Jesus. (Matthew 28:19,20)",
        "*Believe the teachings of Jesus. (Mark 16:16)",
        "*Have repented of past sins. (Acts 2:38)",
        "*Have agreed to turn away from sin. (Romans 6:5,6; Luke 3:7,8)",
        "Baptism is for those who have accepted Jesus and want to live together with Him.  It is an exciting yet very serious decision.  Jesus wants you to get to know Him and fully understand the commitment you are making.",
      ],
    },
    "14-11": {
      Supplements: {
        "-L7zVGNaP4T-EPxo0_CZ": {
          body: "The fruit of the Spirit is listed in Galatians 5:22,23. \n\n“But the fruit of the Spirit is love, joy, peace, long-suffering, kindness, goodness, faithfulness,\ngentleness, self-control.”\n\nWhen a person’s life is surrendered to Jesus and he or she is filled with the Holy Spirit, these Christ-like attributes will be seen in the life of the believer.  This is the transformation God promises each person who yields to Him by faith.\n\nAs Paul wrote in Romans 12:2, “Do not be conformed to this world, but be transformed by the renewing of your mind.”  Just as the fruit of an apple tree is apples, the fruit of a life surrendered to Jesus will be characterized by the attributes of Jesus.\n",
          title: "What is the fruit of the Spirit?",
        },
      },
      blanks: [
        {
          choices: ["sin", "word", "poverty", "wealth", "water", "Spirit"],
          correctAnswer: "water",
          textAfter: " and the",
          textBefore: "Unless one is born of",
        },
        {
          choices: ["sin", "word", "poverty", "wealth", "water", "Spirit"],
          correctAnswer: "Spirit",
          textAfter: " , he cannot enter the kingdom of God.",
        },
      ],
      body: "True water baptism is accompanied by the baptism of the Holy Spirit. To be baptized with the Holy Spirit means to be “fully immersed” in the Holy Spirit: receiving the Holy Spirit and allowing the Spirit to transform the life.\n\nThe role of the Holy Spirit is to convict of sin and to bestow the righteousness of Jesus as the solution for sin (John 16:8). It is also the Holy Spirit who helps us understand the teachings of God’s Word (John 16:13). \n\nThe baptism of the Holy Spirit is demonstrated through producing the fruit of the Spirit (Galatians 5:22, 23), as well as receiving the gifts of the Spirit. This enables us to effectively share the good news about God’s love (1 Corinthians 12:3–7).",
      choices: ["sin", "word", "Spirit", "poverty", "water", "wealth"],
      lessonID: 14,
      question: "What accompanies water baptism?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "Jesus answered, “Most assuredly, I say to you, unless one is born of water and the Spirit, he cannot enter the kingdom of God.",
          ref: "John 3:5",
        },
      ],
    },
    "14-12": {
      blanks: [
        {
          choices: [
            "baptized",
            "church",
            "church",
            "body",
            "saved",
            "multitudes",
            "mind",
            "spirit",
          ],
          correctAnswer: "baptized",
          textAfter:
            " ; and that day about three thousand souls were added to them . . . And the Lord added to the",
          textBefore: "Then those who gladly received his word were",
        },
        {
          choices: [
            "baptized",
            "church",
            "church",
            "body",
            "saved",
            "multitudes",
            "mind",
            "spirit",
          ],
          correctAnswer: "church",
          newline: [1],
          textAfter:
            " daily those who were being saved. He is the head of the body, the church...",
        },
        {
          choices: [
            "baptized",
            "church",
            "church",
            "body",
            "saved",
            "multitudes",
            "mind",
            "spirit",
          ],
          correctAnswer: "body",
          textAfter: " .",
          textBefore: "By one Spirit we were all baptized into one",
        },
      ],
      body: "When we are baptized into Jesus, we automatically become part of His body, the church. The church is God’s chosen body of people who help nurture us in our spiritual life as well as work with us in the spreading of the gospel. When we make a decision for baptism, we are also making a commitment to become an active member of God’s church.",
      choices: [
        "church",
        "saved",
        "body",
        "multitudes",
        "baptized",
        "mind",
        "spirit",
      ],
      lessonID: 14,
      question: "Does baptism have anything to do with joining a church?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "41 Then those who gladly received his word were baptized; and that day about three thousand souls were added to them.\n\n47 praising God and having favor with all the people. And the Lord added to the church daily those who were being saved.\n",
          ref: "Acts 2:41, 47",
        },
        {
          body: "And He is the head of the body, the church, who is the beginning, the firstborn from the dead, that in all things He may have the preeminence.",
          ref: "Colossians 1:18",
        },
        {
          body: "For by one Spirit we were all baptized into one body—whether Jews or Greeks, whether slaves or free—and have all been made to drink into one Spirit.",
          ref: "1 Corinthians 12:13",
        },
      ],
    },
    "14-13": {
      blanks: [
        {
          choices: ["saw", "amazed", "heard", "baptized", "noticed", "pleased"],
          correctAnswer: "heard",
          textAfter: " this, they were",
          textBefore:
            "They said to him, “We have not so much as heard whether there is a Holy Spirit.” And he said to them, “Into what then were you baptized?” So they said, “Into John’s baptism.” Then Paul said, “John indeed baptized with a baptism of repentance, saying to the people that they should believe on Him who would come  after him, that is, on Christ Jesus.” When they",
        },
        {
          choices: ["saw", "amazed", "heard", "baptized", "noticed", "pleased"],
          correctAnswer: "baptized",
          textAfter: " in the name of the Lord Jesus.",
        },
      ],
      body: "Although baptism is ideally a once-only experience, there are instances when rebaptism is not only appropriate but recommended. \n\nWhen substantial new truth is discovered\nWhen Paul was preaching at Ephesus, he found a group of people who had been baptized by John the Baptist, but had never heard of the Holy Spirit. Paul took these people aside and taught them about the work and the power of the Holy Spirit. This truth had such an impact in their lives that they chose to be rebaptized. This example clearly shows that when significant new life-changing truths are learned, rebaptism is appropriate. \n\nIf you desire to return to Jesus after turning away from Him\nBaptism is your marriage ceremony with Jesus. If you have left Jesus and abandoned this relationship, it is also appropriate to be rebaptized. A “fresh start” in your relationship with Jesus results as you once again pledge your love and loyalty to Him.",
      choices: ["saw", "amazed", "baptized", "noticed", "heard", "pleased"],
      lessonID: 14,
      question: "Is rebaptism ever appropriate?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "2 He said to them, “Did you receive the Holy Spirit when you believed?” So they said to him, “We have not so much as heard whether there is a Holy Spirit.”\n\n3 And he said to them, “Into what then were you baptized?” So they said, “Into John’s baptism.”\n\n4 Then Paul said, “John indeed baptized with a baptism of repentance, saying to the people that they should believe on Him who would come after him, that is, on Christ Jesus.”\n\n5 When they heard this, they were baptized in the name of the Lord Jesus.",
          ref: "Acts 19:2-5",
        },
      ],
    },
    "14-14": {
      blanks: [
        {
          choices: [
            "sleeping",
            "wake",
            "joyful",
            "sitting",
            "stand",
            "",
            "waiting",
            "Arise",
            "baptized",
          ],
          correctAnswer: "waiting",
          textAfter: " ?",
          textBefore: "Why are you",
        },
        {
          choices: [
            "sleeping",
            "wake",
            "joyful",
            "sitting",
            "stand",
            "",
            "waiting",
            "Arise",
            "baptized",
          ],
          correctAnswer: "Arise",
          textAfter: " and be",
        },
        {
          choices: [
            "sleeping",
            "wake",
            "joyful",
            "sitting",
            "stand",
            "",
            "waiting",
            "Arise",
            "baptized",
          ],
          correctAnswer: "baptized",
          textAfter: " .",
        },
      ],
      body: "One of the most effective tactics of the devil is causing people to procrastinate—to put off making a decision. The Bible says, “Why are you waiting?” \n\nDon’t put off baptism until you think you are “good enough.” Don’t wait until you feel “clean.” Don’t wait for the approval of others. The Bible says, “Arise and be baptized.” \n\nDon’t delay—make plans today for a fresh start in life through baptism.",
      choices: [
        "sleeping",
        "Arise",
        "wake",
        "baptized",
        "joyful",
        "sitting",
        "waiting",
      ],
      lessonID: 14,
      question:
        "When the Apostle Paul was tempted to put off his baptism for a later time, what advice did he receive?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "And now why are you waiting? Arise and be baptized, and wash away your sins, calling on the name of the Lord.",
          ref: "Acts 22:16",
        },
      ],
    },
    "14-15": {
      blanks: [
        {
          choices: [
            "very proud",
            "riches",
            "well pleased",
            "joy",
            "quite tickled",
            "peace",
          ],
          correctAnswer: "well",
          textAfter: " ",
          textBefore:
            "A voice came from heaven, “You are My beloved Son, in whom I am ",
        },
        {
          choices: [
            "very proud",
            "riches",
            "well pleased",
            "joy",
            "quite tickled",
            "peace",
          ],
          correctAnswer: "pleased",
          newline: [1],
          textAfter: " ",
        },
        {
          choices: [
            "very proud",
            "riches",
            "well pleased",
            "joy",
            "quite tickled",
            "peace",
          ],
          correctAnswer: "joy",
          textAfter:
            " in heaven over one sinner who repents than over ninety-nine just persons who need no repentance.",
          textBefore: "I say to you that likewise there will be more ",
        },
      ],
      body: "When Jesus was baptized, God voiced His approval from heaven! \n\nAll of heaven rejoices when a person is baptized!\n\nThree points to remember:\n1) Baptism is one of the most significant aspects of the Christian life.\n2) Only baptism by full immersion of a believing person is biblical and reflects the meaning behind the symbolism of baptism.\n3) Baptism is the entry point into God's church.",
      choices: [
        "very",
        "proud",
        "riches",
        "well",
        "pleased",
        "joy",
        "quite",
        "tickled",
        "peace",
      ],
      lessonID: 14,
      question: "How does God feel when a person is baptized?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then a voice came from heaven, “You are My beloved Son, in whom I am well pleased.”",
          ref: "Mark 1:11",
        },
        {
          body: "I say to you that likewise there will be more joy in heaven over one sinner who repents than over ninety-nine just persons who need no repentance.",
          ref: "Luke 15:7",
        },
      ],
    },
    "14-16": {
      correctAnswer: "true",
      question:
        "Is it your desire to follow the example of Jesus, have a fresh start in life and begin preparing for your baptism according to the Bible?",
      questionID: 16,
      questionType: "truthConfirmation",
    },
    "14-2": {
      Supplements: {
        "-L7zWINd-YruX2X9VlfH": {
          body: "Jesus was very clear that “of that day and hour no one knows, not even the angels of heaven, but My Father only” (Matthew 24:36.)  However, although we can not know when Jesus is going to return, we have been told by Jesus to be ready for His return whenever it may be (Matthew 24:44.)  While God has not revealed to any human being when Jesus will return, Jesus has urged us to “occupy” until He returns (Luke 19:11.)  This means we should be about God’s business, we should be doing God’s work until Jesus returns, whenever that is.\n\nPeople occasionally rise up to announce the day of Jesus’ return.  Every prediction made concerning the return of Jesus on a certain date is a false prediction.  Some Bible commentators will make claims such as, “I’m not saying it will happen on this date, but…”  Every such statement should be ignored.  Jesus was clear: no one knows the day or hour of His return.\n\nTherefore, people should live in a state of constant readiness for the return of Jesus.  This readiness is attained through surrendering the heart to Him.  See 1 John 5:12.",
          title: "When is Jesus going to return to the Earth?",
        },
      },
      blanks: [
        {
          choices: ["baptizing", "loving", "teaching"],
          correctAnswer: "baptizing",
          textAfter:
            " them in the name of the Father and of the Son and of the Holy Spirit.",
          textBefore: "Go therefore and make disciples of all the nations,",
        },
      ],
      body: "The last words a person speaks are often significant. In some of His last words to His disciples, Jesus shared His vision for the new Christian church. The leaders of this church were commissioned to share the gospel all over the world, encouraging people to accept Jesus and be baptized.",
      choices: ["introducing", "taking", "baptizing", "loving", "teaching"],
      lessonID: 14,
      question:
        "What was one of the last instructions that Jesus gave to His disciples?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "Go therefore and make disciples of all the nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit.",
          ref: "Matthew 28:19",
        },
      ],
    },
    "14-3": {
      blanks: [
        {
          choices: ["love", "mind", "baptism"],
          correctAnswer: "baptism",
          textAfter: " .",
          textBefore: "One Lord, one faith, one",
        },
      ],
      body: "The one true baptism of the Bible is baptism in water, by full immersion. \n\nThe word “baptize” literally means “to immerse” or “to submerge.” It comes from the Greek word baptizo. Therefore, another word for baptism would simply be “immersion.” The Bible never uses the words “sprinkle” or “pour” in reference to baptism.",
      choices: ["church", "mind", "baptism", "nation", "congregation"],
      correctAnswer: "false",
      lessonID: 14,
      question: "How many methods of baptism are recommended in the Bible?",
      questionID: 3,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "There are many recommended types of baptism according to the Bible.",
      verses: [
        {
          body: "One Lord, one faith, one baptism.",
          ref: "Ephesians 4:5",
        },
      ],
    },
    "14-4": {
      Supplements: {
        "-L7zVgl75WzV0s2HfNCy": {
          body: "John the Baptist’s mother was related to Mary, the mother of Jesus (Luke 1:36).  Isaiah 40:3 had predicted one would come who would announce the birth of the Messiah, and John was the one of whom the prophet spoke.  He lived a life of self-denial, and called people to repentance towards God (Matthew 3:8).  He baptized Jesus in the Jordan River (Matthew 3:13-17), and rebuked Herod for Herod’s adulterous behavior (Luke 3:19).  He was subsequently imprisoned, and was executed after the daughter of Herod’s mistress was instructed by her mother to request the head of John the Baptist (Mark 6:19-29).",
          title: "Who was John the Baptist?",
        },
        "-L82fw9Us5zfN5j8OVsP": {
          body: "John the Baptist dwelled in the wilderness (Matthew 3:3), and because baptism required immersion, a river would provide John with all the water he would need to baptize without inconvenience.  \n\n\nThe Jordan River was very significant in the history of Israel.  It marked the border of the Promised Land; it stopped flowing when Joshua and others carried the Ark of the Covenant across the Jordan into Canaan (Joshua 3:13-15); Namaan was healed of leprosy in the Jordan (2 Kings 5:10-14); an axe head floated on the surface of the Jordan (2 Kings 6:5-7); the waters of the Jordan parted so Elisha and Elijah could cross on dry ground (2 Kings 2:8-14).\n\nIt is perhaps because God’s dealings with Israel frequently centered around the Jordan River that this river held special significance as a baptism site.",
          title: "Why did John the Baptist baptize in the Jordan River?",
        },
      },
      blanks: [
        {
          choices: ["down to", "up from", "over beside"],
          correctAnswer: "up",
          textAfter: " ",
          textBefore:
            "It came to pass in those days that Jesus came from Nazareth of Galilee, and was baptized by John in the Jordan. And immediately, coming",
        },
        {
          choices: ["down to", "up from", "over beside"],
          correctAnswer: "from",
          textAfter:
            " the water, He saw the heavens parting and the Spirit descending upon Him like a dove.",
        },
      ],
      body: "Jesus went “in” the Jordan River and then came “up from” the water. John the Baptist specifically chose to baptize people in the Jordan “because there was much water there” (John 3:23). Jesus was baptized in water by full immersion.\n\nIn John 1:29–34, John identifies Jesus as the Messiah (compare with Matthew 3:11). The baptism of Jesus was a fulfillment of prophecy. It was a very important event!",
      choices: ["over", "from", "to", "up", "beside"],
      lessonID: 14,
      question: "How was Jesus baptized?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "9 It came to pass in those days that Jesus came from Nazareth of Galilee, and was baptized by John in the Jordan.\n\n10 And immediately, coming up from the water, He saw the heavens parting and the Spirit descending upon Him like a dove.",
          ref: "Mark 1:9, 10",
        },
      ],
    },
    "14-5": {
      Supplements: {
        "-L82fFrp4a4zXdHm4Auc": {
          body: 'The original practice of the Christian church was to baptize by immersion.  It was fear of babies and young children dying and losing eternal life that first brought infant baptism into the early church.  \n\nThe first clear reference to infant baptism was written by an early church writer named Tertullian, who wrote around 200 AD - and he was against it.  Not long after, Origen, the famous teacher from Alexandria, wrote that “Infants are baptized for the forgiveness of sins". According to the historian, Adolph Harnack, Origen believed that sins could be committed in a former life, necessitating infant baptism for forgiveness of sins. Origen also claimed that “the church had from the apostles a tradition to give baptism even to infants".  Of course he gave no evidence for those claims from the Bible, because there is none.\n\nThere is evidence that infant baptism became common in the region of Carthage in North Africa between 250 AD and early in the 5th Century.  Cyprian, the bishop of Carthage from 249-258 AD, decided baptism should be carried out as soon as a baby is born. There were 66 bishops of North Africa present when he made that decision and there is no record a single one of them objected.  Augustine, also a bishop in North Africa, wrote several times in favor of infant baptism.  In about 400 AD, Augustine said that an infant who dies before being baptized cannot “obtain remission of original sin", that they could “not possibly be vivified in Christ".  In other words, he said, without baptism a baby who dies is lost.  And the Sixteenth Council of Carthage in 418 AD decreed, “If any man says that newborn children need not be baptized…let him be anathema", or, damned forever.\n\nThe writings of early church leaders up to 500 AD make it clear that baptism by immersion was the norm throughout Christendom.  Even in the Middle Ages, the renowned Roman Catholic theologian Thomas Aquinas, who allowed for sprinkling, wrote that “the safer way to baptize” was “by immersion, because that is the most common custom".  Sprinkling first came into common use in France, then in the German regions, including Austria and part of Switzerland.  Historians tell us that some groups such as the Albigenses, and the Waldensians opposed the practice in the Middle Ages, but as a result they faced severe persecution.  Baptism by sprinkling wasn’t practiced in Scotland until around 1550 AD.  It wasn’t until the Protestant Reformation that baptism by immersion became more widespread.\n\nThe late Cardinal Gibbons wrote in his book Faith of our Fathers, “For several centuries after the establishment of Christianity, Baptism was usually conferred by immersion; but since the twelfth century the practice of baptizing by infusion has prevailed in the Catholic Church, as this manner is attended with less inconvenience than Baptism by immersion".  ',
          title: "Why do some believers pour water or sprinkle for baptism?",
        },
      },
      blanks: [
        {
          choices: [
            "and drank",
            "sharing some",
            "",
            "down into",
            "up out",
            "to sip",
            "out terrified",
          ],
          correctAnswer: "down",
          textAfter: " ",
          textBefore: "Both Philip and the eunuch went",
        },
        {
          choices: [
            "and drank",
            "sharing some",
            "",
            "down into",
            "up out",
            "to sip",
            "out terrified",
          ],
          correctAnswer: "into",
          textAfter: " the water, and he baptized him. Now when they came",
        },
        {
          choices: [
            "and drank",
            "sharing some",
            "",
            "down into",
            "up out",
            "to sip",
            "out terrified",
          ],
          correctAnswer: "up",
        },
        {
          choices: [
            "and drank",
            "sharing some",
            "",
            "down into",
            "up out",
            "to sip",
            "out terrified",
          ],
          correctAnswer: "out",
          textAfter:
            " of the water, the Spirit of the Lord caught Philip away, so that the eunuch saw him no more; and he went on his way rejoicing.",
        },
      ],
      body: "It is clear from this passage that the apostles did not change the method of baptism. Here we find Philip and the Ethiopian man going down into the water, and then coming back up out of the water. The baptism was conducted by full immersion, according to the example of Jesus.",
      choices: ["out", "into", "over", "down", "through", "up"],
      lessonID: 14,
      question: "Are there other clear examples of baptism in the Bible?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "38 So he commanded the chariot to stand still. And both Philip and the eunuch went down into the water, and he baptized him.\n\n39 Now when they came up out of the water, the Spirit of the Lord caught Philip away, so that the eunuch saw him no more; and he went on his way rejoicing.",
          ref: "Acts 8:38, 39",
        },
      ],
    },
    "14-6": {
      blanks: [
        {
          choices: ["wash", "shove", "give"],
          correctAnswer: "wash",
          textAfter: " away your sins, calling on the name of the Lord.",
          textBefore: "Arise and be baptized, and",
        },
      ],
      body: "The symbol of water is used to represent spiritual cleansing. It symbolizes purity and a fresh start. The Bible says, “all have sinned and fall short of the glory of God” (Romans 3:23). Everyone is in need of the new start baptism provides.\n\nOf course, there is no power in the water itself to wash away our sins. It is purely symbolic of the work God does in our lives.",
      choices: ["take", "wash", "shove", "work", "give"],
      lessonID: 14,
      question: "What does the symbol of water represent?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "And now why are you waiting? Arise and be baptized, and wash away your sins, calling on the name of the Lord.",
          ref: "Acts 22:16",
        },
      ],
    },
    "14-7": {
      blanks: [
        {
          choices: [
            "born",
            "life",
            "brought",
            "buried",
            "death",
            "raised",
            "conceived",
            "existence",
            "delivered",
          ],
          correctAnswer: "buried",
          textAfter: " with Him through baptism into",
          textBefore: "We were",
        },
        {
          choices: [
            "born",
            "life",
            "brought",
            "buried",
            "death",
            "raised",
            "conceived",
            "existence",
            "delivered",
          ],
          correctAnswer: "death",
          textAfter: " , that just as Christ was",
        },
        {
          choices: [
            "born",
            "life",
            "brought",
            "buried",
            "death",
            "raised",
            "conceived",
            "existence",
            "delivered",
          ],
          correctAnswer: "raised",
          textAfter:
            " from the dead by the glory of the Father, even so we also should walk in newness of life.",
        },
      ],
      body: "Baptism symbolizes the washing away of the old life of sin and the beginning of a new life in Jesus Christ. Baptism is the sign by which believers experience Christ’s death, burial and resurrection in their lives — through death to self and rebirth to a new life.  Just as Jesus died, was buried and then was resurrected, so the new Christian dies to the old life of sin, is buried beneath the water in baptism and then rises with a new life empowered by the Holy Spirit. \n\nThis symbolism is at the heart of the meaning and importance of baptism. The person who is baptized first chooses to lay down the life of sin, is buried in the waters of baptism and is raised up out of the water to live a new life in Jesus.",
      choices: [
        "death",
        "born",
        "life",
        "raised",
        "conceived",
        "buried",
        "delivered",
      ],
      lessonID: 14,
      question: "What does the practice of baptism itself symbolize?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore we were buried with Him through baptism into death, that just as Christ was raised from the dead by the glory of the Father, even so we also should walk in newness of life.",
          ref: "Romans 6:4",
        },
      ],
    },
    "14-8": {
      blanks: [
        {
          choices: ["sat", "thrones", "lived", "faith", "put", "Christ"],
          correctAnswer: "put",
          textAfter: " on",
          textBefore: "As many of you as were baptized into Christ have",
        },
        {
          choices: ["sat", "thrones", "lived", "faith", "put", "Christ"],
          correctAnswer: "Christ",
          textAfter: " .",
        },
      ],
      body: "Paul wrote that when a person is baptized, that person has “put on Christ.” Our old identity is swallowed up in a new identity—that of being one with Jesus Christ.",
      choices: ["Christ", "sat", "life", "lived", "put", "faith"],
      lessonID: 14,
      question: "Whose name do people take when they are baptized?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "For as many of you as were baptized into Christ have put on Christ.",
          ref: "Galatians 3:27",
        },
      ],
    },
    "14-9": {
      Supplements: {
        "-L7zWhG6ij7Q0JLY5Pxw": {
          body: "In mercy, Jesus waits.  The longer Jesus waits, the more time we have to be ready and to encourage us to be ready for His return and eternal life.\n\nAdditionally, it is important that the as-yet unfulfilled Bible prophecies are fulfilled, and that the gospel goes to all the world (see Matthew 24:14; Revelation 14:6.)\n\nAlthough we do not know when Jesus will return, every person alive is given a life in which to choose Jesus in preparation for eternity.  Jesus’ return could happen very suddenly, inasmuch as we are separated from death by nothing more than our next heartbeat.  Life is very fragile.  Even if Jesus were not to return for many years, people would continue to pass off the earth every day.  After death, there is no more opportunity to be made right with God.  \n\nGod wants you to be with Him for eternity.  He is willing that “that all should come to repentance” (2 Peter 3:9.)  Be sure you use your God-given opportunities to “make your calling and election sure.”  (2 Peter 1:10)",
          title: "Why has Jesus taken so long to return?",
        },
      },
      blanks: [
        {
          choices: ["honest", "baptized", "forgiven"],
          correctAnswer: "baptized",
          textAfter: " will be saved.",
          textBefore: "He who believes and is",
        },
      ],
      body: "While baptism itself does not secure the gift of salvation—salvation comes by grace through faith in Jesus Christ—baptism is a vital part of the Christian experience.\n\nIf the form of baptism is incorrect, the symbolism—and therefore the meaning—of baptism is radically changed. Baptism means death to the old life, and resurrection to a new life in Jesus. Only baptism by immersion can signify that spiritual reality.",
      choices: ["honest", "taught", "baptized", "mature", "forgiven"],
      lessonID: 14,
      question: "Does it really matter which form of baptism is used?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "He who believes and is baptized will be saved; but he who does not believe will be condemned.",
          ref: "Mark 16:16",
        },
      ],
    },
  },
  {
    "15-0": {
      body: "Quoting the Danish Twin Study, Dan Buettner, author of The Blue Zones, stated that “only about 10 percent of how long the average person lives, within certain biological limits, is dictated by our genes. The other 90 percent is dictated by our lifestyle.” Evidently, people have a great ability to affect—positively or negatively—how long they live! But God’s plan isn’t just that we live long lives on this earth. He wants us to live eternally. What does the Bible say concerning our physical health? And is there any connection between physical and spiritual health? The Bible contains the keys to a happy, healthy—and very long—life.",
      lessonID: 15,
      questionID: 0,
      type: "text",
    },
    "15-1": {
      Supplements: {
        "-L7zYbR62d7Osg45-8RB": {
          body: "When John expresses his desire that we “be in health”, he uses the Greek word, hugiainō. It means, “to be sound”, not just physically, but also in faith. God is keenly interested in our physical well-being for several reasons. He certainly doesn’t want his children suffering from the maladies that afflict this fallen world, but He also knows that we are spiritual as well as physical beings. Often when we feel sick, it is hard to be the witness He wants us to be to the rest of the world, to enjoy life as we otherwise might or to reach our potential.  And conversely, when we separate ourselves from God spiritually and fill our lives with self-destructive habits, our physical health suffers as well. \n\nGod wants the best for us. And, if we’re willing, He has a prescription to offer us for the best health possible. ",
          title: "What does it mean to “be in health”? ",
        },
      },
      blanks: [
        {
          choices: ["peace", "love", "Christ", "health"],
          correctAnswer: "health",
          textAfter: " , just as your soul prospers.",
          textBefore:
            "Beloved, I pray that you may prosper in all things and be in",
        },
      ],
      body: "The subject of health is one of the most important subjects of the Bible. The Apostle John wished for his friends to prosper both physically and spiritually. Whatever affects the health of the body will affect the whole person. This includes the way we feel, think and interact in our relationships. When you care for your body physically, your mind will also do better. A clear, sharp mind is more easily connected with God, providing a platform for true health and happiness.",
      choices: ["peace", "love", "Christ", "health"],
      lessonID: 15,
      question: "How important is our health?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "Beloved, I pray that you may prosper in all things and be in health, just as your soul prospers.",
          ref: "3 John 2",
        },
      ],
    },
    "15-10": {
      blanks: [
        {
          choices: ["never", "hungry", "not", "eaten", "today", "free"],
          correctAnswer: "not",
          textAfter: " be",
          textBefore:
            "These you shall regard as an abomination among the birds; they shall",
        },
        {
          choices: ["never", "hungry", "not", "eaten", "today", "free"],
          correctAnswer: "eaten",
          textAfter:
            " , they are an abomination: the eagle, the vulture, the buzzard . . .",
        },
      ],
      body: "Birds of prey and birds that feed on carrion (the  flesh of dead animals) are declared by God to be unclean. While chickens and turkeys are clean birds, eagles, vultures and other similar birds are declared by God to be unclean.\n",
      choices: ["never", "hungry", "not", "eaten", "today", "free"],
      lessonID: 15,
      question: "What instruction did God give with regard to eating birds?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "‘And these you shall regard as an abomination among the birds; they shall not be eaten, they are an abomination: the eagle, the vulture, the buzzard,...",
          ref: "Leviticus 11:13",
        },
      ],
    },
    "15-11": {
      blanks: [
        {
          choices: [
            "a fool",
            "crouches",
            "tiger",
            "stings",
            "bee",
            "not wise",
            "bites",
            "serpent",
            "stings",
            "viper",
          ],
          correctAnswer: "wise",
          newline: [1],
          textAfter: "",
          textBefore:
            "Wine is a mocker, strong drink is a brawler, and whoever is led astray by it is not",
        },
        {
          choices: [
            "a fool",
            "crouches",
            "tiger",
            "stings",
            "bee",
            "not wise",
            "bites",
            "serpent",
            "stings",
            "viper",
          ],
          correctAnswer: "bites",
          textBefore:
            " Do not look on the wine when it is red, when it sparkles in the cup, when it swirls around smoothly; at the last it",
        },
        {
          choices: [
            "a fool",
            "crouches",
            "tiger",
            "stings",
            "bee",
            "not wise",
            "bites",
            "serpent",
            "stings",
            "viper",
          ],
          correctAnswer: "serpent",
          textBefore: " like a",
        },
        {
          choices: [
            "a fool",
            "crouches",
            "tiger",
            "stings",
            "bee",
            "not wise",
            "bites",
            "serpent",
            "stings",
            "viper",
          ],
          correctAnswer: "stings",
          textBefore: " , and",
        },
        {
          choices: [
            "a fool",
            "crouches",
            "tiger",
            "stings",
            "bee",
            "not wise",
            "bites",
            "serpent",
            "stings",
            "viper",
          ],
          correctAnswer: "viper",
          textAfter:
            " . Your eyes will see strange things, and your heart will utter perverse things.\n",
          textBefore: " like a",
        },
      ],
      body: "\nThe Bible speaks very clearly about the dangers of alcohol use. While it is true that many people in the Bible drank alcohol, the Bible never portrays such alcohol use in a positive light. Bible  figures also practiced bigamy and owned slaves, yet such  flawed behavior cannot be used to justify similar practices today.\n",
      choices: [
        "fool",
        "crouches",
        "tiger",
        "stings",
        "not",
        "wise",
        "bites",
        "serpent",
        "stings",
        "viper",
      ],
      lessonID: 15,
      question: "Does God speak in favor of consuming alcohol?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "Wine is a mocker, Strong drink is a brawler, And whoever is led astray by it is not wise.",
          ref: "Proverbs 20:1",
        },
        {
          body: "Do not look on the wine when it is red, When it sparkles in the cup, When it swirls around smoothly; 32 At the last it bites like a serpent,  And stings like a viper. 33 Your eyes will see strange things, And your heart will utter perverse things",
          ref: "Proverbs 23:31-33",
        },
      ],
    },
    "15-12": {
      blanks: [
        {
          choices: ["bush", "tree", "cluster"],
          correctAnswer: "cluster",
          textAfter:
            " , and one says, “Do not destroy it, for a blessing is in it,” so will I do for My servants’ sake, that I may not destroy them all.",
          textBefore: "As the new wine is found in the",
        },
      ],
      body: "The “wine” God permits His people to drink is that which is found “in the cluster”—the unfermented juice of the grape. While some people point to Jesus turning water into “wine” at the wedding feast at Cana (John 2:1–11) as justification for drinking alcohol, there is nothing in the story that suggests Jesus created alcohol rather than grape juice. It would be clearly inconsistent for Jesus to inspire Bible writers to speak strongly against alcohol use, and then create many gallons of alcohol to be consumed at the end of a wedding feast!",
      choices: ["bush", "tree", "cluster"],
      lessonID: 15,
      question: "What “wine” does God recommend people freely consume?",
      questionID: 12,
      questionType: "radio",
      verses: [
        {
          body: "Thus says the Lord: “As the new wine is found in the cluster, And one says, ‘Do not destroy it, For a blessing is in it, ’So will I do for My servants’ sake, That I may not destroy them all.",
          ref: "Isaiah 65:8",
        },
      ],
    },
    "15-13": {
      Supplements: {
        "-L7za5dGEJQx3aivBxOL": {
          body: "The first step in overcoming destructive habits is to identify them, and there is no better source for separating the bad from the good than the Bible.\n\nOnce the destructive lifestyle habit has been identified, a person can go through a biblical, 5-step plan to help them achieve victory.\n\nStep 1 - Recognize victory over sin is a free gift, offered to you by Jesus Christ. He wants to give you the victory.  All a person needs to do is accept that victory from him just as easily as you would accept a gift from your best friend on your birthday (see 1 Corinthians 15:57).\n\nStep 2 - Ask in faith for victory over that specific sin or bad habit in your life. If you want victory, you have to ask for it (and mean it!) As the old adage goes, “Be careful what you ask for, because you just might get it.” If you truly want victory over a sin or bad habit in your life, you will want that victory immediately, not after you finish your last pack of cigarettes or the last bottle of wine in your cellar (see Matthew 7:11).\n\nStep 3 - Believe that because you have asked God for victory over a specific sin, He has given you the victory and you are now victorious. Belief (or faith) gave the apostle Peter the ability to walk on water when he didn’t believe it was humanly possible. Belief gave sight to the blind, mobility to the disabled and hearing to the deaf. If you believe God has granted you victory, then you too will be victorious (see Romans 6:11)!\n\nStep 4 - Decide that by God’s grace you will not make provision to fail. Get rid of the things that you associate with that destructive habit. Throw out your cigarettes, empty the bottles of alcohol, dispose of the drugs, delete the inappropriate files from your computer…  Do whatever it takes to physically put the destructive habit out of your life (see Romans 13:14).\n\nStep 5 - Finally, “watch and pray” each day that you will not “enter into temptation”.  If you study your Bible and pray, it will close a thousand doors to temptation. Spend time immersed in God’s word and commune with Him in prayer. You will find a strength and resolve in Jesus that you never experienced in your own will before (Matthew 26:41).\n\nFinally, remember these two powerful promises from the Word of God.\n\nPhilippians 4:13 - I can do all things through Christ who strengthens me.\n\n1 Corinthians 10:13 - No temptation has overtaken you except such as is common to man; but God is faithful, who will not allow you to be tempted beyond what you are able, but with the temptation will also make the way of escape, that you may be able to bear it.",
          title:
            "How can a person who is battling destructive lifestyle habits learn to make positive choices for his or her health?",
        },
      },
      blanks: [
        {
          choices: ["murder", "smoke", "inhale"],
          correctAnswer: "murder",
          textAfter: " .",
          textBefore: "You shall not",
        },
      ],
      body: "Reliable science reveals that every cigarette smoked causes tremendous harm to the human body and mind. According to the Centers for Disease Control and Prevention, 90 percent of lung cancers—and many other diseases—are caused by smoking. Causing intentional and significant harm to the body temple—God’s dwelling place—cannot possibly be construed as giving glory to God (1 Corinthians 10:31).",
      choices: ["murder", "smoke", "inhale"],
      lessonID: 15,
      question:
        "Does it matter to God if people smoke or use other tobacco products?",
      questionID: 13,
      questionType: "radio",
      verses: [
        {
          body: "You shall not murder.",
          ref: "Exodus 20:13",
        },
      ],
    },
    "15-14": {
      blanks: [
        {
          choices: [
            "obtain",
            "temperate",
            "all",
            "imperishable",
            "love",
            "entered",
            "greater",
            "everlasting",
          ],
          correctAnswer: "obtain",
          textAfter: " it. And everyone who competes for the prize is",
          textBefore:
            "Do you not know that those who run in a race all run, but one receives the prize? Run in such a way that you may",
        },
        {
          choices: [
            "obtain",
            "temperate",
            "all",
            "imperishable",
            "love",
            "entered",
            "greater",
            "everlasting",
          ],
          correctAnswer: "temperate",
          textAfter: " in",
        },
        {
          choices: [
            "obtain",
            "temperate",
            "all",
            "imperishable",
            "love",
            "entered",
            "greater",
            "everlasting",
          ],
          correctAnswer: "all",
          textAfter:
            " things. Now they do it to obtain a perishable crown, but we for an",
        },
        {
          choices: [
            "obtain",
            "temperate",
            "all",
            "imperishable",
            "love",
            "entered",
            "greater",
            "everlasting",
          ],
          correctAnswer: "imperishable",
          textAfter: " crown.",
        },
      ],
      body: "Just as an athlete trains and prepares wholeheartedly in his or her pursuit of a prize that will one day perish, the Christian should strive to prepare in every possible way to receive God’s great gift of everlasting life.",
      choices: [
        "obtain",
        "temperate",
        "all",
        "imperishable",
        "love",
        "entered",
        "greater",
        "everlasting",
      ],
      lessonID: 15,
      question:
        "How did Paul describe the Christian journey toward our heavenly home?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: " Do you not know that those who run in a race all run, but one receives the prize? Run in such a way that you may obtain it. 25 And everyone who competes for the prize is temperate in all things. Now they do it to obtain a perishable crown, but we for an imperishable crown.",
          ref: "1 Corinthians 9:24, 25",
        },
      ],
    },
    "15-15": {
      blanks: [
        {
          choices: ["happy place", "living sacrifice", "pure haven"],
          correctAnswer: "living",
          textAfter: " ",
          textBefore:
            "I beseech you therefore, brethren, by the mercies of God, that you present your bodies a",
        },
        {
          choices: ["happy place", "living sacrifice", "pure haven"],
          correctAnswer: "sacrifice",
          textAfter:
            " , holy, acceptable to God, which is your reasonable service.",
        },
      ],
      body: "While salvation does not come through adhering to health principles— salvation comes only through faith in Jesus—those who have faith in Jesus will want to honor Him in every way possible. As we honor God with our bodies and also yield to Him our minds, He can fill us with His presence and communicate with us more clearly.",
      choices: ["happy", "place", "living", "sacrifice", "pure", "haven"],
      lessonID: 15,
      question:
        "What great biblical principle reminds us of the importance of honoring God with our bodies?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "I beseech you therefore, brethren, by the mercies of God, that you present your bodies a living sacrifice, holy, acceptable to God, which is your reasonable service.",
          ref: "Romans 12:1",
        },
      ],
    },
    "15-16": {
      blanks: [
        {
          choices: ["great", "loves", "some", "likes", "all", "strengthens"],
          correctAnswer: "all",
          textAfter: " things through Christ who",
          textBefore: "I can do",
        },
        {
          choices: ["great", "loves", "some", "likes", "all", "strengthens"],
          correctAnswer: "strengthens",
          textAfter: " me.\n",
        },
      ],
      body: "Through the indwelling of the Holy Spirit, God is well able to not only provide strength to make changes in our lives, but also to be the strength we need to live lives that are entirely committed to God’s glory. What seems impossible to us in our human weakness is possible with God in His divine strength. God is able to help anyone enjoy the blessings that come from following His principles for good health.\n   ",
      choices: ["great", "loves", "some", "likes", "all", "strengthens"],
      lessonID: 15,
      question:
        "Where can a person find the strength to adopt the health principles recommended by God?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "I can do all things through Christ who strengthens me.",
          ref: "Philippians 4:13",
        },
      ],
    },
    "15-17": {
      correctAnswer: "true",
      question:
        "Are you willing to surrender your life to God and accept His principles for better physical and spiritual health?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "15-2": {
      Supplements: {
        "-L7zZRmIE1ooc451-wQ4": {
          body: "In 1 Corinthians 6:19, 20, Paul writes, “Or do you not know that your body is the temple of the Holy Spirit who is in you, whom you have from God, and you are not your own? For you were bought at a price; therefore glorify God in your body and in your spirit, which are God’s.” The price that was paid for our bodies was the blood of Jesus Christ, truly the highest price ever paid for anything in the history of the universe. If Jesus was willing to give Himself for you, you’re of inestimable value to Him!\n\nIn 1 Corinthians 10:31, Paul continues the thought. “Therefore, whether you eat or drink, or whatever you do, do all to the glory of God.”  We look around us today and see no shortage of ways that we can damage our health. Temptations come to us in the form of alcohol, tobacco, drugs, poor food choices, overwork, lack of sleep and a host of other damaging substances and activities. How we respond to these temptations can either be done “to the glory of God” or not “to the glory of God.” God wants us to be in health or, as He says in John 10:10, “I have come that they may have life, and that they may have it more abundantly.”\n\nThis all becomes increasingly relevant to us when we consider Revelation 14:7. It says, “Fear God and give glory to Him, for the hour of His judgment has come.” In the final days of earth’s history, God wants us to give glory to Him. Giving glory to God takes many forms, one of which is the care of our bodies. It’s not just a physical issue, but something that affects us on a spiritual level as well. \n\nIn the end, why wouldn’t we want to take care of our bodies? God wants the best for us in this life and He’s trying to help us get prepared for eternity as well. What a loving God!\n",
          title: "How interested is God in our physical health?",
        },
      },
      blanks: [
        {
          choices: ["sickness", "pain", "sin", "sadness"],
          correctAnswer: "sickness",
          textAfter: " away from the midst of you.",
          textBefore:
            "You shall serve the Lord your God, and He will bless your bread and your water. And I will take",
        },
      ],
      body: "God gave His people health principles to protect them from sickness and keep them from premature and unnecessary death. As the Creator God, He knows what is best for our health. Many years ago, God gave us a number of principles that are still very important today.",
      choices: ["sickness", "pain", "sin", "sadness"],
      lessonID: 15,
      question: "Why did God share principles of good health with His people?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "So you shall serve the Lord your God, and He will bless your bread and your water. And I will take sickness away from the midst of you.",
          ref: "Exodus 23:25",
        },
      ],
    },
    "15-3": {
      blanks: [
        {
          choices: ["abundantly", "happily", "better"],
          correctAnswer: "abundantly",
          textAfter: " .",
          textBefore:
            "I have come that they may have life, and that they may have it more",
        },
      ],
      body: "God’s desire is that His people—while preparing for everlasting life—live life to the fullest! God wants us to flourish. An abundant life includes the personal presence of Jesus, who longs to give us a life of health and happiness beyond our imagination.",
      choices: ["abundantly", "happily", "better"],
      lessonID: 15,
      question: "What sort of life does Jesus promise us?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "The thief does not come except to steal, and to kill, and to destroy. I have come that they may have life, and that they may have it more abundantly.",
          ref: "John 10:10",
        },
      ],
    },
    "15-4": {
      blanks: [
        {
          choices: ["spirit", "truth", "temple"],
          correctAnswer: "temple",
          textAfter:
            " of the Holy Spirit who is in you, whom you have from God, and you are not your own? . . . Therefore glorify God in your body.",
          textBefore: "Do you not know that your body is the",
        },
      ],
      body: "Some people have the attitude of “it’s my body, and I can do what I like with it.” But the human body was intended to be a dwelling place for the Holy Spirit. As such, we have a responsibility to care for ourselves physically and emotionally—to keep ourselves in the best possible condition to maintain a loving relationship with God. If the mind is dulled, communication with God is made more difficult and spiritual growth is stunted. Having vitality and good health helps us understand the Bible and establish a close relationship with God.",
      choices: ["spirit", "truth", "temple"],
      lessonID: 15,
      question: "What does the Bible call our body?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "Or do you not know that your body is the temple of the Holy Spirit who is in you, whom you have from God, and you are not your own? 20 For you were bought at a price; therefore glorify God in your body and in your spirit, which are God’s.",
          ref: "1 Corinthians 6:19, 20",
        },
      ],
    },
    "15-5": {
      blanks: [
        {
          choices: ["pleasure", "glory", "sake"],
          correctAnswer: "glory",
          textAfter: " of God.",
          textBefore:
            "Whether you eat or drink, or whatever you do, do all to the",
        },
      ],
      body: "Notice that God wants us to glorify Him in all we do—including how we eat and drink. It is easy to imagine ways of eating and drinking that are not to the glory of God. In His Word, God gives us clear instruction as to how we can treat our body temple in a way that glorifies Him.",
      choices: ["pleasure", "glory", "sake"],
      lessonID: 15,
      question: "What are some practical ways we can enhance our health?",
      questionID: 5,
      questionType: "radio",
      verses: [
        {
          body: "Therefore, whether you eat or drink, or whatever you do, do all to the glory of God.",
          ref: "1 Corinthians 10:31",
        },
      ],
    },
    "15-6": {
      Supplements: {
        "-L82ghZUrEXiOf5u4fIE": {
          body: "Methuselah was the oldest man in the Bible who ever died. Technically, he wasn’t the oldest man who ever lived, because that was Enoch, who was taken to heaven without ever experiencing death. But according to Genesis 5:27, Methuselah lived 969 years and then he died. Why did he live so long, when people today consider themselves fortunate if they live to 90? There are several reasons, but one of them has to do with eating a healthy diet. Prior to the flood, God permitted human beings to eat only fruit, nuts, grains, seeds, and vegetables (see Genesis 1:29 and Genesis 3:18). Once the flood occurred, God for the first time permitted people to eat flesh foods (at least the clean ones.)  He knew that after the flood, there would be limited vegetation left on the earth and His people would need something to sustain them until the plants could grow again. So he instructed Noah to take seven of the clean animals onto the ark and two of every unclean creature (Genesis 7:1-3). It’s interesting to note that shortly after the flood and the introduction of meat-eating, the lifespan of human beings decreased drastically. No longer would people live into their 900’s like Methuselah, but the lifespan would drop into the 400’s, the 300’s and below. Today we live much shorter lives than that. \n\nSo the natural question becomes, “If I go back to eating the pre-flood diet, will I live as long as Methuselah?” No, you won’t. But you might end up adding both more years to your life, and more life to your years. It’s something to prayerfully consider.",
          title: "Who was Methuselah?",
        },
      },
      blanks: [
        {
          choices: ["herb", "fruit", "eye", "branches", "fruit", "roots"],
          correctAnswer: "herb",
          textAfter:
            " that yields seed which is on the face of all the earth, and every tree whose",
          textBefore: "God said, “See, I have given you every",
        },
        {
          choices: ["herb", "fruit", "eye", "branches", "fruit", "roots"],
          correctAnswer: "fruit",
          textAfter: " yields seed; to you it shall be for food.”",
        },
      ],
      body: "\nIn the Garden of Eden,  before the appearance of sin and death, the diet God prescribed for Adam and Eve did not include animal  flesh. Meat was not a part of God’s original dietary plan for the human family. And God’s original dietary plan was clearly effective. Following this plan, Methuselah lived to be 969 years old (Genesis 5:27)!",
      choices: ["herb", "fruit", "eye", "branches", "fruit", "roots"],
      lessonID: 15,
      question:
        "When did God  first speak to the human family about His plan to guide us in good health?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "And God said, See, I have given you every herb that yields seed which is on the face of all the earth, and every tree whose fruit yields seed; to you it shall be for food.",
          ref: "Genesis 1:29",
        },
      ],
    },
    "15-7": {
      blanks: [
        {
          choices: ["has", "grass", "knows", "meat", "divides", "cud"],
          correctAnswer: "divides",
          textAfter: " the hoof, having cloven hooves and chewing the",
          textBefore: "Among the animals, whatever",
        },
        {
          choices: ["has", "grass", "knows", "meat", "divides", "cud"],
          correctAnswer: "cud",
          textAfter: " —that you may eat.",
        },
      ],
      body: "God made it clear that should people decide to eat animal flesh, they should not eat unclean animals—including pigs, rabbits, camels and horses. Only animals that have a split hoof and chew the cud are acceptable for human consumption.",
      choices: ["has", "grass", "knows", "meat", "divides", "cud"],
      lessonID: 15,
      question:
        "When God modified His original dietary plan for humanity, what restrictions did He place on what people should and should not eat?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "Among the animals, whatever divides the hoof, having cloven hooves and chewing the cud—that you may eat.",
          ref: "Leviticus 11:3",
        },
      ],
    },
    "15-8": {
      blanks: [
        {
          choices: ["friends", "unclean", "young"],
          correctAnswer: "unclean",
          textAfter: " , a male and his female.",
          textBefore:
            "You shall take with you seven each of every clean animal, a male and his female; two each of animals that are",
        },
      ],
      body: "As far back as the time of Noah, God clearly distinguished between clean animals and unclean animals—and Jews didn’t yet exist in Noah’s day! He told Noah to take onto the ark seven of every clean animal, and two of every unclean animal. God’s intention was not that the unclean animals would be eaten. If they were, the species in question would have become extinct. God’s instruction to Noah—long  before the first Jew lived—clearly shows that restrictions against eating unclean animals do not apply only to the Jewish people. God’s principles for honoring Him and enjoying good health are for everyone!",
      choices: ["friends", "unclean", "young"],
      lessonID: 15,
      question:
        "Were the restrictions on eating unclean animals intended only for the Jewish people?",
      questionID: 8,
      questionType: "radio",
      verses: [
        {
          body: "You shall take with you seven each of every clean animal, a male and his female; two each of animals that are unclean, a male and his female;",
          ref: "Genesis 7:2",
        },
      ],
    },
    "15-9": {
      blanks: [
        {
          choices: ["fins", "scales", "eyes", "sees", "ears", "hears"],
          correctAnswer: "fins",
          textAfter: " and",
          textBefore:
            "These you may eat of all that are in the water: whatever in the water has",
        },
        {
          choices: ["fins", "scales", "eyes", "sees", "ears", "hears"],
          correctAnswer: "scales",
          textAfter:
            " , whether in the seas or in the rivers—that you may eat. But all in the seas or in the rivers that do not have fins and scales, all that move in the water or any living thing which is in the water, they are an abomination to you.",
        },
      ],
      body: "In an attempt to protect us from illness and disease, God asks that anyone eating creatures that live in the water refrain from eating certain creatures that were never intended to be food for human beings. Filter feeders, such as oysters and other shell fish, have a very important role in the ecosystem. They cleanse waterways by ingesting water and filtering out impurities. Lobsters, crabs and other bottom-feeders cleanse rivers and oceans of dead matter. The same is true for cat fish and other similar creatures. While not intended as food for people, these creatures perform the important task of helping to cleanse the planet’s water supply. And notice: God said that the eating of unclean animals is “an abomination to you.” Nowhere in the Bible did God ever declare something to be an abomination that He later declared to no longer be an abomination. God stated that unclean food is an abomination, and never reversed that declaration.",
      choices: ["fins", "scales", "eyes", "sees", "ears", "hears"],
      lessonID: 15,
      question: "What did God say about creatures that live in the water?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: " ‘These you may eat of all that are in the water: whatever in the water has fins and scales, whether in the seas or in the rivers—that you may eat. 10 But all in the seas or in the rivers that do not have fins and scales, all that move in the water or any living thing which is in the water, they are an abomination to you.",
          ref: "Leviticus 11:9, 10",
        },
      ],
    },
  },
  {
    "16-0": {
      body: "Jerusalem, the “City of Peace,” has a history like few other places on earth. Over thousands of years, many wars have been fought over this site. Today, Jerusalem is still one of the most volatile places in the world. The most prized possession in Jerusalem is the Temple Mount, considered holy by both Jews and Muslims. It was where Solomon built the first great Israelite temple, which Babylon’s King Nebuchadnezzar later destroyed. Herod’s temple, later built on the same spot, was eventually destroyed by the Romans in AD 70. Since that time, there has been talk about rebuilding this temple. But according to the Bible, should the temple be rebuilt? What was the purpose of the ancient temple—also known as the tabernacle or sanctuary? What did all the symbols and ceremonies mean? And as the ancient high priest ministered in the temple on behalf of God’s people in times past, who represents us  before God today?",
      lessonID: 16,
      questionID: 0,
      type: "text",
    },
    "16-1": {
      blanks: [
        {
          choices: ["dwell", "walk", "breathe"],
          correctAnswer: "dwell",
          textAfter: " among them.",
          textBefore: "Let them make Me a sanctuary, that I may",
        },
      ],
      body: "God created humans for love and companionship. He even made us “in His own image” so we could understand Him better and learn to love Him more. When our original parents sinned, the closeness that existed between God and humans was interrupted. Sin raised a barrier between humankind and our pure and holy God (Isaiah 59:2). The sanctuary provided a means whereby God could again live with His people. His presence would reside permanently in the sanctuary. In this way, God went wherever His people went—guiding, providing for and protecting them. The sanctuary symbols and services taught the people to know and understand their loving God.",
      choices: ["dwell", "walk", "breathe"],
      lessonID: 16,
      question: "What was the main purpose of the Jewish sanctuary?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "And let them make Me a sanctuary, that I may dwell among them.",
          ref: "Exodus 25:8",
        },
      ],
    },
    "16-10": {
      blanks: [
        {
          choices: ["love", "paths", "save", "intercession", "see", "space"],
          correctAnswer: "save",
          textAfter:
            " to the uttermost those who come to God through Him, since He always lives to make",
          textBefore: "He is also able to",
        },
        {
          choices: ["love", "paths", "save", "intercession", "see", "space"],
          correctAnswer: "intercession",
          textAfter: " for them.",
        },
      ],
      body: "The primary function of Jesus’ role as our heavenly High Priest is to make salvation a reality in our lives. The cross of Calvary was not the end of the salvation process! Jesus, the Lamb who died for us, now ministers for us as our High Priest. In the Old Testament, the priest stood  before the holiness of God and became the mediator between God and the sinner. In this way, the sinner had constant access to God, and God had constant access to His people. When Jesus returned to heaven, He personally took on the role of ministering  before the Father to bring salvation to us. Jesus is the link between human frailty and divine immortality. He restores our relationship with God and gives us spiritual power to live a victorious Christian life.",
      choices: ["love", "paths", "save", "intercession", "see", "space"],
      lessonID: 16,
      question: "What does Jesus do as High Priest in the heavenly sanctuary?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore He is also able to save to the uttermost those who come to God through Him, since He always lives to make intercession for them.",
          ref: "Hebrews 7:25",
        },
      ],
    },
    "16-11": {
      blanks: [
        {
          choices: ["Rest", "Love", "Atonement"],
          correctAnswer: "Atonement",
          textAfter:
            " . It shall be a holy convocation for you; you shall a afflict your souls, and offer an offering made by fire to the Lord.",
          textBefore: "The tenth day of this seventh month shall be the Day of",
        },
      ],
      body: "The Day of Atonement (Yom Kippur) occurred just once every year. This was the only day the High Priest entered the Most Holy Place. It was a day of judgment and a solemn time of repentance—the day to ensure there was complete harmony between God and His people. Those who refused to participate were cut off from God’s people (Leviticus 23:29). Every day, the priests offered sacrifices, transferring the record of sin (symbolized by eating some of the flesh of the sacrifice or sprinkling some of the blood) onto the Holy Place of the sanctuary. The Day of Atonement was a day to cleanse the sanctuary from sin. The prophet Daniel predicted a time when the sanctuary in heaven would also be cleansed (Daniel 8:14). There will be a judgment prior to the Second Coming of Christ—a time of blessing for all whose lives are surrendered to Jesus.",
      choices: ["Rest", "Love", "Atonement"],
      lessonID: 16,
      question: "What was the Day of Atonement?",
      questionID: 11,
      questionType: "radio",
      verses: [
        {
          body: "Also the tenth day of this seventh month shall be the Day of Atonement. It shall be a holy convocation for you; you shall afflict your souls, and offer an offering made by fire to the Lord.",
          ref: "Leviticus 23:27",
        },
      ],
    },
    "16-12": {
      blanks: [
        {
          choices: ["goats", "shirts", "bets"],
          correctAnswer: "goats",
          textAfter:
            " : one lot for the Lord and the other lot for the scapegoat.",
          textBefore: "Aaron shall cast lots for the two",
        },
      ],
      body: "On the Day of Atonement, two goats were chosen. The Lord’s goat was killed as a sacrifice for God’s people. Blood from the goat was taken by the High Priest into the Most Holy Place and sprinkled on the Mercy Seat upon the Ark of the Covenant. This represented the blood of Jesus and the mercy of God to save us from our sins. Following this, the sins from the sanctuary were symbolically transferred to the scapegoat, which represented Satan. The scapegoat was taken into the wilderness (Leviticus 16:21, 22). to die a lonely death, representing that at the end of the judgment, Satan will be punished for the sins of humanity. Following Jesus’ Second Coming, the devil will be confined to planet Earth for 1,000 years. [See It Is Written Bible Study Guide #11, “Revelation’s 1,000 Years”]. At the end of this period, he will finally perish in the lake of fire (Revelation 20:10).",
      choices: ["goats", "shirts", "bets"],
      lessonID: 16,
      question:
        "What was done on the Day of Atonement that symbolized the final removal of sin?",
      questionID: 12,
      questionType: "radio",
      verses: [
        {
          body: "Then Aaron shall cast lots for the two goats: one lot for the Lord and the other lot for the scapegoat.",
          ref: "Leviticus 16:8",
        },
      ],
    },
    "16-13": {
      blanks: [
        {
          choices: [
            "friend",
            "crushed",
            "brethren",
            "tempted",
            "face",
            "close",
          ],
          correctAnswer: "brethren",
          textAfter:
            " , that He might be a merciful and faithful High Priest in things pertaining to God, to make propitiation for the sins of the people.",
          textBefore: "In all things He had to be made like His",
        },
      ],
      body: "",
      bodyImage: "",
      choices: ["friend", "crushed", "brethren", "tempted", "face", "close"],
      lessonID: 16,
      question: "What makes Jesus our perfect High Priest for today?",
      questionID: 13,
      questionIDTitle: "13a",
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore, in all things He had to be made like His brethren, that He might be a merciful and faithful High Priest in things pertaining to God, to make propitiation for the sins of the people.",
          ref: "Hebrews 2:17",
        },
      ],
    },
    "16-14": {
      blanks: [
        {
          choices: [
            "friend",
            "crushed",
            "brethren",
            "tempted",
            "face",
            "close",
          ],
          correctAnswer: "tempted",
          textAfter: " as we are, yet without sin.",
          textBefore:
            "We do not have a High Priest who cannot sympathize with our weaknesses, but was in all points",
        },
      ],
      body: "Jesus was born in human flesh and was tempted to sin. He knows what it’s like to feel the pull of temptation, and understands our struggle with the flesh. As a result, He is full of mercy and sympathy when we confess our sins. Jesus resisted temptation. He was completely without sin (1 John 3:5). Jesus gained the victory over temptation in His personal experience, and is ready to give you help just when you need it most. Because Jesus perfectly fulfilled the requirements of the law, He can substitute His perfect life for your sinful life. As a result, we can go “boldly to the throne of grace, that we may obtain mercy and find grace to help in time of need.” (Hebrews 4:16). Even more so, He is able to help us follow His example, and live a life free from sin through His power (1 Peter 2:21, 22)!",
      choices: ["friend", "crushed", "brethren", "tempted", "face", "close"],
      lessonID: 16,
      question: "What makes Jesus our perfect High Priest for today?",
      questionID: 14,
      questionIDTitle: "13b",
      questionType: "radio",
      verses: [
        {
          body: "For we do not have a High Priest who cannot sympathize with our weaknesses, but was in all points tempted as we are, yet without sin.",
          ref: "Hebrews 4:15",
        },
      ],
    },
    "16-15": {
      correctAnswer: "true",
      lessonID: 16,
      question:
        "Would you like to accept the forgiveness and power offered you by your heavenly High Priest, ministering for you now in the heavenly sanctuary?",
      questionID: 15,
      questionType: "truthConfirmation",
    },
    "16-2": {
      blanks: [
        {
          choices: ["will", "word", "way"],
          correctAnswer: "way",
          textAfter: " , O God, is in the sanctuary.",
          textBefore: "\nYour",
        },
      ],
      body: "The sanctuary was a three-dimensional model given to show God’s way of salvation. The sanctuary is mentioned or alluded to throughout the Bible, and involves a wide variety of symbols and ceremonies. The sanctuary outlines the complete gospel story in detail. It presents a God of judgment and mercy, and demonstrates how God will ultimately and eternally solve the problem of sin. The books of Daniel and Revelation base their prophecies in large part on the subject of the sanctuary. In fact, the sanctuary and its services are mentioned or alluded to many times in the book of Revelation. There are few, if any, Bible topics more important for us to understand than the subject of the sanctuary.",
      choices: ["will", "word", "way"],
      lessonID: 16,
      question:
        "What did God show His people through the sanctuary and its services?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "Your way, O God, is in the sanctuary; Who is so great a God as our God?",
          ref: "Psalm 77:13",
        },
      ],
    },
    "16-3": {
      Supplements: {
        "-L82hWYfcNQMjzxQpd6z": {
          body: "Sin, simply defined, is found in 1 John 3:4. It is, “the transgression [breaking] of the law”. In other words, when we break one of the Ten Commandments, we have sinned and put ourselves outside of the will of God. 1 John 5:17 states it another way. It says, “All unrighteousness [wrongdoing] is sin”. ",
          title: "What is sin?",
        },
      },
      blanks: [
        {
          choices: ["tears", "blood", "skin"],
          correctAnswer: "blood",
          textAfter: " there is no remission.",
          textBefore: "Without shedding of",
        },
      ],
      body: "The sanctuary service was based on the sacrifice of animals. This heart-wrenching ceremony taught that the shedding of blood was required to obtain forgiveness (remission) and cleansing from sin. Blood is a symbol of life (Leviticus 17:11). Only blood from the life of the One who was sinned against—the God of heaven—could provide forgiveness for the sinner. Jesus is the Lamb of God whose blood takes away the sin of the world (John 1:29). Through the sanctuary services, God demonstrated the great cost of sin. Through the blood of animal sacrifices, God pointed toward the great Sacrifice, Savior and Substitute—Jesus Christ.",
      choices: ["tears", "blood", "skin"],
      lessonID: 16,
      question: "What was the central teaching of the sanctuary?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "And according to the law almost all things are purified with blood, and without shedding of blood there is no remission.",
          ref: "Hebrews 9:22",
        },
      ],
    },
    "16-4": {
      Supplements: {
        "-L82hM_F2n-J_-MFph7N": {
          body: "The Bible goes into great detail when it describes the sanctuary. Every aspect of the construction of the sanctuary had a purpose and a meaning, all intended to help point us toward our Savior, Jesus Christ. \n\nRead Exodus 26 & 27 and you will find that it had walls made of acacia wood, overlaid with gold (Exodus 26:15-29). There were linen curtains dyed blue, purple and scarlet (Exodus 26:1). The covering of the tabernacle was made of goats’ hair, ram skins and badger skins (vs. 7-14). \n\nThe sanctuary was also divided into two compartments, the holy place and the most holy place, surrounded by a courtyard. Again, the elements in the tabernacle (or sanctuary) were intended to point us toward Jesus. In the courtyard was an altar of burnt offering (Jesus is our sacrifice) and a laver for the priests to wash before entering the holy place (representing baptism). In the holy place was the table of shewbread (Jesus is the bread of life), the seven-branched candlestick (He is the light of the world), and the altar of incense (His prayers ascend to the Father on our behalf).\n\nThe earthly sanctuary was there to point God’s people to the Messiah, and for them to understand the plan of salvation. Psalm 77:13 gives us the hopeful words, “Your way, O God, is in the sanctuary”.\n",
          title: "How does the Bible describe the sanctuary?",
        },
      },
      blanks: [
        {
          choices: ["fire", "wonder", "shape", "style", "pattern", "pattern"],
          correctAnswer: "pattern",
          textAfter: " of the tabernacle and the pattern of all its ",
          textBefore: "According to all that I show you, that is, the",
        },
        {
          choices: ["fire", "wonder", "shape", "style", "pattern", "pattern"],
          correctAnswer: "furnishings",
          textAfter: " , just so you shall make it.",
        },
      ],
      body: "When Moses built the sanctuary, he followed “blueprints” that were given to him by God. The sanctuary was meticulously designed by God, and every symbol and ceremony was significant. The original sanctuary was a tent-like structure that the Jews transported with them as they journeyed through the wilderness (Exodus 25–40).It was made of a variety of materials, including acacia wood, goats’ hair, animal skins and precious metals such as silver and gold. The courtyard set a boundary around the sanctuary. There was only one entrance to the sanctuary—through the front curtain (or veil). It was through this veil that the sinner would enter the sanctuary precincts with an animal sacrifice. Within the courtyard was the altar of burnt offering (Exodus 40:6), where the animals were consumed by fire. There was also a laver (Exodus 40:7), a basin used by the priests to wash their hands and feet prior to entering the sanctuary. In the Holy Place was a seven-branched candlestick (Exodus 25:31–40), kept constantly burning with oil. There was also the altar of incense, where incense burned continually (Exodus 30:7, 8), and the table of showbread, upon which were loaves of  at bread (Exodus 25:30; Leviticus 24:5–9). It was in the Most Holy Place that the presence of God resided. The Most Holy Place was the home of the Ark of the Covenant (Exodus 40:3). On the ark stood two angels made of pure gold, watching over the mercy seat, which was upon the ark (Exodus 25:17–22). Inside the ark was the law of God—the Ten Commandments—which was written with the finger of God (Deuteronomy 10:4, 5).",
      choices: [
        "fire",
        "wonder",
        "shape",
        "style",
        "pattern",
        "pattern",
        "furnishings",
      ],
      lessonID: 16,
      question:
        "Where did Moses get the plans for the building of the sanctuary?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "According to all that I show you, that is, the pattern of the tabernacle and the pattern of all its furnishings, just so you shall make it.",
          ref: "Exodus 25:9",
        },
      ],
    },
    "16-5": {
      Supplements: {
        "-L82hp79-w3BmAxT7HwV": {
          body: "God recognizes that we are inclined toward sin and that we will need forgiveness once we have strayed away from Him by disobedience. All through the Bible, we find examples of people who departed from God’s will and needed to get right with Him again. David committed adultery (2 Samuel 11). Moses was a murderer (Exodus 2:12). Countless people throughout the Bible lied to one another. But once a person sins, then what?\n\nThe penalty for sinning is significant. Romans 6:23 says that, “The wages of sin is death”. That’s what we deserve as a result of our sin. Hebrews 9:22 tells us that sin separates us from God and if we’re separated from him, death is all that is left to us. But then Romans 6:23 goes on to say, “But the gift of God is eternal life in Christ Jesus our Lord”. That’s good news! We can have our sins forgiven. In fact, we must have our sins forgiven in order to be saved. \n\nBut how do we go about having them forgiven? One of the most hope-filled verses in the Bible is 1 John 1:9. It says that, “If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness”. And there are no “excepts” in that verse. It doesn’t say that He is faithful and just to forgive us our sins, except stealing. Or, except lying. There are no “excepts”. If you confess the sin to God - if you genuinely repent of it - then the promise is that you are forgiven. It’s that simple. \n\nWhen we follow that simple teaching of God, we can have the peace that comes from knowing that our sins are forgiven. Romans 5:1 says, “Therefore, having been justified by faith, we have peace with God through our Lord Jesus Christ”. \n\nBut what if you don’t feel forgiven? This is where the devil tries to make things more complicated than they actually are. Once we confess our sins, then the only thing left for us to do is believe that they are forgiven. If we don’t believe that, if we don’t trust that God means what he promised, we give evidence that we do not trust Him and that we are, in fact, calling Him a liar. The good news is that God wants to forgive you. And He’s ready to do it right now. Psalm 86:5 says, “For You, Lord, are good, and ready to forgive, and abundant in mercy to all those who call upon You”. Confess your sins to God, believe that He has forgiven them, and enjoy the peace that He promises will come from that realization.\n",
          title: "How is a person forgiven of sin?",
        },
      },
      blanks: [
        {
          choices: ["kill", "offer", "show"],
          correctAnswer: "kill",
          textAfter:
            " it as a sin offering at the place where they kill the burnt offering.",
          textBefore:
            "He shall lay his hand on the head of the sin offering, and",
        },
      ],
      body: "\nThe sinner would take a lamb to the sanctuary, walk through the veil, and approach the altar of burnt offering. He would then place his hand on the head of the lamb and confess his specific sins onto that lamb (Leviticus 4:29; 5:5). By doing this, the sinner symbolically transferred his sins to the lamb, and the lamb would die. In what was intended by God to be a difficult process, the sinner then killed the lamb himself. Depending on the sacrifice offered, the priest either ate part of the animal or sprinkled some of its blood inside the sanctuary. Thus the sin was transferred from the sinner to the lamb, then to the priest and then into the sanctuary. The sinner left the sanctuary free from the penalty of sin.",
      choices: ["kill", "offer", "show"],
      lessonID: 16,
      question: "How did the sinner receive forgiveness for sins?",
      questionID: 5,
      questionType: "radio",
      verses: [
        {
          body: "Then he shall lay his hand on the head of the sin offering, and kill it as a sin offering at the place where they kill the burnt offering.",
          ref: "Leviticus 4:33",
        },
      ],
    },
    "16-6": {
      Supplements: {
        "-L82hySSic9Yvppmo3RQ": {
          body: "In Hebrews 6–8, the author of the book (believed by many scholars to be Paul) contrasts the two priesthoods, emphasizing that Jesus has now obtained a “more excellent ministry” (Hebrews 8:6) than the earthly ministry. Whereas the earthly priests had to stop their ministry because they would die, Jesus’ ministry need never end (Hebrews 7:23, 24). Earthly priests were born to the office, but Jesus took an oath and was made a surety of a better testament (Hebrews 7:21, 22). In the earthly ministry, mortal men received tithes, but in heaven, Jesus receives them (Hebrews 7:8). In a nutshell, Jesus is the perfected version of what the imperfect earthly ministry of the priests was pointing towards. Praise the Lord that Jesus is now doing what we need him to do for us today!\n ",
          title: "How do the earthly and heavenly priesthoods differ?",
        },
      },
      blanks: [
        {
          choices: ["true", "Lord", "high", "shape", "holy", "fallen"],
          correctAnswer: "true",
          textAfter: " tabernacle which the",
          textBefore:
            "We have such a High Priest, who is seated at the right hand of the throne of the Majesty in the heavens, a Minister of the sanctuary and of the",
        },
        {
          choices: ["true", "Lord", "high", "shape", "holy", "fallen"],
          correctAnswer: "Lord",
          textAfter: " erected, and not man.",
        },
      ],
      body: "\nThe earthly sanctuary was modeled after the sanctuary in heaven. The sanctuary that Moses built was a “shadow” (Hebrews 8:5), representing the original temple that God built. As the book of Hebrews points out, there is a High Priest granting salvation to sinners from the sanctuary in heaven. This being so, there is no need for a new temple to be erected in Jerusalem. The true sanctuary—the one that should be our focus—is in heaven. The sanctuary spoken of in the Bible’s end-time prophecies is the sanctuary in heaven, and not a sanctuary on planet Earth.",
      choices: ["true", "Lord", "high", "shape", "holy", "fallen"],
      lessonID: 16,
      question: "On what was the Hebrew sanctuary modeled?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "Now this is the main point of the things we are saying: We have such a High Priest, who is seated at the right hand of the throne of the Majesty in the heavens, (2) a Minister of the sanctuary and of the true tabernacle which the Lord erected, and not man.",
          ref: "Hebrews 8:1-2",
        },
      ],
    },
    "16-7": {
      blanks: [
        {
          choices: ["Son", "Lamb", "Child"],
          correctAnswer: "Lamb",
          textAfter: " of God who takes away the sin of the world!",
          textBefore: "Behold! The",
        },
      ],
      body: "God made the great sacrifice to provide forgiveness to sinful humanity. As sacrifices were offered in the courtyard of the earthly sanctuary, it was on this earth that Jesus—the divine Son of God—died. When He died on Calvary, the veil in the earthly sanctuary was torn from top to bottom (Matthew 27:51), indicating that the services of the earthly sanctuary were obsolete from that moment on. By His death, Jesus brought “an end to sacrifice and offering” (Daniel 9:27). God’s true sanctuary is the heavenly sanctuary, and not an earthly sanctuary (or temple).",
      choices: ["Son", "Lamb", "Child"],
      lessonID: 16,
      question: "What did Jesus do in the “courtyard” of this earth?",
      questionID: 7,
      questionType: "radio",
      verses: [
        {
          body: "The next day John saw Jesus coming toward him, and said, “Behold! The Lamb of God who takes away the sin of the world!",
          ref: "John 1:29",
        },
      ],
    },
    "16-8": {
      lessonID: 16,
      question: "What did Jesus do in the “courtyard” of this earth?",
      questionID: 8,
      questionType: "text",
      text: [
        "Each piece of furniture in the sanctuary represents an aspect of Jesus' work to save us from sin.",
        "To illustrate:",
        "1. Altar of Burnt Offering:  The sacrifice of Jesus on Calvary (John 1:29).",
        "2. Laver:  Jesus the Living Water (John 4:10, Titus 3:5).",
        "3. Candlestick:  Jesus the Light of the Word (John 1:9).",
        "4. Showbread:  Jesus the Bread of Life ( John 6:48).",
        "5. Altar of Incense:  The righteousness of Jesus mixed with the prayers of the faithful (Revelation 8:3).",
        "6. Ark of the Covenant and Mercy Seat:  The mercy of God offered to those who break His law (1 John 2:1; Psalm 85: 10).",
      ],
    },
    "16-9": {
      blanks: [
        {
          choices: ["John", "Peter", "Jesus"],
          correctAnswer: "Jesus",
          textAfter: " the Son of God, let us hold fast our confession.",
          textBefore:
            "Seeing then that we have a great High Priest who has passed through the heavens,",
        },
      ],
      body: "Today, everyone still needs a priest for salvation— a heavenly High Priest. The Bible says there is “one Mediator between God and men, the Man Christ Jesus” (1 Timothy 2:5). Jesus is our only Mediator today.",
      choices: ["John", "Peter", "Jesus"],
      lessonID: 16,
      question: "Who is our High Priest today?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "Seeing then that we have a great High Priest who has passed through the heavens, Jesus the Son of God, let us hold fast our confession.",
          ref: "Hebrews 4:14",
        },
      ],
    },
  },
  {
    "17-0": {
      body: "In recent times, courtroom dramas have become popular features on television news programs. Those accused of notorious—even grisly— offenses often find their cases and court proceedings the subject of moment-by-moment media coverage. Society’s fascination with crime and punishment has become a fixture of contemporary life. The Bible speaks of a day in court that none can evade or avoid. What does the Bible say about this judgment? When will it happen? Who is in charge? And will you be found guilty or innocent  before God? Keep reading. God’s Word offers answers that are filled with hope!",
      lessonID: 17,
      questionID: 0,
      type: "text",
    },
    "17-1": {
      blanks: [
        {
          choices: ["all", "now", "go"],
          correctAnswer: "all",
          textAfter:
            " appear  before the judgment seat of Christ, that each one may receive the things done in the body, according to what he has done, whether good or bad.",
          textBefore: "We must",
        },
      ],
      body: "\nEvery person will face the judgment and answer for the decisions made in this life. As serious as this is, there is no need to be afraid of this event. God’s Word reveals that if you put your trust in Jesus, you can look forward to the judgment with confidence!",
      choices: ["all", "now", "go"],
      lessonID: 17,
      question: "How many people will face the judgment?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "For we must all appear before the judgment seat of Christ, that each one may receive the things done in the body, according to what he has done, whether good or bad.",
          ref: "2 Corinthians 5:10",
        },
      ],
    },
    "17-10": {
      blanks: [
        {
          choices: ["King", "Messiah", "Father"],
          correctAnswer: "Messiah",
          textAfter: " the Prince.\n",
          textBefore: ". . . until",
        },
      ],
      body: "Daniel was told that the Messiah would come 69 weeks  after the command to rebuild Jerusalem. That command was given in 457 BC, so 69 weeks (483 literal years) brings us to the year AD 27 (when calculating this, remember that there is no year 0, so we must add a year). According to this prophecy, the Messiah would appear in AD 27. “Messiah” means “the Anointed One.” In AD 27, Jesus was baptized in the Jordan River and was anointed by the Holy Spirit (Acts 10:37, 38), beginning His public ministry as the Messiah. Luke 3:1 says Jesus’ baptism took place in the 15th year of Tiberius Caesar’s reign, which history places at AD 27. The Messiah, Jesus Christ, came right on time in AD 27! When Jesus announced that “the time is fulfilled” (Mark 1:15), He was declaring that the time prophecy of Daniel 9:25 had been fulfilled. Jesus was announcing that He was the Messiah.",
      choices: ["King", "Messiah", "Father"],
      lessonID: 17,
      question: "What would happen at the end of the first 69 weeks?",
      questionID: 10,
      questionType: "radio",
      verses: [
        {
          body: "“Know therefore and understand, That from the going forth of the command to restore and build Jerusalem until Messiah the Prince, there shall be seven weeks and sixty-two weeks; The street shall be built again, and the wall, even in troublesome times.",
          ref: "Daniel 9:25",
        },
      ],
    },
    "17-11": {
      blanks: [
        {
          choices: ["cut", "off", "left", "alone", "then", "abandoned"],
          correctAnswer: "cut",
          textAfter: " ",
          textBefore: "After the sixty-two weeks Messiah shall be",
        },
        {
          choices: ["cut", "off", "left", "alone", "then", "abandoned"],
          correctAnswer: "off",
          textAfter: " , but not for Himself.",
        },
      ],
      body: "Daniel predicted the death of the Messiah! Jesus would die for the sins of the world.",
      choices: ["cut", "off", "left", "alone", "then", "abandoned"],
      lessonID: 17,
      question: "What was predicted to happen to the Messiah?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "And after the sixty-two weeks Messiah shall be cut off, but not for Himself; And the people of the prince who is to come shall destroy the city and the sanctuary. The end of it shall be with a flood, and till the end of the war desolations are determined.",
          ref: "Daniel 9:26",
        },
      ],
    },
    "17-12": {
      blanks: [
        {
          choices: ["pain", "slavery", "sacrifice"],
          correctAnswer: "sacrifice",
          textAfter: " and offering.",
          textBefore: "In the middle of the week He shall bring an end to",
        },
      ],
      body: "The “middle” of this week—seven days representing seven years in prophecy—is the year AD 31, three-and-a-half years  after the coming of the Messiah in the autumn of AD 27. When Jesus died, the curtain in the temple was miraculously torn from top to bottom (Mark 15:38), indicating that the sacrificial system was now obsolete, because Jesus—the true Lamb—had died for the sins of the world. In the temple service, the Passover lamb was sacrificed once a year on a specific day and at a specific time (the  afternoon of the 14th day in the Hebrew month of Nisan). Jesus was dying on the cross as the priests were preparing to kill the Passover lamb. On that dark  afternoon, prophecy was fulfilled as “Christ, our Passover, was sacrificed for us” (1 Corinthians 5:7). This time, prophecy demonstrates that the Bible can be trusted and that Jesus Christ is the true Messiah of Bible prophecy!",
      choices: ["pain", "slavery", "sacrifice"],
      lessonID: 17,
      question:
        "What would happen in the middle of the last week of this prophecy?",
      questionID: 12,
      questionType: "radio",
      verses: [
        {
          body: "Then he shall confirm a covenant with many for one week; But in the middle of the week He shall bring an end to sacrifice and offering. And on the wing of abominations shall be one who makes desolate, even until the consummation, which is determined, is poured out on the desolate.",
          ref: "Daniel 9:27",
        },
      ],
    },
    "17-13": {
      blanks: [
        {
          choices: ["Israel", "Jacob", "David"],
          correctAnswer: "Israel",
          textAfter: " .",
          textBefore:
            "Do not go into the way of the Gentiles, and do not enter a city of the Samaritans. But go rather to the lost sheep of the house of",
        },
      ],
      body: "\n After being anointed as the Messiah in AD 27, Jesus instructed His disciples to focus on preaching to the Jewish people. He longed for the Jewish nation to accept and present Him as the Messiah to the whole world. Even  after His death, Jesus told His disciples to begin their ministry at Jerusalem. He had not given up on the people of Jerusalem. There was still time for them to repent of their sin of rejecting the true Messiah.",
      choices: ["Israel", "Jacob", "David"],
      lessonID: 17,
      question: "To whom did Jesus tell His disciples to first preach?",
      questionID: 13,
      questionType: "radio",
      verses: [
        {
          body: "These twelve Jesus sent out and commanded them, saying: “Do not go into the way of the Gentiles, and do not enter a city of the Samaritans. But go rather to the lost sheep of the house of Israel.",
          ref: "Matthew 10:5, 6",
        },
      ],
    },
    "17-14": {
      blanks: [
        {
          choices: ["known", "taken", "bought"],
          correctAnswer: "taken",
          textAfter:
            " from you and given to a nation bearing the fruits of it.",
          textBefore: "The kingdom of God will be",
        },
      ],
      body: "Jesus loved the people of Jerusalem. He knew the prophecy of Daniel 9, and He passionately warned them about refusing to accept the gift of salvation. Jesus declared that the great promise of a glorious future would be taken away from the Jews and given to another people.",
      choices: ["known", "taken", "bought"],
      lessonID: 17,
      question: "What warning did Jesus give to the people of Israel?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore I say to you, the kingdom of God will be taken from you and given to a nation bearing the fruits of it.",
          ref: "Matthew 21:43",
        },
      ],
    },
    "17-15": {
      blanks: [
        {
          choices: ["everywhere", "about", "south"],
          correctAnswer: "everywhere",
          textAfter: " preaching the word.",
          textBefore:
            "Devout men carried Stephen to his burial . . . Therefore those who were scattered went",
        },
      ],
      body: "When Stephen was killed by the Jewish religious leaders, he became the first Christian martyr. This occurred in AD 34, exactly 490 years  after the start of the prophecy. The blessings of the gospel were now to be extended to Gentiles as well as Jews. Israel was no longer God’s exclusive nation. Today, all who accept Jesus Christ as their Savior are considered part of God’s modern Israel. Galatians 3:29 says, “If you are Christ’s, then you are Abraham’s seed, and heirs according to the promise.” Paul wrote in Romans 2:28, 29, “He is not a Jew who is one outwardly, nor is circumcision that which is outward in the flesh; but he is a Jew who is one inwardly; and circumcision is that of the heart.”",
      choices: ["everywhere", "about", "south"],
      lessonID: 17,
      question: "When did the gospel really begin to go to the Gentiles?",
      questionID: 15,
      questionType: "radio",
      verses: [
        {
          body: "2 And devout men carried Stephen to his burial, and made great lamentation over him. 4 Therefore those who were scattered went everywhere preaching the word.",
          ref: "Acts 8:2, 4",
        },
      ],
    },
    "17-16": {
      blanks: [
        {
          choices: [
            "Reckoning",
            "show",
            "Coming",
            "steer",
            "Atonement",
            "cleanse",
          ],
          correctAnswer: "Atonement",
          newline: [1],
          textAfter:
            " . It shall be a holy convocation for you; you shall afflict your souls, and offer an offering made by fire to the Lord. ",
          textBefore: "The tenth day of this seventh month shall be the Day of",
        },
        {
          choices: [
            "Reckoning",
            "show",
            "Coming",
            "steer",
            "Atonement",
            "cleanse",
          ],
          correctAnswer: "cleanse",
          textAfter:
            " you, that you may be clean from all your sins  before the Lord.",
          textBefore: "On that day the priest shall make atonement for you, to",
        },
      ],
      body: "As animal sacrifices were offered each day, the priest took some of the blood of the sacrifices and sprinkled it inside the Holy Place of the sanctuary. On other occasions, the priest ate part of the flesh of the sacrifice. Both services symbolized the transfer of sin from the animal into the sanctuary. On one day each year, a special event took place. On the Day of Atonement, the High Priest entered the Most Holy Place, into the very presence of God and His law. The Day of Atonement, or Yom Kippur, was a day set aside to ensure complete harmony between God and humans. To “atone” means to restore “at one”-ness with God. The purpose was to cleanse both the sanctuary and the sinner. The record of sin left by sacrificial blood had built up in the sanctuary throughout the year. On the Day of Atonement, these sins were symbolically “blotted out,” and the sanctuary was cleansed of sin. This was a day of judgment. The people of Israel would “afflict” their souls by making sure there were no specific sins left unconfessed or unforsaken. On this day, those who refused to confess their sins were judged guilty and cut off from God’s people (Leviticus 23:29).",
      choices: ["Reckoning", "show", "Coming", "steer", "Atonement", "cleanse"],
      lessonID: 17,
      question: "When was the earthly sanctuary “cleansed”?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "Also the tenth day of this seventh month shall be the Day of Atonement. It shall be a holy convocation for you; you shall afflict your souls, and offer an offering made by fire to the Lord.",
          ref: "Leviticus 23:27",
        },
        {
          body: "For on that day the priest shall make atonement for you, to cleanse you, that you may be clean from all your sins before the Lord.",
          ref: "Leviticus 16:30",
        },
      ],
    },
    "17-17": {
      blanks: [
        {
          choices: ["purified", "better", "seen", "more", "washed", "fresh"],
          correctAnswer: "purified",
          textAfter:
            " with these [the blood of animals], but the heavenly things themselves [the heavenly sanctuary] with",
          textBefore:
            "It was necessary that the copies of the things in the heavens [the earthly sanctuary] should be",
        },
        {
          choices: ["purified", "better", "seen", "more", "washed", "fresh"],
          correctAnswer: "better",
          textAfter: " sacrifices than these [the precious blood of Jesus].",
        },
      ],
      body: "The cleansing of the sanctuary referred to by Daniel does not involve an earthly sanctuary. The Jewish temple was destroyed by the Romans in AD 70 and has never been rebuilt. The events and symbols of the earthly sanctuary point to Jesus and the sanctuary in heaven. The cleansing of the heavenly sanctuary is the removal of the record of our sins from the books of heaven (Daniel 7:10). While sinners are forgiven when they repent of their sins, even the very record of our sins is blotted out in God’s judgment!",
      choices: ["purified", "better", "seen", "more", "washed", "fresh"],
      lessonID: 17,
      question: "How will the heavenly sanctuary be cleansed?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore it was necessary that the copies of the things in the heavens should be purified with these, but the heavenly things themselves with better sacrifices than these.",
          ref: "Hebrews 9:23",
        },
      ],
    },
    "17-18": {
      Supplements: {
        "-L82jBu6qP_uvEYDrEDL": {
          body: "The whole 2300-day prophecy stands or falls together. If the judgment in heaven didn’t begin in 1844, then that means that the rest of the events in the prophecy didn’t happen on time either. In other words, Stephen wasn’t stoned in AD 34, Jesus wasn’t crucified in AD 31, He wasn’t baptized in AD 27, and the decree of Artaxerxes wasn’t given in 457 BC. Or, to put it in even clearer words, if the judgment didn’t begin in 1844, Jesus isn’t the Messiah. \n\nIn fact, this prophecy is the MOST POWERFUL prophecy in the entire Bible, showing that Jesus is the Messiah. And if He is the Messiah, then that means that you and I have a judgment day coming very soon. Now is a good time to make sure we’re right with God.\n",
          title: "How do we know the judgment began in 1844?",
        },
      },
      blanks: [
        {
          choices: ["whole", "cleansed", "new"],
          correctAnswer: "cleansed",
          textAfter: " .\n",
          textBefore:
            "For two thousand three hundred days; then the sanctuary shall be",
        },
      ],
      body: "\nThe starting date of this prophecy was the command allowing the Jews to return to Jerusalem and rebuild their city (Daniel 9:25), which was issued in the year 457 BC. Counting 2,300 years from 457 BC brings us to the year 1844, the start of the cleansing of the sanctuary. In 1844, Jesus began the work of judgment in God’s sanctuary in heaven. According to the Bible, we are now living in heaven’s judgment hour! (Again, when calculating this time prophecy, remember to add one year because there is no year 0).",
      choices: ["whole", "cleansed", "new"],
      lessonID: 17,
      question: "When will the sanctuary be cleansed?",
      questionID: 18,
      questionType: "radio",
      verses: [
        {
          body: "And he said to me, “For two thousand three hundred days; then the sanctuary shall be cleansed.",
          ref: "Daniel 8:14",
        },
      ],
    },
    "17-19": {
      Supplements: {
        "-L82jKp2o1NdPESQL3ar": {
          body: "Facing the judgment is easy if you remember three things:\n1. Jesus is your lawyer (advocate – 1 John 2:1). If you could have anyone represent you in court, you couldn’t get a better advocate than Jesus.\n2. Jesus is your judge (John 5;22). In an act of incredible mercy, the Father has given all judgment over to the Son and there is not a fairer judge in the universe than He. Not only does He understand the trials and tribulations of humanity, but He has the heart of divinity as well. \n3. Jesus is your friend (John 15:12-17). If Jesus is your friend, you can expect that He will never let you down.\n\nSo, if Jesus is your lawyer, and your judge, and your friend, then there’s no reason to fear the judgement.\n",
          title: "How can I have more confidence as I face the judgment?",
        },
        "-L82jgUGoGKE6Tv2Ok4W": {
          body: "As long as you have genuinely accepted Jesus as your Lord and Savior, then you can expect that He will defend you in the judgment. If you have confessed your sins to Him, are trusting completely in Him, and are allowing Him to guide your life, then you will be in good shape.\n\nHowever, if you’re only paying him lip-service (playacting as a Christian, if you will), then that will come out in the judgment. You can hide sinful words, thoughts, and deeds from the people you know, but everything is “naked and opened” before God (Hebrews 4:13). He knows whether your profession of faith in Him is authentic or not.\n\nIf your acceptance of Him is genuine, He will stand for you in the judgment. Then, when your name is called in the books of heaven, Jesus will stand on your behalf and the book of His life will be opened in place of yours. That’s because His life will be substituted for yours. But if your acceptance of Him is not genuine, if He is not truly the Lord of your life, then He will not stand on your behalf. Then, in the judgment, all that will be seen in your case is the long list of sins that you have committed. So, in truth, if Jesus stands on your behalf, there’s no way you can fail the judgment. But, if Jesus doesn’t stand on your behalf, there’s no way you can pass the judgment. The big question then becomes, will Jesus stand on your behalf?\n\nIn this judgment, is God going to judge the individual sins I have committed?\n\nYes and no.  While God “will bring every work into judgment, with every secret thing” (Ecclesiastes 12:14), people facing judgment have effectively already judged themselves.  Jesus simply looks at the books of record to see if the person in question chose Him as Lord and Savior, and if so, whether that person had repented of his or her sins.  If so, he or she is saved.  Jesus simply honors the decision that was made for Him.  However, if decisions were made against Him, He will likewise honor that decision.\n\nThe judgment is basically an audit.  God looks at the books and honors the decisions reflected there, inscribed by the choices we have made for or against Jesus.",
          title: "How can I make sure that Jesus defends me in the judgment?",
        },
      },
      blanks: [
        {
          choices: ["has", "will", "might"],
          correctAnswer: "has",
          textAfter:
            " come; and worship Him who made heaven and earth, the sea and springs of water.",
          textBefore:
            "Fear God and give glory to Him, for the hour of His judgment",
        },
      ],
      body: "Living at this time in earth’s history is not “business as usual.” God’s judgment is now in session. Therefore, we can confidently worship God, knowing that as we yield our lives fully to Jesus Christ, we have a High Priest in heaven who is “for us” (Hebrews 9:24).",
      choices: ["has", "will", "might"],
      lessonID: 17,
      question: "What impact should the judgment have on a person’s life?",
      questionID: 19,
      questionType: "radio",
      verses: [
        {
          body: "7 saying with a loud voice, “Fear God and give glory to Him, for the hour of His judgment has come; and worship Him who made heaven and earth, the sea and springs of water.”",
          ref: "Revelation 14:7",
        },
      ],
    },
    "17-2": {
      blanks: [
        {
          choices: ["father", "son", "reward"],
          correctAnswer: "reward",
          textAfter: " is with Me, to give to every one according to his work.",
          textBefore: "Behold, I am coming quickly, and My",
        },
      ],
      body: "\nJesus will come with His reward, and a reward must first be determined  before it can be given. Therefore, there is a time prior to Christ’s return when the judgment will take place. This judgment will reveal who is saved and who is lost. As with any courtroom, there will be an investigation of the evidence, followed by a verdict and a sentence. For the believer in Jesus, the sentence (or reward) is eternity with our Friend and Savior.",
      choices: ["father", "son", "reward"],
      correctAnswer: "true",
      lessonID: 17,
      question:
        "Will the judgment take place prior to the Second Coming of Jesus?",
      questionID: 2,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "According to Revelation 22:12, the Judgment will take place prior to the Second Coming of Jesus",
      verses: [
        {
          body: "And behold, I am coming quickly, and My reward is with Me, to give to every one according to his work.",
          ref: "Revelation 22:12",
        },
      ],
    },
    "17-20": {
      correctAnswer: "true",
      lessonID: 17,
      question: "Are you willing to commit your life to Jesus today?",
      questionID: 20,
      questionType: "truthConfirmation",
    },
    "17-3": {
      blanks: [
        {
          choices: ["house", "doors", "court", "books", "Lord", "tables"],
          correctAnswer: "court",
          textAfter: " was seated, and the",
          textBefore:
            "I watched till thrones were put in place, and the Ancient of Days was seated . . . The",
        },
        {
          choices: ["house", "doors", "court", "books", "Lord", "tables"],
          correctAnswer: "books",
          textAfter: " were opened.",
        },
      ],
      body: "Daniel in vision saw the judgment in heaven’s sanctuary. God sat on His throne. The court was seated. Millions of angels were present. The books were opened for investigation, and the judgment began. Daniel portrays this scene as a spectacular event.",
      choices: ["house", "doors", "court", "books", "Lord", "tables"],
      lessonID: 17,
      question: "How did the prophet Daniel describe the judgment?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "I watched till thrones were put in place, and the Ancient of Days was seated; His garment was white as snow, and the hair of His head was like pure wool.  His throne was a fiery flame, its wheels a burning fire; 10 A fiery stream issued and came forth from before Him.  A thousand thousands ministered to Him; Ten thousand times ten thousand stood before Him. The court was seated, and the books were opened.",
          ref: "Daniel 7:9, 10",
        },
      ],
    },
    "17-4": {
      blanks: [
        {
          choices: ["kingdom", "glory", "gifts"],
          correctAnswer: "kingdom",
          textAfter:
            " , and possess the kingdom forever, even forever and ever.",
          textBefore: "The saints of the Most High shall receive the",
        },
      ],
      body: "As people have lived on the earth, they have either accepted or rejected Jesus Christ as their Lord and Savior. The judgment reveals and ratifies the decisions that have been made for or against Jesus. The saved will be found to have yielded their lives to Him, while the lost will be found to have chosen against surrender to Christ. At the completion of this judgment, none will doubt God’s integrity, justice or love. Heaven’s response to God’s judgment is, “Great and marvelous are Your works, Lord God Almighty! Just and true are Your ways, O King of the saints . . . For all nations shall come and worship  before You, for Your judgments have been manifested” (Revelation 15:3, 4).",
      choices: ["kingdom", "glory", "gifts"],
      lessonID: 17,
      question: "What is the purpose of the judgment?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "But the saints of the Most High shall receive the kingdom, and possess the kingdom forever, even forever and ever",
          ref: "Daniel 7:18",
        },
      ],
    },
    "17-5": {
      blanks: [
        {
          choices: [
            "person",
            "yard",
            "statue",
            "being",
            "story",
            "want",
            "work",
            "law",
            "law",
          ],
          correctAnswer: "work",
          newline: [1],
          textAfter:
            " into judgment, including every secret thing, whether good or evil. ",
          textBefore: "God will bring every",
        },
        {
          choices: [
            "person",
            "yard",
            "statue",
            "being",
            "story",
            "want",
            "work",
            "law",
            "law",
          ],
          correctAnswer: "law",
          textAfter: " , and yet stumble in one point, he is guilty of all. ",
          textBefore: "Whoever shall keep the whole",
        },
        {
          choices: [
            "person",
            "yard",
            "statue",
            "being",
            "story",
            "want",
            "work",
            "law",
            "law",
          ],
          correctAnswer: "liberty",
          textAfter: ".",
          textBefore:
            "For He who said, “Do not commit adultery,” also said, “Do not murder.” Now if you do not commit adultery, but you do murder, you have become a transgressor of the law. So speak and so do as those who will be judged by the law of",
        },
      ],
      body: "The standard in the judgment is the law of God. Our thoughts and actions are measured against the holy standard of God’s law. Since “all have sinned,” how can a just God declare a guilty person to be “not guilty”? The Bible says the “wages of sin is death” (Romans 6:23). All who have sinned are guilty and deserve death, but Jesus took the sentence and died in the place of the sinner. Since He is the One who was sinned against, He is the only One who can take the punishment for sin on behalf of the guilty. Jesus forgives us “according to the riches of His grace” (Ephesians 1:7). His grace then enables us to be cleansed of sin through that same power (1 John 1:7, 9). Our names are written in the Lamb’s Book of Life. At the end of time, those whose names are found written in this book will be saved (Daniel 12:1). In the judgment, Jesus promises His followers—those who experience His forgiving and overcoming power—that He will not blot their names out of the Book of Life. Rather, the record of their sins will be blotted out (Acts 3:19).",
      choices: [
        "person",
        "yard",
        "statue",
        "being",
        "story",
        "want",
        "work",
        "law",
        "liberty",
      ],
      lessonID: 17,
      question: "On what basis will people be judged?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "For God will bring every work into judgment, including every secret thing, whether good or evil.",
          ref: "Ecclesiastes 12:14",
        },
        {
          body: "10 For whoever shall keep the whole law, and yet stumble in one point, he is guilty of all. 11 For He who said, “Do not commit adultery,” also said, “Do not murder.” Now if you do not commit adultery, but you do murder, you have become a transgressor of the law. 12 So speak and so do as those who will be judged by the law of liberty.",
          ref: "James 2:10-12",
        },
      ],
    },
    "17-6": {
      blanks: [
        {
          choices: ["cleansed", "whole", "built"],
          correctAnswer: "cleansed",
          textAfter: " .",
          textBefore:
            "For two thousand three hundred days; then the sanctuary shall be",
        },
      ],
      body: "In Daniel 9:20–22, the angel Gabriel appears to Daniel—the same angel “seen in the vision” of chapter 8 “at the beginning” (Daniel 9:21). Gabriel provides the starting date of the judgment when he tells Daniel about a period of 2,300 years. Gabriel then provides further details of the vision that relate specifically to Daniel’s city and people—Jerusalem and the Jews.",
      choices: ["cleansed", "whole", "built"],
      lessonID: 17,
      question: "When does the judgment begin?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "And he said to me, “For two thousand three hundred days; then the sanctuary shall be cleansed.",
          ref: "Daniel 8:14",
        },
      ],
    },
    "17-7": {
      blanks: [
        {
          choices: ["Forty", "Several", "Seventy"],
          correctAnswer: "Seventy",
          textAfter:
            " weeks are determined for your people and for your holy city, to finish the transgression, to make an end of sins, to make reconciliation for iniquity, to bring in everlasting righteousness, to seal up vision and prophecy, and to anoint the Most Holy.",
        },
      ],
      body: "God gave a 70-week time period for the nation of Israel to repent of its apostasy, during which time Jesus would come to the world as the long-awaited Messiah.",
      choices: ["Forty", "Several", "Seventy"],
      lessonID: 17,
      question: "What incredible prophecy reveals Jesus as the Messiah?",
      questionID: 7,
      questionType: "radio",
      verses: [
        {
          body: "Seventy weeks are determined for your people and for your holy city, to finish the transgression, to make an end of sins, to make reconciliation for iniquity, to bring in everlasting righteousness, to seal up vision and prophecy, and to anoint the Most Holy.",
          ref: "Daniel 9:24",
        },
      ],
    },
    "17-8": {
      blanks: [
        {
          choices: ["month", "year", "hour"],
          correctAnswer: "year",
          textAfter: " .",
          textBefore: "I have laid on you a day for each",
        },
      ],
      body: "In Bible prophecy, a day represents a literal year. This principle is found in several places throughout the Bible (see Numbers 14:34), and is validated by numerous prophecies. It would be impossible for the events of Daniel 9 to apply to a literal 490 days. The 70 weeks (490 days) represent 490 literal years.",
      choices: ["month", "year", "hour"],
      correctAnswer: "false",
      lessonID: 17,
      question: "In prophetic symbolism, what does a day represent?",
      questionID: 8,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "According to Ezekiel 4:6, a day represents 100 years in prophetic symbolism.",
      verses: [
        {
          body: "And when you have completed them, lie again on your right side; then you shall bear the iniquity of the house of Judah forty days. I have laid on you a day for each year.",
          ref: "Ezekiel 4:6",
        },
      ],
    },
    "17-9": {
      blanks: [
        {
          choices: ["command", "mission", "idea"],
          correctAnswer: "command",
          textAfter:
            " to restore and build Jerusalem until Messiah the Prince, there shall be seven weeks and sixty-two weeks; the street shall be built again, and the wall, even in troublesome times.",
          textBefore:
            "Know therefore and understand, that from the going forth of the",
        },
      ],
      body: "The starting point of this prophecy was a command allowing the Jews to return to Jerusalem and rebuild their city. This decree, found in Ezra 7:11–26, was made by King Artaxerxes in the seventh year of his reign, in 457 BC.",
      choices: ["command", "mission", "idea"],
      lessonID: 17,
      question:
        "What was the starting point for this time period for the Jews?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "Know therefore and understand, that from the going forth of the command to restore and build Jerusalem until Messiah the Prince, there shall be seven weeks and sixty-two weeks; The street shall be built again, and the wall, even in troublesome times.",
          ref: "Daniel 9:25",
        },
      ],
    },
  },
  {
    "18-0": {
      body: "According to Greek legend, the Trojan War began after Helen, the wife of the king of Sparta, left him to be with a man named Paris in the city of Troy. The expedition to avenge the Spartan king was unsuccessful, so the Greeks set sail for Troy in a fleet of 1,000 ships.  After years of fruitless efforts to take Troy, the Spartans resorted to treachery rather than force. They constructed a large wooden horse, and left it—filled with armed warriors—outside the city of Troy. Believing the horse would bring them good fortune, the Trojans brought it inside their city. At night, Greek soldiers emerged from the wooden horse, and the city of Troy was captured and destroyed. Something promising good fortune instead brought calamity! As we look at the prophecies of this planet’s final days and the prediction that a time of spiritual crisis will come to the world, the Bible details the rise of a spiritual Trojan horse. Something that seems to offer hope and blessing will instead bring spiritual danger-ultimately preparing the world for Satan’s final, deadly plans.",
      lessonID: 18,
      questionID: 0,
      type: "text",
    },
    "18-1": {
      blanks: [
        {
          choices: ["imbecile", "liar", "antichrist"],
          correctAnswer: "antichrist",
          textAfter: " .",
          textBefore:
            "Many deceivers have gone out into the world who do not confess Jesus Christ as coming in the flesh. This is a deceiver and an",
        },
      ],
      body: "The term “antichrist” is mentioned in only four passages of the Bible—all in the letters of John. In each case, the term is used to portray a false teacher or a deceptive power that corrupts faith within the church. While the prefix “anti” can mean “against,” it can also mean “in place of.” The antichrist of the last days will not be an open opposer of Christ, but will actually seek to take the place of Christ. Consider this: the great deception of the last days will result in “all the world” following the beast of Revelation 13 (Revelation 13:8). Someone coming in open opposition to Jesus—standing against Him and refuting the Word of God—would not succeed in deceiving “all the world,” especially the Christian world. But a power espousing Christian virtues and appearing to represent God would be far more likely to deceive the planet. It was Lucifer who first wanted to take the place of Christ (Isaiah 14:12–14), and it is he who continually opposes and misrepresents Him. But through whom or what will he work in earth’s final days?",
      choices: ["imbecile", "liar", "antichrist"],
      lessonID: 18,
      question: "What does the Bible say about the antichrist?",
      questionID: 1,
      questionType: "radio",
      verses: [
        {
          body: "For many deceivers have gone out into the world who do not confess Jesus Christ as coming in the flesh. This is a deceiver and an antichrist.",
          ref: "2 John 1:7",
        },
      ],
    },
    "18-10": {
      blanks: [
        {
          choices: ["growing", "healed", "bad"],
          correctAnswer: "healed",
          textAfter: " . And all the world marveled and followed the beast.",
          textBefore:
            "I saw one of his heads as if it had been mortally wounded, and his deadly wound was",
        },
      ],
      body: "The first beast (nation) of Revelation 13 and the little horn of Daniel 7 are the same entity. Notice the similarities: both speak blasphemies (Daniel 7:25; Revelation 13:5, 6), both persecute God’s people (Daniel 7:21, 25; Revelation 13:7), and both rule for 1,260 years (Daniel 7:25; Revelation 13:5). The entire world will be so influenced by this power that those who do not receive its mark will not be able to buy and sell (Revelation 13:17). Everyone on the planet—with the exception of those who remain faithful to Jesus—will worship this power (Revelation 13:8).",
      choices: ["growing", "healed", "bad"],
      lessonID: 18,
      question:
        "How influential will the little horn’s role be in planet Earth’s final days?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I saw one of his heads as if it had been mortally wounded, and his deadly wound was healed. And all the world marveled and followed the beast.",
          ref: "Revelation 13:3",
        },
      ],
    },
    "18-11": {
      blanks: [
        {
          choices: ["Satan", "fools", "death"],
          correctAnswer: "death",
          textAfter: " .",
          textBefore:
            "There is a way that seems right to a man, but its end is the way of",
        },
      ],
      body: "William Shakespeare once wrote, “All that glisters is not gold.” While it is undoubtedly true that Vatican City stands for much that is good and right, many of her teachings deviate far from the truth of the Bible. These and many other unbiblical ideas demonstrate that Rome’s teachings do not build faith in the Bible or in Jesus as the Savior of the world. Rather, they undermine the Bible and are in opposition to the teachings of Jesus. Churches don’t typically set out to misrepresent the Word of God. In fact, in most cases, those who are teaching unbiblical doctrines are unaware they are doing so, and are intending to be a blessing to the world. But when Bible truth is rejected, churches can only offer the world a gospel that is riddled with inconsistencies and inaccuracies. Such errors are never harmless, and some are dangerous and misleading. False teachings also misrepresent the character of God, making it difficult for people to truly understand God’s grace and mercy, and the beauty of the gift of eternal life.",
      choices: ["Satan", "fools", "death"],
      lessonID: 18,
      question: "How can something be wrong when it looks so good?",
      questionID: 11,
      questionType: "radio",
      verses: [
        {
          body: "There is a way that seems right to a man, but its end is the way of death.",
          ref: "Proverbs 14:12",
        },
      ],
    },
    "18-12": {
      blanks: [
        {
          choices: ["Lord Jesus Christ", "word of God", "truth of love"],
          correctAnswer: "Lord",
          textAfter: " ",
          textBefore: "Believe on the",
        },
        {
          choices: ["Lord Jesus Christ", "word of God", "truth of love"],
          correctAnswer: "Jesus",
          textAfter: " ",
        },
        {
          choices: ["Lord Jesus Christ", "word of God", "truth of love"],
          correctAnswer: "Christ",
          textAfter: " , and you will be saved.",
        },
      ],
      body: "Faith in Jesus Christ, demonstrated by a moment-by-moment connection with Him, will prepare any person to live a heaven-bound life ready for Jesus’ Second Coming.",
      choices: ["Lord", "word", "truth", "Jesus", "Christ"],
      lessonID: 18,
      question:
        "Where should our faith be directed in preparation for the return of Jesus?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "So they said, “Believe on the Lord Jesus Christ, and you will be saved, you and your household.",
          ref: "Acts 16:31",
        },
      ],
    },
    "18-13": {
      blanks: [
        {
          choices: [
            "God",
            "His",
            "lives",
            "faith",
            "I",
            "your",
            "within",
            "works",
          ],
          correctAnswer: "God",
          textAfter: " who works in you both to will and to do for",
          textBefore: "It is",
        },
        {
          choices: [
            "God",
            "His",
            "lives",
            "faith",
            "I",
            "your",
            "within",
            "works",
          ],
          correctAnswer: "His",
          newline: [1],
          textAfter: " good pleasure.",
        },
        {
          choices: [
            "God",
            "His",
            "lives",
            "faith",
            "I",
            "your",
            "within",
            "works",
          ],
          correctAnswer: "lives",
          textAfter:
            " in me; and the life which I now live in the flesh I live by",
          textBefore:
            " I have been crucified with Christ; it is no longer I who live, but Christ",
        },
        {
          choices: [
            "God",
            "His",
            "lives",
            "faith",
            "I",
            "your",
            "within",
            "works",
          ],
          correctAnswer: "faith",
          textAfter:
            " in the Son of God, who loved me and gave Himself for me.",
        },
      ],
      body: "Jesus pledges to live in the lives of all who surrender themselves unreservedly to Him. When your life is given to Christ, you have the assurance that His power  fills you, directs you and keeps you. No one is left to fight the power of evil on his or her own. Jesus living His life in you enables you to live a life of faith and victory! Romans 6:16 (KJV) says, “Know ye not, that to whom ye yield yourselves servants to obey, his servants ye are to whom ye obey; whether of sin unto death, or of obedience unto righteousness?” Through the power of the Holy Spirit, you can live a life of surrender today!",
      choices: ["I", "works", "lives", "within", "God", "your", "faith", "His"],
      lessonID: 18,
      question:
        "How can a person hope to be faithful to God in a time when “all the world” follows this entity?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "For it is God who works in you both to will and to do for His good pleasure.",
          ref: "Philippians 2:13",
        },
        {
          body: "I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.",
          ref: "Galatians 2:20",
        },
      ],
    },
    "18-14": {
      correctAnswer: "true",
      lessonID: 18,
      question:
        "Are you willing to follow Jesus wherever He leads, and allow the Bible to be the basis for your faith in Him?",
      questionID: 14,
      questionType: "truthConfirmation",
    },
    "18-2": {
      blanks: [
        {
          choices: ["power; God", "man; sin", "foolishness; men"],
          correctAnswer: "man",
          textAfter: " of",
          textBefore:
            "Let no one deceive you by any means; for that Day will not come unless the falling away comes first, and the",
        },
        {
          choices: ["power; God", "man; sin", "foolishness; men"],
          correctAnswer: "sin",
          textAfter: " is revealed, the son of perdition.",
        },
      ],
      body: "Paul states that  before Jesus returns to this planet, the church would experience a major spiritual “falling away,” revealing the “man of lawlessness” (or “man of sin”). As 1 John 3:4 states that “sin is lawlessness” (or “the transgression of the law,” KJV), it can be expected that the great apostasy of earth’s last days will be characterized by disrespect for God’s authority—and in particular, His law.",
      choices: ["power", "God", "man", "sin", "foolishness", "men"],
      lessonID: 18,
      question:
        "How does the Bible describe the power that will bring spiritual danger to the world?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "Let no one deceive you by any means; for that Day will not come unless the falling away comes first, and the man of sin is revealed, the son of perdition",
          ref: "2 Thessalonians 2:3",
        },
      ],
    },
    "18-3": {
      blanks: [
        {
          choices: [
            "yourselves",
            "temple",
            "these",
            "house",
            "earth",
            "throne",
          ],
          correctAnswer: "yourselves",
          textAfter:
            " men will rise up, speaking perverse things, to draw away the disciples after themselves. He sits as God in the",
          textBefore:
            "I know this, that after my departure savage wolves will come in among you, not sparing the flock. Also from among",
        },
        {
          choices: [
            "yourselves",
            "temple",
            "these",
            "house",
            "earth",
            "throne",
          ],
          correctAnswer: "temple",
          textAfter: " of God, showing himself that he is God.",
        },
      ],
      body: "Paul stated that significant problems would arise from within the Christian church. As stated in It Is Written Bible Study Guides #16 and #17, the earthly temple and its services became obsolete when Jesus died on the cross, and any rebuilt temple would not be of God. When the Bible says the last-day antichrist will sit “in the temple of God,” it is stating that this entity will rise up in the Christian church. The New Testament refers to God’s people or God’s church as a “temple” numerous times. (See 1 Corinthians 3:16, 17; 1 Corinthians 6:19; 2 Corinthians 6:16 and Ephesians 2:20–22)",
      choices: ["yourselves", "temple", "these", "house", "earth", "throne"],
      lessonID: 18,
      question:
        "From where did the Bible writers warn apostasy would arise in planet Earth’s final days?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: " For I know this, that after my departure savage wolves will come in among you, not sparing the flock. 30 Also from among yourselves men will rise up, speaking perverse things, to draw away the disciples after themselves.",
          ref: "Acts 20:29, 30",
        },
        {
          body: "Who opposes and exalts himself above all that is called God or that is worshiped, so that he sits as God in the temple of God, showing himself that he is God.",
          ref: "2 Thessalonians 2:4",
        },
      ],
    },
    "18-4": {
      blanks: [
        {
          choices: ["one", "monster", "four", "beasts", "no", "worries"],
          correctAnswer: "four",
          textAfter: " great",
          textBefore:
            "The four winds of heaven were stirring up the Great Sea. And",
        },
        {
          choices: ["one", "monster", "four", "beasts", "no", "worries"],
          correctAnswer: "beasts",
          textAfter: " came up from the sea, each different from the other.",
        },
      ],
      body: "In Bible prophecy, symbols are frequently used to represent important realities.\nA beast represents a kingdom or a nation (Daniel 7:17, 23).\nThe sea represents multitudes of people (Revelation 17:1, 15).\nWind represents strife or warfare (Jeremiah 49:36, 37; Revelation 7:1–3).\nIn Daniel 7, Daniel sees the rise of four powerful nations—the same nations revealed to King Nebuchadnezzar in Daniel 2.",
      choices: ["one", "monster", "four", "beasts", "no", "worries"],
      lessonID: 18,
      question: "What did Daniel see emerging from a windswept sea?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "Daniel spoke, saying, “I saw in my vision by night, and behold, the four winds of heaven were stirring up the Great Sea.   3 And four great beasts came up from the sea, each different from the other.",
          ref: "Daniel 7:2, 3",
        },
      ],
    },
    "18-5": {
      blanks: [
        {
          choices: [
            "bird",
            "penguin",
            "llama",
            "scary",
            "sharp",
            "lion",
            "bear",
            "leopard",
            "strong",
            "iron",
          ],
          correctAnswer: "lion",
          textAfter: " , and had eagle’s wings. ",
          textBefore: "The first was like a",
        },
        {
          choices: [
            "bird",
            "penguin",
            "llama",
            "scary",
            "sharp",
            "lion",
            "bear",
            "leopard",
            "strong",
            "iron",
          ],
          correctAnswer: "bear",
          textAfter:
            " . It was raised up on one side, and had three ribs in its mouth between its teeth. ",
          textBefore: "Suddenly another beast, a second, like a",
        },
        {
          choices: [
            "bird",
            "penguin",
            "llama",
            "scary",
            "sharp",
            "lion",
            "bear",
            "leopard",
            "strong",
            "iron",
          ],
          correctAnswer: "leopard",
          textAfter:
            " , which had on its back four wings of a bird. The beast also had four heads, and dominion was given to it. ",
          textBefore: "There was another, like a",
        },
        {
          choices: [
            "bird",
            "penguin",
            "llama",
            "scary",
            "sharp",
            "lion",
            "bear",
            "leopard",
            "strong",
            "iron",
          ],
          correctAnswer: "strong",
          textBefore:
            "Behold, a fourth beast, dreadful and terrible, exceedingly",
        },
        {
          choices: [
            "bird",
            "penguin",
            "llama",
            "scary",
            "sharp",
            "lion",
            "bear",
            "leopard",
            "strong",
            "iron",
          ],
          correctAnswer: "iron",
          textAfter:
            " teeth; it was devouring, breaking in pieces, and trampling the residue with its feet. It was different from all the beasts that were  before it, and it had ten horns.",
          textBefore: " . It had huge",
        },
      ],
      body: "Just as in the prophecy of Daniel 2, the nations Daniel saw in Daniel 7 are the same nations.",
      bodyImage: "",
      choices: ["iron", "weak", "lion", "leopard", "strong", "bear", "dragon"],
      lessonID: 18,
      question: "What were the four nations Daniel saw?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "4 The first was like a lion, and had eagle’s wings. I watched till its wings were plucked off; and it was lifted up from the earth and made to stand on two feet like a man, and a man’s heart was given to it.  5 “And suddenly another beast, a second, like a bear. It was raised up on one side, and had three ribs in its mouth between its teeth. And they said thus to it: ‘Arise, devour much flesh!’ 6 “After this I looked, and there was another, like a leopard, which had on its back four wings of a bird. The beast also had four heads, and dominion was given to it. 7 “After this I saw in the night visions, and behold, a fourth beast, dreadful and terrible, exceedingly strong. It had huge iron teeth; it was devouring, breaking in pieces, and trampling the residue with its feet. It was different from all the beasts that were before it, and it had ten horns.",
          ref: "Daniel 7:4-7",
        },
      ],
    },
    "18-6": {
      blanks: [
        {
          choices: ["kings", "men", "women"],
          correctAnswer: "kings",
          textAfter: " who shall arise from this kingdom.",
          textBefore: "The ten horns are ten",
        },
      ],
      body: "\nJust as the iron legs of Rome divided into the feet and the 10 toes of Daniel 2, Daniel now sees 10 horns rising out of the power of Rome. The 10 horns represent the 10 powers that rose from the divided Roman Empire. Today, these nations are in what we recognize as Western Europe.",
      choices: ["kings", "men", "women"],
      lessonID: 18,
      question: "What would take the place of the fourth kingdom?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "The ten horns are ten kings who shall arise from this kingdom. And another shall rise after them;  He shall be different from the first ones, and shall subdue three kings.",
          ref: "Daniel 7:24",
        },
      ],
    },
    "18-7": {
      blanks: [
        {
          choices: ["big", "loud", "little"],
          correctAnswer: "little",
          textAfter:
            " one, coming up among them,  before whom three of the first horns were plucked out by the roots.",
          textBefore:
            "I was considering the horns, and there was another horn, a",
        },
      ],
      body: "Historically, it has been believed that this little horn is the same power as the first beast of Revelation 13—often referred to as the “antichrist.”",
      choices: ["big", "loud", "little"],
      lessonID: 18,
      question: "What did Daniel see coming up out of the 10 horns?",
      questionID: 7,
      questionType: "radio",
      verses: [
        {
          body: "I was considering the horns, and there was another horn, a little one, coming up among them, before whom three of the first horns were plucked out by the roots. And there, in this horn, were eyes like the eyes of a man, and a mouth speaking pompous words.",
          ref: "Daniel 7:8",
        },
      ],
    },
    "18-8": {
      lessonID: 18,
      question:
        "What are the characteristics that clearly identify the little horn?",
      questionID: 8,
      questionType: "text",
      text: [
        '1.  It arises from Western Europe, from "among" the rest of the horns  (Daniel 7:8).',
        "2. It is small (Daniel 7:8).",
        '3. It arises "after" the 10 tribes of Europe are established (Daniel 7:24).',
        "4. It destroys three of the other horns/nations (Daniel 7:8).",
        '5. It is "different from " the other 10 powers (Daniel 7:24).',
        "6.  A man would speak for the little horn (Daniel 7:8).",
        '7. It blasphemes against God, speaking "pompous words against the Most High" (Daniel 7:25).',
        '8. It would "persecute" God\'s people (Daniel 7:25).',
        '9. It would reign for 1,260 years-" a time and times and half a time" (Daniel 7:25). Prophetically, a "time" is one year, "times" is two years, and "half a time" is six months ( or "three-and-one-half years" as the Amplified Bible translates it).',
        "Based on the 30-day calendar used by the ancient Scriptures, three-and-a-half-years is 1,260 days.  In Bible prophecy, a day is symbolic code for a literal year (Ezekiel 4:6). Thus, 1,260 days represent 1,260 years.  Seven times in the books of Daniel and Revelation, this same time period is given - using different phrases - to represent the length of the rule for this power.",
        '10. This power "shall intend to change times and law" (Daniel 7:25), indicating an attempt would be made to change the law of God. ',
      ],
    },
    "18-9": {
      lessonID: 18,
      question: "Who is the little horn power of Daniel 7?",
      questionID: 9,
      questionType: "text",
      text: [
        "When Christianity stays faithful to God's Word, the church is a source of light, grace and blessing.  But when Christians stray from faithfulness to the Bible and allow Bible truth to be eclipsed by traditions, false doctrines and church rules, the church cannot fulfill the position God has called it to.  Throughout history, there have been times when the church has misrepresented the Word of God - often with disastrous results.",
        'As Protestant Reformers such as Martin Luther, John Calvin and John Knox studied the book of Daniel, they identified the Roman papacy as the "little horn" power.',
        "Historically, Vatican City has been seen by many as fulfilling the identifying marks of the little horn of Daniel 7.  Is there any validity to this conclusion?",
        "Each of the 10 points in the previous question applies to the Roman papacy:",
        "1. The Vatican arose in Western Europe",
        '2. The Vatican is a "small" nation.',
        "3. The Vatican arose after the other 10 nations.  The rest of the 10 kingdoms were established by AD 476.  The Vatican  came to full political power in AD 538.",
        '4. The Vatican conquered three nations as it rose to power - the Heruli, the Vandals and the Ostrogoths.  All three kingdoms were "plucked out by the roots."  They have disappeared from Europe.',
        '5. The Vatican is "different" from the other nations in that it is both a religious and a political power.',
        '6. Daniel said that in the little horn were "eyes like the eyes of a man"  (Daniel 7:8). There would be a man " seeing" for - or leading - this power.',
        "7. The Bible defines blasphemy as a person claiming to have the ability to forgive sin ( Luke 5:21) or a person claiming to be God  ( John 10:33).  The Vatican blasphemes against God by claiming to have the power to forgive sin, and by claiming the prerogatives of God.  In 1870, The Vatican Council declared that the pope was infallible whenever speaking from his position of papal authority.",
        "8. The Vatican has persecuted Bible-believing Christians down through the centuries, and is responsible for the deaths of multiplied millions of people.",
        '9. The Vatican gained ultimate power in AD 538, and reigned until 1798 - a period of 1,260 years.  In 1798, the Emperor Napoleon had Pope Pius VI taken captive, and the Vatican lost its status as a self-governing civil power - the " deadly wound" prophesied about in Revelation 13:3.',
        "10.  The Vatican attempted to change God's law by substituting Sunday for the Bible Sabbath, removing the second commandment from its official teaching and dividing the 10th commandment into two separate commandments.",
      ],
    },
  },
  {
    "19-0": {
      body: "Recovery experts sifting through the rubble following a major earthquake in Turkey in 1999 made a shocking discovery. Thousands of the buildings that collapsed in the temblor were poorly constructed, and many lives might have been saved if these buildings had only been built according to code. External appearances gave no indication of problems with the buildings. But when the earth shook, it became painfully obvious that what appeared to be solid and stable was anything but. In the final days of earth’s history, a time of trouble will shake the world. Only those who have built their faith according to the Word of God are going to withstand the spiritual shaking that will take place.",
      lessonID: 19,
      questionID: 0,
      type: "text",
    },
    "19-1": {
      blanks: [
        {
          choices: ["lot", "sadness", "times", "trouble", "mood", "distrust"],
          correctAnswer: "time",
          textAfter: " of",
          textBefore: "There shall be a",
        },
        {
          choices: ["lot", "sadness", "times", "trouble", "mood", "distrust"],
          correctAnswer: "trouble",
          textAfter: " , such as never was since there was a nation.\n",
        },
      ],
      body: "\nA final great conflict is set to engulf the earth, preparing the way for the enforcement of the mark of the beast.\n",
      choices: ["lot", "trouble", "mood", "sadness", "time", "distrust"],
      lessonID: 19,
      question:
        "What did the prophet Daniel see happening on planet Earth at the end of time?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "At that time Michael shall stand up, the great prince who stands watch over the sons of your people; and there shall be a time of trouble, such as never was since there was a nation, even to that time.  And at that time your people shall be delivered, every one who is found written in the book.",
          ref: "Daniel 12:1",
        },
      ],
    },
    "19-10": {
      blanks: [
        {
          choices: ["666", "7", "14"],
          correctAnswer: "666",
          textAfter: " .",
          textBefore:
            "Let him who has understanding calculate the number of the beast, for it is the number of a man: His number is",
        },
      ],
      body: "The number is 666, and 666 is not the mark of the beast. It is the number of a “man” and can be “calculated” (Revelation 13:17, 18) to help identify the first nation of Revelation 13. Some Bible scholars have demonstrated that a title given to the pope, Vicarius Filii Dei (meaning “Vicar of the Son of God”), has a numerical value of 666 (a Latin phrase written in Roman numerals; each letter of the phrase has a numerical value).",
      choices: ["666", "7", "14"],
      lessonID: 19,
      question: "What is the number of the beast?",
      questionID: 10,
      questionType: "radio",
      verses: [
        {
          body: "Here is wisdom. Let him who has understanding calculate the number of the beast, for it is the number of a man: His number is 666.",
          ref: "Revelation 13:18",
        },
      ],
    },
    "19-11": {
      blanks: [
        {
          choices: ["hands", "foreheads", "foot", "phones", "side", "face"],
          correctAnswer: "hand",
          textAfter: " or on their",
          textBefore:
            "He causes all, both small and great, rich and poor, free and slave, to receive a mark on their right",
        },
        {
          choices: ["hands", "foreheads", "foot", "phones", "side", "face"],
          correctAnswer: "foreheads",
          textAfter: " .",
        },
      ],
      body: "The symbol of the hand represents work or actions (Ecclesiastes 9:10). The forehead represents the mind, where decisions are made. People will demonstrate allegiance to the beast either in their thoughts—by agreeing with the agenda of the beast—or in their actions, by submitting to the beast’s authority even if they disagree with that authority. The mark of the beast is a symbol of allegiance to the false religion of the last days.",
      choices: ["side", "foreheads", "foot", "phones", "hand", "face"],
      lessonID: 19,
      question: "Where is the mark of the beast placed?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "He causes all, both small and great, rich and poor, free and slave, to receive a mark on their right hand or on their forehead...,",
          ref: "Revelation 13:16",
        },
      ],
    },
    "19-12": {
      lessonID: 19,
      question:
        "What is the mark of the authority of the beast of Revelation 13",
      questionID: 12,
      questionType: "text",
      text: [
        "Just as the Sabbath is a sign that represents the authority of God, Sunday is a sign that represents the authority of the church.  ",
        '"Fundamentalists meet for worship on Sunday, yet there is no evidence in the Bible that corporate worship was to be made on Sundays.  The Jewish Sabbath, or day of rest, was, of course, Saturday.  It was the Catholic Church that decided Sunday should be the day of worship for Christians, in honor of the Resurrection" ( Karl Keating, Catholicism and Fundamentalism, p.38).',
        "The change of the Sabbath is a mark of Rome's authority, because the Vatican instituted Sunday worship without any biblical authority.  The only basis for keeping Sunday is the authority of the Catholic Church.  There is no authority from the Scriptures to observe Sunday as a holy day.",
        "\"Moreover, the same pope decreed that the rest of the Sabbath should be transferred rather to the Lord's day [Sunday], in order that on that day we should rest from worldly works for the praise of God\" ( De Clericorum Institutione [Concerning the Instruction of the Clergymen], book 2, ch. 46, as translated by the writer for the Latin text in Migne's Patrologia Latina, vol. 107, col. 361).",
        "Eusebius, the Bishop of Caesaria in the fourth century wrote, \"And all things whatsoever that it was duty to do on the Sabbath, these we have transferred to the Lord's day, as more appropriately belonging to it, because it has precedence, and is first in rank, and more honorable than the Jewish Sabbath\" (Eusebius'\" Commentary on the Psalms - Psalm 92, A Psalm or Song for the Sabbath-day\" in Migne's Patrologia Graeca, vol. 23, col. 1171 & 1172; and Bernard de Montfaucon's Collectio Nova Patrum Et Sciptorum Graecorum, 2 vols., folio, Paris, 1706).",
      ],
    },
    "19-13": {
      Supplements: {
        "-L82mhF5v6Da14TKynqv": {
          body: "One of the great attributes of God is His mercy. In Acts 17:30, Luke writes, “Truly, these times of ignorance God overlooked”. When a person doesn’t know something, God closes His eyes and does not count it against them as sin. However, the verse continues, “but [He] now commands all men everywhere to repent”. Once our eyes have been opened to the claims of God’s word, we are called to change direction and, full of an overwhelming love for Him, follow in the way He leads.\n\nThe issue is really of much greater importance than the day on which we worship. The question involved is a question of authority. It is about Who we choose to worship. And Revelation 14:12 indicates that the highest form of worship is obedience. “Here is the patience of the saints; here are those who keep the commandments of God and the faith of Jesus”.\n\nIn the end, we will follow either Jesus Christ or antichrist. We will either follow the commandments of God or the commandments of men. The day on which we choose to worship simply indicates who we have chosen to serve. Paul says in Romans 6:16, “Do you not know that to whom you present yourselves slaves to obey, you are that one’s slaves whom you obey, whether of sin leading to death, or of obedience leading to righteousness?“. Whether the commandment says, “You shall not murder”, “You shall not commit adultery”, or, “Remember the Sabbath day, to keep it holy”, it is of equal value in the eyes of God. If we begin to suggest which commandments are more important than others, we have placed ourselves above the One who wrote them.\n",
          title:
            "Lots of good Christians go to church on Sunday. Is breaking the Sabbath commandment really as bad as breaking the other nine?",
        },
      },
      blanks: [
        {
          choices: ["this", "that", "times", "law", "hearts", "minds"],
          correctAnswer: "times",
          textAfter: " and",
          textBefore: "And shall intend to change",
        },
        {
          choices: ["this", "that", "times", "law", "hearts", "minds"],
          correctAnswer: "law",
          textAfter: " .",
        },
      ],
      body: "The papacy—represented in Daniel 7:25 as the little horn—has attempted to change God’s times and laws by changing Sabbath observance from the seventh to the first day of the week, and by altering the second and the 10th of the Ten Commandments.",
      choices: ["this", "that", "minds", "law", "hearts", "times"],
      lessonID: 19,
      question: "What does the papacy believe it has the power to do?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "He shall speak pompous words against the Most High, shall persecute the saints of the Most High, and shall intend to change times and law.  Then the saints shall be given into his hand for a time and times and half a time.",
          ref: "Daniel 7:25",
        },
      ],
    },
    "19-14": {
      blanks: [
        {
          choices: ["enslaves", "hates", "causes"],
          correctAnswer: "causes",
          textAfter:
            " all, both small and great, rich and poor, free and slave, to receive a mark on their right hand or on their foreheads.",
          textBefore: "He",
        },
      ],
      body: "\nIt is when this mark is enforced by law that it becomes the “mark of the beast.” Until that time, nobody will have the mark of the beast.",
      choices: ["enslaves", "hates", "causes"],
      lessonID: 19,
      question: "Who has the mark of the beast today?",
      questionID: 14,
      questionType: "radio",
      verses: [
        {
          body: "He causes all, both small and great, rich and poor, free and slave, to receive a mark on their right hand or on their forehead...",
          ref: "Revelation 13:16",
        },
      ],
    },
    "19-15": {
      Supplements: {
        "-L82msbVTvFU5T30RZ5b": {
          body: "Certainly not. The mark of the beast has not yet been enforced. Once it is enforced, everyone will have to make an informed decision as to whether they will choose to adopt a day of worship that has been instituted by man or to “remember the Sabbath day, to keep it holy”. Once that time has come, humanity will be divided into two camps; those who receive the seal of God (Sabbath) and those who receive the mark of the authority of the beast (Sunday). That day has not yet come. However, it is always better to choose to follow God and His teachings as soon as you hear them, since we have a natural tendency to procrastinate and allow spiritual calluses to develop on our ears (Matthew 13:15). Hebrews 3:15 admonishes us, “Today, if you will hear His voice, do not harden your hearts as in the rebellion”.\n\n",
          title:
            "Does everyone who worships on Sunday today have the mark of the beast?",
        },
      },
      blanks: [
        {
          choices: [
            "word",
            "rules",
            "commandments",
            "faith",
            "thoughts",
            "mind",
          ],
          correctAnswer: "commandments",
          textAfter: " of God and the",
          textBefore: "Here are those who keep the",
        },
        {
          choices: [
            "word",
            "rules",
            "commandments",
            "faith",
            "thoughts",
            "mind",
          ],
          correctAnswer: "faith",
          textAfter: " of Jesus.",
        },
      ],
      body: "Those who avoid the mark of the beast will remain faithful to Jesus Christ and obedient to God—having surrendered their lives fully to Him.\n",
      choices: ["word", "rules", "commandments", "faith", "thoughts", "mind"],
      lessonID: 19,
      question:
        "What are the characteristics of those who avoid the mark of the beast?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "Here is the patience of the saints; here are those who keep the commandments of God and the faith of Jesus",
          ref: "Revelation 14:12",
        },
      ],
    },
    "19-16": {
      blanks: [
        {
          choices: ["follow", "remember", "hear"],
          correctAnswer: "follow",
          textAfter: " the Lamb wherever He goes.",
          textBefore: "These are the ones who",
        },
      ],
      choices: ["follow", "remember", "hear"],
      lessonID: 19,
      question:
        "What relationship does Jesus have with those who receive the seal of God?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "These are the ones who were not defiled with women, for they are virgins. These are the ones who follow the Lamb wherever He goes. These were redeemed from among men, being first-fruits to God and to the Lamb.",
          ref: "Revelation 14:4",
        },
      ],
    },
    "19-17": {
      correctAnswer: "true",
      lessonID: 19,
      question:
        "Would you like to prepare for the seal of God by keeping all of God's commandments, including the Sabbath, as a sign that you will follow Jesus wherever He leads?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "19-2": {
      blanks: [
        {
          choices: ["buy", "sell", "talk", "see", "understand", "explain"],
          correctAnswer: "buy",
          textAfter: " or",
          textBefore:
            "He causes all, both small and great, rich and poor, free and slave, to receive a mark on their right hand or on their foreheads, and that no one may",
        },
        {
          choices: ["buy", "sell", "talk", "see", "understand", "explain"],
          correctAnswer: "sell",
          textAfter:
            " except one who has the mark or the name of the beast, or the number of his name.",
        },
      ],
      body: "\nRestrictions on buying and selling are not a new idea. During wartime, rationing was common as a means of restricting what and how much of various products people were able to buy. In addition to a prohibition on buying and selling, Revelation 13:15 says that there will be a time when those who refuse to receive the mark of the beast will be threatened with death, and will even be killed.",
      choices: ["understand", "sell", "talk", "see", "buy", "explain"],
      lessonID: 19,
      question: "What is the consequence of receiving the mark of the beast?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "He causes all, both small and great, rich and poor, free and slave, to receive a mark on their right hand or on their foreheads, 17 and that no one may buy or sell except one who has the mark or the name of the beast, or the number of his name.",
          ref: "Revelation 13:16, 17",
        },
      ],
    },
    "19-3": {
      blanks: [
        {
          choices: ["Those", "strength", "Any", "voice", "All", "seal"],
          correctAnswer: "All",
          newline: [1],
          textAfter:
            " who dwell on the earth will worship him, whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
        },
        {
          choices: ["Those", "strength", "Any", "voice", "All", "seal"],
          correctAnswer: "seal",
          textAfter:
            " of the living God. And he cried with a loud voice . . . saying, “Do not harm the earth, the sea, or the trees till we have sealed the servants of our God on their foreheads.”",
          textBefore:
            " I saw another angel ascending from the east, having the",
        },
      ],
      body: "The Bible states that only those who remain faithfully committed to Jesus will not receive the mark of the beast. The rest of the people living on the earth—the vast majority—will receive the mark of the beast. Every person will receive one of two marks. Those who worship and obey the Creator God will receive the seal of God. Those who do not will receive the mark of the beast.",
      choices: ["seal", "strength", "Any", "voice", "All", "Those"],
      lessonID: 19,
      question: "How many people will receive the mark of the beast?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "All who dwell on the earth will worship him, whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
          ref: "Revelation 13:8",
        },
        {
          body: "Then I saw another angel ascending from the east, having the seal of the living God. And he cried with a loud voice to the four angels to whom it was granted to harm the earth and the sea, 3 saying, “Do not harm the earth, the sea, or the trees till we have sealed the servants of our God on their foreheads.",
          ref: "Revelation 7:2, 3",
        },
      ],
    },
    "19-4": {
      blanks: [
        {
          choices: ["foreheads", "phones", "hands"],
          correctAnswer: "foreheads",
          textAfter: " .",
          textBefore: "Till we have sealed the servants of our God on their",
        },
      ],
      body: "The seal of God is placed on (or “in”) the forehead of the believer, representing that the seal of God will be placed in the mind of the person who receives it. Behind the forehead is the frontal lobe of the brain—the area of the mind responsible for decision-making. Those who receive the seal of God will have made an immovable decision for God.",
      choices: ["foreheads", "phones", "hands"],
      lessonID: 19,
      question: "Where is the seal of God placed?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "Saying, “Do not harm the earth, the sea, or the trees till we have sealed the servants of our God on their foreheads.",
          ref: "Revelation 7:3",
        },
      ],
    },
    "19-5": {
      blanks: [
        {
          choices: ["sweat", "words", "name", "name", "mind", "thoughts"],
          correctAnswer: "name",
          newline: [1],
          textAfter: " shall be on their foreheads.",
          textBefore: "They shall see His face, and His",
        },
        {
          choices: ["sweat", "words", "name", "name", "mind", "thoughts"],
          correctAnswer: "Fathers",
          textAfter: " name written on their foreheads.",
          textBefore: " Having His ",
        },
      ],
      body: "In ancient times, a seal was used to signify authority and approval. Here we find God writing His name—which represents His character (Exodus 34:5–7)—in the minds of the redeemed. Those who receive the seal of God will have the gracious character of Jesus deeply planted in their minds. Humanity was originally created in the image of God. When Adam and Eve fell into sin, that perfect image of God was lost. The entire plan of salvation is based on God re-creating in human beings the image of God. The hopeful fact is that those who receive the seal of God will have been remade in the image of God, through the power of God and the presence of Jesus in their lives. The mark of the beast issue sees planet Earth divided into two groups: one willing to allow Jesus to live in their hearts no matter the cost, and the other unwilling to surrender their lives totally to Him.",
      choices: [
        "sweat",
        "words",
        "name",
        "mind",
        "thoughts",
        "Fathers",
        "Mothers",
      ],
      lessonID: 19,
      question:
        "What does God write on the foreheads of those who receive His mark?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "They shall see His face, and His name shall be on their foreheads.",
          ref: "Revelation 22:4",
        },
        {
          body: "Then I looked, and behold, a Lamb standing on Mount Zion, and with Him one hundred and forty-four thousand, having His Father’s name written on their foreheads.",
          ref: "Revelation 14:1",
        },
      ],
    },
    "19-6": {
      blanks: [
        {
          choices: ["made", "saw", "walked"],
          correctAnswer: "made",
          textAfter: " heaven and earth, the sea and springs of water.",
          textBefore: "Worship Him who",
        },
      ],
      body: "God’s Word urges us to worship the Creator, rather than His created beings. The mark of the beast issue contrasts true worship—the worship of the Creator God—with false worship. Just as Satan attempted to have Jesus worship him in the wilderness (Matthew 4:9), he seeks to receive the worship of the world before Jesus returns. And in calling us to worship the Creator, Revelation 14:7 quotes directly from the fourth commandment, which calls people to remember the Sabbath day and keep it holy (Exodus 20:11).",
      choices: ["made", "saw", "walked"],
      lessonID: 19,
      question: "Who does God call us to worship in earth’s final days?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "Saying with a loud voice, “Fear God and give glory to Him, for the hour of His judgment has come; and worship Him who made heaven and earth, the sea and springs of water.",
          ref: "Revelation 14:7",
        },
      ],
    },
    "19-7": {
      blanks: [
        {
          choices: ["house", "covenant", "words", "pact", "Sabbaths", "sign"],
          correctAnswer: "Sabbaths",
          textAfter: " , and they will be a",
          textBefore: "Hallow my",
        },
        {
          choices: ["house", "covenant", "words", "pact", "Sabbaths", "sign"],
          correctAnswer: "sign",
          textAfter:
            " between Me and you, that you may know that I am the Lord your God.",
        },
      ],
      body: "\nThe Sabbath is a sign, or seal, that signifies the authority of God, calling to mind God’s creatorship, and His power to re-create. In keeping the Sabbath, a person demonstrates allegiance to the Creator God and full acceptance of His complete authority.\n",
      choices: ["house", "covenant", "sign", "pact", "Sabbaths", "words"],
      lessonID: 19,
      question: "Which part of God’s law is a special sign of God’s authority?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "Hallow My Sabbaths, and they will be a sign between Me and you, that you may know that I am the Lord your God.",
          ref: "Ezekiel 20:20",
        },
      ],
    },
    "19-8": {
      blanks: [
        {
          choices: [
            "Lord made",
            "all",
            "sanctifies",
            "creation of",
            "things",
            "blessed",
            "Lord saw",
            "animals",
            "loved",
          ],
          correctAnswer: "Lord",
          textAfter: " made ",
          textBefore: "For in six days the",
        },
        {
          choices: [
            "Lord made",
            "all",
            "sanctifies",
            "creation of",
            "things",
            "blessed",
            "Lord saw",
            "animals",
            "loved",
          ],
          correctAnswer: "all",
          textAfter: " that is in them, and rested the seventh day. ",
          textBefore: " the heavens and the earth, the sea, and",
        },
        {
          choices: [
            "Lord made",
            "all",
            "sanctifies",
            "creation of",
            "things",
            "blessed",
            "Lord saw",
            "animals",
            "loved",
          ],
          correctAnswer: "sanctifies",
          textAfter: " them.",
          textBefore:
            "I also gave them My Sabbaths, to be a sign between them and Me, that they might know that I am the Lord who",
        },
      ],
      body: "\nThe seal of God represents God’s authority as Creator and Redeemer. The Sabbath exists not only as a memorial of Creation and of God’s creative power, but also as a sign of God’s re-creative power. Only the Creator has the power to be the Re-Creator. Full surrender to God leads to obedience regarding His commandments. As Jesus said in John 14:15, “If you love Me, keep My commandments.” Obedience to God represents full submission to God’s leadership and lordship, with the Sabbath being God’s special sign that the Creator has been given permission to re-create the sinner in His image.",
      choices: [
        "Lord",
        "all",
        "sanctifies",
        "creation of",
        "things",
        "blessed",
        "animals",
        "loved",
      ],
      lessonID: 19,
      question: "Why is the Sabbath called the seal of God?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "For in six days the Lord made the heavens and the earth, the sea, and all that is in them, and rested the seventh day. Therefore the Lord blessed the Sabbath day and hallowed it",
          ref: "Exodus 20:11",
        },
        {
          body: "Moreover I also gave them My Sabbaths, to be a sign between them and Me, that they might know that I am the Lord who sanctifies them.",
          ref: "Ezekiel 20:12",
        },
      ],
    },
    "19-9": {
      blanks: [
        {
          choices: ["terrible", "first", "holy"],
          correctAnswer: "first",
          textAfter: " beast, whose deadly wound was healed.",
          textBefore:
            "He exercises all the authority of the first beast in his presence, and causes the earth and those who dwell in it to worship the",
        },
      ],
      body: "In Bible prophecy, a beast is a symbol used to represent a kingdom or a nation. Consistent with the testimony of the Bible, the nation being referred to here is Vatican City. [See It Is Written Bible Study Guide #18, “The Mystery Beast of Revelation.”]",
      choices: ["terrible", "first", "holy"],
      lessonID: 19,
      question: "Who is the beast who has his own mark of authority?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "And he exercises all the authority of the first beast in his presence, and causes the earth and those who dwell in it to worship the first beast, whose deadly wound was healed.",
          ref: "Revelation 13:12",
        },
      ],
    },
  },
  {
    "20-0": {
      body: "Governor Alfred E. Smith of New York, a prominent American political leader of the 20th century and twice a candidate for the presidency, stated in his final public appearance why he believed God would never abandon the United States. Speaking of this country, Smith stated, “I have been taught to look upon this country as designed and founded by Divine Providence itself to be the haven of rest and the harbor of refuge for the downtrodden and the oppressed of every land.” From America’s earliest days, men and women throughout the world have sought its shores seeking this promise. A young woman from New York City— herself a descendant of immigrants to the United States—penned the poem that is quoted on the Statue of Liberty in New York Harbor: “Give me your tired, your poor, your huddled masses yearning to breathe free, the wretched refuse of your teeming shore. Send these, the homeless, tempest-tost to me, I lift my lamp beside the golden door!” (Emma Lazarus, “The New Colossus”). Millions of people from all over the world have been inspired by America’s assurance of liberty and justice for all. But for students of the Bible and many others, the questions arise: Will America continue to offer this promise? And at the close of human history as foretold in Bible prophecy, will America still be the world’s champion of freedom?",
      lessonID: 20,
      questionID: 0,
      type: "text",
    },
    "20-1": {
      blanks: [
        {
          choices: ["monster", "affliction", "kingdom"],
          correctAnswer: "kingdom",
          textAfter: " on earth.",
          textBefore: "The fourth beast shall be a fourth",
        },
      ],
      body: "In Bible prophecy, a beast represents a nation or a kingdom.",
      choices: ["monster", "affliction", "kingdom"],
      lessonID: 20,
      question: "What does a beast represent in Bible prophecy?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "The fourth beast shall be a fourth kingdom on earth, which shall be different from all other kingdoms, and shall devour the whole earth, trample it and break it in pieces.",
          ref: "Daniel 7:23",
        },
      ],
    },
    "20-10": {
      blanks: [
        {
          choices: ["mark", "symbol", "phone"],
          correctAnswer: "mark",
          textAfter: " on their right hand or on their foreheads.",
          textBefore:
            "He causes all, both small and great, rich and poor, free and slave, to receive a",
        },
      ],
      body: "Revelation 13 concludes with the Vatican and the United States simultaneously reaching a pinnacle of power. This will result in the implementation of the mark of the beast. The Bible says that if you receive the mark of the beast, you will be on the right side of civil powers, but on the wrong side of the will of God. If you refuse the mark of the beast, you will be in harmony with God’s will but out of harmony with the will of civil powers. [For more information on the mark of the beast, see It Is Written Bible Study Guide #19, “The Mark of the Beast.”]",
      choices: ["mark", "symbol", "phone"],
      lessonID: 20,
      question:
        "What form of worship will be enforced by the second nation of Revelation 13?",
      questionID: 10,
      questionType: "radio",
      verses: [
        {
          body: "He causes all, both small and great, rich and poor, free and slave, to receive a mark on their right hand or on their foreheads,",
          ref: "Revelation 13:16",
        },
      ],
    },
    "20-11": {
      blanks: [
        {
          choices: ["killed", "deported", "imprisoned"],
          correctAnswer: "killed",
          textAfter: " .",
          textBefore:
            "He [causes] as many as would not worship the image of the beast to be",
        },
      ],
      body: "Not only will America establish an image to the first beast—that is, a replica of medieval intolerance—but it will eventually levy the death penalty upon dissenters. The old saying states that “history repeats itself.” The book of Revelation reveals that the future of this world will see the return of religious intolerance and persecution toward all who do not cooperate with Satan’s end-time agenda of enforcing the mark of the beast. [See It Is Written Study Guide #19, “The Mark of the Beast.”]",
      choices: ["killed", "deported", "imprisoned"],
      lessonID: 20,
      question:
        "What will become of those who choose to resist the power of this nation?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "He was granted power to give breath to the image of the beast, that the image of the beast should both speak and cause as many as would not worship the image of the beast to be killed.",
          ref: "Revelation 13:15",
        },
      ],
    },
    "20-12": {
      blanks: [
        {
          choices: ["nation", "Those", "world", "All", "city", "Any"],
          correctAnswer: "world",
          newline: [1],
          textAfter:
            " , to gather them to the battle of that great day of God Almighty.",
          textBefore:
            "I saw three unclean spirits like frogs coming out of the mouth of the dragon, out of the mouth of the beast, and out of the mouth of the false prophet. For they are the spirits of demons, performing signs, which go out to the kings of the earth and of the whole",
        },
        {
          choices: ["nation", "Those", "world", "All", "city", "Any"],
          correctAnswer: "All",
          textAfter:
            " who dwell on the earth will worship him, whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
        },
      ],
      body: "The lack of freedom and the enacting of laws governing worship will see virtually the entire population of the world uniting with the beast against God and His people. The entire world—all but those who allow Jesus to possess their lives—will be united in a state of defiance against God and His people. This same scenario played out in the days of the prophet Daniel. Daniel 3:4–6 says, “A herald cried aloud: ‘To you it is commanded, O peoples, nations, and languages, that at the time you hear the sound of the horn, flute, harp, lyre, and psaltery, in symphony with all kinds of music, you shall fall down and worship the gold image that King Nebuchadnezzar has set up; and whoever does not fall down and worship shall be cast immediately into the midst of a burning fiery furnace.’” Nebuchadnezzar cast the young men into the furnace because they disobeyed him and chose to obey the commandment of God (Exodus 20:4–6). God responded by miraculously protecting Shadrach, Meshach and Abednego, as Jesus stood with them in the fiery furnace. Daniel 3:25 says, “‘Look!’ he answered. ‘I see four men loose, walking in the midst of the fire; and they are not hurt, and the form of the fourth is like the Son of God.’”",
      choices: ["All", "nation", "Those", "world", "city", "Any"],
      lessonID: 20,
      question:
        "What is the result of this end-time departure from civil and religious freedom?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I saw three unclean spirits like frogs coming out of the mouth of the dragon, out of the mouth of the beast, and out of the mouth of the false prophet. 14 For they are spirits of demons, performing signs, which go out to the kings of the earth and of the whole world, to gather them to the battle of that great day of God Almighty.",
          ref: "Revelation 16:13, 14",
        },
        {
          body: " ll who dwell on the earth will worship him, whose names have not been written in the Book of Life of the Lamb slain from the foundation of the world.",
          ref: "Revelation 13:8",
        },
      ],
    },
    "20-13": {
      blanks: [
        {
          choices: [
            "abilities",
            "tricks",
            "things",
            "convinces",
            "signs",
            "wonders",
            "signs",
            "deceives",
          ],
          correctAnswer: "signs",
          textAfter: " and",
          textBefore:
            "For false christs and false prophets will rise and show great",
        },
        {
          choices: [
            "abilities",
            "tricks",
            "things",
            "convinces",
            "signs",
            "wonders",
            "signs",
            "deceives",
          ],
          correctAnswer: "wonders",
          newline: [1],
          textAfter: " to deceive, if possible, even the elect.",
        },
        {
          choices: [
            "abilities",
            "tricks",
            "things",
            "convinces",
            "signs",
            "wonders",
            "signs",
            "deceives",
          ],
          correctAnswer: "fire",
          textAfter:
            " come down from heaven on the earth in the sight of men. And he",
          textBefore: " He performs great signs, so that he even makes ",
        },
        {
          choices: [
            "abilities",
            "tricks",
            "things",
            "convinces",
            "signs",
            "wonders",
            "signs",
            "deceives",
          ],
          correctAnswer: "deceives",
          textAfter:
            " those who dwell on the earth by those signs which he was granted to do in the sight of the beast.\n",
        },
      ],
      body: "Revelation 16:14 mentions “spirits of demons, performing signs, which go out to the kings of the earth and of the whole world, to gather them to the battle of that great day of God Almighty.” Earth’s final days will be a time of strong deception, calculated by Satan to separate people from faith in God and His Word.",
      choices: [
        "abilities",
        "tricks",
        "things",
        "convinces",
        "signs",
        "wonders",
        "signs",
        "deceives",
        "fire",
      ],
      lessonID: 20,
      question: "What does Satan do in an attempt to deceive God’s faithful?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "For false christs and false prophets will rise and show great signs and wonders to deceive, if possible, even the elect.",
          ref: "Matthew 24:24",
        },
        {
          body: "He performs great signs, so that he even makes fire come down from heaven on the earth in the sight of men. 14 And he deceives those who dwell on the earth by those signs which he was granted to do in the sight of the beast, telling those who dwell on the earth to make an image to the beast who was wounded by the sword and lived.",
          ref: "Revelation 13:13, 14",
        },
      ],
    },
    "20-14": {
      blanks: [
        {
          choices: ["word", "text", "message"],
          correctAnswer: "word",
          textAfter: " , it is because there is no light in them.\n",
          textBefore:
            "To the law and to the testimony! If they do not speak according to this",
        },
      ],
      body: "Complete reliance on the Word of God will keep people from being deceived in a time of overwhelming deception.",
      choices: ["word", "text", "message"],
      lessonID: 20,
      question:
        "How can God’s people be safe from the deceptions of earth’s final days?",
      questionID: 14,
      questionType: "radio",
      verses: [
        {
          body: "To the law and to the testimony! If they do not speak according to this word, it is because there is no light in them.",
          ref: "Isaiah 8:20",
        },
      ],
    },
    "20-15": {
      blanks: [
        {
          choices: ["kings", "councilors", "God", "men", "John", "Judas"],
          correctAnswer: "God",
          textAfter: " rather than",
          textBefore:
            'Peter and the other apostles answered and said: "We ought to obey',
        },
        {
          choices: ["kings", "councilors", "God", "men", "John", "Judas"],
          correctAnswer: "men",
          textAfter: ' ."',
        },
      ],
      body: "Disciples of Jesus who have surrendered their lives to Him will esteem obedience to God far above obedience to any human being.",
      choices: ["kings", "councilors", "men", "John", "God", "Judas"],
      lessonID: 20,
      question:
        "What attitude will God’s people have regarding loyalty and faithfulness in earth’s last days?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "But Peter and the other apostles answered and said: “We ought to obey God rather than men.",
          ref: "Acts 5:29",
        },
      ],
    },
    "20-16": {
      blanks: [
        {
          choices: ["I", "within", "Satan", "is", "God", "lives"],
          correctAnswer: "God",
          newline: [1],
          textAfter:
            " who works in you both to will and to do for His good pleasure.",
          textBefore: "It is",
        },
        {
          choices: ["I", "within", "Satan", "is", "God", "lives"],
          correctAnswer: "lives",
          textAfter: " in me.",
          textBefore:
            " I have been crucified with Christ; it is no longer I who live, but Christ",
        },
      ],
      body: "Jesus acknowledged that His followers would “have tribulation” (John 16:33), and Paul wrote that “all who desire to live godly in Christ Jesus will suffer persecution” (2 Timothy 3:12). But Jesus has pledged that through the Holy Spirit, He will dwell in us. Just as Daniel was able to be faithful to God while facing the lions’ den, the grace of God is pledged to sustain every child of God—all who choose to be faithful to Him.",
      choices: ["I", "within", "lives", "Satan", "is", "God"],
      lessonID: 20,
      question:
        "In a time when all the world follows the beast of Revelation 13, how will it be possible for someone to be faithful to God?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "For it is God who works in you both to will and to do for His good pleasure",
          ref: "Philippians 2:13",
        },
        {
          body: " I have been crucified with Christ; it is no longer I who live, but Christ lives in me; and the life which I now live in the flesh I live by faith in the Son of God, who loved me and gave Himself for me.",
          ref: "Galatians 2:20",
        },
      ],
    },
    "20-17": {
      correctAnswer: "true",
      lessonID: 20,
      question:
        "Are you willing to yield your life to Jesus, and - by His power - live a life committed to Him and His Word?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "20-2": {
      blanks: [
        {
          choices: ["another", "terrible", "golden"],
          correctAnswer: "another",
          textAfter: " beast coming up out of the earth.",
          textBefore: "I saw",
        },
      ],
      body: "John saw this second beast, or nation, of Revelation rising to prominence after the demise of the first beast. The first beast experienced a period of decline before ultimately losing power in 1798 [See It Is Written Study Guide #18, “The Mystery Beast of Revelation”]. As the first nation declined and ultimately lost power in 1798, the second beast would arise around the year 1798.",
      choices: ["terrible", "another", "golden"],
      lessonID: 20,
      question: "When does this beast rise to a position of power?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "Then I saw another beast coming up out of the earth, and he had two horns like a lamb and spoke like a dragon.",
          ref: "Revelation 13:11",
        },
      ],
    },
    "20-3": {
      blanks: [
        {
          choices: ["throngs", "peoples", "humans"],
          correctAnswer: "peoples",
          textAfter: " , multitudes, nations, and tongues.",
          textBefore: "The waters which you saw . . . are",
        },
      ],
      body: "The first beast in Revelation 13 comes up out of the sea, as do the four beasts in Daniel 7. In Bible prophecy, waters represent multitudes of people. In contrast, the earth represents a part of the world that is sparsely populated. This beast will arise in a sparsely populated area of the world.",
      choices: ["throngs", "peoples", "humans"],
      lessonID: 20,
      question: "Where does the second beast of Revelation 13 arise?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then he said to me, “The waters which you saw, where the harlot sits, are peoples, multitudes, nations, and tongues.",
          ref: "Revelation 17:15",
        },
      ],
    },
    "20-4": {
      blanks: [
        {
          choices: ["lamb", "lion", "moose"],
          correctAnswer: "lamb",
          textAfter: " .",
          textBefore: "He had two horns like a",
        },
      ],
      body: "In the book of Revelation, Jesus is repeatedly described as a Lamb (Revelation 5:6; 6:1; 13:8; 14:1; 21:27; 22:1; etc.). John the Baptist exclaimed, “Behold! The Lamb of God who takes away the sin of the world” (John 1:29)! This nation would in some way be Christ-like, exhibiting principles consistent with Jesus, the true Lamb. Political, historical, geographical and philosophical evidence all suggest the nation portrayed in Revelation 13:11–15 is the United States of America. This power is represented as a lamb because it was founded on the very principles Jesus came to this planet to share. As Jesus came to make people free (John 8:32), this nation offers—and models for the world— religious and political freedom. And as horns represent power and strength in Scripture, these two freedoms are the great strengths of the nation portrayed. “[The Declaration of Independence includes guarantees of] . . . right to trial; guarantees of freedom of assembly, free speech, free press and, for the first time in history, the guarantee that the state would support no ‘establishment of religion’” (Theodore H. White, Breach of Faith: The Fall of Richard Nixon, p. 323).",
      choices: ["lamb", "lion", "moose"],
      lessonID: 20,
      question: "What is the character of the second beast in Revelation 13?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "Then I saw another beast coming up out of the earth, and he had two horns like a lamb and spoke like a dragon.",
          ref: "Revelation 13:11",
        },
      ],
    },
    "20-5": {
      blanks: [
        {
          choices: ["human", "dragon", "fool"],
          correctAnswer: "dragon",
          textAfter: " .",
          textBefore: "He had two horns like a lamb and spoke like a",
        },
      ],
      body: "Jesus said in Matthew 12:34, “Out of the abundance of the heart the mouth speaks.” Revelation predicts that there will be a change at the heart of this nation that will cause it to appear as a lamb but speak as a dragon.",
      choices: ["human", "dragon", "fool"],
      lessonID: 20,
      question: "Will this nation always stand in defense of freedom?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then I saw another beast coming up out of the earth, and he had two horns like a lamb and spoke like a dragon.",
          ref: "Revelation 13:11",
        },
      ],
    },
    "20-6": {
      blanks: [
        {
          choices: ["liar", "thief", "betrayer", "sin", "Devil", "Satan"],
          correctAnswer: "Devil",
          textAfter: " and",
          textBefore:
            "The great dragon was cast out, that serpent of old, called the",
        },
        {
          choices: ["liar", "thief", "betrayer", "sin", "Devil", "Satan"],
          correctAnswer: "Satan",
          textAfter: " , who deceives the whole world.",
        },
      ],
      body: "\nLike a lamb, America offers people a life of freedom. But according to Bible prophecy, this country will one day abandon liberty—setting aside the methods of the Lamb for those of the dragon.\n",
      choices: ["liar", "Satan", "thief", "betrayer", "sin", "Devil"],
      lessonID: 20,
      question: "What does a dragon represent in the book of Revelation?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "So the great dragon was cast out, that serpent of old, called the Devil and Satan, who deceives the whole world; he was cast to the earth, and his angels were cast out with him.",
          ref: "Revelation 12:9",
        },
      ],
    },
    "20-7": {
      blanks: [
        {
          choices: ["first", "unholy", "terrible"],
          correctAnswer: "first",
          textAfter: " beast.",
          textBefore: "He exercises all the authority of the",
        },
      ],
      body: "Of the first beast, the Bible says, “It was granted to him to make war with the saints and to overcome them” (Revelation 13:7). Revelation predicts a time when the second nation will govern in the manner of the first nation of Revelation 13—Vatican City.\n",
      choices: ["first", "unholy", "terrible"],
      lessonID: 20,
      question:
        "What type of influence will this second nation have in the world?",
      questionID: 7,
      questionType: "radio",
      verses: [
        {
          body: "And he exercises all the authority of the first beast in his presence, and causes the earth and those who dwell in it to worship the first beast, whose deadly wound was healed.",
          ref: "Revelation 13:12",
        },
      ],
    },
    "20-8": {
      blanks: [
        {
          choices: ["follow", "find", "worship"],
          correctAnswer: "worship",
          textAfter: " the first beast, whose deadly wound was healed.",
          textBefore:
            "He exercises all the authority of the first beast in his presence, and causes the earth and those who dwell in it to",
        },
      ],
      body: "\nThe Bible says that this power will unite with the first beast to restore power to the first beast and cause the world to yield to its power.",
      choices: ["follow", "find", "worship"],
      lessonID: 20,
      question:
        "How does the second nation of Revelation 13 cooperate with the first nation in Revelation 13?",
      questionID: 8,
      questionType: "radio",
      verses: [
        {
          body: "And he exercises all the authority of the first beast in his presence, and causes the earth and those who dwell in it to worship the first beast, whose deadly wound was healed.",
          ref: "Revelation 13:12",
        },
      ],
    },
    "20-9": {
      blanks: [
        {
          choices: ["commands", "causes", "warps"],
          correctAnswer: "causes",
          textAfter:
            " the earth and those who dwell in it to worship the first beast, whose deadly wound was healed.",
          textBefore:
            "He exercises all the authority of the first beast in his presence, and",
        },
      ],
      body: "A nation affects the actions of its citizens by passing laws, and laws will be passed causing people to yield to the first beast of Revelation 13.\n           ",
      choices: ["commands", "causes", "warps"],
      lessonID: 20,
      question:
        "How will the second nation in Revelation 13 (the United States) influence people to yield to the authority of the first nation (the Vatican)?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "And he exercises all the authority of the first beast in his presence, and causes the earth and those who dwell in it to worship the first beast, whose deadly wound was healed.",
          ref: "Revelation 13:12",
        },
      ],
    },
  },
  {
    "21-0": {
      body: "Legend has it that Spanish explorer Juan Ponce de León discovered Florida in 1513 while he was searching for the legendary Fountain of Youth. The Fountain of Youth was said to miraculously restore the youthfulness of any person who drank from its waters. While it might be exciting to think of discovering the Fountain of Youth or something as remarkable as Atlantis, many people would be satisfied if they could only find the right church—a church faithfully teaching the truths of the Bible. With numerous churches in existence, does it matter which church you belong to? And does God have a church for this time?",
      lessonID: 21,
      questionID: 0,
      type: "text",
    },
    "21-1": {
      blanks: [
        {
          choices: ["again", "apart", "together"],
          correctAnswer: "together",
          textAfter:
            " , as is the manner of some, but exhorting one another, and so much the more as you see the Day approaching.",
          textBefore: "Not forsaking the assembling of ourselves",
        },
      ],
      body: "\nThe Bible example is that God’s people gather together for worship and fellowship, as well as for the purpose of unitedly working to share the gospel with the world.\n",
      choices: ["again", "apart", "together"],
      correctAnswer: "true",
      lessonID: 21,
      question: "Does it matter if a person attends church?",
      questionID: 1,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        '"It matters whether or not a person attends a church."',
      verses: [
        {
          body: "not forsaking the assembling of ourselves together, as is the manner of some, but exhorting one another, and so much the more as you see the Day approaching.",
          ref: "Hebrews 10:25",
        },
      ],
    },
    "21-10": {
      blanks: [
        {
          choices: ["Devil", "does", "holy", "one", "falling", "away"],
          correctAnswer: "falling",
          textAfter: " ",
          textBefore:
            "Let no one deceive you by any means; for that Day [the Second Coming] will not come unless the",
        },
        {
          choices: ["Devil; does", "holy one", "falling away"],
          correctAnswer: "away",
          textAfter:
            " comes first, and the man of sin is revealed, the son of perdition.",
        },
      ],
      body: "After the first 300 years or so of Christianity, the truths of God’s Word were obscured by tradition and false teaching. When persecution was reintroduced, multitudes who would not yield to the authority of the ruling church were banished or killed.\n",
      choices: ["Devil", "does", "holy", "one", "falling", "away"],
      lessonID: 21,
      question: "What happened to the Christian church during the Middle Ages?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "Let no one deceive you by any means; for that Day will not come unless the falling away comes first, and the man of sin is revealed, the son of perdition,",
          ref: "2 Thessalonians 2:3",
        },
      ],
    },
    "21-11": {
      blanks: [
        {
          choices: [
            "desert",
            "safe",
            "wilderness",
            "nourished",
            "mountains",
            "fed",
          ],
          correctAnswer: "wilderness",
          newline: [1],
          textAfter: " , where she has a place prepared by God.",
          textBefore: "The woman fled into the",
        },
        {
          choices: [
            "desert",
            "safe",
            "wilderness",
            "nourished",
            "mountains",
            "fed",
          ],
          correctAnswer: "nourished",
          textAfter: " .",
          textBefore:
            " The woman was given two wings of a great eagle, that she might fly into the wilderness to her place, where she is",
        },
      ],
      body: "In many parts of Europe, faithful believers in the Bible were forced to flee to remote wilderness areas where they could live their faith in God in some safety. In these areas, church members could still meet together, worship and study the Bible. It is important to note that God’s church was still in existence during these times, but not as an official mainstream organization. The church was “in the wilderness.” It was comprised of groups of people who remained faithful to God at the risk of persecution and death.",
      choices: [
        "desert",
        "safe",
        "wilderness",
        "nourished",
        "mountains",
        "fed",
      ],
      lessonID: 21,
      question: "What did the true church do during times of persecution?",
      questionID: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then the woman fled into the wilderness, where she has a place prepared by God, that they should feed her there one thousand two hundred and sixty days.",
          ref: "Revelation 12:6",
        },
        {
          body: "But the woman was given two wings of a great eagle, that she might fly into the wilderness to her place, where she is nourished for a time and times and half a time, from the presence of the serpent.",
          ref: "Revelation 12:14",
        },
      ],
    },
    "21-12": {
      blanks: [
        {
          choices: ["time", "times", "half", "day", "weeks", "years"],
          correctAnswer: "sixty",
          newline: [1],
          textAfter: "days.",
          textBefore:
            "The woman fled into the wilderness, where she has a place prepared by God, that they should feed her there one thousand two hundred and ",
        },
        {
          choices: ["time", "times", "half", "day", "weeks", "years"],
          correctAnswer: "time",
          textAfter: " and",
          textBefore:
            "The woman was given two wings of a great eagle, that she might fly into the wilderness to her place, where she is nourished for a",
        },
        {
          choices: ["time", "times", "half", "day", "weeks", "years"],
          correctAnswer: "times",
          textAfter: " and",
          textBefore: "",
        },
        {
          choices: ["time", "times", "half", "day", "weeks", "years"],
          correctAnswer: "half",
          textAfter: " a time, from the presence of the serpent.\n",
        },
      ],
      body: "The prophecy predicted a period of 1,260 years in the wilderness for God’s church. (Note: A “time” is one Jewish year of 360 days. “Times” is two years, 720 days. “Half a time” is half a year, 180 days. These add up to 1,260, showing that Revelation 12:6 and 12:14 describe the same time period). This prediction was perfectly fulfilled when the church went into hiding during the reign of the beast power, which stretched from AD 538 to 1798. [See It Is Written Bible Study Guide #18, “The Mystery Beast of Revelation,” for more details]. Prior to the fall of the papacy, a movement began that brought reformation to the Christian church. The Bible was translated into the common language, and people understood the gospel of Jesus and Bible prophecy.  After the darkness of tradition and error, the light of the gospel began to shine. The slow process of exiting the wilderness had begun. As the light of the Word of God began to shine brighter in the world, churches emerged that built on the truths taught by earlier churches. The spirit of the Reformation continued throughout the world until God’s church was established for the last days—a church that returned to all the original teachings of the Christian church.",
      choices: ["time", "times", "half", "day", "weeks", "years", "sixty"],
      lessonID: 21,
      question: "How long would God’s true church remain in the wilderness?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then the woman fled into the wilderness, where she has a place prepared by God, that they should feed her there one thousand two hundred and sixty days.",
          ref: "Revelation 12:6",
        },
        {
          body: "But the woman was given two wings of a great eagle, that she might fly into the wilderness to her place, where she is nourished for a time and times and half a time, from the presence of the serpent.",
          ref: "Revelation 12:14",
        },
      ],
    },
    "21-13": {
      blanks: [
        {
          choices: ["proud", "peace", "bummed", "trouble", "enraged", "war"],
          correctAnswer: "enraged",
          textAfter: " with the woman, and he went to make",
          textBefore: "The dragon was",
        },
        {
          choices: ["proud", "peace", "bummed", "trouble", "enraged", "war"],
          correctAnswer: "war",
          textAfter:
            " with the rest of her off spring, who keep the commandments of God and have the testimony of Jesus Christ.",
        },
      ],
      body: "The devil is especially angry with the “rest of her offspring”—called the “remnant” in the King James Version—the church of the last days. The devil will do his best to deceive and discourage as many of God’s people as possible because he knows that time is short and that this is a war that he will ultimately lose!",
      choices: ["proud", "peace", "bummed", "trouble", "enraged", "war"],
      lessonID: 21,
      question:
        "What is the devil’s attitude toward God’s church in the last days?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the dragon was enraged with the woman, and he went to make war with the rest of her offspring, who keep the commandments of God and have the testimony of Jesus Christ",
          ref: "Revelation 12:17",
        },
      ],
    },
    "21-14": {
      blanks: [
        {
          choices: [
            "commandments",
            "testimony",
            "word",
            "influence",
            "mind",
            "mission",
          ],
          correctAnswer: "commandments",
          textAfter: " of God and have the",
          textBefore: ". . . the rest of her offspring, who keep the",
        },
        {
          choices: [
            "commandments",
            "testimony",
            "word",
            "influence",
            "mind",
            "mission",
          ],
          correctAnswer: "testimony",
          textAfter: " of Jesus Christ.\n",
        },
      ],
      body: "The “rest” (or “remnant”) is the  final church that represents Jesus Christ and His truth in the closing moments prior to the return of Jesus.\nGod has provided a number of clear characteristics to enable us to easily identify this church.\n A) It will rise after AD 1798 (Revelation 12:6, 14). \nIn the wilderness until AD 1798—the end of the 1,260 years of papal supremacy—the church would emerge from obscurity to be a global representation of God’s love and truth.\n  B) It will believe the original teachings of the Christian church (Revelation 12:17). \nJust as a remnant of material is the end piece of cloth—the same color and pattern as the original—God’s final church will teach the same message as the original Christian church.\n  C) It will be a global movement (Revelation 14:6).\nGod’s church will proclaim His final message to “every nation, tribe, tongue,\nand people” (Revelation 14:6). \n  D) It will proclaim the everlasting gospel (Revelation 14:6–12).\nThe everlasting gospel found in Revelation 14 presents several key teachings:\n■ Fear God (Revelation 14:7).\n■ Give glory to Him (Revelation 14:7).\n■ The hour of His judgment has come (Revelation 14:7).\n■ Worship Him who made heaven and earth, the sea and springs of water (Revelation 14:7). This is a call to worship the Creator God.\n■ Babylon is fallen (Revelation 14:8).\n■ Do not worship the beast or receive the mark of the beast (Revelation 14:9, 10).\n             \n        E. It believes—and keeps—all of God’s commandments, including the seventh-day Sabbath. (Revelation 12:17; 14:12)\nF. It will teach that death is a peaceful rest that lasts until the resurrection. (Revelation 14:13",
      choices: [
        "commandments",
        "testimony",
        "word",
        "influence",
        "mind",
        "mission",
      ],
      lessonID: 21,
      question: "What are the identifying marks of God’s final church?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the dragon was enraged with the woman, and he went to make war with the rest of her offspring, who keep the commandments of God and have the testimony of Jesus Christ",
          ref: "Revelation 12:17",
        },
      ],
    },
    "21-15": {
      Supplements: {
        "-L82ncLbV8yZBeo85nGH": {
          body: "Remember that the safest thing to do in making any decision is to consult God’s Word on the matter. In Revelation 18:4, He does not say, “I want you to remain in a church that is not teaching Bible truth and attempt to reform her”.  Having said that, it is also important to note that God loves His people in all churches. His counsel to His people is to leave a church that is not teaching the truths of the Bible, find one that is, and endeavor to reach more people from the outside. \n",
          title:
            "Now that I know these things, can't I just stay in my church and try to change it from the inside out?",
        },
      },
      blanks: [
        {
          choices: ["just", "one", "a"],
          correctAnswer: "one",
          textAfter:
            " body and one Spirit, just as you were called in one hope of your calling; one Lord, one faith, one baptism.",
          textBefore: "There is",
        },
      ],
      body: "Rather than a multitude of various churches presenting a wide range of differing messages, God is seeking to bring His people together—united in the truths of His Word.",
      choices: ["just", "one", "a"],
      lessonID: 21,
      question:
        "How many church organizations does Jesus desire to have on this earth?",
      questionID: 15,
      questionType: "radio",
      verses: [
        {
          body: "There is one body and one Spirit, just as you were called in one hope of your calling; 5 one Lord, one faith, one baptism;",
          ref: "Ephesians 4:4, 5",
        },
      ],
    },
    "21-16": {
      Supplements: {
        "-L82oOyqlCNHaksvSqmV": {
          body: "No, certainly not. God has His people in many churches. Membership in one church or another is no guarantee of salvation. Paul makes it plain in Ephesians 2:8–9 that, “For by grace you have been saved through faith, and that not of yourselves; it is the gift of God, not of works, lest anyone should boast”. So, while everyone is saved by grace through faith in Jesus Christ, we also choose to follow Christ out of an overwhelming love for His gift of salvation to us. And Christ’s call to His people in many churches is found in Revelation 18:4. He says, “Come out of her, my people”. God’s true followers will choose to listen to His voice and follow Him. In John 10:16, Jesus says, “And other sheep I have which are not of this fold; them also I must bring, and they will hear My voice; and there will be one flock and one shepherd”.\n",
          title:
            "If God has a church in the end times, does that mean that only members of that church will be saved?",
        },
      },
      blanks: [
        {
          choices: [
            "forth",
            "you",
            "notice",
            "huge",
            "out",
            "my",
            "hear",
            "one",
          ],
          correctAnswer: "out",
          textAfter: " of her,",
          textBefore: "I heard another voice from heaven saying, “Come",
        },
        {
          choices: [
            "forth",
            "you",
            "notice",
            "huge",
            "out",
            "my",
            "hear",
            "one",
          ],
          correctAnswer: "my",
          newline: [1],
          textAfter:
            " people, lest you share in her sins, and lest you receive of her plagues.” ",
        },
        {
          choices: [
            "forth",
            "you",
            "notice",
            "huge",
            "out",
            "my",
            "hear",
            "one",
          ],
          correctAnswer: "hear",
          textAfter: " My voice; and there will be",
          textBefore:
            "Other sheep I have which are not of this fold; them also I must bring, and they will",
        },
        {
          choices: [
            "forth",
            "you",
            "notice",
            "huge",
            "out",
            "my",
            "hear",
            "one",
          ],
          correctAnswer: "one",
          textAfter: " flock and one shepherd.",
        },
      ],
      body: "The word “church” comes from the Greek word ecclesia, which means “called-out ones.” There are saved people within all churches—people who love God and are living up to the spiritual light they have. And as we approach the end of time, Jesus calls His people into “one flock”—His final church of the last days.\nSoon there will be only two global religions. One will worship and obey Jesus Christ. The other will yield to the religious powers of the world. Now is the time to hear the call of Jesus—to follow Him in truth and be part of His last-day church.",
      choices: ["out", "stuff", "share", "my", "notice", "one", "hear"],
      lessonID: 21,
      question:
        "God describes the confused system of religion in the last days as “Babylon.” What invitation does Jesus make to those outside His final church?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I heard another voice from heaven saying, “Come out of her, my people, lest you share in her sins, and lest you receive of her plagues.",
          ref: "Revelation 18:4",
        },
        {
          body: "And other sheep I have which are not of this fold; them also I must bring, and they will hear My voice; and there will be one flock and one shepherd.",
          ref: "John 10:16",
        },
      ],
    },
    "21-17": {
      correctAnswer: "true",
      lessonID: 21,
      question:
        "Jesus loves you, and He is calling you to join Him within God's end-time church.  Is it your decision to follow Jesus according to the teachings of the Bible and become a part of sharing God's final message with the world?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "21-2": {
      blanks: [
        {
          choices: ["church", "life", "house"],
          correctAnswer: "church",
          textAfter: " .",
          textBefore: "On this rock I will build My",
        },
      ],
      body: "Jesus faithfully attended church every Sabbath (Luke 4:16). He made it clear that His intention was that He would build a church. It is hard to imagine that Jesus would establish a church He would not want people to be part of!",
      choices: ["church", "life", "house"],
      lessonID: 21,
      question: "Did Jesus believe people should belong to a church?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "And I also say to you that you are Peter, and on this rock I will build My church, and the gates of Hades shall not prevail against it.",
          ref: "Matthew 16:18",
        },
      ],
    },
    "21-3": {
      blanks: [
        {
          choices: ["people", "churches", "houses"],
          correctAnswer: "churches",
          textAfter:
            " throughout all Judea, Galilee, and Samaria had peace and were edified. And walking in the fear of the Lord and in the comfort of the Holy Spirit, they were multiplied.",
          textBefore: "The",
        },
      ],
      body: "After Jesus died, the church multiplied and grew, and was used by God to share light and blessing with the world.",
      choices: ["people", "churches", "houses"],
      correctAnswer: "false",
      lessonID: 21,
      question:
        "Did Jesus establish a church in this world  before He went to heaven?",
      questionID: 3,
      questionType: "trueOrFalse",
      trueFalseQuestion:
        "Jesus didn't establish any church in this world before He went to heaven.",
      verses: [
        {
          body: "Then the churches throughout all Judea, Galilee, and Samaria had peace and were edified. And walking in the fear of the Lord and in the comfort of the Holy Spirit, they were multiplied.",
          ref: "Acts 9:31",
        },
      ],
    },
    "21-4": {
      blanks: [
        {
          choices: ["people", "numbers", "church"],
          correctAnswer: "church",
          textAfter: " daily those who were being saved.",
          textBefore: "The Lord added to the",
        },
      ],
      body: "\nAlthough it did not have a denominational name, the disciples labored to build up Christ’s church. It was an organized church, described as the body of Christ (Colossians 1:18), which people became part of through the ordinance of baptism (1 Corinthians 12:13). Christ’s church had deacons and elders and sent out missionaries. Jesus established an organized church.",
      choices: ["people", "numbers", "church"],
      lessonID: 21,
      question: "Did the disciples work to establish a particular church?",
      questionID: 4,
      questionType: "radio",
      verses: [
        {
          body: "praising God and having favor with all the people. And the Lord added to the church daily those who were being saved.",
          ref: "Acts 2:47",
        },
      ],
    },
    "21-5": {
      blanks: [
        {
          choices: ["truth", "faith", "church"],
          correctAnswer: "truth",
          textAfter: " .",
          textBefore:
            "I write so that you may know how you ought to conduct yourself in the house of God, which is the church of the living God, the pillar and ground of the",
        },
      ],
      body: "The Bible is clear that God’s church would be characterized by a commitment to teaching His truth—not traditions, customs or man-made doctrines.",
      choices: ["truth", "faith", "church"],
      lessonID: 21,
      question: "How did the Apostle Paul describe the church?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "but if I am delayed, I write so that you may know how you ought to conduct yourself in the house of God, which is the church of the living God, the pillar and ground of the truth.",
          ref: "1 Timothy 3:15",
        },
      ],
    },
    "21-6": {
      blanks: [
        {
          choices: ["flower", "woman", "goat"],
          correctAnswer: "woman",
          textAfter: " .\n",
          textBefore:
            "I have likened the daughter of Zion to a lovely and delicate",
        },
      ],
      body: "\nThroughout the Bible, a woman symbolically represents a church. A pure woman represents God’s true church. An impure woman represents an impure church (2 Corinthians 11:2; Revelation 17:1–6).",
      choices: ["flower", "woman", "goat"],
      lessonID: 21,
      question: "What symbol is used in the Bible to represent a church?",
      questionID: 6,
      questionType: "radio",
      verses: [
        {
          body: "I have likened the daughter of Zion to a lovely and delicate woman.",
          ref: "Jeremiah 6:2",
        },
      ],
    },
    "21-7": {
      blanks: [
        {
          choices: [
            "commandments",
            "commandments",
            "faith",
            "word",
            "word",
            "love",
          ],
          correctAnswer: "commandments",
          newline: [1],
          textAfter: " of God and have the testimony of Jesus Christ.",
          textBefore:
            "The dragon was enraged with the woman, and he went to make war with the rest of her offspring, who keep the",
        },
        {
          choices: [
            "commandments",
            "commandments",
            "faith",
            "word",
            "word",
            "love",
          ],
          correctAnswer: "God",
          textAfter: "  and the",
          textBefore: " Here are those who keep the commandments of ",
        },
        {
          choices: [
            "commandments",
            "commandments",
            "faith",
            "word",
            "word",
            "love",
          ],
          correctAnswer: "faith",
          textAfter: " of Jesus.",
        },
      ],
      body: 'God’s end-time church will be characterized by faith in God and obedience to Him. These characteristics have always been present in those who have faithfully followed the God of the Bible. In Genesis 26:5, God said of Abraham, “Abraham obeyed My voice and kept My charge, My commandments, My statutes, and My laws". God is seeking to prepare a group of people who are ready to spend eternity with Him."',
      choices: ["God", "commandments", "faith", "word", "love"],
      lessonID: 21,
      question:
        "What special characteristics will the church of the last days possess?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the dragon was enraged with the woman, and he went to make war with the rest of her offspring, who keep the commandments of God and have the testimony of Jesus Christ",
          ref: "Revelation 12:17",
        },
        {
          body: "Here is the patience of the saints; here are those who keep the commandments of God and the faith of Jesus.",
          ref: "Revelation 14:12",
        },
      ],
    },
    "21-8": {
      blanks: [
        {
          choices: [
            "light",
            "world",
            "flowers",
            "robes",
            "ground",
            "loaves",
            "sun",
            "moon",
            "stars",
          ],
          correctAnswer: "sun",
          textAfter: " , with the",
          textBefore:
            "A great sign appeared in heaven: a woman clothed with the",
        },
        {
          choices: [
            "light",
            "world",
            "flowers",
            "robes",
            "ground",
            "loaves",
            "sun",
            "moon",
            "stars",
          ],
          correctAnswer: "moon",
          textAfter: " under her feet, and on her head a garland of twelve",
        },
        {
          choices: [
            "light",
            "world",
            "flowers",
            "robes",
            "ground",
            "loaves",
            "sun",
            "moon",
            "stars",
          ],
          correctAnswer: "stars",
          textAfter: " .",
        },
      ],
      body: "Revelation chapter 12 depicts a pure church—clothed with the beauty of nature and reflecting light to the world. However, God’s church would have a difficult experience throughout human history.",
      choices: [
        "light",
        "world",
        "flowers",
        "sun",
        "robes",
        "ground",
        "loaves",
        "moon",
        "stars",
      ],
      lessonID: 21,
      question: "How is God’s true church described in the book of Revelation?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "Now a great sign appeared in heaven: a woman clothed with the sun, with the moon under her feet, and on her head a garland of twelve stars.",
          ref: "Revelation 12:1",
        },
      ],
    },
    "21-9": {
      blanks: [
        {
          choices: ["woman", "man", "person"],
          correctAnswer: "woman",
          textAfter: " who gave birth to the male Child.",
          textBefore:
            "When the dragon saw that he had been cast to the earth, he persecuted the",
        },
      ],
      body: "The devil knows the most effective way to hurt Jesus is to hurt those He loves. The early Christian church suffered greatly at the hands of pagan Rome. Enormous numbers of people were martyred. But instead of destroying God’s church, persecution became the catalyst for growth. The Christian character in life and death was such a powerful witness that others were inspired to join the Christian church. The early Christian writer Tertullian is quoted as having said, “The blood of the martyrs is seed”—that is, the seed of the church. Realizing that persecution would not achieve his aim of destroying the Christian church, the devil changed his tactics and resorted to corrupting the Christian church—bringing about its ruin from the inside out.",
      choices: ["woman", "man", "person"],
      lessonID: 21,
      question: "How has Satan especially targeted God’s church?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "Now when the dragon saw that he had been cast to the earth, he persecuted the woman who gave birth to the male Child.",
          ref: "Revelation 12:13",
        },
      ],
    },
  },
  {
    "22-0": {
      body: "In one of the most dramatic stories in the Bible, King Belshazzar of Babylon was hosting a party in his palace when—in the midst of the festivities—a mysterious hand appeared and wrote several words on a wall in the room where the party was taking place. Unable to interpret the writing on the wall, the king summoned the prophet Daniel, who told the king the meaning of the mysterious message. Daniel said, “God has numbered your kingdom, and finished it . . . you have been weighed in the balances, and found wanting” (Daniel 5:26, 27). Then Daniel stated ominously, “Your kingdom has been divided, and given to the Medes and Persians” (Daniel 5:28). The Bible says, “That very night Belshazzar, king of the Chaldeans, was slain. And Darius the Mede received the kingdom, being about sixty-two years old” (Daniel 5:30, 31). That evening, the mightiest kingdom in the world was overthrown. Babylon had fallen. The Bible tells us that Babylon is going to fall again. How are we to understand the future fall of Babylon? And in what way does this affect people of faith?",
      lessonID: 22,
      questionID: 0,
      type: "text",
    },
    "22-1": {
      blanks: [
        {
          choices: ["great", "city", "tower"],
          correctAnswer: "great",
          textAfter:
            " Babylon, that I have built for a royal dwelling by my mighty power and for the honor of my majesty?”\n",
          textBefore: "The king spoke, saying, “Is not this",
        },
      ],
      body: "Ancient Babylon was a leading world power. The Babylonians ruled a significant section of the planet, and the city of Babylon was a center of wealth and influence. Babylon was also a religious center without rival in the world. The religion of Babylon was characterized by idolatry, ancestor worship and sun worship.",
      choices: ["great", "city", "tower"],
      correctAnswer: "false",
      lessonID: 22,
      question: "How powerful a kingdom was ancient Babylon?",
      questionID: 1,
      questionType: "trueOrFalse",
      trueFalseQuestion: "The kingdom of ancient Babylon was not very strong.",
      verses: [
        {
          body: "The king spoke, saying, “Is not this great Babylon, that I have built for a royal dwelling by my mighty power and for the honor of my majesty?",
          ref: "Daniel 4:30",
        },
      ],
    },
    "22-10": {
      blanks: [
        {
          choices: ["MOTHER", "HARLOTS", "DECEIVER", "WORLDS", "LADY", "EARTH"],
          correctAnswer: "MOTHER",
          textAfter: " OF",
          textBefore:
            "On her forehead a name was written: MYSTERY, BABYLON THE GREAT, THE",
        },
        {
          choices: ["MOTHER", "HARLOTS", "DECEIVER", "WORLDS", "LADY", "EARTH"],
          correctAnswer: "HARLOTS",
          textAfter: " AND OF THE ABOMINATIONS OF THE EARTH.",
        },
      ],
      body: "Just as the woman—the “mother”—of Revelation 17 represents a church, her daughters—also women—likewise represent churches. The mother church, Babylon, is the church that like ancient Babylon has confused the world with her teachings. The daughter churches are those that follow the key teachings of the mother church. They teach her errors as truth, even though those errors have no biblical basis and rest only upon human authority. The churches teaching the errors of the mother church are also a part of what the Bible calls “Babylon.”",
      choices: ["MOTHER", "HARLOTS", "DECEIVER", "WORLDS", "LADY", "EARTH"],
      lessonID: 22,
      question:
        "What relationship is there between Babylon and other churches?",
      questionID: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: " And on her forehead a name was written: MYSTERY, BABYLON THE GREAT, THE MOTHER OF HARLOTS AND OF THE ABOMINATIONS OF THE EARTH.",
          ref: "Revelation 17:5",
        },
      ],
    },
    "22-11": {
      blanks: [
        {
          choices: ["tasted", "drunk", "thought"],
          correctAnswer: "drunk",
          textAfter:
            " of the wine of the wrath of her fornication, the kings of the earth have committed fornication with her, and the merchants of the earth have become rich through the abundance of her luxury.",
          textBefore: "All the nations have",
        },
      ],
      body: "\nJust as wine is intoxicating (confusing), the teachings of Babylon have intoxicated and confused the earth. Because of Babylon’s influence, many people in the world today reject some of the plainest teachings in the Bible and accept in their place the confusing wine of Babylon.",
      choices: ["tasted", "drunk", "thought"],
      lessonID: 22,
      question: "How has modern Babylon affected the world?",
      questionID: 11,
      questionType: "radio",
      verses: [
        {
          body: "For all the nations have drunk of the wine of the wrath of her fornication, the kings of the earth have committed fornication with her, and the merchants of the earth have become rich through the abundance of her luxury.",
          ref: "Revelation 18:3",
        },
      ],
    },
    "22-12": {
      blanks: [
        {
          choices: ["sadness", "Tammuz", "children"],
          correctAnswer: "Tammuz",
          textAfter: " .",
          textBefore:
            "He brought me to the door of the north gate of the Lord’s house; and to my dismay, women were sitting there weeping for",
        },
      ],
      body: "The Babylonians believed that people survived bodily death and went on existing in another form. This was not only the precursor to modern spiritualism, but also formed the basis of what many Christians believe today. Tammuz was a god worshiped by the Babylonians. They believed that Tammuz—a god of food and vegetation—died each year, and they mourned his passing. The Babylonians believed in the immortality of the soul.",
      choices: ["sadness", "Tammuz", "children"],
      lessonID: 22,
      question: "What did ancient Babylon believe about death?",
      questionID: 12,
      questionType: "radio",
      verses: [
        {
          body: "So He brought me to the door of the north gate of the Lord’s house; and to my dismay, women were sitting there weeping for Tammuz.",
          ref: "Ezekiel 8:14",
        },
      ],
    },
    "22-13": {
      blanks: [
        {
          choices: [
            "nothing",
            "praise",
            "silence",
            "sleep",
            "trumpet",
            "all",
            "sleep",
            "history",
            "sing",
            "day",
          ],
          correctAnswer: "nothing",
          newline: [1],
          textAfter:
            " , and they have no more reward, for the memory of them is forgotten.",
          textBefore: "The living know that they will die; but the dead know",
        },
        {
          choices: [
            "nothing",
            "praise",
            "silence",
            "sleep",
            "trumpet",
            "all",
            "sleep",
            "history",
            "sing",
            "day",
          ],
          correctAnswer: "praise",
          textAfter: " the Lord, nor any who go down into",
          textBefore: " The dead do not",
        },
        {
          choices: [
            "nothing",
            "praise",
            "silence",
            "sleep",
            "trumpet",
            "all",
            "sleep",
            "history",
            "sing",
            "day",
          ],
          correctAnswer: "silence",
          newline: [1],
          textAfter: " . ",
        },
        {
          choices: [
            "nothing",
            "praise",
            "silence",
            "sleep",
            "trumpet",
            "all",
            "sleep",
            "history",
            "sing",
            "day",
          ],
          correctAnswer: "sleep",
          textAfter:
            " , but we shall all be changed—in a moment, in the twinkling of an eye, at the last",
          textBefore: "Behold, I tell you a mystery: We shall not all",
        },
        {
          choices: [
            "nothing",
            "praise",
            "silence",
            "sleep",
            "trumpet",
            "all",
            "sleep",
            "history",
            "sing",
            "day",
          ],
          correctAnswer: "trumpet",
          textAfter: " .",
        },
      ],
      body: "The Bible teaches that death is an unconscious sleep between life in this world and the resurrection when Jesus returns. The teaching that people have a soul that survives bodily death did not originate in the Bible. Instead, it entered Christianity from paganism, where the idea was made popular by the Babylonians, who worshipped the dead. The teaching of the immortality of the soul—that people continue to live on or be conscious after death—is part of the wine (or false teaching) of Babylon. It has been made popular in modern Christianity due to the influence of spiritual Babylon.",
      choices: [
        "nothing",
        "praise",
        "silence",
        "sleep",
        "trumpet",
        "all",
        "sleep",
        "history",
        "sing",
        "day",
      ],
      lessonID: 22,
      question: "What does the Bible teach about death?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "For the living know that they will die; But the dead know nothing, And they have no more reward, for the memory of them is forgotten.",
          ref: "Ecclesiastes 9:5",
        },
        {
          body: "The dead do not praise the Lord, nor any who go down into silence.",
          ref: "Psalm 115:17",
        },
        {
          body: "Behold, I tell you a mystery: We shall not all sleep, but we shall all be changed— 52 in a moment, in the twinkling of an eye, at the last trumpet. For the trumpet will sound, and the dead will be raised incorruptible, and we shall be changed.",
          ref: "1 Corinthians 15:51, 52",
        },
      ],
    },
    "22-14": {
      blanks: [
        {
          choices: ["sun", "idols", "Devil"],
          correctAnswer: "sun",
          textAfter: " toward the east.",
          textBefore:
            "He brought me into the inner court of the Lord’s house; and there, at the door of the temple of the Lord, between the porch and the altar, were about twenty-five men with their backs toward the temple of the Lord and their faces toward the east, and they were worshiping the",
        },
      ],
      body: "Sun worship was practiced in ancient Babylon. Not only did it corrupt the way God’s people worshipped in Bible times, but it has also become a key component of Christian worship today. Sunday—the day of the sun—has replaced the Bible Sabbath day as the day of worship for many Christians. While many are unaware of the origin of their worship, they break this commandment of God and practice unbiblical worship.\n",
      choices: ["sun", "idols", "Devil"],
      lessonID: 22,
      question:
        "What other aspect of Babylonian worship has entered the church?",
      questionID: 14,
      questionType: "radio",
      verses: [
        {
          body: "So He brought me into the inner court of the Lord’s house; and there, at the door of the temple of the Lord, between the porch and the altar, were about twenty-five men with their backs toward the temple of the Lord and their faces toward the east, and they were worshiping the sun toward the east.",
          ref: "Ezekiel 8:16",
        },
      ],
    },
    "22-15": {
      blanks: [
        {
          choices: [
            "first",
            "last",
            "word",
            "final",
            "seventh",
            "blessing",
            "Sabbath",
            "seventh",
            "Sabbaths",
          ],
          correctAnswer: "Sabbath",
          textAfter:
            " day, to keep it holy. Six days you shall labor and do all your work, but the",
          textBefore: "Remember the",
        },
        {
          choices: [
            "first",
            "last",
            "word",
            "final",
            "seventh",
            "blessing",
            "Sabbath",
            "seventh",
            "Sabbaths",
          ],
          correctAnswer: "seventh",
          newline: [1],
          textAfter: " day is the Sabbath of the Lord your God.",
        },
        {
          choices: [
            "first",
            "last",
            "word",
            "final",
            "seventh",
            "blessing",
            "Sabbath",
            "seventh",
            "Sabbaths",
          ],
          correctAnswer: "Sabbaths",
          textAfter:
            " , to be a sign between them and Me, that they might know that I am the Lord who sanctifies them.",
          textBefore: " Moreover I also gave them My",
        },
      ],
      body: "God gave the human family the seventh-day Sabbath as a memorial of His power to create and re-create. The Sabbath was kept not only by the patriarchs and prophets, but by Jesus, the disciples, and the early Christian church of the New Testament. As Jesus said, “The Sabbath was made for man” (Mark 2:27). The Sabbath day was given as a gift to the human family, designed to be observed by those whose love for God has motivated them to obey Him. Sunday worship—which originated in paganism and became established in Christianity—is part of the wine of Babylon. It has been made popular in modern Christianity because of the influence of spiritual Babylon.",
      choices: [
        "first",
        "last",
        "word",
        "final",
        "seventh",
        "blessing",
        "Sabbath",
        "seventh",
        "Sabbaths",
      ],
      lessonID: 22,
      question: "What is God’s will concerning worship for His people?",
      questionID: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "Remember the Sabbath day, to keep it holy. 9 Six days you shall labor and do all your work, 10 but the seventh day is the Sabbath of the Lord your God. In it you shall do no work: you, nor your son, nor your daughter, nor your male servant, nor your female servant, nor your cattle, nor your stranger who is within your gates.",
          ref: "Exodus 20:8-10",
        },
        {
          body: "Moreover I also gave them My Sabbaths, to be a sign between them and Me, that they might know that I am the Lord who sanctifies them.",
          ref: "Ezekiel 20:12",
        },
      ],
    },
    "22-16": {
      blanks: [
        {
          choices: ["See", "Flee", "Watch"],
          correctAnswer: "Flee",
          textAfter:
            " from the midst of Babylon, and every one save his life! Do not be cut off in her iniquity, for this is the time of the Lord’s vengeance; He shall recompense her.",
        },
      ],
      body: "Recognizing the impending fall of Babylon, God called His people to flee fallen Babylon and come to a place of safety.",
      choices: ["See", "Flee", "Watch"],
      lessonID: 22,
      question:
        "What was God’s message to His faithful people living in ancient Babylon?",
      questionID: 16,
      questionType: "radio",
      verses: [
        {
          body: "Flee from the midst of Babylon, and every one save his life!  Do not be cut off in her iniquity, for this is the time of the Lord’s vengeance; He shall recompense her.",
          ref: "Jeremiah 51:6",
        },
      ],
    },
    "22-17": {
      Supplements: {
        "-L82sT0d6L2rwhXDGZf0": {
          body: "Of course he does. Those are good things. There are many good things that the Roman Catholic Church is engaged in. The issue isn’t so much whether a person (or institution) does good things or not. In fact, there are many non-Christian organizations that do wonderful things to help humanity.  In the end, what matters is what we have done with the light of truth God has given us. Jesus says in John 14:15, “If you love Me, keep My commandments”. Once God has given His people light, He desires that we would follow that light out of love for Him.  If we choose to consciously ignore His teachings, then any amount of good works that we do can’t help us make it to heaven. God’s great desire is that we would believe in Him and, as a result, that our lives may be changed and we would choose to glorify Him in the works that we do.  Salvation comes through an acceptance of Jesus Christ as Lord and Savior, and surrender to the will of God.  Good deeds do not take the place of full surrender to Jesus.\n",
          title:
            "The Roman Catholic Church has done so much to help the poor, sick, and uneducated. Doesn't God care about those things?",
        },
      },
      blanks: [
        {
          choices: ["out", "share", "forth", "dwell", "away", "indulge"],
          correctAnswer: "out",
          textAfter: " of her, my people, lest you",
          textBefore: "I heard another voice from heaven saying, “Come",
        },
        {
          choices: ["out", "share", "forth", "dwell", "away", "indulge"],
          correctAnswer: "share",
          textAfter:
            " in her sins, and lest you receive of her plagues. For her sins have reached to heaven, and God has remembered her iniquities.”\n",
        },
      ],
      body: "Knowing He has faithful, committed people who are part of the system the Bible calls “Babylon,” God calls those believers to come out of Babylon and to be a part of His end-time church. [For more on God’s end-time church, see It Is Written Bible Study Guide #21, “In Search of the Church.”] God understands that remaining in a system that teaches error in the place of truth is spiritually dangerous. Recognizing that coming out of a church can sometimes seem difficult, Jesus offers the same advice today that He offered Peter when Peter asked Jesus about the responsibilities of another individual. Jesus said, “What is that to you? You follow Me” (John 21:22). Rather than concerning ourselves with what others think or what others might say, Jesus urges us to keep our hearts connected with His heart and to faithfully follow His leading.",
      choices: ["out", "share", "forth", "dwell", "away", "indulge"],
      lessonID: 22,
      question:
        "What is God’s message to His faithful people who are in modern, spiritual Babylon?",
      questionID: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I heard another voice from heaven saying, “Come out of her, my people, lest you share in her sins, and lest you receive of her plagues. 5 For her sins have reached to heaven, and God has remembered her iniquities.",
          ref: "Revelation 18:4, 5",
        },
      ],
    },
    "22-18": {
      Supplements: {
        "-L82sXVBU12YucrLYtNo": {
          body: "No, certainly not. God has “His people” in virtually all churches.  Anyone genuinely living up to the light of the gospel they have received is a child of God. But in Earth’s final days God will call His children out of churches that are not teaching His word and into the full light of His Word. In His mercy, He is proclaiming His message to “Come out of Babylon” around the earth, knowing He has faithful children who will respond.  However, a choice to remain in either the mother church or the daughter churches is a choice to “share in her sins, and ...  receive of her plagues” (Revelation 18:",
          title: "Are all Catholics going to be lost?",
        },
      },
      blanks: [
        {
          choices: [
            "flames",
            "words",
            "name",
            "truth",
            "commandments",
            "faith",
            "temple",
            "covenant",
            "heart",
          ],
          correctAnswer: "truth",
          newline: [1],
          textAfter: " .",
          textBefore:
            "I write so that you may know how you ought to conduct yourself in the house of God, which is the church of the living God, the pillar and ground of the",
        },
        {
          choices: [
            "flames",
            "words",
            "name",
            "truth",
            "commandments",
            "faith",
            "temple",
            "covenant",
            "heart",
          ],
          correctAnswer: "commandments",
          textAfter: " of God and the",
          textBefore: " Here are those who keep the",
        },
        {
          choices: [
            "flames",
            "words",
            "name",
            "truth",
            "commandments",
            "faith",
            "temple",
            "covenant",
            "heart",
          ],
          correctAnswer: "faith",
          textAfter: " of Jesus.\n",
        },
      ],
      body: "When Jesus returns, He will return for “a glorious church, not having spot or wrinkle or any such thing, but that she should be holy and without blemish” (Ephesians 5:27). His church will be made up of faithful people following Christ in harmony with the Bible. They will have made the decision to be separate from false teachings and traditions that have no place in the Bible. They will say with David, “I delight to do Your will, O my God, and Your law is within my heart” (Psalm 40:8).",
      choices: [
        "flames",
        "words",
        "name",
        "truth",
        "commandments",
        "faith",
        "temple",
        "covenant",
        "heart",
      ],
      lessonID: 22,
      question: "How does God describe the church in the last days?",
      questionID: 18,
      questionType: "wordCloud",
      verses: [
        {
          body: "but if I am delayed, I write so that you may know how you ought to conduct yourself in the house of God, which is the church of the living God, the pillar and ground of the truth.",
          ref: "1 Timothy 3:15",
        },
        {
          body: "Here is the patience of the saints; here are those who keep the commandments of God and the faith of Jesus.",
          ref: "Revelation 14:12",
        },
      ],
    },
    "22-19": {
      correctAnswer: "true",
      lessonID: 22,
      question:
        "Are you willing to come out of Babylon, and to allow God to lead you in harmony with the truth of His Word?",
      questionID: 19,
      questionType: "truthConfirmation",
    },
    "22-2": {
      blanks: [
        {
          choices: ["struck", "confused", "split"],
          correctAnswer: "confused",
          textAfter: " the language of all the earth.\n",
          textBefore: "Its name is called Babel, because there the Lord",
        },
      ],
      body: "\nThe name “Babylon” appears to be derived from the word “Babel,” meaning “confusion,” an apt description of the confused pagan teachings of Babylon.",
      choices: ["struck", "confused", "split"],
      lessonID: 22,
      question: "Where did Old Testament Babylon originate?",
      questionID: 2,
      questionType: "radio",
      verses: [
        {
          body: "Therefore its name is called Babel, because there the Lord confused the language of all the earth; and from there the Lord scattered them abroad over the face of all the earth.",
          ref: "Genesis 11:9",
        },
      ],
    },
    "22-3": {
      blanks: [
        {
          choices: [
            "Sodom",
            "Gomorrah",
            "Jericho",
            "Jerusalem",
            "man",
            "woman",
          ],
          correctAnswer: "Sodom",
          textAfter: " and",
          textBefore:
            "Babylon, the glory of kingdoms, the beauty of the Chaldeans’ pride, will be as when God overthrew",
        },
        {
          choices: [
            "Sodom",
            "Gomorrah",
            "Jericho",
            "Jerusalem",
            "man",
            "woman",
          ],
          correctAnswer: "Gomorrah",
          textAfter: " .",
        },
      ],
      body: "Due to its great wickedness, God promised that ancient Babylon would one day be destroyed.\n",
      choices: ["Sodom", "Gomorrah", "Jericho", "Jerusalem", "man", "woman"],
      lessonID: 22,
      question: "What warning did God issue concerning ancient Babylon?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "And Babylon, the glory of kingdoms, the beauty of the Chaldeans’ pride, will be as when God overthrew Sodom and Gomorrah.",
          ref: "Isaiah 13:19",
        },
      ],
    },
    "22-4": {
      blanks: [
        {
          choices: ["drunk", "fools", "sleep"],
          correctAnswer: "drunk",
          textAfter:
            " . The nations drank her wine; therefore the nations are deranged.",
          textBefore:
            "Babylon was a golden cup in the Lord’s hand, that made all the earth",
        },
      ],
      body: "Babylon confused—or made drunk—the nations of the earth with its wickedness and false teachings.",
      choices: ["drunk", "fools", "sleep"],
      correctAnswer: "false",
      lessonID: 22,
      question: "What effect did ancient Babylon have on other nations?",
      questionID: 4,
      questionType: "trueOrFalse",
      trueFalseQuestion: "Babylon had little to no effect on other nations.",
      verses: [
        {
          body: "Babylon was a golden cup in the Lord’s hand, that made all the earth drunk. The nations drank her wine; Therefore the nations are deranged.",
          ref: "Jeremiah 51:7",
        },
      ],
    },
    "22-5": {
      blanks: [
        {
          choices: ["burned", "exploded", "fallen"],
          correctAnswer: "fallen",
          textAfter: " and been destroyed. Wail for her!",
          textBefore: "Babylon has suddenly",
        },
      ],
      body: "In persistently refusing the blessing of God and choosing not to yield to Him, Babylon fell and was destroyed. A once mighty nation was reduced to ruin.",
      choices: ["burned", "exploded", "fallen"],
      lessonID: 22,
      question:
        "What effect did Babylon’s apostasy ultimately have upon itself?",
      questionID: 5,
      questionType: "radio",
      verses: [
        {
          body: "Babylon has suddenly fallen and been destroyed. Wail for her! Take balm for her pain; Perhaps she may be healed.",
          ref: "Jeremiah 51:8",
        },
      ],
    },
    "22-6": {
      blanks: [
        {
          choices: [
            "people",
            "service",
            "temple",
            "Jerusalem",
            "servants",
            "Nazareth",
          ],
          correctAnswer: "temple",
          textAfter: " which had been in",
          textBefore:
            "Belshazzar the king made a great feast for a thousand of his lords, and drank wine in the presence of the thousand. While he tasted the wine, Belshazzar gave the command to bring the gold and silver vessels which his father Nebuchadnezzar had taken from the",
        },
        {
          choices: [
            "people",
            "service",
            "temple",
            "Jerusalem",
            "servants",
            "Nazareth",
          ],
          correctAnswer: "Jerusalem",
          textAfter:
            " , that the king and his lords, his wives, and his concubines might drink from them.",
        },
      ],
      body: "\nWhile the armies of Medo-Persia were gathering outside the gates of the city, the king of Babylon hosted a lavish party, during which he drank wine from the holy worship vessels stolen from the temple of God in Jerusalem. The pagan king defied the God of heaven by desecrating holy items intended by God for use in true worship. Belshazzar used God’s holy worship items for the unholy worship of false gods (Daniel 5:4).",
      choices: [
        "people",
        "service",
        "temple",
        "Jerusalem",
        "servants",
        "Nazareth",
      ],
      lessonID: 22,
      question: "What took place on the night of the fall of Babylon?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "Belshazzar the king made a great feast for a thousand of his lords, and drank wine in the presence of the thousand. 2 While he tasted the wine, Belshazzar gave the command to bring the gold and silver vessels which his father Nebuchadnezzar had taken from the temple which had been in Jerusalem, that the king and his lords, his wives, and his concubines might drink from them.",
          ref: "Daniel 5:1, 2",
        },
      ],
    },
    "22-7": {
      blanks: [
        {
          choices: [
            "sleeping",
            "honor",
            "banished",
            "title",
            "slain",
            "kingdom",
          ],
          correctAnswer: "slain",
          textAfter: " . And Darius the Mede received the",
          textBefore: "That very night Belshazzar, king of the Chaldeans, was",
        },
        {
          choices: [
            "sleeping",
            "honor",
            "banished",
            "title",
            "slain",
            "kingdom",
          ],
          correctAnswer: "kingdom",
          textAfter: " .",
        },
      ],
      body: "Belshazzar went too far when he took the holy things of God and used them for unholy purposes. In total rebellion to God, he perished as Babylon fell.",
      choices: ["sleeping", "honor", "banished", "title", "slain", "kingdom"],
      lessonID: 22,
      question: "What was the result of this blasphemy?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "That very night Belshazzar, king of the Chaldeans, was slain. 31 And Darius the Mede received the kingdom, being about sixty-two years old.",
          ref: "Daniel 5:30, 31",
        },
      ],
    },
    "22-8": {
      blanks: [
        {
          choices: [
            "never",
            "inhabited",
            "always",
            "standing",
            "not",
            "tolerated",
          ],
          correctAnswer: "never",
          textAfter: " be",
          textBefore: "It will",
        },
        {
          choices: [
            "never",
            "inhabited",
            "always",
            "standing",
            "not",
            "tolerated",
          ],
          correctAnswer: "inhabited",
          textAfter:
            " , nor will it be settled from generation to generation; nor will the Arabian pitch tents there, nor will the shepherds make their sheepfolds there.\n",
        },
      ],
      body: "\nGod has made clear that ancient Babylon will never be revived. Therefore, the Babylon of the book of Revelation will not be a revived literal Babylon. The Babylon of the book of Revelation is spiritual Babylon.",
      choices: ["never", "inhabited", "always", "standing", "not", "tolerated"],
      lessonID: 22,
      question: "Will ancient Babylon ever rise again?",
      questionID: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "It will never be inhabited, nor will it be settled from generation to generation; nor will the Arabian pitch tents there, nor will the shepherds make their sheepfolds there.",
          ref: "Isaiah 13:20",
        },
      ],
    },
    "22-9": {
      blanks: [
        {
          choices: [
            "woman",
            "her",
            "ONE",
            "city",
            "her",
            "MOTHER",
            "deceiver",
            "her",
            "LIAR",
          ],
          correctAnswer: "city",
          newline: [1],
          textAfter: " which reigns over the kings of the earth. ",
          textBefore: "The woman whom you saw is that great",
        },
        {
          choices: [
            "woman",
            "her",
            "ONE",
            "city",
            "her",
            "MOTHER",
            "deceiver",
            "her",
            "LIAR",
          ],
          correctAnswer: "her",
          textAfter:
            " forehead a name was written: MYSTERY, BABYLON THE GREAT, THE",
          textBefore: "On",
        },
        {
          choices: [
            "woman",
            "her",
            "ONE",
            "city",
            "her",
            "MOTHER",
            "deceiver",
            "her",
            "LIAR",
          ],
          correctAnswer: "MOTHER",
          textAfter: " OF HARLOTS AND OF THE ABOMINATIONS OF THE EARTH.\n",
        },
      ],
      body: "In the book of Revelation, spiritual Babylon is represented in two ways: as a city—demonstrating a parallel with ancient Babylon, and as a woman—representing that she is a church.\nJeremiah 6:2 and 2 Corinthians 11:2 use the symbol of a woman to represent the church. In the book of Revelation, the Bible uses the term “Babylon” to represent a spiritual entity.\n“Babylon” in the book of Revelation is referred to as:\n■ A woman (a church) (Revelation 17:1).\n■ Sitting on a beast (a nation or kingdom), depicting a union of church and state (Revelation 17:3).\n■ Having colors of purple and red (scarlet) (Revelation 17:4).\n■ Having persecuted God’s people (Revelation 17:6).\n■ Being located in a city on seven mountains (Revelation 17:9).\nEach of these identifying marks point to the church of Rome as being the Babylon of the book of Revelation. In 1 Peter 5:13, Peter referred to those “in Babylon.” As Peter was clearly not referring to people in the literal city of Babylon, it is believed by many that Peter was referring to believers in the city of Rome.",
      choices: [
        "woman",
        "her",
        "ONE",
        "city",
        "her",
        "MOTHER",
        "deceiver",
        "her",
        "LIAR",
      ],
      lessonID: 22,
      question: "How is Babylon described in the book of Revelation?",
      questionID: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the woman whom you saw is that great city which reigns over the kings of the earth.",
          ref: "Revelation 17:18",
        },
        {
          body: "And on her forehead a name was written: MYSTERY, BABYLON THE GREAT, THE MOTHER OF HARLOTS AND OF THE ABOMINATIONS OF THE EARTH.",
          ref: "Revelation 17:5",
        },
      ],
    },
  },
  {
    "23-0": {
      body: "The man was beaming! “We had such a great night at our church a few nights ago,” he began. “We had a guest speaker—and not only was he a great speaker, but he was also a prophet!” His friend answered with a question of his own. “How do you know he was a prophet?” The man thought for a moment. “Well,” he began, “the pastor said he was a prophet, so I guess he had to be!” How do you know if someone has the genuine gift of prophecy? And is the gift of prophecy still relevant today?",
      lessonID: 23,
      questionID: 0,
      type: "text",
    },
    "23-1": {
      blanks: [
        {
          choices: [
            "false",
            "false",
            "deceive",
            "bold",
            "bold",
            "share",
            "true",
            "true",
            "witness",
          ],
          correctAnswer: "prophets",
          newline: [1],
          textAfter: " will rise up and deceive many. ",
          textBefore: "Many false",
        },
        {
          choices: [
            "false",
            "false",
            "deceive",
            "bold",
            "bold",
            "share",
            "true",
            "true",
            "witness",
          ],
          correctAnswer: "false",
          textAfter: " prophets will rise and show great signs and wonders to",
          textBefore: "False christs and",
        },
        {
          choices: [
            "false",
            "false",
            "deceive",
            "bold",
            "bold",
            "share",
            "true",
            "true",
            "witness",
          ],
          correctAnswer: "deceive",
          textAfter: " , if possible, even the elect.",
        },
      ],
      body: "Jesus warned about false prophets in the end times. He did not, however, say that people should beware of all prophets. Jesus warned against false prophets, suggesting that He believed the genuine gift of prophecy would exist in the world.",
      choices: [
        "false",
        "prophets",
        "deceive",
        "bold",
        "bold",
        "share",
        "true",
        "true",
        "witness",
      ],
      lessonID: 23,
      question:
        "What was Jesus’ warning about prophets in the last days of earth’s history?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then many false prophets will rise up and deceive many.",
          ref: "Matthew 24:11",
        },
        {
          body: "For false christs and false prophets will rise and show great signs and wonders to deceive, if possible, even the elect.",
          ref: "Matthew 24:24",
        },
      ],
    },
    "23-10": {
      blanks: [
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "law",
          textAfter: " and to the",
          textBefore: " To the",
        },
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "testimony",
          textAfter:
            " ! If they do not speak according to this word, it is because there is no",
        },
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "light",
          textAfter: " in them.",
        },
      ],
      choices: [
        "pass",
        "truly",
        "light",
        "law",
        "testimony",
        "been",
        "other",
        "not",
        "word",
        "love",
      ],
      lessonID: 23,
      question: "What are the tests for the genuine gift of prophecy?",
      questionID: 10,
      questionIDTitle: "8",
      questionType: "wordCloud",
      subQuestion:
        "C.  The genuine gift of prophecy will always speak in harmony with God's law.",
      verses: [
        {
          body: "To the law and to the testimony! If they do not speak according to this word, it is because there is no light in them.",
          ref: "Isaiah 8:20",
        },
      ],
    },
    "23-11": {
      Supplements: {
        "-L83GO-D4FZUDsgcRKwy": {
          body: "Not necessarily. Revelation 16:14 says that even the devils can work miracles. And Deuteronomy 13:1–3 warns us, “If there arises among you a prophet or a dreamer of dreams, and he gives you a sign or a wonder, and the sign or the wonder comes to pass, of which he spoke to you, saying, ‘Let us go after other gods’—which you have not known—‘and let us serve them,’ you shall not listen to the words of that prophet or that dreamer of dreams, for the Lord your God is testing you to know whether you love the Lord your God with all your heart and with all your soul”. So just because a person performs a genuine miracle, or makes a series of predictions that come to pass, that doesn’t make them a genuine prophet. They must pass all of the biblical tests to qualify. You can be sure that your faith in God’s word will be tested in this area, because God has said it would be.\n",
          title:
            "If someone performs a genuine miracle, isn’t that evidence that they are a true prophet?",
        },
      },
      blanks: [
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "false",
          textAfter:
            " prophets, who come to you in sheep’s clothing, but inwardly they are ravenous wolves . . . Therefore by their fruits you will know them.",
          textBefore: "Beware of",
        },
      ],
      choices: [
        "pass",
        "truly",
        "light",
        "law",
        "been",
        "false",
        "not",
        "word",
        "love",
      ],
      lessonID: 23,
      question: "What are the tests for the genuine gift of prophecy?",
      questionID: 11,
      questionIDTitle: "8",
      questionType: "wordCloud",
      subQuestion:
        "D. The life of someone with the genuine gift of prophecy will reveal the character of Jesus.",
      verses: [
        {
          body: "Beware of false prophets, who come to you in sheep’s clothing, but inwardly they are ravenous wolves.",
          ref: "Matthew 7:15",
        },
      ],
    },
    "23-12": {
      blanks: [
        {
          choices: [
            "medium",
            "spiritist",
            "dead",
            "liar",
            "thief",
            "demons",
            "wizard",
            "witch",
            "unholy",
          ],
          correctAnswer: "medium",
          textAfter: " , or a",
          textBefore:
            "There shall not be found among you anyone who makes his son or his daughter pass through the fire, or one who practices witchcraft, or a soothsayer, or one who interprets omens, or a sorcerer, or one who conjures spells, or a",
        },
        {
          choices: [
            "medium",
            "spiritist",
            "dead",
            "liar",
            "thief",
            "demons",
            "wizard",
            "witch",
            "unholy",
          ],
          correctAnswer: "spiritist",
          textAfter: " , or one who calls up the",
        },
        {
          choices: [
            "medium",
            "spiritist",
            "dead",
            "liar",
            "thief",
            "demons",
            "wizard",
            "witch",
            "unholy",
          ],
          correctAnswer: "dead",
          textAfter:
            " . For all who do these things are an abomination to the Lord, and because of these abominations the Lord your God drives them out from  before you.",
        },
      ],
      body: "In spite of their popularity, mediums and psychics do not possess the gift of prophecy, nor any other gift given of God. The practice of communicating with the dead has been specifically outlawed in Scripture. Because “the dead know nothing” (Ecclesiastes 9:5), it is certain that God does not speak through those who claim to communicate with the dead. [See It Is Written Bible Study Guide #10, “The Mystery of Death.”]",
      choices: [
        "medium",
        "spiritist",
        "dead",
        "liar",
        "thief",
        "demons",
        "wizard",
        "witch",
        "unholy",
      ],
      lessonID: 23,
      question: "Do mediums and fortune-tellers have a God-given gift?",
      questionID: 12,
      questionIDTitle: 9,
      questionType: "wordCloud",
      verses: [
        {
          body: "or one who conjures spells, or a medium, or a spiritist, or one who calls up the dead. 12 For all who do these things are an abomination to the Lord, and because of these abominations the Lord your God drives them out from before you.",
          ref: "Deuteronomy 18:11-12",
        },
      ],
    },
    "23-13": {
      blanks: [
        {
          choices: ["word", "trust", "prophet", "words", "Law", "vision"],
          correctAnswer: "Law",
          textAfter: " is no more, and her prophets find no",
          textBefore:
            "Her gates have sunk into the ground; He has destroyed and broken her bars. Her king and her princes are among the nations; the",
        },
        {
          choices: ["word", "trust", "prophet", "words", "Law", "vision"],
          correctAnswer: "vision",
          textAfter: " from the Lord.\n",
        },
      ],
      body: "\nWhen God’s people lived in rebellion and disregarded His law, He responded by withholding the gift of prophecy. The gifts of the Spirit are given to those who are earnestly seeking to live lives of surrender and obedience in harmony with God. When His people would not surrender their lives to Him and obey His law, the gift of prophecy was not given.",
      choices: ["word", "trust", "prophet", "words", "Law", "vision"],
      lessonID: 23,
      question:
        "Why is the gift of prophecy absent from the majority of churches today?",
      questionID: 13,
      questionIDTitle: 10,
      questionType: "wordCloud",
      verses: [
        {
          body: "Her gates have sunk into the ground;  He has destroyed and broken her bars. Her king and her princes are among the nations; The Law is no more, and her prophets find no vision from the Lord.",
          ref: "Lamentations 2:9",
        },
      ],
    },
    "23-14": {
      blanks: [
        {
          choices: [
            "church",
            "prophets",
            "temple",
            "pastors",
            "Bible",
            "healers",
          ],
          correctAnswer: "church",
          textAfter: " :  first apostles, second",
          textBefore: "God has appointed these in the",
        },
        {
          choices: [
            "church",
            "prophets",
            "temple",
            "pastors",
            "Bible",
            "healers",
          ],
          correctAnswer: "prophets",
          textAfter:
            " , third teachers,  after that miracles, then gifts of healings, helps, administrations, varieties of tongues.",
        },
      ],
      body: "The gift of prophecy is not found on television talk shows or in blogs. The genuine gift of prophecy is given to operate within the confines of and in harmony with the ministry of the church. As with all spiritual gifts, the gift of prophecy is given to be a blessing to all and to help people come closer to God, in preparation for the return of Jesus.",
      choices: ["church", "prophets", "temple", "pastors", "Bible", "healers"],
      lessonID: 23,
      question: "Where is the gift of prophecy to be found?",
      questionID: 14,
      questionIDTitle: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "And God has appointed these in the church: first apostles, second prophets, third teachers, after that miracles, then gifts of healings, helps, administrations, varieties of tongues.",
          ref: "1 Corinthians 12:28",
        },
      ],
    },
    "23-15": {
      blanks: [
        {
          choices: [
            "teachers",
            "word",
            "body",
            "prophets",
            "edifying",
            "body",
            "preachers",
            "sound",
            "word",
          ],
          correctAnswer: "prophets",
          textAfter:
            " , some evangelists, and some pastors and teachers, for the equipping of the saints for the work of ministry, for the",
          textBefore:
            "When He ascended on high, He led captivity captive, and gave gifts to men . . . And He Himself gave some to be apostles, some",
        },
        {
          choices: [
            "teachers",
            "word",
            "body",
            "prophets",
            "edifying",
            "body",
            "preachers",
            "sound",
            "word",
          ],
          correctAnswer: "edifying",
          textAfter: " of the",
        },
        {
          choices: [
            "teachers",
            "word",
            "body",
            "prophets",
            "edifying",
            "body",
            "preachers",
            "sound",
            "word",
          ],
          correctAnswer: "body",
          textAfter: " of Christ.",
        },
      ],
      body: "The gift of prophecy is not intended to take the place of the Word of God. Old Testament Israel possessed the gift of prophecy, as did the early Christian church. But this did not in any way minimize the importance of the Scriptures. The gifts of the Spirit were given by God to equip His people for ministry, and to prepare the church for the return of Jesus.",
      choices: [
        "teachers",
        "word",
        "body",
        "prophets",
        "edifying",
        "body",
        "preachers",
        "sound",
        "word",
      ],
      lessonID: 23,
      question:
        "Is the gift of prophecy intended to take the place of the Bible?",
      questionID: 15,
      questionIDTitle: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore He says: “When He ascended on high, He led captivity captive, And gave gifts to men. 9 (Now this, “He ascended”—what does it mean but that He also first descended into the lower parts of the earth? 10 He who descended is also the One who ascended far above all the heavens, that He might fill all things.) 11 And He Himself gave some to be apostles, some prophets, some evangelists, and some pastors and teachers, 12 for the equipping of the saints for the work of ministry, for the edifying of the body of Christ,",
          ref: "Ephesians 4:8, 11, 12",
        },
      ],
    },
    "23-16": {
      blanks: [
        {
          choices: ["know", "love", "keep", "testimony", "hear", "love"],
          correctAnswer: "keep",
          textAfter: " the commandments of God and have the",
          textBefore:
            "The dragon was enraged with the woman, and he went to make war with the rest of her offspring, who",
        },
        {
          choices: ["know", "love", "keep", "testimony", "hear", "love"],
          correctAnswer: "testimony",
          textAfter: " of Jesus Christ.\n",
        },
      ],
      body: "Revelation 19:10 says that “the testimony of Jesus is the spirit of prophecy.” God makes it clear that the gift of prophecy is an identifying mark of His last-day church. According to God Himself, the church at the end of time must possess the genuine gift of prophecy!\nAs it was explained in It Is Written Bible Study Guide #21, “In Search of the Church,” God’s end-time church will:\nA. Rise after AD 1798 (Revelation 12:6, 14).\nB. Believe the original teachings of the Christian church (Revelation 12:17).\nC. Be a global movement (Revelation 14:6). \nD. Proclaim the everlasting gospel (Revelation 14:6–12). \nE. Believe in all of God’s commandments, including the Sabbath (Revelation 12:17; 14:12).",
      choices: ["know", "love", "keep", "testimony", "hear", "love"],
      lessonID: 23,
      question:
        "Has God said the gift of prophecy will be found in the church of the last days?",
      questionID: 16,
      questionIDTitle: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "And the dragon was enraged with the woman, and he went to make war with the rest of her offspring, who keep the commandments of God and have the testimony of Jesus Christ",
          ref: "Revelation 12:17",
        },
      ],
    },
    "23-17": {
      lessonID: 23,
      question:
        "How did God place the gift of prophecy within His end-time church",
      questionID: 17,
      questionIDTitle: 14,
      questionType: "text",
      text: [
        "As God's end-time church began to emerge, God placed His hand on a young woman named Ellen Harmon (1827 - 1915) and blessed her with the gift of prophecy.",
        "God wanted to guide the growing church, and through the writings and instruction of Ellen Harmon - who married and became Ellen White - God was able to counsel and encourage this growing group of mission-minded believers.",
        "In spite of having a very basic formal education, this young woman went on to write millions of words, dozens of books, and provide invaluable guidance to a church that would experience rapid growth around the world.",
        "During her 70-year ministry, her writings on health, parenting, Christian living and the Bible provided guidance and strength for many people.  Since her death, her writings have continued to direct people to the Bible as the sole rule of faith and practice, and to Jesus as the Savior of the world.",
        "Her writings have been widely translated.  Steps to Christ - her masterpiece on having a saving relationship with Jesus - has been translated into more than 165 languages. ",
        "Tens of millions of copies of her books have been printed, and people around the world have been led into a closer relationship with Jesus as a result of the ministry of Ellen White.",
      ],
    },
    "23-18": {
      lessonID: 23,
      question:
        "How can a person become more familiar with the genuine gift of prophecy.",
      questionID: 18,
      questionIDTitle: 15,
      questionType: "text",
      text: [
        "The best way to become familiar with this special spiritual gift is to read what Ellen White has written.  Prayerful consideration of her writings has led many people to become convinced that God has used Ellen White to communicate light, blessing and truth to the world. [Two of her most well-known books, Steps to Christ and The Great Controversy, are available from the It Is Written Store at www.itiswirtten.com/store or by calling 1-888-664-5573.]",
      ],
    },
    "23-19": {
      blanks: [
        {
          choices: [
            "prophesy",
            "visions",
            "Spirit",
            "sing",
            "wonders",
            "love",
            "dance",
            "heaven",
            "blessing",
          ],
          correctAnswer: "prophesy",
          textAfter:
            " , your old men shall dream dreams, your young men shall see",
          textBefore:
            "I will pour out My Spirit on all flesh; your sons and your daughters shall",
        },
        {
          choices: [
            "prophesy",
            "visions",
            "Spirit",
            "sing",
            "wonders",
            "love",
            "dance",
            "heaven",
            "blessing",
          ],
          correctAnswer: "visions",
          textAfter:
            " . And also on My menservants and on My maidservants I will pour out My",
        },
        {
          choices: [
            "prophesy",
            "visions",
            "Spirit",
            "sing",
            "wonders",
            "love",
            "dance",
            "heaven",
            "blessing",
          ],
          correctAnswer: "Spirit",
          textAfter: " in those days.\n",
        },
      ],
      body: "Joel’s prophecy makes it appear that it is possible that God could raise up more individuals with the gift of prophecy. While only time can tell, it is important we remember Jesus’ warning regarding false prophets in earth’s final days (Matthew 24:24), as well as Paul’s counsel: “Do not despise prophecies. Test all things; hold fast what is good” (1 Thessalonians 5:20, 21).",
      choices: [
        "prophesy",
        "visions",
        "Spirit",
        "sing",
        "wonders",
        "love",
        "dance",
        "heaven",
        "blessing",
      ],
      lessonID: 23,
      question:
        "Is it likely that there will be more people with the gift of prophecy  before Jesus returns?",
      questionID: 19,
      questionIDTitle: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "And it shall come to pass afterward that I will pour out My Spirit on all flesh;  Your sons and your daughters shall prophesy, your old men shall dream dreams, your young men shall see visions. 29 And also on My menservants and on My maidservants I will pour out My Spirit in those days.",
          ref: "Joel 2:28, 29",
        },
      ],
    },
    "23-2": {
      blanks: [
        {
          choices: [
            "word",
            "people",
            "prophets",
            "prophets",
            "temple",
            "children",
          ],
          correctAnswer: "prophets",
          textAfter:
            " , and have multiplied visions; I have given symbols through the ",
          textBefore: "I have also spoken by the",
        },
        {
          choices: [
            "word",
            "people",
            "prophets",
            "witness",
            "temple",
            "children",
          ],
          correctAnswer: "witness",
          textAfter: " of the prophets.",
        },
      ],
      body: "\nProphets were used by God to communicate His will to humanity. Prophets were spokespeople for God—making known God’s will and sharing messages from heaven. In Exodus 7:1, Aaron is referred to as being Moses’ “prophet,” the one who spoke on Moses’ behalf. A prophet speaks on behalf of God.\n",
      choices: ["word", "people", "prophets", "witness", "temple", "children"],
      lessonID: 23,
      question: "How has God spoken to humanity down through time?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "I have also spoken by the prophets, and have multiplied visions; I have given symbols through the witness of the prophets.",
          ref: "Hosea 12:10",
        },
      ],
    },
    "23-20": {
      blanks: [
        {
          choices: ["every", "God", "my", "Jesus", "no", "Satan"],
          correctAnswer: "every",
          textAfter: " word that proceeds from the mouth of",
          textBefore:
            "It is written, “Man shall not live by bread alone, but by",
        },
        {
          choices: ["every", "God", "my", "Jesus", "no", "Satan"],
          correctAnswer: "God",
          textAfter: " .”",
        },
      ],
      body: "Doctrinal beliefs are derived from the Bible. People blessed with the gift of prophecy are used by God to direct people to the Bible, and not to themselves. While it is true that prophets have been used by God to clarify God’s Word, the prophets themselves were not used by God to originate beliefs that have no basis in the Bible.",
      choices: ["every", "God", "my", "Jesus", "no", "Satan"],
      lessonID: 23,
      question:
        "Are doctrinal beliefs derived from the Bible, the gift of prophecy, or both?",
      questionID: 20,
      questionIDTitle: 17,
      questionType: "wordCloud",
      verses: [
        {
          body: "But He answered and said, “It is written, ‘Man shall not live by bread alone, but by every word that proceeds from the mouth of God.’”",
          ref: "Matthew 4:4",
        },
      ],
    },
    "23-21": {
      correctAnswer: "true",
      lessonID: 23,
      question:
        "Are you willing to embrace the genuine gift of prophecy, and allow God to guide you in your understanding of this special end-time blessing?",
      questionID: 21,
      questionIDTitle: 17,
      questionType: "truthConfirmation",
    },
    "23-3": {
      blanks: [
        {
          choices: [
            "help",
            "people",
            "wonders",
            "sinners",
            "nothing",
            "prophets",
          ],
          correctAnswer: "nothing",
          textAfter: " , unless He reveals His secret to His servants the",
          textBefore: "Surely the Lord God does",
        },
        {
          choices: [
            "help",
            "people",
            "wonders",
            "sinners",
            "nothing",
            "prophets",
          ],
          correctAnswer: "prophets",
          textAfter: " .",
        },
      ],
      body: "When God intended to do great things in the world, He communicated that intention to prophets to make it known to the human family.\n■ God used Noah to warn the world of the coming flood (2 Peter 2:5). \n■ God spoke through Isaiah to announce that Jesus would be born of a\n virgin (Isaiah 7:14). \n■ Micah prophesied that Jesus would be born in Bethlehem (Micah 5:2).\n■ God used Jeremiah to prophesy of Israel’s 70-year Babylonian captivity (Jeremiah 25:11). \n■ Daniel prophesied that the Messiah would die (be “cut off ”) (Daniel 9:26).\n■ Jesus’ anguished words on the cross were made known by David (Psalm 22:1).\n■ God used John the Baptist to foretell the coming of the Messiah (John 1:23–27).\n■ God used Paul (and others) to announce that Jesus would come again (1 Thessalonians 4:16, 17).\n■ God has often used prophets to demonstrate that He knows the future (Daniel 2).\nAnd Isaiah 46:9, 10 says, “I am God, and there is no other; I am God, and there is none like Me, declaring the end from the beginning, and from ancient times things that are not yet done, saying, ‘My counsel shall stand, and I will do all my pleasure.’”\nBut not all prophecy is predictive. The gift of prophecy is also used by God to provide counsel, direction and an understanding of His will.",
      choices: ["help", "people", "wonders", "sinners", "nothing", "prophets"],
      lessonID: 23,
      question: "How important is the ministry of the prophets?",
      questionID: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "Surely the Lord God does nothing, unless He reveals His secret to His servants the prophets.",
          ref: "Amos 3:7",
        },
      ],
    },
    "23-4": {
      blanks: [
        {
          choices: [
            "prophesy",
            "visions",
            "Spirit",
            "see",
            "wonders",
            "blessing",
            "preach",
            "marvels",
            "knowledge",
          ],
          correctAnswer: "prophesy",
          textAfter:
            " , your old men shall dream dreams, your young men shall see",
          textBefore:
            "It shall come to pass  afterward that I will pour out My Spirit on all flesh; your sons and your daughters shall",
        },
        {
          choices: [
            "prophesy",
            "visions",
            "Spirit",
            "see",
            "wonders",
            "blessing",
            "preach",
            "marvels",
            "knowledge",
          ],
          correctAnswer: "visions",
          textAfter:
            " . And also on My menservants and on My maidservants I will pour out My",
        },
        {
          choices: [
            "prophesy",
            "visions",
            "Spirit",
            "see",
            "wonders",
            "blessing",
            "preach",
            "marvels",
            "knowledge",
          ],
          correctAnswer: "Spirit",
          textAfter: " in those days.",
        },
      ],
      body: "This prophecy was partially fulfilled at the feast of Pentecost in Acts 2. The Bible indicates that God will give the gift of the Holy Spirit in great power  before the return of Jesus. At this time, it can be expected that the gift of prophecy will be evident.",
      choices: [
        "prophesy",
        "visions",
        "Spirit",
        "see",
        "wonders",
        "blessing",
        "preach",
        "marvels",
        "knowledge",
      ],
      lessonID: 23,
      question:
        "Can we expect the gift of prophecy to be present in planet Earth’s final days?",
      questionID: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: "And it shall come to pass afterward that I will pour out My Spirit on all flesh;  Your sons and your daughters shall prophesy, your old men shall dream dreams, your young men shall see visions. 29 And also on My menservants and on My maidservants I will pour out My Spirit in those days.",
          ref: "Joel 2:28, 29",
        },
      ],
    },
    "23-5": {
      blanks: [
        {
          choices: ["fashion", "code", "story", "book", "vision", "dream"],
          correctAnswer: "vision",
          textAfter: " ; I speak to him in a",
          textBefore:
            "If there is a prophet among you, I, the Lord, make Myself known to him in a",
        },
        {
          choices: ["fashion", "code", "story", "book", "vision", "dream"],
          correctAnswer: "dream",
          textAfter: " .",
        },
      ],
      choices: ["fashion", "code", "story", "book", "vision", "dream"],
      lessonID: 23,
      question: "How does God reveal His will to prophets?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "Then He said, “Hear now My words: If there is a prophet among you, I, the Lord, make Myself known to him in a vision; I speak to him in a dream.",
          ref: "Numbers 12:6",
        },
      ],
    },
    "23-6": {
      blanks: [
        {
          choices: ["Holy Spirit", "Lords presence", "booming voice"],
          correctAnswer: "Holy",
          textAfter: " ",
          textBefore:
            "Prophecy never came by the will of man, but holy men of God spoke as they were moved by the",
        },
        {
          choices: ["Holy Spirit", "Lords presence", "booming voice"],
          correctAnswer: "Spirit",
          textAfter: " .",
        },
      ],
      body: "The gift of prophecy is one of the gifts of the Holy Spirit (1 Corinthians 12:7–11). At no time did God ever suggest that the gifts of the Holy Spirit were only for a certain period of time. As long as the Holy Spirit is at work in the world, we can expect to see spiritual gifts at work for the glory of God.",
      choices: ["Holy", "Voice", "Spirit"],
      lessonID: 23,
      question: "Whose influence enabled prophets to speak on behalf of God",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "for prophecy never came by the will of man, but holy men of God spoke as they were moved by the Holy Spirit.",
          ref: "2 Peter 1:21",
        },
      ],
    },
    "23-7": {
      blanks: [
        {
          choices: [
            "honor",
            "live",
            "them",
            "true",
            "believe",
            "prosper",
            "prophecies",
            "good",
          ],
          correctAnswer: "believe",
          textAfter: " His prophets, and you shall",
          textBefore:
            "Believe in the Lord your God, and you shall be established;",
        },
        {
          choices: [
            "honor",
            "live",
            "them",
            "true",
            "believe",
            "prosper",
            "prophecies",
            "good",
          ],
          correctAnswer: "prosper",
          newline: [1],
          textAfter: " .",
        },
        {
          choices: [
            "honor",
            "live",
            "them",
            "true",
            "believe",
            "prosper",
            "prophecies",
            "good",
          ],
          correctAnswer: "prophecies",
          textAfter: " . Test all things; hold fast what is",
          textBefore: " Do not despise",
        },
        {
          choices: [
            "honor",
            "live",
            "them",
            "true",
            "believe",
            "prosper",
            "prophecies",
            "good",
          ],
          correctAnswer: "good",
          textAfter: " .",
        },
      ],
      body: "At no time did God ever declare that He would no longer speak through prophets or give the gift of prophecy. God has promised blessings to those who believe in the words of the prophets, and urges us to discern between the genuine gift of prophecy and that which is false.\n",
      choices: [
        "honor",
        "live",
        "them",
        "true",
        "believe",
        "prosper",
        "prophecies",
        "good",
      ],
      lessonID: 23,
      question:
        "Has God encouraged believers in Jesus to accept the genuine gift of prophecy?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "So they rose early in the morning and went out into the Wilderness of Tekoa; and as they went out, Jehoshaphat stood and said, “Hear me, O Judah and you inhabitants of Jerusalem: Believe in the Lord your God, and you shall be established; believe His prophets, and you shall prosper.",
          ref: "2 Chronicles 20:20",
        },
        {
          body: "Do not despise prophecies.",
          ref: "1 Thessalonians 5:20, 21",
        },
      ],
    },
    "23-8": {
      blanks: [
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "pass",
          textAfter: " , the prophet will be known as one whom the Lord has",
          textBefore:
            "As for the prophet who prophesies of peace, when the word of the prophet comes to",
        },
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "truly",
          textAfter: " sent.",
        },
      ],
      choices: [
        "pass",
        "truly",
        "light",
        "law",
        "been",
        "other",
        "not",
        "word",
        "love",
      ],
      lessonID: 23,
      question: "What are the tests for the genuine gift of prophecy?",
      questionID: 8,
      questionIDTitle: "8",
      questionType: "wordCloud",
      subQuestion: "A. The prophet's predictions must come to pass.",
      verses: [
        {
          body: "As for the prophet who prophesies of peace, when the word of the prophet comes to pass, the prophet will be known as one whom the Lord has truly sent.",
          ref: "Jeremiah 28:9",
        },
      ],
    },
    "23-9": {
      blanks: [
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "other",
          textAfter:
            " gods”—which you have not known—“and let us serve them,” you shall",
          textBefore:
            "If there arises among you a prophet or a dreamer of dreams, and he gives you a sign or a wonder, and the sign or the wonder comes to pass, of which he spoke to you, saying, “Let us go after ",
        },
        {
          choices: [
            "pass",
            "truly",
            "other",
            "not",
            "law",
            "testimony",
            "light",
            "false",
            "light",
            "been",
            "other",
            "not",
            "word",
            "light",
            "love",
            "false",
          ],
          correctAnswer: "not",
          textAfter:
            " listen to the words of that prophet or that dreamer of dreams.",
        },
      ],
      choices: [
        "pass",
        "truly",
        "light",
        "law",
        "been",
        "other",
        "not",
        "word",
        "love",
      ],
      lessonID: 23,
      question: "What are the tests for the genuine gift of prophecy?",
      questionID: 9,
      questionIDTitle: "8",
      questionType: "wordCloud",
      subQuestion:
        "B. Someone possessing the genuine gift of prophecy will not speak contrary to the Word of God - even if what he predicts comes to pass.",
      verses: [
        {
          body: "If there arises among you a prophet or a dreamer of dreams, and he gives you a sign or a wonder, 2 and the sign or the wonder comes to pass, of which he spoke to you, saying, ‘Let us go after other gods’—which you have not known—‘and let us serve them,’ 3 you shall not listen to the words of that prophet or that dreamer of dreams, for the Lord your God is testing you to know whether you love the Lord your God with all your heart and with all your soul.",
          ref: "Deuteronomy 13:1-3",
        },
      ],
    },
  },
  {
    "24-0": {
      body: "Carlo’s new business venture looked like a great success. Investors were pouring millions of dollars into his company, and the return on investment was so good that some people mortgaged their homes and invested their life savings with Carlo. He was making $250,000 a day—in 1920! But it was soon discovered that Carlo’s company wasn’t generating any profits at all. Carlo had been using the money of new investors to provide dividends to longer-term investors. When a greater number of his clients began demanding their money, Carlo (Charles) Ponzi’s scheme was revealed to be a massive fraud—and many people lost everything they had. Ponzi’s get-rich-quick scheme wasn’t the first ever devised, and it certainly won’t be the last. While the Bible doesn’t suggest that God wants His people to be involved in get-rich-quick schemes, it does clearly state that God intends for His people to be financially secure. In fact, the Bible says that God wants us to have more than enough!",
      lessonID: 24,
      questionID: 0,
      type: "text",
    },
    "24-1": {
      blanks: [
        {
          choices: [
            "temple",
            "the",
            "chickens",
            "universe",
            "all",
            "animals",
            "earth",
            "every",
            "cattle",
          ],
          correctAnswer: "earth",
          newline: [1],
          textAfter:
            " is the Lord’s, and all its fullness, the world and those who dwell therein. ",
          textBefore: "The",
        },
        {
          choices: [
            "temple",
            "the",
            "chickens",
            "universe",
            "all",
            "animals",
            "earth",
            "every",
            "cattle",
          ],
          correctAnswer: "every",
          testBefore: "For",
          textAfter: " beast of the forest is Mine, and the",
        },
        {
          choices: [
            "temple",
            "the",
            "chickens",
            "universe",
            "all",
            "animals",
            "earth",
            "every",
            "cattle",
          ],
          correctAnswer: "cattle",
          textAfter:
            " on a thousand hills. I know all the birds of the mountains, and the wild beasts of the field are Mine. If I were hungry, I would not tell you; for the world is Mine, and all its fullness.",
        },
      ],
      body: "\nThe Bible begins by saying, “In the beginning God created the heavens and the earth” (Genesis 1:1). God created the universe out of nothing “by the breath of His mouth” (Psalm 33:6). Therefore, everything in the world is God’s property. Human beings—to whom God has entrusted wealth—are simply managers of God’s goods. We are stewards given the task of managing God’s property. All we have is His. Jesus explained this in a parable when He said, “For the kingdom of heaven is like a man traveling to a far country, who called his own servants and delivered his goods to them” (Matthew 25:14).",
      choices: [
        "temple",
        "the",
        "chickens",
        "universe",
        "all",
        "animals",
        "earth",
        "every",
        "cattle",
      ],
      lessonID: 24,
      question:
        "When it comes to our possessions, to whom do they really belong?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "The earth is the Lord’s, and all its fullness, the world and those who dwell therein.",
          ref: "Psalm 24:1",
        },
        {
          body: "For every beast of the forest is Mine, And the cattle on a thousand hills. 11 I know all the birds of the mountains, And the wild beasts of the field are Mine.  12 “If I were hungry, I would not tell you; For the world is Mine, and all its fullness.",
          ref: "Psalm 50:10-12",
        },
      ],
    },
    "24-10": {
      blanks: [
        {
          choices: ["holy", "worthy", "good", "pleasing"],
          correctAnswer: "holy",
          textAfter: " to the Lord.",
          textBefore:
            "All the tithe of the land, whether of the seed of the land or of the fruit of the tree, is the Lord’s. It is",
        },
      ],
      body: "The tithe has been designated by God to be used for the work of ministry. It is holy. Therefore, we are not to decide for ourselves to use it in another way that we might think suitable. The tithe is not to be used for charitable giving purposes. God has specifically claimed it as His own.",
      choices: ["holy", "worthy", "good", "pleasing"],
      correctAnswer: "false",
      lessonID: 24,
      question: "Can I choose what I want my tithe to be used for?",
      questionID: 10,
      questionType: "trueOrFalse",
      trueFalseQuestion: "I can choose what I want my tithe to be used for.",
      verses: [
        {
          body: "And all the tithe of the land, whether of the seed of the land or of the fruit of the tree, is the Lord’s. It is holy to the Lord.",
          ref: "Leviticus 27:30",
        },
      ],
    },
    "24-11": {
      blanks: [
        {
          choices: ["donations", "sacrifices", "givings", "offerings"],
          correctAnswer: "offerings",
          textAfter: " .",
          textBefore:
            "Will a man rob God? Yet you have robbed me! But you say, “In what way have we robbed you?” In tithes and",
        },
      ],
      body: "\nIn addition to the tithe—which is holy and is intended solely for the support of the work of ministry—God’s people were able to bring to Him free-will offerings. These offerings were voluntary, and were left to the discretion of the giver. In the same way, after our first 10 percent has been returned to God as tithe, we are free to give God additional offerings. Additional offerings beyond the tithe may be directed to a variety of causes, at the discretion of the giver.",
      choices: ["donations", "sacrifices", "givings", "offerings"],
      lessonID: 24,
      question:
        "So how should a person support worthy causes if not by using the tithe?",
      questionID: 11,
      questionType: "radio",
      verses: [
        {
          body: "Will a man rob God? Yet you have robbed Me!  But you say, ‘In what way have we robbed You?’ In tithes and offerings.",
          ref: "Malachi 3:8",
        },
      ],
    },
    "24-12": {
      blanks: [
        {
          choices: [
            "rob",
            "robbed",
            "robbed",
            "choose",
            "chosen",
            "chosen",
            "love",
            "loved",
            "loved",
          ],
          correctAnswer: "rob",
          textAfter: " God? Yet you have",
          textBefore: "Will a man",
        },
        {
          choices: [
            "rob",
            "robbed",
            "robbed",
            "choose",
            "chosen",
            "chosen",
            "love",
            "loved",
            "loved",
          ],
          correctAnswer: "robbed",
          textAfter:
            " Me! But you say, “In what way have we robbed You?” In tithes and offerings. You are cursed with a curse, for you have robbed",
        },
        {
          choices: [
            "rob",
            "robbed",
            "robbed",
            "choose",
            "chosen",
            "chosen",
            "love",
            "loved",
            "loved",
          ],
          correctAnswer: "Me",
          textAfter: " , even this whole nation.",
        },
      ],
      body: "To neglect to tithe is to commit robbery! He leaves us in no doubt as to the seriousness of refusing to tithe. In Exodus 20:15, God says, “You shall not steal.” Neglecting to tithe is stealing from God. The tithe belongs to Him.",
      choices: [
        "rob",
        "robbed",
        "robbed",
        "choose",
        "chosen",
        "chosen",
        "love",
        "loved",
        "loved",
        "Me",
      ],
      lessonID: 24,
      question:
        "How important is it that a person faithfully returns tithes to God?",
      questionID: 12,
      questionType: "wordCloud",
      verses: [
        {
          body: "Will a man rob God? Yet you have robbed Me!   But you say, ‘In what way have we robbed You? ’In tithes and offerings.  9 You are cursed with a curse, for you have robbed Me, even this whole nation.",
          ref: "Malachi 3:8, 9",
        },
      ],
    },
    "24-13": {
      blanks: [
        {
          choices: [
            "times, the comprehension;",
            "blessing, room, enough",
            "food; hungry enough",
          ],
          correctAnswer: "blessing",
          textAfter: " that there will not be",
          textBefore:
            "“Bring all the tithes into the storehouse, that there may be food in my house, and try me now in this,” says the Lord of hosts, “if I will not open for you the windows of heaven and pour out for you such",
        },
        {
          choices: [
            "times, the comprehension;",
            "blessing, room, enough",
            "food; hungry enough",
          ],
          correctAnswer: "room",
          textAfter: " ",
        },
        {
          choices: [
            "times, the comprehension;",
            "blessing, room, enough",
            "food; hungry enough",
          ],
          correctAnswer: "enough",
          textAfter:
            " to receive it. And I will rebuke the devourer for your sakes, so that he will not destroy the fruit of your ground, nor shall the vine fail to bear fruit for you in the field,” says the Lord of hosts; “and all nations will call you blessed, for you will be a delightful land.”",
        },
      ],
      body: "God promises to prosper those who faithfully tithe, stating that those who tithe out of a heart of love for God will receive so much blessing that they will not have enough room to receive it!",
      choices: ["enough", "blessing", "room", "curse", "space"],
      lessonID: 24,
      question:
        "What blessing is promised to those who faithfully return the tithe to God?",
      questionID: 13,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I will rebuke the devourer for your sakes, so that he will not destroy the fruit of your ground, nor shall the vine fail to bear fruit for you in the field, says the Lord of hosts; 12 'And all nations will call you blessed, for you will be a delightful land', Says the Lord of hosts.",
          ref: "Malachi 3:11-12",
        },
      ],
    },
    "24-14": {
      blanks: [
        {
          choices: [
            "know",
            "diverge",
            "word",
            "do",
            "don't",
            "sin",
            "keep",
            "obeyed",
            "heart",
          ],
          correctAnswer: "keep",
          textAfter:
            " My commandments. God be thanked that though you were slaves of sin, yet you",
          textBefore: "If you love Me,",
        },
        {
          choices: [
            "know",
            "diverge",
            "word",
            "do",
            "don't",
            "sin",
            "keep",
            "obeyed",
            "heart",
          ],
          correctAnswer: "obeyed",
          textAfter: " from the",
        },
        {
          choices: [
            "know",
            "diverge",
            "word",
            "do",
            "don't",
            "sin",
            "keep",
            "obeyed",
            "heart",
          ],
          correctAnswer: "heart",
          textAfter: " that form of doctrine to which you were delivered.\n",
        },
      ],
      body: "While tithing is not one of the Ten Commandments, it is clearly something God wills for us. Obedience to God is not a matter of righteousness by works, but is a form of righteousness by faith. God has always called His people to live lives of obedience. When His will is obeyed from the heart, such demonstrations of faith are evidence that love for God reigns supreme in the life of the believer.",
      choices: [
        "know",
        "diverge",
        "word",
        "do",
        "don't",
        "sin",
        "keep",
        "obeyed",
        "heart",
      ],
      lessonID: 24,
      question:
        "How can a person be sure tithing is the right thing to do? Could this not be seen as a form of righteousness by works?",
      questionID: 14,
      questionType: "wordCloud",
      verses: [
        {
          body: "But God be thanked that though you were slaves of sin, yet you obeyed from the heart that form of doctrine to which you were delivered.",
          ref: "Romans 6:17",
        },
        {
          body: "If you love Me, keep My commandments",
          ref: "John 14:15",
        },
      ],
    },
    "24-15": {
      blanks: [
        {
          choices: ["kindness", "blessings", "wealth", "love"],
          correctAnswer: "blessings",
          textAfter: " that there will not be room enough to receive it.”",
          textBefore:
            "“Try me now in this,” says the Lord of hosts, “if I will not open for you the windows of heaven and pour out for you such",
        },
      ],
      body: "“Blessing” comes in many ways. While God can certainly choose to prosper the business of His faithful children, or cause an unexpected windfall to come into a person’s life, He might instead choose to grant the blessing of good health, or savings on purchases, or the blessing of peace of mind. The greatest blessing God can choose to offer is that of His presence. And while He has promised to pour out great blessings into the lives of those who tithe, it is presumptuous to believe that tithing is the doorway to financial prosperity. While God has promised that His people will be secure, He has not guaranteed material riches.",
      choices: ["kindness", "blessings", "wealth", "love"],
      lessonID: 24,
      question:
        "If a person tithes, can that person expect to prosper financially?",
      questionID: 15,
      questionType: "radio",
      verses: [
        {
          body: "Bring all the tithes into the storehouse, that there may be food in My house, and try Me now in this,”Says the Lord of hosts, “If I will not open for you the windows of heaven and pour out for you such blessing that there will not be room enough to receive it.",
          ref: "Malachi 3:10",
        },
      ],
    },
    "24-16": {
      blanks: [
        {
          choices: ["all", "added", "then", "given", "when", "known"],
          correctAnswer: "all",
          textAfter: " these things shall be",
          textBefore:
            "Seek first the kingdom of God and His righteousness, and",
        },
        {
          choices: ["all", "added", "then", "given", "when", "known"],
          correctAnswer: "added",
          textAfter: " to you.",
        },
      ],
      body: "Any person seeking to honor God should make it his or her first priority to seek God’s ways and allow Jesus to work out His will in his or her life. It is faith that takes God at His word and permits the will of God to be done.\nGod encourages us to seek His will, and then trust that the blessings He has promised will be graciously granted.",
      choices: ["all", "added", "then", "given", "when", "known"],
      lessonID: 24,
      question:
        "How should a person who has not tithed begin to incorporate tithing into their life?",
      questionID: 16,
      questionType: "wordCloud",
      verses: [
        {
          body: "But seek first the kingdom of God and His righteousness, and all these things shall be added to you.",
          ref: "Matthew 6:33",
        },
      ],
    },
    "24-17": {
      correctAnswer: "true",
      lessonID: 24,
      question:
        "Are you willing to trust God, and in faith return 10 percent to Him?",
      questionID: 17,
      questionType: "truthConfirmation",
    },
    "24-2": {
      blanks: [
        {
          choices: ["silver", "gold", "earth", "wealth", "food", "water"],
          correctAnswer: "silver",
          textAfter: " is Mine, and the",
          textBefore: "“The",
        },
        {
          choices: ["silver", "gold", "earth", "wealth", "food", "water"],
          correctAnswer: "gold",
          textAfter: " is Mine,” says the Lord of hosts.",
        },
      ],
      body: "The God of heaven is the rightful owner of all the world’s wealth. A person may have money in the bank or investments in precious metals, but the true owner of everything is God.",
      choices: ["silver", "gold", "earth", "wealth", "food", "water"],
      lessonID: 24,
      question: "What has God specifically said about the world’s wealth?",
      questionID: 2,
      questionType: "wordCloud",
      verses: [
        {
          body: "‘The silver is Mine, and the gold is Mine,’ says the Lord of hosts.",
          ref: "Haggai 2:8",
        },
      ],
    },
    "24-3": {
      blanks: [
        {
          choices: ["wealth", "well", "power", "blessed"],
          correctAnswer: "wealth",
          textAfter: " .",
          textBefore:
            "You shall remember the Lord your God, for it is He who gives you power to get",
        },
      ],
      body: "\nThe Bible makes it clear that God is the source of all blessing. James 1:17 says, “Every good gift and every perfect gift is from above, and comes down from the Father of lights, with whom there is no variation or shadow of turning.” When it comes to financial matters, it is the blessing of God that enables us to obtain what we have. Our financial blessings come from God.",
      choices: ["wealth", "well", "power", "blessed"],
      lessonID: 24,
      question: "Where do all our financial blessings come from?",
      questionID: 3,
      questionType: "radio",
      verses: [
        {
          body: "“And you shall remember the Lord your God, for it is He who gives you power to get wealth, that He may establish His covenant which He swore to your fathers, as it is this day.",
          ref: "Deuteronomy 8:18",
        },
      ],
    },
    "24-4": {
      blanks: [
        {
          choices: ["harvest", "crop", "tithe", "yield"],
          correctAnswer: "tithe",
          textAfter:
            " of the land, whether of the seed of the land or of the fruit of the tree, is the Lord’s. It is holy to the Lord.",
          textBefore: "All the",
        },
      ],
      body: "The word “tithe” means “a tenth.” God claims one-tenth of our income as His. It is to be returned to Him as a demonstration of faith in God and as an expression of love for Him.\n",
      choices: ["harvest", "crop", "tithe", "yield"],
      correctAnswer: "false",
      lessonID: 24,
      question:
        "How much of a person’s income has God asked to be returned to Him?",
      questionID: 4,
      questionType: "trueOrFalse",
      trueFalseQuestion: "God has asked us to return 7% tithes to him.",
      verses: [
        {
          body: "And all the tithe of the land, whether of the seed of the land or of the fruit of the tree, is the Lord’s. It is holy to the Lord.",
          ref: "Leviticus 27:30",
        },
      ],
    },
    "24-5": {
      blanks: [
        {
          choices: [
            "inheritance",
            "tabernacle",
            "temple",
            "use",
            "slaves",
            "purpose",
          ],
          correctAnswer: "inheritance",
          textAfter:
            " in return for the work which they perform, the work of the",
          textBefore:
            "I have given the children of Levi all the tithes in Israel as an",
        },
        {
          choices: [
            "inheritance",
            "tabernacle",
            "temple",
            "use",
            "slaves",
            "purpose",
          ],
          correctAnswer: "tabernacle",
          textAfter: " of meeting.",
        },
      ],
      body: "When God divided the Promised Land among the tribes of Israel, He did not give the tribe of Levi a large tract of real estate, as He gave the other tribes. Along with certain cities that God gave Levi, He designated that the Levites be supported by the tithe. This was to be their income, in return for the ministry they performed in the sanctuary.\n",
      choices: [
        "inheritance",
        "tabernacle",
        "temple",
        "use",
        "slaves",
        "purpose",
      ],
      lessonID: 24,
      question: "What was the purpose of the tithing system?",
      questionID: 5,
      questionType: "wordCloud",
      verses: [
        {
          body: "Behold, I have given the children of Levi all the tithes in Israel as an inheritance in return for the work which they perform, the work of the tabernacle of meeting.",
          ref: "Numbers 18:21",
        },
      ],
    },
    "24-6": {
      blanks: [
        {
          choices: ["evil", "come", "favorite", "be", "material", "live"],
          correctAnswer: "material",
          textAfter:
            " things? . . . Do you not know that those who minister the holy things eat of the things of the temple, and those who serve at the altar partake of the offerings of the altar? Even so the Lord has commanded that those who preach the gospel should",
          textBefore:
            "If we have sown spiritual things for you, is it a great thing if we reap your",
        },
        {
          choices: ["evil", "come", "favorite", "be", "material", "live"],
          correctAnswer: "live",
          textAfter: " from the gospel.",
        },
      ],
      body: "\nJust as God intended for ministers in Old Testament times to be supported by the tithing system, He intends for ministers today to be supported in the same way. Paul was very specific in his commentary about the tithing system, making it clear that tithing is still God’s means of supporting the preaching of the gospel. God intends for all His people to return the tithe to Him, so that the good news of the gospel can be proclaimed throughout the world. In this way, all God’s children can participate equally and share in the blessing of taking the gospel to the world!",
      choices: ["evil", "come", "favorite", "be", "material", "live"],
      lessonID: 24,
      question:
        "Does God intend for ministers today to be supported by the tithe?",
      questionID: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "11 If we have sown spiritual things for you, is it a great thing if we reap your material things? 12 If others are partakers of this right over you, are we not even more?  Nevertheless we have not used this right, but endure all things lest we hinder the gospel of Christ. 13 Do you not know that those who minister the holy things eat of the things of the temple, and those who serve at the altar partake of the offerings of the altar? 14 Even so the Lord has commanded that those who preach the gospel should live from the gospel.",
          ref: "1 Corinthians 9:11-14",
        },
      ],
    },
    "24-7": {
      blanks: [
        {
          choices: ["have", "behind", "ought", "undone", "should", "miserable"],
          correctAnswer: "ought",
          textAfter: " to have done, without leaving the others",
          textBefore:
            "Woe to you, scribes and Pharisees, hypocrites! For you pay tithe of mint and anise and cummin, and have neglected the weightier matters of the law: justice and mercy and faith. These you",
        },
        {
          choices: ["have", "behind", "ought", "undone", "should", "miserable"],
          correctAnswer: "undone",
          textAfter: " .",
        },
      ],
      body: "Jesus was unimpressed with people who observed certain religious principles while failing to experience the heart change offered through the work of the Holy Spirit. While he rebuked the spirit that failed to demonstrate Christian grace, He commended the practice of returning tithe. While the Pharisees were wrong in failing to show justice, mercy and faith, they were right to tithe.",
      choices: ["have", "behind", "ought", "undone", "should", "miserable"],
      lessonID: 24,
      question: "Did Jesus comment on the system of tithing?",
      questionID: 7,
      questionType: "wordCloud",
      verses: [
        {
          body: "Woe to you, scribes and Pharisees, hypocrites! For you pay tithe of mint and anise and cummin, and have neglected the weightier matters of the law: justice and mercy and faith. These you ought to have done, without leaving the others undone.",
          ref: "Matthew 23:23",
        },
      ],
    },
    "24-8": {
      blanks: [
        {
          choices: ["portion", "part", "tithe", "place"],
          correctAnswer: "tithe",
          textAfter: " of all.",
          textBefore:
            "Melchizedek king of Salem brought out bread and wine; he was the priest of God Most High. And he blessed him and said: “Blessed be Abram of God Most High, Possessor of heaven and earth; and blessed be God Most High, who has delivered your enemies into your hand.” And he gave him a",
        },
      ],
      body: "\nTithing was practiced  before the nation of Israel existed. Clearly, tithing is not an ordinance reserved only for Jews. God grants people of all ages the privilege of practicing faithful stewardship, and honoring Him with their possessions. In Genesis 28:22, Jacob also pledges to honor God with a tithe of his wealth. The Bible refers to Jesus’ ministry as our High Priest as being “according to the order of Melchizedek” (Hebrews 6:20). As Melchizedek’s ministry was supported by the tithing system, it is appropriate that the priesthood during Jesus’ ministry would also be supported by the tithe.",
      choices: ["portion", "part", "tithe", "place"],
      lessonID: 24,
      question: "Where in the Bible is the first example of tithing found?",
      questionID: 8,
      questionType: "radio",
      verses: [
        {
          body: "And he blessed him and said: “Blessed be Abram of God Most High, possessor of heaven and earth; 20 And blessed be God Most High, who has delivered your enemies into your hand.” And he gave him a tithe of all.",
          ref: "Genesis 14:19-20",
        },
      ],
    },
    "24-9": {
      blanks: [
        {
          choices: ["warehouse", "storehouse", "house", "gates"],
          correctAnswer: "storehouse",
          textAfter: " , that there may be food in My house.\n",
          textBefore: "Bring all the tithes into the",
        },
      ],
      body: "\nThe “storehouse” was administered by the priests, and was closely connected with the temple (or sanctuary) ministry. Nehemiah 10:38 says, “And the priest, the descendant of Aaron, shall be with the Levites when the Levites receive tithes; and the Levites shall bring up a tenth of the tithes to the house of our God, to the rooms of the storehouse.” When God stated that the tithe should be brought into the storehouse—which today we would recognize as the church— God’s clear intention was that the tithe would be used specifically for the work of ministry.",
      choices: ["warehouse", "storehouse", "house", "gates"],
      lessonID: 24,
      question: "For what purpose should the tithe be used?",
      questionID: 9,
      questionType: "radio",
      verses: [
        {
          body: "Bring all the tithes into the storehouse, that there may be food in My house, and try Me now in this,” says the Lord of hosts,“If I will not open for you the windows of heaven and pour out for you such blessing that there will not be room enough to receive it.",
          ref: "Malachi 3:10",
        },
      ],
    },
  },
  {
    "25-0": {
      body: "As he prepared to use a power tool to complete an important project, the man was surprised to find that the tool would not work. He checked the on/off  switch, but still it failed to operate. Wondering if the tool needed to be fixed, he noticed the cause of the problem: it wasn’t plugged into the power supply! Once it was plugged in, it worked perfectly and the job was soon finished. For something to work properly and reliably, it needs to be connected to a power source. The same is true for believers in Jesus. For a believer to have a successful Christian experience, that individual must be connected to a source of spiritual power. And the source of spiritual power for believers everywhere is the Holy Spirit!",
      lessonID: 25,
      questionID: 0,
      type: "text",
    },
    "25-1": {
      blanks: [
        {
          choices: ["Lord", "chosen", "Holy"],
          correctAnswer: "Holy",
          textAfter: " ",
          textBefore:
            "The grace of the Lord Jesus Christ, and the love of God, and the communion of the",
        },
        {
          choices: ["God", "one", "Spirit"],
          correctAnswer: "Spirit",
          textAfter: " be with you all.",
        },
      ],
      body: "The Holy Spirit is the third Person of the Godhead—which is also referred to as the Trinity (Romans 1:20; Colossians 2:9). The Bible teaches that there is one God, made up of three distinct Persons: the Father, the Son and the Holy Spirit. Each of these divine entities is a Person, and these three Persons are united as one God. The Father is not the Son; the Son is not the Holy Spirit; the Spirit is not the Father. But each of the three is in perfect harmony, each is eternal and each is powerful.",
      choices: ["Lord", "chosen", "Holy", "Man", "Spirit"],
      lessonID: 25,
      question: "Who is the Holy Spirit?",
      questionID: 1,
      questionType: "wordCloud",
      verses: [
        {
          body: "The grace of the Lord Jesus Christ, and the love of God, and the communion of the Holy Spirit be with you all. Amen.",
          ref: "2 Corinthians 13:14",
        },
      ],
    },
    "25-10": {
      blanks: [
        {
          choices: ["actions", "point", "works", "fruit"],
          correctAnswer: "fruit",
          textAfter:
            " of the Spirit is love, joy, peace, long suffering, kindness, goodness, faithfulness, gentleness, self-control.",
          textBefore: "The",
        },
      ],
      body: "When the Holy Spirit comes into a person’s life, that person experiences spiritual growth that will enable him or her to become more like Jesus. The “works of the flesh” (Galatians 5:19–21) disappear and are replaced by the “fruit of the Spirit”—the attributes of Jesus that become a part of the life of the believer. Paul wrote, “Walk in the Spirit, and you shall not fulfill the lust of the flesh” (Galatians 5:16).",
      choices: ["actions", "point", "works", "fruit"],
      lessonID: 25,
      question:
        "What happens in the life of a person who has been filled with the Holy Spirit?",
      questionID: 10,
      questionIDTitle: 7,
      questionType: "radio",
      verses: [
        {
          body: "But the fruit of the Spirit is love, joy, peace, longsuffering, kindness, goodness, faithfulness, 23 gentleness, self-control. Against such there is no law.",
          ref: "Galatians 5:22, 23",
        },
      ],
    },
    "25-11": {
      blanks: [
        {
          choices: ["given", "Spirit", "known", "Father", "not", "Devil"],
          correctAnswer: "given",
          textAfter: " the word of wisdom through the",
          textBefore: "To one is",
        },
        {
          choices: ["given", "Spirit", "known", "Father", "not", "Devil"],
          correctAnswer: "Spirit",
          textAfter:
            " , to another the word of knowledge through the same Spirit, to another faith by the same Spirit, to another gifts of healings by the same Spirit, to another the working of miracles, to another prophecy, to another discerning of spirits, to another different kinds of tongues, to another the interpretation of tongues.",
        },
      ],
      body: "Spiritual gifts are special endowments that produce in a believer capabilities that can be used for the upbuilding of the church and the fulfilling of its mission. They can be miraculous endowments, or the Holy Spirit can use and develop talents and capabilities already present in a person’s life. Other lists of spiritual gifts can be found in Romans 12:6–8 and Ephesians 4:11–13.",
      choices: ["given", "Spirit", "known", "Father", "not", "Devil"],
      lessonID: 25,
      question: "What are the gifts of the Holy Spirit?",
      questionID: 11,
      questionIDTitle: 8,
      questionType: "wordCloud",
      verses: [
        {
          body: "for to one is given the word of wisdom through the Spirit, to another the word of knowledge through the same Spirit, 9 to another faith by the same Spirit, to another gifts of healings by the same Spirit, 10 to another the working of miracles, to another prophecy, to another discerning of spirits, to another different kinds of tongues, to another the interpretation of tongues.",
          ref: "1 Corinthians 12:8-10",
        },
      ],
    },
    "25-12": {
      blanks: [
        {
          choices: ["It", "He", "one", "they"],
          correctAnswer: "He",
          textAfter: " wills.\n",
          textBefore:
            "One and the same Spirit works all these things, distributing to each one individually as",
        },
      ],
      body: "\nWhile a person may desire to receive a certain spiritual gift, it is the Holy Spirit who decides which spiritual gifts are to be given.",
      choices: ["It", "He", "one", "they"],
      lessonID: 25,
      question: "Who decides which spiritual gifts a person is to receive?",
      questionID: 12,
      questionIDTitle: 9,
      questionType: "radio",
      verses: [
        {
          body: "But one and the same Spirit works all these things, distributing to each one individually as He wills",
          ref: "1 Corinthians 12:11",
        },
      ],
    },
    "25-13": {
      blanks: [
        {
          choices: ["ask", "asks", "know", "follow"],
          correctAnswer: "ask",
          textAfter: " Him!",
          textBefore:
            "If you then, being evil, know how to give good gifts to your children, how much more will your heavenly Father give the Holy Spirit to those who",
        },
      ],
      body: "Receiving the Holy Spirit is as simple as asking God for the gift! God is willing that we receive this vital gift, and therefore will gladly give the gift of the Spirit to those who ask Him to do so.",
      choices: ["ask", "demand", "know", "follow"],
      lessonID: 25,
      question: "How do we receive the Holy Spirit?",
      questionID: 13,
      questionIDTitle: 10,
      questionType: "radio",
      verses: [
        {
          body: "If you then, being evil, know how to give good gifts to your children, how much more will your heavenly Father give the Holy Spirit to those who ask Him!”",
          ref: "Luke 11:13",
        },
      ],
    },
    "25-14": {
      Supplements: {
        "-L83EgM6uF3e8fEyznsp": {
          body: " It is indeed possible for a person who claims to be a Christian to commit the unpardonable sin. The Holy Spirit teaches us (John 14:26), guides us (John 16:13), convicts us (John 16:8), and unites us together (1 Corinthians 12:13). But if He teaches us and we refuse to listen, if He guides us and we refuse to follow, if He convicts us and we refuse to act, or if He seeks to unite us into one commandment-keeping body and we refuse to follow His leading, then we are taking steps toward committing the sin that God can never forgive. So, the wisest thing for a committed Christian to do when he or she hears the call of the Holy Spirit is to act immediately to follow Him.\n",
          title: "Can a Christian commit the unpardonable sin?",
        },
      },
      blanks: [
        {
          choices: [
            "Father",
            "forgiven",
            "Son",
            "forgiven",
            "Spirit",
            "forgiven",
          ],
          correctAnswer: "Spirit",
          textAfter:
            " will not be forgiven men. Anyone who speaks a word against the Son of Man, it will be forgiven him; but whoever speaks against the Holy Spirit, it will not be",
          textBefore:
            "Every sin and blasphemy will be forgiven men, but the blasphemy against the",
        },
        {
          choices: [
            "Father",
            "forgiven",
            "Son",
            "forgiven",
            "Spirit",
            "forgiven",
          ],
          correctAnswer: "forgiven",
          textAfter: " him, either in this age or in the age to come.",
        },
      ],
      body: "The unpardonable sin is the sin against the Holy Spirit. Rather than being a specific sin, the unpardonable sin is a condition in sin. God has made it clear that He is willing to forgive any sin. As 1 John 1:9 says, “If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.” But a sin that we choose not to confess cannot be forgiven.",
      choices: ["Father", "forgiven", "Son", "forgiven", "Spirit", "forgiven"],
      lessonID: 25,
      question: "What is the unpardonable sin?",
      questionID: 14,
      questionIDTitle: 11,
      questionType: "wordCloud",
      verses: [
        {
          body: "Therefore I say to you, every sin and blasphemy will be forgiven men, but the blasphemy against the Spirit will not be forgiven men. 32 Anyone who speaks a word against the Son of Man, it will be forgiven him; but whoever speaks against the Holy Spirit, it will not be forgiven him, either in this age or in the age to come.",
          ref: "Matthew 12:31, 32",
        },
      ],
    },
    "25-15": {
      Supplements: {
        "-L83Ecq4luQiQPIfWC1m": {
          body: "The longer we resist the promptings of the Holy Spirit, the more likely we are to resist Him in the future. Hebrews 3:15 counsels us, “Today, if you will hear His voice, do not harden your hearts as in the rebellion”. When we resist the Holy Spirit’s leading, we build up spiritual calluses and it makes it more difficult to hear His voice in the future. Eventually, if we continue to resist Him, we will become deaf to His urging. Since the Holy Spirit is just as much a part of the Godhead as Jesus is, if we choose to resist the Holy Spirit, it’s just as if we’re choosing to resist Jesus. Acts 22:16 says, “And now why are you waiting? Arise and be baptized, and wash away your sins, calling on the name of the Lord”. \n\nIf you truly love Jesus, why would you wait?\n",
          title:
            "If the Holy Spirit is convicting me to do something and I resist, how dangerous is that?",
        },
      },
      lessonID: 25,
      question: "How is blasphemy against the Spirit committed?",
      questionID: 15,
      questionIDTitle: 12,
      questionType: "text",
      text: [
        'In the passage in Matthew 12 discussing the unpardonable sin, Jesus heals a man who was "demon-possessed, blind and mute." (Matthew 12:22)',
        "In attributing the miracle to the working of Satan, the Pharisees rejected not only Jesus but also the Holy Spirit, who was present to bring conviction to their hearts.  When an individual refuses to surrender to the conviction of the Holy Spirit, that person is rejecting the Holy Spirit.",
        "While God in His goodness continues to bear with resistant people, there comes a time when those who harden their heart against conviction are left to their own devices.  Having rejected the Holy Spirit, they have committed the unpardonable sin.",
        "The reason the unpardonable sin is not forgiven is because it is not confessed.  If a sin remains unconfessed, the sin in question becomes the unpardonable sin.",
        "Please note: There is no need to worry that any sin committed in the past and not confessed is the unpardonable sin.  The upardonable sin represents a continual rejection of the Holy Spirit's pleading - how long until the unpardonable sin is committed is not known.",
        'What is known is that it is neither wise nor safe to say "no" to the Holy Spirit.  The only right course of action is to surrender when God\'s Spirit speaks, and to enjoy the peace and blessing of a union with the God of heaven.',
      ],
    },
    "25-16": {
      blanks: [
        {
          choices: ["grieve", "anger", "hate", "demand"],
          correctAnswer: "grieve",
          textAfter: " the Holy Spirit of God.",
          textBefore: "Do not",
        },
      ],
      body: "\nThe word “grieve” as used in Ephesians 4:30 means to “make sorrowful.” In failing to surrender to the Spirit’s promptings, either by the sins we commit or by the things we refuse to do—sins of commission or sins of omission— we can grieve and turn away the Spirit of God. In Genesis 6:3, God told Noah that His Spirit “shall not strive with man forever.” There comes a time after continued rejection of the Holy Spirit that He ceases to invite a person to come to Christ.",
      choices: ["grieve", "anger", "hate", "demand"],
      lessonID: 25,
      question: "What warning is given to us regarding the Holy Spirit?",
      questionID: 16,
      questionIDTitle: 13,
      questionType: "radio",
      verses: [
        {
          body: "And do not grieve the Holy Spirit of God, by whom you were sealed for the day of redemption.",
          ref: "Ephesians 4:30",
        },
      ],
    },
    "25-17": {
      blanks: [
        {
          choices: ["them", "us", "me", "everyone"],
          correctAnswer: "me",
          textAfter:
            " , for He will take of what is Mine and declare it to you.",
          textBefore: "He will glorify",
        },
      ],
      body: "The Holy Spirit is Christ’s personal representative in the world. His ministry involves drawing the world to Jesus, and urging people to yield fully to Him and know Him in His true character. This helps us to understand that those with genuine spiritual gifts will not seek to draw attention to themselves or to worthless, worldly enterprises. The Holy Spirit seeks to draw people to Jesus, that He might be glorified.",
      choices: ["them", "us", "me", "everyone"],
      correctAnswer: "false",
      lessonID: 25,
      question: "Who is it that the Holy Spirit seeks to glorify?",
      questionID: 17,
      questionIDTitle: 14,
      questionType: "trueOrFalse",
      trueFalseQuestion: "The Holy Spirit seeks to Glorify Himself primarily.",
      verses: [
        {
          body: "He will glorify Me, for He will take of what is Mine and declare it to you.",
          ref: "John 16:14",
        },
      ],
    },
    "25-18": {
      blanks: [
        {
          choices: [
            "cleansed",
            "purified",
            "well",
            "heaven",
            "baptized",
            "Holy",
            "Father",
            "Spirit",
          ],
          correctAnswer: "baptized",
          textAfter: " with the",
          textBefore: "John truly baptized with water, but you shall be",
        },
        {
          choices: [
            "cleansed",
            "flaming sword",
            "well",
            "heaven's blessing",
            "baptized",
            "Holy Spirit",
          ],
          correctAnswer: "Holy",
          textAfter: " ",
        },
        {
          choices: [
            "cleansed",
            "flaming sword",
            "well",
            "heaven's blessing",
            "baptized",
            "Holy Spirit",
          ],
          correctAnswer: "Spirit",
          textAfter: " not many days from now.",
        },
      ],
      body: "Jesus’ promise of the baptism of the Holy Spirit was realized at the Feast of Pentecost, when the Holy Spirit descended upon the disciples with great power and they received supernatural spiritual gifts. Just as the baptism of the Holy Spirit empowered the apostles for service, believers today are prepared for service through this same outpouring of God’s Spirit (Ephesians 4:11–13). During his sermon at Pentecost, Peter promised the believers that should they repent and be baptized, they would “receive the gift of the Holy Spirit,” a gift that is still available to believers today (Acts 2:38).",
      choices: [
        "cleansed",
        "purified",
        "well",
        "heaven",
        "baptized",
        "Holy",
        "Father",
        "Spirit",
      ],
      lessonID: 25,
      question: "What is the baptism of the Holy Spirit?",
      questionID: 18,
      questionIDTitle: 15,
      questionType: "wordCloud",
      verses: [
        {
          body: "for John truly baptized with water, but you shall be baptized with the Holy Spirit not many days from now.",
          ref: "Acts 1:5",
        },
      ],
    },
    "25-19": {
      correctAnswer: "true",
      lessonID: 25,
      question:
        "Are you willing to receive the Holy Spirit?  Do you desire to be equipped to serve God, and to be made like Jesus?",
      questionID: 19,
      questionType: "truthConfirmation",
    },
    "25-2": {
      blanks: [
        {
          choices: [
            "yourself",
            "He",
            "knowledge",
            "God",
            "He",
            "Spirit",
            "others",
            "He",
            "face",
          ],
          correctAnswer: "God",
          textAfter: " .",
          textBefore:
            "Peter said, “Ananias, why has Satan filled your heart to lie to the Holy Spirit and keep back part of the price of the land for yourself? . . . You have not lied to men but to",
        },
      ],
      body: "\nWhen Ananias and Sapphira lied about their dealings with God and the church, Peter declared that in lying to the Holy Spirit, they had lied to God. This demonstrates not only that the Holy Spirit is considered to be God, but also that as the Holy Spirit can be lied to, the Holy Spirit has personality and therefore must be considered a Person. ",
      choices: [
        "yourself",
        "He",
        "knowledge",
        "God",
        null,
        "Spirit",
        "others",
        null,
        "face",
      ],
      lessonID: 25,
      question: "Does the Bible teach that the Holy Spirit is a Person?",
      questionID: 2,
      questionIDTitle: "2a",
      questionType: "wordCloud",
      verses: [
        {
          body: "But Peter said, “Ananias, why has Satan filled your heart to lie to the Holy Spirit and keep back part of the price of the land for yourself? 4 While it remained, was it not your own? And after it was sold, was it not in your own control? Why have you conceived this thing in your heart? You have not lied to men but to God.”",
          ref: "Acts 5:3, 4",
        },
      ],
    },
    "25-3": {
      blanks: [
        {
          choices: [
            "yourself",
            "He",
            "knowledge",
            "God",
            "He",
            "Spirit",
            "others",
            "He",
            "face",
          ],
          correctAnswer: "He",
          textAfter: ", the ",
          textBefore: "When ",
        },
        {
          choices: [
            "yourself",
            "He",
            "knowledge",
            "God",
            "He",
            "Spirit",
            "others",
            "He",
            "face",
          ],
          correctAnswer: "Spirit",
          textAfter:
            " of truth, has come, He will guide you into all truth; for He will not speak on His own authority, but whatever He hears He will speak; and He will tell you things to come.",
        },
      ],
      body: "Seven times in this verse, the Holy Spirit is referred to as an individual Being. Jesus considered the Holy Spirit to be a Person. The Holy Spirit is not an impersonal “force,” but a member of the Godhead who loves and cares for God’s children.",
      choices: [
        "yourself",
        "He",
        "knowledge",
        "God",
        "Spirit",
        "others",
        "face",
      ],
      lessonID: 25,
      question: "Does the Bible teach that the Holy Spirit is a Person?",
      questionID: 3,
      questionIDTitle: "2b",
      questionType: "wordCloud",
      verses: [
        {
          body: "However, when He, the Spirit of truth, has come, He will guide you into all truth; for He will not speak on His own authority, but whatever He hears He will speak; and He will tell you things to come.",
          ref: "John 16:13",
        },
      ],
    },
    "25-4": {
      blanks: [
        {
          choices: ["Helper", "orphans", "man", "again", "angel", "alone"],
          correctAnswer: "Helper",
          textAfter:
            " , that He may abide with you forever . . . I will not leave you",
          textBefore: "I will pray the Father, and He will give you another",
        },
        {
          choices: ["Helper", "orphans", "man", "again", "angel", "alone"],
          correctAnswer: "orphans",
          textAfter: " ; I will come to you.",
        },
      ],
      body: "Jesus promised to send the Holy Spirit to be our Helper (or “Comforter,” KJV). Jesus ensured that when He returned to heaven, we would still have access to His presence and help—through the Person of the Holy Spirit.",
      choices: ["Helper", "orphans", "man", "again", "angel", "alone"],
      lessonID: 25,
      question: "What promise did Jesus make concerning the Holy Spirit?",
      questionID: 4,
      questionIDTitle: 3,
      questionType: "wordCloud",
      verses: [
        {
          body: "And I will pray the Father, and He will give you another Helper, that He may abide with you forever— 17 the Spirit of truth, whom the world cannot receive, because it neither sees Him nor knows Him; but you know Him, for He dwells with you and will be in you. 18 I will not leave you orphans; I will come to you.",
          ref: "John 14:16, 18",
        },
      ],
    },
    "25-5": {
      blanks: [
        {
          choices: [
            "is",
            "inside",
            "Jesus",
            "grace",
            "might",
            "for",
            "man",
            "knowledge",
            "dwells",
            "in",
            "I",
            "Spirit",
          ],
          correctAnswer: "dwells",
          textAfter: " with you and will be",
          textBefore:
            "The Spirit of truth, whom the world cannot receive, because it neither sees Him nor knows Him; but you know Him, for He",
        },
        {
          choices: [
            "is",
            "inside",
            "Jesus",
            "grace",
            "might",
            "for",
            "man",
            "knowledge",
            "dwells",
            "in",
            "I",
            "Spirit",
          ],
          correctAnswer: "in",
          textAfter: " you. I will not leave you orphans;",
        },
        {
          choices: [
            "is",
            "inside",
            "Jesus",
            "grace",
            "might",
            "for",
            "man",
            "knowledge",
            "dwells",
            "in",
            "I",
            "Spirit",
          ],
          correctAnswer: "I",
          newline: [1, 1],
          textAfter: " will come to you.",
        },
        {
          choices: [
            "is",
            "inside",
            "Jesus",
            "grace",
            "might",
            "for",
            "man",
            "knowledge",
            "dwells",
            "in",
            "I",
            "Spirit",
          ],
          correctAnswer: "Spirit",
          textAfter: " whom He has given us.",
          textBefore:
            " He who keeps His commandments abides in Him, and He in him. And by this we know that He abides in us, by the",
        },
      ],
      body: "The Holy Spirit brings to us the personal presence of Jesus Christ. Jesus lives and dwells in us through the Holy Spirit.",
      choices: [
        "is",
        "inside",
        "Jesus",
        "grace",
        "might",
        "for",
        "man",
        "knowledge",
        "dwells",
        "in",
        "I",
        "Spirit",
      ],
      lessonID: 25,
      question:
        "How does the Holy Spirit help us to experience the presence of Jesus?",
      questionID: 5,
      questionIDTitle: 4,
      questionType: "wordCloud",
      verses: [
        {
          body: " the Spirit of truth, whom the world cannot receive, because it neither sees Him nor knows Him; but you know Him, for He dwells with you and will be in you. 18 I will not leave you orphans; I will come to you.",
          ref: "John 14:17, 18",
        },
        {
          body: "Now he who keeps His commandments abides in Him, and He in him. And by this we know that He abides in us, by the Spirit whom He has given us.",
          ref: "1 John 3:24",
        },
      ],
    },
    "25-6": {
      blanks: [
        {
          choices: [
            "error",
            "truth",
            "know",
            "testify",
            "bring",
            "guide",
            "cleanse",
          ],
          correctAnswer: "guide",
          textAfter: " you into all",
          textBefore: "When He, the Spirit of truth, has come, He will",
        },
        {
          choices: [
            "hear",
            "know",
            "convict",
            "truth",
            "bring",
            "things",
            "cleanse",
          ],
          correctAnswer: "truth",
          textAfter:
            " ; for He will not speak on His own authority, but whatever He hears He will speak; and He will tell you things to come.",
        },
      ],
      body: "\nIt is the Holy Spirit’s role to guide the mind of the student of Scripture into an understanding of the truth of the Bible. Psalm 119:130 says, “The entrance of Your words gives light; it gives understanding to the simple.” The understanding that David writes of is provided by the Holy Spirit.",
      choices: [
        "error",
        "truth",
        "know",
        "testify",
        "bring",
        "guide",
        "cleanse",
      ],
      lessonID: 25,
      question: "What is the role of the Holy Spirit?",
      questionID: 6,
      questionIDTitle: "5a",
      questionType: "wordCloud",
      verses: [
        {
          body: "However, when He, the Spirit of truth, has come, He will guide you into all truth; for He will not speak on His own authority, but whatever He hears He will speak; and He will tell you things to come.",
          ref: "John 16:13",
        },
      ],
    },
    "25-7": {
      blanks: [
        {
          choices: ["convict", "wash", "hear", "testify", "kingdom", "things"],
          correctAnswer: "convict",
          textAfter:
            " the world of sin, and of righteousness, and of judgment. ",
          textBefore: "When He has come, He will",
        },
      ],
      body: "Conviction of sin, an understanding and appreciation of righteousness, and an awareness of judgment are all brought to the believer by the Holy Spirit. Without the ministry of the Holy Spirit, spiritual growth, love for God and holy living are impossible. ",
      choices: [
        "error",
        "truth",
        "know",
        "testify",
        "bring",
        "convict",
        "cleanse",
      ],
      lessonID: 25,
      question: "What is the role of the Holy Spirit?",
      questionID: 7,
      questionIDTitle: "5b",
      questionType: "wordCloud",
      verses: [
        {
          body: "And when He has come, He will convict the world of sin, and of righteousness, and of judgment:",
          ref: "John 16:8",
        },
      ],
    },
    "25-8": {
      blanks: [
        {
          choices: ["hear", "wash", "convict", "kingdom", "bring", "testify"],
          correctAnswer: "testify",
          textAfter: " of Me.\n    ",
          textBefore:
            "When the Helper comes, whom I shall send to you from the Father, the Spirit of truth who proceeds from the Father, He will",
        },
      ],
      body: " The Holy Spirit speaks of Jesus and brings the presence of Jesus to the searching believer. The Holy Spirit also produces the character of Jesus in the life of the believer.",
      choices: [
        "error",
        "truth",
        "know",
        "testify",
        "bring",
        "guide",
        "cleanse",
      ],
      lessonID: 25,
      question: "What is the role of the Holy Spirit?",
      questionID: 8,
      questionIDTitle: "5c",
      questionType: "wordCloud",
      verses: [
        {
          body: "But when the Helper comes, whom I shall send to you from the Father, the Spirit of truth who proceeds from the Father, He will testify of Me.",
          ref: "John 15:26",
        },
      ],
    },
    "25-9": {
      blanks: [
        {
          choices: ["one", "one", "filled", "baptized", "distant", "known"],
          correctAnswer: "filled",
          newline: [1],
          textAfter: " with the Spirit. ",
          textBefore:
            "Do not be drunk with wine, in which is dissipation; but be",
        },
        {
          choices: ["one", "one", "filled", "baptized", "distant", "known"],
          correctAnswer: "baptized",
          textAfter: " with the Holy Spirit not many days from now.",
          textBefore: "John truly baptized with water, but you shall be",
        },
      ],
      body: "God’s desire is that His children be filled with the Holy Spirit—described by Jesus as the baptism of the Holy Spirit.",
      choices: ["one", "many", "filled", "baptized", "distant", "known"],
      lessonID: 25,
      question: "How much should the Holy Spirit affect a person’s life?",
      questionID: 9,
      questionIDTitle: 6,
      questionType: "wordCloud",
      verses: [
        {
          body: "And do not be drunk with wine, in which is dissipation; but be filled with the Spirit,",
          ref: "Ephesians 5:18",
        },
        {
          body: "for John truly baptized with water, but you shall be baptized with the Holy Spirit not many days from now.",
          ref: "Acts 1:5",
        },
      ],
    },
  },
];
